/* YOUR EXISTING JSON FORMAT */
window.RAW_PINCODE_DATA = [
  {
    "pincode": "110001",
    "city": "ANTARIKSH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110002",
    "city": "INDRAPRAKASH BLDG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110003",
    "city": "ANTARIKSH BHAVAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110004",
    "city": "ANTARIKSH BHAVAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110005",
    "city": "RAJENDRA PLACE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110006",
    "city": "CP BRANCH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110007",
    "city": "CP BRANCH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110008",
    "city": "RAJENDRA PLACE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110009",
    "city": "WAZIRPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110010",
    "city": "DELHI CANTONMENT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110011",
    "city": "ANTARIKSH BHAVAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110012",
    "city": "RAJENDRA PLACE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110013",
    "city": "OKHLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110014",
    "city": "OKHLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110015",
    "city": "RAMA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110016",
    "city": "SAFDARJUNG ENCLAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110017",
    "city": "SAKET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110018",
    "city": "PASCHIM VIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110019",
    "city": "NEHRU PLACE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110020",
    "city": "OKHLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110021",
    "city": "DELHI CANTONMENT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110022",
    "city": "DELHI CANTONMENT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110023",
    "city": "SAFDARJUNG ENCLAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110024",
    "city": "NEHRU PLACE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110025",
    "city": "MOHAN CO OP INDL AREA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110026",
    "city": "RAMA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110027",
    "city": "RAMA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110028",
    "city": "RAJENDRA PLACE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110029",
    "city": "SAFDARJUNG ENCLAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110030",
    "city": "VASANT VIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110031",
    "city": "KRISHNA NAGAR SERVICE CEN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110032",
    "city": "JHILMIL INDUSTRIAL AREA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110033",
    "city": "WAZIRPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110034",
    "city": "PITAMPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110035",
    "city": "RAMA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110036",
    "city": "ROHINI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110037",
    "city": "KAPASHERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110038",
    "city": "KAPASHERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110039",
    "city": "ROHINI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110040",
    "city": "ROHINI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110041",
    "city": "HIRANKUDNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110042",
    "city": "ROHINI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110043",
    "city": "JANAKPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110044",
    "city": "MOHAN CO OP INDL AREA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110045",
    "city": "PALAM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110046",
    "city": "JANAKPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110047",
    "city": "VASANT VIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110048",
    "city": "NEHRU PLACE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110049",
    "city": "SAFDARJUNG ENCLAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110050",
    "city": "PASCHIM VIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110051",
    "city": "KRISHNA NAGAR SERVICE CEN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110052",
    "city": "WAZIRPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110053",
    "city": "JHILMIL INDUSTRIAL AREA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110054",
    "city": "CP BRANCH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110055",
    "city": "CP BRANCH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110056",
    "city": "PASCHIM VIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110057",
    "city": "DELHI CANTONMENT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110058",
    "city": "JANAKPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110059",
    "city": "JANAKPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110060",
    "city": "RAJENDRA PLACE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110061",
    "city": "KAPASHERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110062",
    "city": "SAKET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110063",
    "city": "PASCHIM VIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110064",
    "city": "RAMA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110065",
    "city": "OKHLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110066",
    "city": "SAFDARJUNG ENCLAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110067",
    "city": "SAKET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110068",
    "city": "SAKET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110069",
    "city": "ANTARIKSH BHAVAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110070",
    "city": "VASANT VIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110071",
    "city": "NAZAFGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110072",
    "city": "NAZAFGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110073",
    "city": "NAZAFGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110074",
    "city": "VASANT VIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110075",
    "city": "DWARIKA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110076",
    "city": "MOHAN CO OP INDL AREA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110077",
    "city": "DWARIKA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110078",
    "city": "DWARIKA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110080",
    "city": "SAKET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110081",
    "city": "HIRANKUDNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110082",
    "city": "ROHINI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110083",
    "city": "PITAMPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110084",
    "city": "WAZIRPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110085",
    "city": "ROHINI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110086",
    "city": "HIRANKUDNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110087",
    "city": "PASCHIM VIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110088",
    "city": "WAZIRPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110089",
    "city": "ROHINI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110090",
    "city": "JHILMIL INDUSTRIAL AREA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110091",
    "city": "MAYUR VIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110092",
    "city": "EAST DELHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110093",
    "city": "JHILMIL INDUSTRIAL AREA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110094",
    "city": "JHILMIL INDUSTRIAL AREA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110095",
    "city": "JHILMIL INDUSTRIAL AREA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110096",
    "city": "MAYUR VIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110097",
    "city": "KAPASHERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110098",
    "city": "MAYUR VIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110100",
    "city": "ANTARIKSH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110101",
    "city": "ANTARIKSH BHAVAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110103",
    "city": "INDRAPRAKASH BLDG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110104",
    "city": "INDRAPRAKASH BLDG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110105",
    "city": "ANTARIKSH BHAVAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110106",
    "city": "ANTARIKSH BHAVAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110107",
    "city": "ANTARIKSH BHAVAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110108",
    "city": "ANTARIKSH BHAVAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110109",
    "city": "INDRAPRAKASH BLDG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110110",
    "city": "INDRAPRAKASH BLDG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110112",
    "city": "INDRAPRAKASH BLDG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110113",
    "city": "INDRAPRAKASH BLDG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110114",
    "city": "ANTARIKSH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110115",
    "city": "ANTARIKSH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110116",
    "city": "ANTARIKSH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110117",
    "city": "ANTARIKSH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110118",
    "city": "ANTARIKSH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110119",
    "city": "ANTARIKSH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110120",
    "city": "ANTARIKSH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110122",
    "city": "ANTARIKSH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110124",
    "city": "INDRAPRAKASH BLDG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110125",
    "city": "RAJENDRA PLACE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110301",
    "city": "EAST DELHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110302",
    "city": "EAST DELHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110501",
    "city": "OKHLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110502",
    "city": "ANTARIKSH BHAVAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110503",
    "city": "ANTARIKSH BHAVAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110504",
    "city": "ANTARIKSH BHAVAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110505",
    "city": "NEHRU PLACE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110510",
    "city": "ANTARIKSH BHAVAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110511",
    "city": "ANTARIKSH BHAVAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110512",
    "city": "ANTARIKSH BHAVAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110601",
    "city": "SAFDARJUNG ENCLAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110602",
    "city": "SAFDARJUNG ENCLAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110603",
    "city": "SAFDARJUNG ENCLAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110604",
    "city": "SAFDARJUNG ENCLAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110605",
    "city": "SAFDARJUNG ENCLAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110606",
    "city": "SAFDARJUNG ENCLAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110607",
    "city": "SAFDARJUNG ENCLAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110608",
    "city": "SAFDARJUNG ENCLAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "110609",
    "city": "SAFDARJUNG ENCLAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "111105",
    "city": "ICICI RTOS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "111111",
    "city": "DELHI HUB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "111112",
    "city": "RAMA ROAD HUB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "111113",
    "city": "DPA COMAILS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "111115",
    "city": "FAR COD PROCESSING CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "111116",
    "city": "COD PROCESSING CENTRE III",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "111117",
    "city": "COD PROCESSING CENTRE II",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "111118",
    "city": "COD PROCESSING CENTRE I",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "114145",
    "city": "VIJAYPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121000",
    "city": "FAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121001",
    "city": "FARIDABAD NIT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121002",
    "city": "FARIDABAD NEHAR PAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121003",
    "city": "FARIDABAD SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121004",
    "city": "FAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121005",
    "city": "FAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121006",
    "city": "FARIDABAD NEHAR PAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121007",
    "city": "FAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121008",
    "city": "FARIDABAD SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121009",
    "city": "FARIDABAD SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121010",
    "city": "FARIDABAD SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121011",
    "city": "FAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121012",
    "city": "FARIDABAD NIT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121013",
    "city": "FARIDABAD SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121014",
    "city": "FAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121015",
    "city": "FARIDABAD EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121101",
    "city": "FAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121102",
    "city": "PALWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121103",
    "city": "PALWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121104",
    "city": "FAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121105",
    "city": "HODAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121106",
    "city": "HODAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121107",
    "city": "HODAL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "121206",
    "city": "FAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122001",
    "city": "GURUGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122002",
    "city": "DLF CYBER CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122003",
    "city": "GURUGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122004",
    "city": "GURUGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122005",
    "city": "GURUGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122006",
    "city": "GURUGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122007",
    "city": "GURUGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122008",
    "city": "DLF CYBER CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122009",
    "city": "GURUGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122010",
    "city": "DLF CYBER CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122011",
    "city": "GURUGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122012",
    "city": "GURUGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122015",
    "city": "UDYOGVIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122016",
    "city": "UDYOGVIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122017",
    "city": "UDYOGVIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122018",
    "city": "SOHANA ROAD S/C",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122019",
    "city": "SOHANA ROAD S/C",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122022",
    "city": "GURUGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122050",
    "city": "LAST MILE MANESAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122051",
    "city": "LAST MILE MANESAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122052",
    "city": "LAST MILE MANESAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122098",
    "city": "GURUGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122100",
    "city": "KUSHKHERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122101",
    "city": "SOHNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122102",
    "city": "SOHNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122103",
    "city": "SOHNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122104",
    "city": "GURGAON BILASPUR ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122105",
    "city": "GURGAON BILASPUR ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122106",
    "city": "DARUHERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122107",
    "city": "SOHNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122222",
    "city": "GURGAON RTO CARDS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122413",
    "city": "GURUGRAM PATAUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122414",
    "city": "KUSHKHERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122502",
    "city": "RAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122503",
    "city": "GURUGRAM PATAUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122504",
    "city": "GURGAON BILASPUR ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122505",
    "city": "LAST MILE MANESAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "122506",
    "city": "GURUGRAM PATAUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123001",
    "city": "NARNAUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123003",
    "city": "DLF CYBER CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123021",
    "city": "MAHENDRAGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123023",
    "city": "KOTPUTALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123024",
    "city": "LOHARU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123027",
    "city": "MAHENDRAGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123028",
    "city": "MAHENDRAGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123029",
    "city": "MAHENDRAGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123031",
    "city": "MAHENDRAGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123034",
    "city": "MAHENDRAGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123035",
    "city": "RAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123101",
    "city": "REWARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123102",
    "city": "REWARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123103",
    "city": "NEEMRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123106",
    "city": "DARUHERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123110",
    "city": "DARUHERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123301",
    "city": "JHAJJAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123302",
    "city": "JHAJJAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123303",
    "city": "MAHENDRAGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123305",
    "city": "BAHADURGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123401",
    "city": "REWARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123411",
    "city": "MAHENDRAGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123412",
    "city": "NEEMRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123413",
    "city": "GURGAON BILASPUR ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123414",
    "city": "DLF CYBER CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123501",
    "city": "NEEMRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123502",
    "city": "DLF CYBER CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123504",
    "city": "GURUGRAM PATAUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123505",
    "city": "GURUGRAM PATAUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "123506",
    "city": "GURUGRAM PATAUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124001",
    "city": "ROHTAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124021",
    "city": "ROHTAK IMT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124102",
    "city": "JHAJJAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124103",
    "city": "JHAJJAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124104",
    "city": "JHAJJAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124105",
    "city": "JHAJJAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124106",
    "city": "JHAJJAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124107",
    "city": "JHAJJAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124108",
    "city": "JHAJJAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124109",
    "city": "JHAJJAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124111",
    "city": "MEHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124112",
    "city": "MEHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124129",
    "city": "OKHLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124141",
    "city": "JHAJJAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124142",
    "city": "JHAJJAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124146",
    "city": "JHAJJAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124201",
    "city": "JHAJJAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124202",
    "city": "JHAJJAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124301",
    "city": "ROHTAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124302",
    "city": "SONEPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124306",
    "city": "DELHI WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124308",
    "city": "ROHTAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124310",
    "city": "SONEPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124402",
    "city": "SONEPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124403",
    "city": "DELHI WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124404",
    "city": "SAMPLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124408",
    "city": "DELHI WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124409",
    "city": "DELHI WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124413",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124415",
    "city": "SONEPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124416",
    "city": "ROHTAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124429",
    "city": "DELHI WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124501",
    "city": "SAMPLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124503",
    "city": "BAHADURGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124504",
    "city": "JHAJJAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124505",
    "city": "SAMPLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124506",
    "city": "BAHADURGARH REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124507",
    "city": "BAHADURGARH REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124508",
    "city": "BAHADURGARH REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124512",
    "city": "BAHADURGARH REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124524",
    "city": "ROHTAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "124532",
    "city": "DELHI WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125001",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125002",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125003",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125004",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125005",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125006",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125007",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125011",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125032",
    "city": "BHIWANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125033",
    "city": "HANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125034",
    "city": "HANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125035",
    "city": "HANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125037",
    "city": "TOSHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125039",
    "city": "JIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125042",
    "city": "MEHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125044",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125047",
    "city": "BARWALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125048",
    "city": "FATEHABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125049",
    "city": "HANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125050",
    "city": "FATEHABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125051",
    "city": "RATIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125052",
    "city": "MANDI ADAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125053",
    "city": "MANDI ADAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125054",
    "city": "SIRSA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125055",
    "city": "SIRSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125058",
    "city": "SIRSA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125060",
    "city": "SIRSA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125068",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125069",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125070",
    "city": "HANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125073",
    "city": "HANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125075",
    "city": "ELLENABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125076",
    "city": "ELLENABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125077",
    "city": "MANDI DABWALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125078",
    "city": "SIRSA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125080",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125081",
    "city": "HANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125083",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125084",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125086",
    "city": "HANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125101",
    "city": "MANDI DABWALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125102",
    "city": "ELLENABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125103",
    "city": "MANDI DABWALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125104",
    "city": "MANDI DABWALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125106",
    "city": "RATIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125109",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125110",
    "city": "SIRSA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125111",
    "city": "BARWALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125112",
    "city": "BARWALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125113",
    "city": "BARWALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125120",
    "city": "TOHANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125121",
    "city": "BARWALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125122",
    "city": "BARWALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125133",
    "city": "JAKHAL MANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "125201",
    "city": "TALWANDI SABOO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126001",
    "city": "TOHANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126006",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126007",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126009",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126010",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126011",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126013",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126015",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126025",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126027",
    "city": "BAHADURGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126101",
    "city": "JIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126102",
    "city": "JIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126110",
    "city": "JIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126111",
    "city": "JIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126112",
    "city": "ASSAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126113",
    "city": "JIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126114",
    "city": "JIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126115",
    "city": "NARWANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126116",
    "city": "NARWANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126125",
    "city": "JIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126126",
    "city": "NARWANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126127",
    "city": "NARWANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126128",
    "city": "NARWANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126133",
    "city": "HISSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "126152",
    "city": "NARWANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127020",
    "city": "BHIWANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127021",
    "city": "BHIWANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127022",
    "city": "CHARKHI DADRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127025",
    "city": "CHARKHI DADRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127026",
    "city": "CHARKHI DADRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127027",
    "city": "BHIWANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127030",
    "city": "BHIWANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127031",
    "city": "BHIWANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127032",
    "city": "TOSHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127035",
    "city": "TOSHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127040",
    "city": "TOSHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127041",
    "city": "MEHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127043",
    "city": "TOSHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127045",
    "city": "SIWANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127046",
    "city": "SIWANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127110",
    "city": "BHIWANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127111",
    "city": "BHIWANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127201",
    "city": "LOHARU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127306",
    "city": "CHARKHI DADRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127308",
    "city": "LOHARU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127309",
    "city": "BHIWANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "127310",
    "city": "CHARKHI DADRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131001",
    "city": "SONEPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131002",
    "city": "SONEPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131021",
    "city": "SONEPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131022",
    "city": "SONEPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131023",
    "city": "SONEPAT EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131024",
    "city": "GOHANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131025",
    "city": "SONEPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131027",
    "city": "SONEPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131028",
    "city": "KUNDLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131029",
    "city": "JATHERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131030",
    "city": "KUNDLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131032",
    "city": "DELHI WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131034",
    "city": "DELHI WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131036",
    "city": "DELHI WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131039",
    "city": "GANAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131040",
    "city": "SONEPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131101",
    "city": "GANAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131102",
    "city": "GANAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131103",
    "city": "KUNDLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131105",
    "city": "SONEPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131107",
    "city": "SONEPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131108",
    "city": "DELHI WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131110",
    "city": "SONEPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131111",
    "city": "DELHI WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131112",
    "city": "DELHI WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131114",
    "city": "SONEPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131115",
    "city": "PANIPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131301",
    "city": "GOHANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131302",
    "city": "GOHANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131303",
    "city": "SONEPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131304",
    "city": "GOHANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131305",
    "city": "GOHANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131306",
    "city": "GOHANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131310",
    "city": "SONEPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131402",
    "city": "SONEPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131403",
    "city": "SONEPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131408",
    "city": "GOHANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "131409",
    "city": "GOHANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132001",
    "city": "KARNAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132002",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132022",
    "city": "KARNAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132024",
    "city": "KARNAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132026",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132035",
    "city": "KARNAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132037",
    "city": "KARNAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132038",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132039",
    "city": "ASSAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132040",
    "city": "KARNAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132044",
    "city": "KARNAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132046",
    "city": "ASSANDH EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132048",
    "city": "PANIPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132054",
    "city": "KARNAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132101",
    "city": "SAMALKHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132102",
    "city": "SAMALKHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132103",
    "city": "PANIPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132104",
    "city": "PANIPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132105",
    "city": "PANIPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132106",
    "city": "PANIPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132107",
    "city": "GOHANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132108",
    "city": "PANIPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132110",
    "city": "PANIPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132111",
    "city": "KARNAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132113",
    "city": "ASSAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132114",
    "city": "KARNAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132115",
    "city": "SAMALKHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132116",
    "city": "TAROAORI/NILOKHERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132117",
    "city": "TAROAORI/NILOKHERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132122",
    "city": "SAMALKHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132124",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132125",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132128",
    "city": "KARNAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132129",
    "city": "KARNAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132130",
    "city": "KARNAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132132",
    "city": "PANIPAT ETAIL CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132133",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132134",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132136",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132137",
    "city": "KARNAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132140",
    "city": "PANIPAT IOCL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132141",
    "city": "PANIPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132144",
    "city": "KARNAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132145",
    "city": "PANIPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132146",
    "city": "PANIPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132151",
    "city": "PANIPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132153",
    "city": "KARNAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132155",
    "city": "PANIPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "132157",
    "city": "KURUKSHETRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133001",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133003",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133004",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133005",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133006",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133007",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133008",
    "city": "AMBALA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133010",
    "city": "AMBALA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133021",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133101",
    "city": "MULLANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133102",
    "city": "SHAHABAD MARKANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133103",
    "city": "JAGADHRI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133104",
    "city": "MULLANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133105",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133201",
    "city": "MULLANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133202",
    "city": "MULLANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133203",
    "city": "MULLANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133204",
    "city": "NARAINGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133205",
    "city": "MULLANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133206",
    "city": "JAGADHRI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133207",
    "city": "MULLANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133301",
    "city": "PANCHKULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "133302",
    "city": "KALKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134001",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134002",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134003",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134004",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134005",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134006",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134007",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134008",
    "city": "AMBALA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134011",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134012",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134101",
    "city": "KALKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134102",
    "city": "KALKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134103",
    "city": "PANCHKULLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134104",
    "city": "KALKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134105",
    "city": "PANCHKULLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134107",
    "city": "PANCHKULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134108",
    "city": "PANCHKULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134109",
    "city": "PANCHKULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134111",
    "city": "CHANDIGARH WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134112",
    "city": "PANCHKULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134113",
    "city": "PANCHKULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134114",
    "city": "PANCHKULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134115",
    "city": "PANCHKULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134116",
    "city": "PANCHKULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134117",
    "city": "PANCHKULLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134118",
    "city": "BARWALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134201",
    "city": "MULLANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134202",
    "city": "MULLANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134203",
    "city": "NARAINGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134204",
    "city": "PANCHKULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "134205",
    "city": "PANCHKULLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "135001",
    "city": "YAMUNANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "135002",
    "city": "YAMUNANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "135003",
    "city": "YAMUNANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "135004",
    "city": "JAGADHRI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "135021",
    "city": "JAGADHRI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "135101",
    "city": "JAGADHRI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "135102",
    "city": "JAGADHRI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "135103",
    "city": "JAGADHRI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "135105",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "135106",
    "city": "JAGADHRI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "135133",
    "city": "JAGADHRI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136020",
    "city": "PUNDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136021",
    "city": "PUNDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136026",
    "city": "PUNDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136027",
    "city": "PUNDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136030",
    "city": "PEHOWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136033",
    "city": "PUNDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136034",
    "city": "PEHOWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136035",
    "city": "PEHOWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136038",
    "city": "KURUKSHETRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136042",
    "city": "PUNDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136043",
    "city": "PUNDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136044",
    "city": "PUNDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136117",
    "city": "NARWANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136118",
    "city": "KURUKSHETRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136119",
    "city": "KURUKSHETRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136128",
    "city": "PEHOWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136129",
    "city": "PEHOWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136130",
    "city": "KURUKSHETRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136131",
    "city": "KURUKSHETRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136132",
    "city": "KURUKSHETRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136135",
    "city": "SHAHABAD MARKANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136136",
    "city": "SHAHABAD MARKANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "136156",
    "city": "KURUKSHETRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140001",
    "city": "ROPAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140101",
    "city": "MORINDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140102",
    "city": "CHAMKAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140103",
    "city": "MORINDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140104",
    "city": "MOHALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140105",
    "city": "ZIRAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140108",
    "city": "ROPAR SURROUNDING",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140109",
    "city": "ROPAR SURROUNDING",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140110",
    "city": "ROPAR SURROUNDING",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140111",
    "city": "CHAMKAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140112",
    "city": "CHAMKAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140113",
    "city": "ROPAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140114",
    "city": "ROPAR SURROUNDING",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140115",
    "city": "ANANDPUR SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140116",
    "city": "ANANDPUR SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140117",
    "city": "ANANDPUR SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140118",
    "city": "ANANDPUR SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140119",
    "city": "ANANDPUR SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140123",
    "city": "ANANDPUR SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140125",
    "city": "TAHLIWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140126",
    "city": "TAHLIWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140201",
    "city": "DERABASSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140301",
    "city": "KHARAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140306",
    "city": "MOHALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140307",
    "city": "KHARAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140308",
    "city": "MOHALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140401",
    "city": "RAJPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140402",
    "city": "RAJPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140405",
    "city": "PATIALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140406",
    "city": "FATEHGARH SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140407",
    "city": "FATEHGARH SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140408",
    "city": "FATEHGARH SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140413",
    "city": "KHARAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140417",
    "city": "RAJPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140501",
    "city": "LALRU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140506",
    "city": "DERABASSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140507",
    "city": "DERABASSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140601",
    "city": "RAJPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140602",
    "city": "RAJPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140603",
    "city": "ZIRAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140604",
    "city": "ZIRAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140701",
    "city": "RAJPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140702",
    "city": "PATIALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140802",
    "city": "MORINDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "140901",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141001",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141002",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141003",
    "city": "LUDHIANA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141004",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141005",
    "city": "JALANDHAR BYPASS SC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141006",
    "city": "JALANDHAR BYPASS SC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141007",
    "city": "JALANDHAR BYPASS SC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141008",
    "city": "JALANDHAR BYPASS SC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141009",
    "city": "JALANDHAR BYPASS SC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141010",
    "city": "OUTER-LUDHIANA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141011",
    "city": "OUTER-LUDHIANA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141012",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141013",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141014",
    "city": "OUTER-LUDHIANA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141015",
    "city": "OUTER-LUDHIANA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141016",
    "city": "OUTER-LUDHIANA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141017",
    "city": "OUTER-LUDHIANA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141020",
    "city": "JALANDHAR BYPASS SC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141101",
    "city": "MULLANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141102",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141103",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141104",
    "city": "MULLANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141105",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141106",
    "city": "MULLANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141107",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141108",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141109",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141110",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141111",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141112",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141113",
    "city": "OUTER-LUDHIANA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141114",
    "city": "MACHHIWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141115",
    "city": "MACHHIWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141116",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141119",
    "city": "MALERKOTLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141120",
    "city": "OUTER-LUDHIANA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141121",
    "city": "MACHHIWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141122",
    "city": "JALANDHAR BYPASS SC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141123",
    "city": "OUTER-LUDHIANA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141124",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141125",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141127",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141128",
    "city": "PATIALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141201",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141202",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141203",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141204",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141205",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141220",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141221",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141229",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141230",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141304",
    "city": "PHAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141309",
    "city": "ITO SERV CENTRE-JALANDHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141401",
    "city": "KHANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141402",
    "city": "KHANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141411",
    "city": "MANDI GOBINDGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141412",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141413",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141414",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141415",
    "city": "MALERKOTLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141416",
    "city": "OUTER-LUDHIANA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141417",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141418",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141419",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141421",
    "city": "OUTER-LUDHIANA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141422",
    "city": "LUDHIANA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "141801",
    "city": "CHAMKAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142001",
    "city": "MOGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142002",
    "city": "MOGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142003",
    "city": "MOGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142011",
    "city": "MOGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142021",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142023",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142024",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142025",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142026",
    "city": "JAGRAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142027",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142028",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142030",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142031",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142032",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142033",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142034",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142035",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142036",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142037",
    "city": "MOGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142038",
    "city": "MOGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142039",
    "city": "MOGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142040",
    "city": "MOGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142041",
    "city": "MOGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142042",
    "city": "MOGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142043",
    "city": "MOGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142044",
    "city": "ZIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142045",
    "city": "MOGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142046",
    "city": "MOGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142047",
    "city": "ZIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142048",
    "city": "MOGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142049",
    "city": "KOTKAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142050",
    "city": "ZIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142051",
    "city": "MOGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142052",
    "city": "FEROZEPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142053",
    "city": "MOGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142054",
    "city": "MOGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142055",
    "city": "MOGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142056",
    "city": "MOGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142057",
    "city": "MOGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142058",
    "city": "MOGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142060",
    "city": "FARIDKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142112",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142113",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142126",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "142216",
    "city": "LUDHIANA CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143001",
    "city": "AMRITSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143002",
    "city": "AMRITSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143003",
    "city": "AMRITSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143004",
    "city": "AMRITSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143005",
    "city": "AMRITSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143006",
    "city": "AMRITSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143007",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143008",
    "city": "AMRITSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143009",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143010",
    "city": "AMRITSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143021",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143022",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143026",
    "city": "AMRITSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143102",
    "city": "AJNALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143103",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143104",
    "city": "AMRITSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143105",
    "city": "AMRITSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143106",
    "city": "AMRITSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143107",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143108",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143109",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143110",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143111",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143112",
    "city": "BEAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143113",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143114",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143115",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143116",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143117",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143118",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143119",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143149",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143201",
    "city": "BEAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143202",
    "city": "BEAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143203",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143204",
    "city": "BEAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143205",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143301",
    "city": "PATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143302",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143303",
    "city": "PATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143304",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143305",
    "city": "PATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143401",
    "city": "TARANTARAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143402",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143406",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143407",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143408",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143409",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143410",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143411",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143412",
    "city": "PATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143413",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143414",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143415",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143416",
    "city": "PATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143417",
    "city": "AMRITSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143419",
    "city": "PATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143422",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143501",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143502",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143504",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143505",
    "city": "BATALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143506",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143507",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143511",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143512",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143513",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143514",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143515",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143517",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143518",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143519",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143520",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143521",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143525",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143526",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143527",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143528",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143529",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143530",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143531",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143532",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143533",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143534",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143601",
    "city": "AJNALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143602",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143603",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143604",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143605",
    "city": "GURDASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "143606",
    "city": "AMRITSAR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144001",
    "city": "ITO SERV CENTRE-JALANDHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144002",
    "city": "ITO SERV CENTRE-JALANDHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144003",
    "city": "ITO SERV CENTRE-JALANDHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144004",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144005",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144006",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144007",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144008",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144009",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144010",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144011",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144012",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144013",
    "city": "ITO SERV CENTRE-JALANDHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144014",
    "city": "ITO SERV CENTRE-JALANDHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144015",
    "city": "JALANDHAR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144020",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144021",
    "city": "ITO SERV CENTRE-JALANDHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144022",
    "city": "ITO SERV CENTRE-JALANDHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144023",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144024",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144025",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144026",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144027",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144028",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144029",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144030",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144031",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144032",
    "city": "PHAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144033",
    "city": "NAKODAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144034",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144035",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144036",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144037",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144038",
    "city": "PHAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144039",
    "city": "NAKODAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144040",
    "city": "NAKODAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144041",
    "city": "NAKODAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144042",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144043",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144044",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144101",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144103",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144104",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144105",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144106",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144202",
    "city": "TANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144203",
    "city": "TANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144204",
    "city": "TANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144205",
    "city": "DASUYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144206",
    "city": "DASUYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144207",
    "city": "DASUYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144208",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144209",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144210",
    "city": "DASUYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144211",
    "city": "MUKERIAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144212",
    "city": "DASUYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144213",
    "city": "DASUYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144214",
    "city": "DASUYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144216",
    "city": "DASUYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144221",
    "city": "DASUYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144222",
    "city": "DASUYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144223",
    "city": "DASUYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144224",
    "city": "DASUYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144301",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144302",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144303",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144304",
    "city": "PHAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144305",
    "city": "DASUYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144306",
    "city": "MUKERIAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144311",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144401",
    "city": "PHAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144402",
    "city": "PHAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144403",
    "city": "PHAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144404",
    "city": "PHAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144405",
    "city": "PHAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144406",
    "city": "PHAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144407",
    "city": "PHAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144408",
    "city": "PHAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144409",
    "city": "GORAYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144410",
    "city": "GORAYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144411",
    "city": "LOVELY PROFESSIONAL UNIVERSITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144415",
    "city": "GARHSHANKER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144416",
    "city": "GORAYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144417",
    "city": "GARHSHANKER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144418",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144419",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144421",
    "city": "GARHSHANKER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144422",
    "city": "GARHSHANKER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144424",
    "city": "PHAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144501",
    "city": "PHAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144502",
    "city": "PHAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144503",
    "city": "PHAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144504",
    "city": "PHAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144505",
    "city": "BANGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144509",
    "city": "GARHSHANKER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144510",
    "city": "GARHSHANKER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144511",
    "city": "GARHSHANKER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144512",
    "city": "GARHSHANKER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144513",
    "city": "GARHSHANKER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144514",
    "city": "NAWANSHAHR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144515",
    "city": "NAWANSHAHR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144516",
    "city": "NAWANSHAHR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144517",
    "city": "NAWANSHAHR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144518",
    "city": "GARHSHANKER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144519",
    "city": "PHAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144520",
    "city": "PHAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144521",
    "city": "GARHSHANKER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144522",
    "city": "NAWANSHAHR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144523",
    "city": "GARHSHANKER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144524",
    "city": "GARHSHANKER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144525",
    "city": "GARHSHANKER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144526",
    "city": "GARHSHANKER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144527",
    "city": "GARHSHANKER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144528",
    "city": "GARHSHANKER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144529",
    "city": "GARHSHANKER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144530",
    "city": "GARHSHANKER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144531",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144532",
    "city": "GARHSHANKER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144533",
    "city": "ROPAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144601",
    "city": "KAPURTHALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144602",
    "city": "KAPURTHALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144603",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144606",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144620",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144621",
    "city": "BEGOWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144622",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144623",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144624",
    "city": "BEGOWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144625",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144626",
    "city": "SULTANPUR LODHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144628",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144629",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144630",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144631",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144632",
    "city": "PHAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144633",
    "city": "PHAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144701",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144702",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144703",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144801",
    "city": "KARTARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144802",
    "city": "KAPURTHALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144803",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144804",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144805",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144806",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "144819",
    "city": "JALANDHAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "145001",
    "city": "PATHANKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "145021",
    "city": "AMRITSAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "145022",
    "city": "PATHANKOT COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "145023",
    "city": "PATHANKOT COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "145024",
    "city": "PATHANKOT COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "145025",
    "city": "PATHANKOT COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "145026",
    "city": "PATHANKOT COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "145027",
    "city": "PATHANKOT COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "145029",
    "city": "PATHANKOT COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "145101",
    "city": "PATHANKOT COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "146001",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "146021",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "146022",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "146023",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "146024",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "146101",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "146102",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "146103",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "146104",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "146106",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "146107",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "146108",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "146109",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "146110",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "146111",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "146112",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "146113",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "146114",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "146115",
    "city": "HOSHIARPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "146116",
    "city": "DASUYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147001",
    "city": "PATIALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147002",
    "city": "PATIALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147003",
    "city": "PATIALA EXPANSION RSP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147004",
    "city": "PATIALA EXPANSION RSP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147005",
    "city": "PATIALA EXPANSION RSP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147006",
    "city": "PATIALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147007",
    "city": "PATIALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147021",
    "city": "PATIALA EXPANSION RSP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147023",
    "city": "PATIALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147056",
    "city": "PATIALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147101",
    "city": "SAMANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147102",
    "city": "SANGRUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147103",
    "city": "PATIALA EXPANSION RSP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147104",
    "city": "PATIALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147105",
    "city": "PATRAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147111",
    "city": "PATIALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147201",
    "city": "NABHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147202",
    "city": "MANDI GOBINDGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147203",
    "city": "MANDI GOBINDGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147204",
    "city": "PATIALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147208",
    "city": "PATIALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "147301",
    "city": "MANDI GOBINDGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148001",
    "city": "SANGRUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148002",
    "city": "SANGRUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148004",
    "city": "BHATINDA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148005",
    "city": "BHATINDA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148007",
    "city": "BHATINDA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148008",
    "city": "BHATINDA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148009",
    "city": "BHATINDA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148017",
    "city": "SANGRUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148018",
    "city": "PATIALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148019",
    "city": "MALERKOTLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148020",
    "city": "MALERKOTLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148021",
    "city": "MALERKOTLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148022",
    "city": "MALERKOTLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148023",
    "city": "MALERKOTLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148024",
    "city": "DHURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148025",
    "city": "BARNALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148026",
    "city": "SANGRUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148027",
    "city": "RATIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148028",
    "city": "SUNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148029",
    "city": "SANGRUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148030",
    "city": "PATIALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148031",
    "city": "LEHRAGAGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148033",
    "city": "JAKHAL MANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148034",
    "city": "SANGRUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148035",
    "city": "SANGRUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148044",
    "city": "BHATINDA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148049",
    "city": "BHATINDA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148100",
    "city": "BARNALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148101",
    "city": "BARNALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148102",
    "city": "BARNALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148103",
    "city": "BARNALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148104",
    "city": "BARNALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148105",
    "city": "BARNALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148106",
    "city": "SANGRUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148107",
    "city": "BARNALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148108",
    "city": "RAMPURA PHULL EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148109",
    "city": "RAMPURA PHULL EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "148117",
    "city": "BHATINDA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151001",
    "city": "BHATINDA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151002",
    "city": "BHATINDA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151003",
    "city": "BHATINDA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151004",
    "city": "BHATINDA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151005",
    "city": "BHATINDA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151101",
    "city": "BHUCHO MANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151102",
    "city": "BHUCHO MANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151103",
    "city": "RAMPURA PHULL EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151104",
    "city": "RAMPURA PHULL EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151105",
    "city": "RAMPURA PHULL EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151106",
    "city": "RAMPURA PHULL EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151107",
    "city": "PATIALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151108",
    "city": "RAMPURA PHULL EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151111",
    "city": "RAMPURA PHULL EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151201",
    "city": "GONIANA MANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151202",
    "city": "KOTKAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151203",
    "city": "FARIDKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151204",
    "city": "KOTKAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151205",
    "city": "KOTKAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151206",
    "city": "KOTKAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151207",
    "city": "KOTKAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151209",
    "city": "KOTKAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151210",
    "city": "MALOUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151211",
    "city": "MANDI DABWALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151212",
    "city": "FARIDKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151213",
    "city": "FARIDKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151301",
    "city": "TALWANDI SABOO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151302",
    "city": "TALWANDI SABOO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151401",
    "city": "GONIANA MANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151501",
    "city": "MANSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151502",
    "city": "MANSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151503",
    "city": "MANSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151504",
    "city": "MANSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151505",
    "city": "MANSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151506",
    "city": "TALWANDI SABOO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151507",
    "city": "MANSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151508",
    "city": "MANSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151509",
    "city": "TALWANDI EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "151510",
    "city": "BARNALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152002",
    "city": "FIROZEPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152003",
    "city": "FEROZEPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152004",
    "city": "FEROZEPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152005",
    "city": "FEROZEPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152020",
    "city": "FAZILKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152021",
    "city": "ZIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152022",
    "city": "FEROZEPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152023",
    "city": "FEROZEPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152024",
    "city": "MUKTSAR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152025",
    "city": "MUKTSAR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152026",
    "city": "MUKTSAR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152028",
    "city": "ZIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152031",
    "city": "MUKTSAR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152032",
    "city": "MUKTSAR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152033",
    "city": "MUKTSAR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152101",
    "city": "MALOUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152107",
    "city": "MALOUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152112",
    "city": "MUKTSAR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152113",
    "city": "MALOUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152114",
    "city": "MALOUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152115",
    "city": "MANDI DABWALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152116",
    "city": "ABOHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152117",
    "city": "ABOHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152118",
    "city": "ABOHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152121",
    "city": "FAZILKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152122",
    "city": "ABOHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152123",
    "city": "FAZILKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152124",
    "city": "MUKTSAR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152128",
    "city": "ABOHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152132",
    "city": "ABOHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "152204",
    "city": "BHATINDA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160001",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160002",
    "city": "CHANDIGARH WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160003",
    "city": "CHANDIGARH WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160004",
    "city": "ZIRAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160005",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160006",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160007",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160008",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160009",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160010",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160011",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160012",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160013",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160014",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160015",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160016",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160017",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160018",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160019",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160020",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160021",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160022",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160023",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160024",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160025",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160026",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160027",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160028",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160029",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160030",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160031",
    "city": "CHANDIGARH WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160032",
    "city": "CHANDIGARH NEW EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160033",
    "city": "CHANDIGARH NEW EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160034",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160035",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160036",
    "city": "CHANDIGARH NEW EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160037",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160038",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160039",
    "city": "CHANDIGARH WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160040",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160041",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160042",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160043",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160044",
    "city": "CHANDIGARH NEW EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160045",
    "city": "CHANDIGARH NEW EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160046",
    "city": "CHANDIGARH NEW EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160047",
    "city": "CHANDIGARH NEW EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160048",
    "city": "CHANDIGARH NEW EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160049",
    "city": "CHANDIGARH NEW EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160051",
    "city": "CHANDIGARH NEW EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160052",
    "city": "MOHALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160053",
    "city": "MOHALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160054",
    "city": "MOHALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160055",
    "city": "MOHALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160056",
    "city": "MOHALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160057",
    "city": "MOHALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160058",
    "city": "MOHALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160059",
    "city": "MOHALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160061",
    "city": "MOHALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160062",
    "city": "MOHALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160071",
    "city": "MOHALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160101",
    "city": "CHANDIGARH WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160102",
    "city": "CHANDIGARH WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160103",
    "city": "MADHYA MARG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160104",
    "city": "ZIRAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160106",
    "city": "CHANDIGARH WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "160107",
    "city": "CHANDIGARH WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171001",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171002",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171003",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171004",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171005",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171006",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171008",
    "city": "SHIMLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171009",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171010",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171011",
    "city": "TOTU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171013",
    "city": "SHIMLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171014",
    "city": "SHIMLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171015",
    "city": "SHIMLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171018",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171019",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171102",
    "city": "ARKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171103",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171201",
    "city": "THEOG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171202",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171203",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171204",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171205",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171206",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171207",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171208",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171209",
    "city": "THEOG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171210",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171211",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171212",
    "city": "THEOG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171213",
    "city": "KUMARSAIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171214",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171215",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171216",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171217",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171220",
    "city": "THEOG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171221",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171222",
    "city": "THEOG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171223",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171224",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171225",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171226",
    "city": "THEOG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171302",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171303",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171304",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171305",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "171306",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172001",
    "city": "RAMPUR BUSHAHR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172002",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172021",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172022",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172023",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172024",
    "city": "KUMARSAIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172025",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172026",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172027",
    "city": "KUMARSAIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172028",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172029",
    "city": "KUMARSAIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172030",
    "city": "KUMARSAIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172031",
    "city": "KUMARSAIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172032",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172033",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172034",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172101",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172102",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172103",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172104",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172105",
    "city": "RECKONG PEO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172106",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172107",
    "city": "RECKONG PEO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172108",
    "city": "RECKONG PEO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172109",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172110",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172111",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172112",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172113",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172114",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172115",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172116",
    "city": "RECKONG PEO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172117",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172201",
    "city": "RAMPUR BUSHAHR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "172212",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173001",
    "city": "NARAINGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173020",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173021",
    "city": "PAONTA SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173022",
    "city": "PAONTA SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173023",
    "city": "PAONTA SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173024",
    "city": "PAONTA SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173025",
    "city": "PAONTA SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173026",
    "city": "NARAINGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173028",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173029",
    "city": "PAONTA SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173030",
    "city": "NARAINGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173031",
    "city": "PAONTA SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173032",
    "city": "PAONTA SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173101",
    "city": "SOLAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173104",
    "city": "PAONTA SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173201",
    "city": "DHARAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173202",
    "city": "DHARAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173203",
    "city": "SOLAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173204",
    "city": "DHARAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173205",
    "city": "BADDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173206",
    "city": "DHARAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173207",
    "city": "ARKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173208",
    "city": "ARKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173209",
    "city": "DHARAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173210",
    "city": "DHARAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173211",
    "city": "BAROG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173212",
    "city": "SOLAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173213",
    "city": "SOLAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173214",
    "city": "SOLAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173215",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173216",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173217",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173218",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173219",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173220",
    "city": "PARWANOO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173221",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173222",
    "city": "ARKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173223",
    "city": "SOLAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173224",
    "city": "SOLAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173225",
    "city": "PARWANOO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173227",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173228",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173229",
    "city": "DHARAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173230",
    "city": "SOLAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173233",
    "city": "SOLAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "173235",
    "city": "ARKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174001",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174002",
    "city": "ANANDPUR SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174003",
    "city": "GHUMARWIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174004",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174005",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174011",
    "city": "ANANDPUR SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174012",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174013",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174015",
    "city": "ANANDPUR SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174017",
    "city": "GHUMARWIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174021",
    "city": "GHUMARWIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174023",
    "city": "GHUMARWIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174024",
    "city": "GHUMARWIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174026",
    "city": "GHUMARWIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174027",
    "city": "GHUMARWIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174028",
    "city": "GHUMARWIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174029",
    "city": "GHUMARWIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174030",
    "city": "GHUMARWIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174031",
    "city": "GHUMARWIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174032",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174033",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174034",
    "city": "GHUMARWIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174035",
    "city": "GHUMARWIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174036",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174101",
    "city": "NALAGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174102",
    "city": "BADDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174103",
    "city": "BADDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174201",
    "city": "ANANDPUR SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174301",
    "city": "TAHLIWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174302",
    "city": "AMB OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174303",
    "city": "TAHLIWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174304",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174305",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174306",
    "city": "TAHLIWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174307",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174308",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174309",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174310",
    "city": "ANANDPUR SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174311",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174312",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174314",
    "city": "AMB OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174315",
    "city": "TAHLIWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174316",
    "city": "AMB OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174317",
    "city": "TAHLIWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174319",
    "city": "AMB OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174320",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174321",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174401",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174402",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174403",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174405",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174503",
    "city": "TAHLIWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174505",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "174507",
    "city": "TAHLIWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175001",
    "city": "MANDI NER CHOWK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175002",
    "city": "MANDI NER CHOWK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175003",
    "city": "MANDI NER CHOWK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175004",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175005",
    "city": "MANDI NER CHOWK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175006",
    "city": "MANDI NER CHOWK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175007",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175008",
    "city": "MANDI NER CHOWK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175009",
    "city": "KARSOG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175010",
    "city": "KARSOG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175011",
    "city": "KARSOG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175012",
    "city": "JOGINDER NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175013",
    "city": "JOGINDER NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175014",
    "city": "JOGINDER NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175015",
    "city": "JOGINDER NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175016",
    "city": "BAIJNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175017",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175018",
    "city": "MANDI NER CHOWK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175019",
    "city": "MANDI NER CHOWK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175021",
    "city": "MANDI NER CHOWK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175023",
    "city": "MANDI NER CHOWK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175024",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175025",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175026",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175027",
    "city": "MANDI NER CHOWK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175028",
    "city": "MANDI NER CHOWK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175029",
    "city": "MANDI NER CHOWK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175030",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175031",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175032",
    "city": "BIR BILLING",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175033",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175034",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175035",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175036",
    "city": "MANDI NER CHOWK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175037",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175038",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175039",
    "city": "MANDI NER CHOWK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175040",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175042",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175045",
    "city": "MANDI NER CHOWK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175046",
    "city": "KARSOG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175047",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175048",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175049",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175050",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175051",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175052",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175101",
    "city": "KULLU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175102",
    "city": "KULLU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175103",
    "city": "MANALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175104",
    "city": "MANALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175105",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175106",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175121",
    "city": "KULLU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175122",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175123",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175124",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175125",
    "city": "KULLU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175126",
    "city": "KULLU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175128",
    "city": "KULLU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175129",
    "city": "MANALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175130",
    "city": "MANALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175131",
    "city": "MANALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175132",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175133",
    "city": "SHIMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175134",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175136",
    "city": "MANALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175138",
    "city": "KULLU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175139",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175140",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175141",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175142",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "175143",
    "city": "MANALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176001",
    "city": "KANGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176002",
    "city": "KANGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176021",
    "city": "AMBALA WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176022",
    "city": "NURPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176023",
    "city": "NURPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176024",
    "city": "AMBALA WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176025",
    "city": "AMBALA WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176026",
    "city": "KANGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176027",
    "city": "AMBALA WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176028",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176029",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176030",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176031",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176032",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176033",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176036",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176037",
    "city": "KANGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176038",
    "city": "KANGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176039",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176040",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176041",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176042",
    "city": "GHUMARWIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176043",
    "city": "GHUMARWIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176044",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176045",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176047",
    "city": "KANGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176048",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176049",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176051",
    "city": "NURPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176052",
    "city": "KANGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176053",
    "city": "NURPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176054",
    "city": "KANGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176055",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176056",
    "city": "KANGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176057",
    "city": "KANGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176058",
    "city": "AMBALA WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176059",
    "city": "MARANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176060",
    "city": "MARANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176061",
    "city": "PALAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176062",
    "city": "PALAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176063",
    "city": "MARANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176064",
    "city": "MARANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176065",
    "city": "MARANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176066",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176071",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176072",
    "city": "MARANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176073",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176075",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176076",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176077",
    "city": "BIR BILLING",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176081",
    "city": "BAIJNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176082",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176083",
    "city": "MARANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176084",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176085",
    "city": "MARANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176086",
    "city": "MARANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176087",
    "city": "MARANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176088",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176089",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176090",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176091",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176092",
    "city": "MARANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176093",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176094",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176095",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176096",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176097",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176098",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176101",
    "city": "MARANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176102",
    "city": "MARANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176103",
    "city": "MARANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176107",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176108",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176109",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176110",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176111",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176115",
    "city": "BAIJNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176120",
    "city": "AMBALA WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176121",
    "city": "AMBALA WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176122",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176123",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176125",
    "city": "BAIJNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176126",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176127",
    "city": "AMBALA WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176128",
    "city": "BAIJNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176200",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176201",
    "city": "NURPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176202",
    "city": "NURPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176203",
    "city": "ITO SERV CENTRE-JALANDHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176204",
    "city": "AMBALA WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176205",
    "city": "KANGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176206",
    "city": "KANGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176207",
    "city": "DALHOUSIE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176208",
    "city": "KANGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176209",
    "city": "KANGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176210",
    "city": "AMBALA WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176211",
    "city": "AMBALA WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176213",
    "city": "KANGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176214",
    "city": "KANGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176215",
    "city": "DHARAMSHALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176217",
    "city": "KANGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176220",
    "city": "ITO SERV CENTRE-JALANDHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176222",
    "city": "AMBALA WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176223",
    "city": "AMBALA WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176225",
    "city": "AMBALA WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176226",
    "city": "AMBALA WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176301",
    "city": "DALHOUSIE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176302",
    "city": "DALHOUSIE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176303",
    "city": "DALHOUSIE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176304",
    "city": "DALHOUSIE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176305",
    "city": "DALHOUSIE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176306",
    "city": "DALHOUSIE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176308",
    "city": "CHAMBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176309",
    "city": "CHAMBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176310",
    "city": "CHAMBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176311",
    "city": "CHAMBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176312",
    "city": "CHAMBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176313",
    "city": "DALHOUSIE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176314",
    "city": "CHAMBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176315",
    "city": "CHAMBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176316",
    "city": "CHAMBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176317",
    "city": "CHAMBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176318",
    "city": "CHAMBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176319",
    "city": "CHAMBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176320",
    "city": "CHAMBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176321",
    "city": "CHAMBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176322",
    "city": "ITO SERV CENTRE-JALANDHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176323",
    "city": "CHAMBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176324",
    "city": "CHAMBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176325",
    "city": "DALHOUSIE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176326",
    "city": "CHAMBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176401",
    "city": "ITO SERV CENTRE-JALANDHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176402",
    "city": "ITO SERV CENTRE-JALANDHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176403",
    "city": "PATHANKOT COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176404",
    "city": "AMBALA WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176501",
    "city": "AMBALA WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176502",
    "city": "AMBALA WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "176601",
    "city": "TAHLIWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177001",
    "city": "HAMIRPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177005",
    "city": "HAMIRPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177006",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177007",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177020",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177021",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177022",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177023",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177024",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177025",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177026",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177027",
    "city": "HAMIRPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177028",
    "city": "JAISINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177029",
    "city": "HAMIRPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177030",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177031",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177032",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177033",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177034",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177038",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177039",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177040",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177041",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177042",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177043",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177044",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177045",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177046",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177048",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177101",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177103",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177104",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177105",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177106",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177107",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177108",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177109",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177110",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177111",
    "city": "AMBALA WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177112",
    "city": "AMBALA WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177113",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177114",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177116",
    "city": "AMBALA WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177117",
    "city": "DEHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177118",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177119",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177201",
    "city": "AMB OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177202",
    "city": "AMB OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177203",
    "city": "AMB OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177204",
    "city": "AMB OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177205",
    "city": "AMB OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177206",
    "city": "AMB OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177207",
    "city": "TAHLIWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177208",
    "city": "AMB OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177209",
    "city": "TAHLIWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177210",
    "city": "AMB OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177211",
    "city": "AMB OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177212",
    "city": "AMB OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177213",
    "city": "AMB OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177214",
    "city": "CHANDIGARH WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177215",
    "city": "CHANDIGARH WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177218",
    "city": "CHANDIGARH WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177219",
    "city": "AMB OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177220",
    "city": "TAHLIWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177301",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177401",
    "city": "MEHRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177501",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "177601",
    "city": "SARKAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "180001",
    "city": "JAMMU OUTER AREA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "180002",
    "city": "JAMMU OUTER AREA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "180003",
    "city": "MIRAN SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "180004",
    "city": "JAMMU ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "180005",
    "city": "JAMMU OUTER AREA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "180006",
    "city": "JAMMU ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "180007",
    "city": "JAMMU OUTER AREA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "180010",
    "city": "JAMMU ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "180011",
    "city": "JAMMU ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "180012",
    "city": "JAMMU ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "180013",
    "city": "JAMMU OUTER AREA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "180015",
    "city": "JAMMU ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "180016",
    "city": "JAMMU OUTER AREA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "180017",
    "city": "NAGROTAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "180018",
    "city": "JAMMU OUTER AREA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "180019",
    "city": "NAGROTAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "180020",
    "city": "JAMMU ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "181101",
    "city": "MIRAN SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "181102",
    "city": "MIRAN SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "181111",
    "city": "MIRAN SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "181121",
    "city": "JAMMU OUTER AREA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "181122",
    "city": "AKHNOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "181124",
    "city": "JAMMU OUTER AREA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "181132",
    "city": "MIRAN SAHIB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "181133",
    "city": "VIJAYPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "181143",
    "city": "VIJAYPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "181145",
    "city": "VIJAYPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "181152",
    "city": "JAMMU ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "181201",
    "city": "AKHNOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "181202",
    "city": "AKHNOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "181205",
    "city": "JAMMU OUTER AREA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "181221",
    "city": "NAGROTAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "182101",
    "city": "UDHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "182104",
    "city": "UDHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "182121",
    "city": "UDHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "182122",
    "city": "UDHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "182301",
    "city": "KATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "182311",
    "city": "KATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "182320",
    "city": "KATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "184101",
    "city": "KATHUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "184102",
    "city": "KATHUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "184120",
    "city": "VIJAYPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "184121",
    "city": "SAMBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "184142",
    "city": "SAMBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201001",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201002",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201003",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201004",
    "city": "GHAZIABAD GT ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201005",
    "city": "GHAZIABAD GT ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201006",
    "city": "GHAZIABAD GT ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201007",
    "city": "GHAZIABAD GT ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201009",
    "city": "CROSSING REPUBLIC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201010",
    "city": "INDIRAPURAM SERVICECENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201011",
    "city": "GHAZIABAD GT ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201012",
    "city": "INDIRAPURAM SERVICECENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201013",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201014",
    "city": "INDIRAPURAM SERVICECENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201015",
    "city": "CROSSING REPUBLIC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201016",
    "city": "CROSSING REPUBLIC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201017",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201018",
    "city": "INDIRAPURAM SERVICECENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201019",
    "city": "INDIRAPURAM SERVICECENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201020",
    "city": "INDIRAPURAM SERVICECENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201102",
    "city": "GHAZIABAD GT RD EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201103",
    "city": "GHAZIABAD GT RD EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201201",
    "city": "MODINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201204",
    "city": "MODINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201206",
    "city": "MODINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201300",
    "city": "ICA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201301",
    "city": "NOIDA SECTOR 16",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201302",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201303",
    "city": "NOIDA SECTOR 16",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201304",
    "city": "GREATER NOIDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201305",
    "city": "GREATER NOIDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201306",
    "city": "GAUR CITY OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201307",
    "city": "NOIDA SECTOR 63",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201308",
    "city": "GREATER NOIDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201309",
    "city": "NOIDA KHODA CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201310",
    "city": "GREATER NOIDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201311",
    "city": "GREATER NOIDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201312",
    "city": "GREATER NOIDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201313",
    "city": "GREATER NOIDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201314",
    "city": "DADRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201316",
    "city": "NOIDA SECTOR 63",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201317",
    "city": "ZEWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "201318",
    "city": "GAUR CITY OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202001",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202002",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202120",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202121",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202122",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202123",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202124",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202125",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202126",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202127",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202128",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202129",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202130",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202131",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202132",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202133",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202134",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202135",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202136",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202137",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202138",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202139",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202140",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202141",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202142",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202143",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202144",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202145",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202146",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202150",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202155",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202170",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202280",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202281",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202282",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202389",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202390",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202391",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202392",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202393",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202394",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202395",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202396",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202397",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202398",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202399",
    "city": "NOIDA SECTOR 63",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202410",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202411",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202412",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202413",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202414",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202415",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202417",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202421",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202440",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202520",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202521",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202522",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202523",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202524",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202525",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202526",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "202527",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203001",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203002",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203129",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203131",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203132",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203135",
    "city": "ZEWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203141",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203150",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203155",
    "city": "GREATER NOIDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203201",
    "city": "ZEWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203202",
    "city": "ZEWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203203",
    "city": "ZEWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203205",
    "city": "SIKANDRABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203206",
    "city": "SIKANDRABAD EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203207",
    "city": "DADRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203208",
    "city": "NOIDA SECTOR 63",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203209",
    "city": "ZEWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203389",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203390",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203391",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203392",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203393",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203394",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203395",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203396",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203397",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203398",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203399",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203401",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203402",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203403",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203405",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203407",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203408",
    "city": "HAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203409",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203411",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "203412",
    "city": "BULANDSHAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "204101",
    "city": "HATHRAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "204102",
    "city": "HATHRAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "204105",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "204106",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "204205",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "204207",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "204210",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "204211",
    "city": "HATHRAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "204212",
    "city": "HATHRAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "204213",
    "city": "HATHRAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "204214",
    "city": "HATHRAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "204215",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "204216",
    "city": "HATHRAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205001",
    "city": "MAINPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205119",
    "city": "MAINPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205121",
    "city": "MAINPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205130",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205135",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205141",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205142",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205145",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205147",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205151",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205152",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205247",
    "city": "MAINPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205261",
    "city": "MAINPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205262",
    "city": "MAINPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205263",
    "city": "MAINPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205264",
    "city": "MAINPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205265",
    "city": "MAINPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205267",
    "city": "MAINPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205268",
    "city": "MAINPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205301",
    "city": "MAINPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205302",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205303",
    "city": "MAINPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "205304",
    "city": "MAINPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206001",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206002",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206003",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206120",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206121",
    "city": "AURAIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206122",
    "city": "AURAIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206123",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206124",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206125",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206126",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206127",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206128",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206129",
    "city": "AURAIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206130",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206131",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206241",
    "city": "AURAIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206242",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206243",
    "city": "AURAIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206244",
    "city": "AURAIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206245",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206246",
    "city": "AURAIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206247",
    "city": "AURAIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206248",
    "city": "AURAIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206249",
    "city": "AURAIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206250",
    "city": "AURAIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206251",
    "city": "AURAIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206252",
    "city": "AURAIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206253",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206255",
    "city": "AURAIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206301",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206302",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206303",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "206451",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207001",
    "city": "ETAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207002",
    "city": "ETAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207003",
    "city": "ETAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207013",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207120",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207121",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207122",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207123",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207124",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207125",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207126",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207241",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207242",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207243",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207244",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207245",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207246",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207247",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207248",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207249",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207250",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207301",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207302",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207401",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207402",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207403",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207501",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207502",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207503",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207504",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "207505",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208001",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208002",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208003",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208004",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208005",
    "city": "SWAROOP NAGAR COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208006",
    "city": "DAMODAR NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208007",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208008",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208009",
    "city": "KANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208010",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208011",
    "city": "DAMODAR NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208012",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208013",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208014",
    "city": "DAMODAR NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208015",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208016",
    "city": "SWAROOP NAGAR COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208017",
    "city": "SWAROOP NAGAR COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208018",
    "city": "SWAROOP NAGAR COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208019",
    "city": "SWAROOP NAGAR COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208020",
    "city": "KANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208021",
    "city": "DAMODAR NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208022",
    "city": "KANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208023",
    "city": "DAMODAR NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208024",
    "city": "SWAROOP NAGAR COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208025",
    "city": "SWAROOP NAGAR COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208026",
    "city": "SWAROOP NAGAR COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "208027",
    "city": "KANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209101",
    "city": "AKBARPUR KANPUR DEHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209111",
    "city": "AKBARPUR KANPUR DEHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209112",
    "city": "AKBARPUR KANPUR DEHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209115",
    "city": "AKBARPUR KANPUR DEHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209121",
    "city": "AKBARPUR KANPUR DEHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209125",
    "city": "AKBARPUR KANPUR DEHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209201",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209202",
    "city": "KANNUAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209203",
    "city": "CHAUBEPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209204",
    "city": "KANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209205",
    "city": "CHAUBEPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209206",
    "city": "HAMIRPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209208",
    "city": "CHAUBEPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209209",
    "city": "KANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209210",
    "city": "CHAUBEPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209214",
    "city": "KANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209217",
    "city": "CHAUBEPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209293",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209301",
    "city": "KANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209302",
    "city": "AKBARPUR KANPUR DEHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209303",
    "city": "AKBARPUR KANPUR DEHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209304",
    "city": "CHAUBEPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209305",
    "city": "KANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209306",
    "city": "KANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209307",
    "city": "AKBARPUR KANPUR DEHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209308",
    "city": "AKBARPUR KANPUR DEHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209310",
    "city": "AKBARPUR KANPUR DEHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209311",
    "city": "AKBARPUR KANPUR DEHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209312",
    "city": "AKBARPUR KANPUR DEHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209344",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209401",
    "city": "KANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209402",
    "city": "KANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209407",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209501",
    "city": "FARRUKHABAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209502",
    "city": "FARRUKHABAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209503",
    "city": "FARRUKHABAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209504",
    "city": "FARRUKHABAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209505",
    "city": "FARRUKHABAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209506",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209601",
    "city": "FARRUKHABAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209602",
    "city": "FARRUKHABAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209621",
    "city": "FARRUKHABAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209622",
    "city": "FARRUKHABAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209625",
    "city": "FARRUKHABAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209651",
    "city": "FARRUKHABAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209652",
    "city": "FARRUKHABAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209715",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209720",
    "city": "KANNUAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209721",
    "city": "KANNUAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209722",
    "city": "KANNUAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209723",
    "city": "KANNUAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209724",
    "city": "FARRUKHABAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209725",
    "city": "KANNAUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209726",
    "city": "KANNAUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209727",
    "city": "KANNAUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209728",
    "city": "KANNUAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209729",
    "city": "KANNUAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209731",
    "city": "KANNUAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209732",
    "city": "KANNUAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209733",
    "city": "KANNUAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209734",
    "city": "KANNUAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209735",
    "city": "KANNUAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209736",
    "city": "KANNUAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209738",
    "city": "KANNUAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209739",
    "city": "FARRUKHABAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209743",
    "city": "FARRUKHABAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209745",
    "city": "FARRUKHABAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209746",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209747",
    "city": "KANNUAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209748",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209749",
    "city": "FARRUKHABAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209801",
    "city": "UNNAO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209808",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209820",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209821",
    "city": "UNNAO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209825",
    "city": "UNNAO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209827",
    "city": "UNNAO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209831",
    "city": "UNNAO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209841",
    "city": "UNNAO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209851",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209859",
    "city": "UNNAO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209860",
    "city": "UNNAO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209861",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209862",
    "city": "UNNAO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209863",
    "city": "UNNAO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209864",
    "city": "UNNAO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209865",
    "city": "UNNAO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209866",
    "city": "UNNAO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209867",
    "city": "UNNAO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209868",
    "city": "UNNAO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209869",
    "city": "UNNAO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209870",
    "city": "UNNAO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209871",
    "city": "UNNAO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "209881",
    "city": "UNNAO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210001",
    "city": "BANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210010",
    "city": "PRAYAGRAJ EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210120",
    "city": "BANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210121",
    "city": "BANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210123",
    "city": "BANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210125",
    "city": "BANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210126",
    "city": "BANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210128",
    "city": "BANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210129",
    "city": "CHITRAKOOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210201",
    "city": "CHITRAKOOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210202",
    "city": "BANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210203",
    "city": "BANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210204",
    "city": "CHITRAKOOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210205",
    "city": "CHITRAKOOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210206",
    "city": "CHITRAKOOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210207",
    "city": "CHITRAKOOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210208",
    "city": "CHITRAKOOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210209",
    "city": "CHITRAKOOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210301",
    "city": "HAMIRPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210341",
    "city": "HAMIRPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210421",
    "city": "MAHOBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210422",
    "city": "HAMIRPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210423",
    "city": "MAHOBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210424",
    "city": "MAHOBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210425",
    "city": "MAHOBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210426",
    "city": "MAHOBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210427",
    "city": "MAHOBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210428",
    "city": "MAHOBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210429",
    "city": "MAHOBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210430",
    "city": "MAHOBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210431",
    "city": "MAHOBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210432",
    "city": "HAMIRPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210433",
    "city": "MAHOBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210501",
    "city": "HAMIRPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210502",
    "city": "HAMIRPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210504",
    "city": "HAMIRPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210505",
    "city": "HAMIRPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210506",
    "city": "HAMIRPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "210507",
    "city": "HAMIRPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "211001",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "211002",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "211003",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "211004",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "211005",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "211006",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "211007",
    "city": "NAINI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "211008",
    "city": "NAINI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "211009",
    "city": "NAINI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "211010",
    "city": "NAINI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "211011",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "211012",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "211014",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "211015",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "211016",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "211017",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "211018",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "211019",
    "city": "JHUNSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "211021",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "211022",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212104",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212105",
    "city": "PRAYAGRAJ EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212106",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212107",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212108",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212109",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212111",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212128",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212204",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212208",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212212",
    "city": "PRAYAGRAJ EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212218",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212301",
    "city": "NAINI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212302",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212303",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212305",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212306",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212307",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212308",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212401",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212402",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212404",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212405",
    "city": "PRAYAGRAJ EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212502",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212503",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212507",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212601",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212620",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212621",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212622",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212623",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212631",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212635",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212641",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212645",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212650",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212651",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212652",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212653",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212654",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212655",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212656",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212657",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212658",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212659",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212660",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212661",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212662",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212663",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212664",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212665",
    "city": "FATEHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "212666",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "215126",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "216221",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "218580",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "218581",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221001",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221002",
    "city": "SARNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221003",
    "city": "SARNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221004",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221005",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221006",
    "city": "SARNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221007",
    "city": "SARNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221008",
    "city": "MUGHALSARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221009",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221010",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221011",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221012",
    "city": "SARNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221101",
    "city": "SARNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221102",
    "city": "MUGHALSARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221103",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221104",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221105",
    "city": "SARNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221106",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221107",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221108",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221109",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221110",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221112",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221115",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221116",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221131",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221201",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221202",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221204",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221206",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221207",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221208",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221209",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221210",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221301",
    "city": "BHADOHI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221302",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221303",
    "city": "BHADOHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221304",
    "city": "BHADOHI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221305",
    "city": "MIRZAPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221306",
    "city": "BHADOHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221307",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221308",
    "city": "BHADOHI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221309",
    "city": "BHADOHI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221310",
    "city": "BHADOHI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221311",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221312",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221313",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221314",
    "city": "BHADOHI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221401",
    "city": "BHADOHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221402",
    "city": "BHADOHI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221403",
    "city": "BHADOHI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221404",
    "city": "BHADOHI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221405",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221406",
    "city": "BHADOHI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221407",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221408",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221409",
    "city": "BHADOHI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221501",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221502",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221506",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221507",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221508",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221601",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221602",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221603",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221701",
    "city": "BALLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221705",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221706",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221711",
    "city": "BALLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221712",
    "city": "BALLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221713",
    "city": "BALLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221714",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221715",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221716",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221717",
    "city": "BALLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221718",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221719",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221721",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "221722",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222001",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222002",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222003",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222101",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222102",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222103",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222104",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222105",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222107",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222108",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222109",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222110",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222111",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222112",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222113",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222125",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222127",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222128",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222129",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222131",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222132",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222133",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222135",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222136",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222137",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222138",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222139",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222141",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222142",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222143",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222144",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222145",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222146",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222148",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222149",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222161",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222162",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222165",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222170",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222172",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222175",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222180",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222181",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222201",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222202",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222203",
    "city": "BHADOHI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222204",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222226",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222301",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222302",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222303",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "222333",
    "city": "GURGAON CPC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "223101",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "223102",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "223103",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "223104",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "223105",
    "city": "JAUNPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "223106",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "223107",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "223221",
    "city": "AZAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "223222",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "223223",
    "city": "AZAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "223224",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "223225",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "223226",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "223227",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224001",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224116",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224117",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224118",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224119",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224120",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224121",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224122",
    "city": "TANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224123",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224126",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224127",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224129",
    "city": "TANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224133",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224135",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224141",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224143",
    "city": "TANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224145",
    "city": "TANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224147",
    "city": "TANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224149",
    "city": "TANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224153",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224155",
    "city": "TANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224158",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224161",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224164",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224166",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224167",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224175",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224181",
    "city": "TANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224182",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224188",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224190",
    "city": "TANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224198",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224201",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224204",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224206",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224207",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224208",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224209",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224212",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224213",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224215",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224216",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224217",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224220",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224221",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224222",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224223",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224225",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224229",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224234",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224238",
    "city": "TANDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "224284",
    "city": "FAIZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225001",
    "city": "BARABANKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225002",
    "city": "BARABANKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225003",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225119",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225120",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225121",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225122",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225123",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225124",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225125",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225126",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225201",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225202",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225203",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225204",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225205",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225206",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225207",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225208",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225301",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225302",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225303",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225304",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225305",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225306",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225401",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225402",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225403",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225404",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225405",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225406",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225407",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225408",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225409",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225411",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225412",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225413",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225414",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225415",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225416",
    "city": "BARABANKI E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "225701",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226001",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226002",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226003",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226004",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226005",
    "city": "TRANSPORT NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226006",
    "city": "LUCKNOW SITAPUR ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226007",
    "city": "LUCKNOW SITAPUR ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226008",
    "city": "TRANSPORT NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226009",
    "city": "TRANSPORT NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226010",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226011",
    "city": "TRANSPORT NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226012",
    "city": "TRANSPORT NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226013",
    "city": "LUCKNOW SITAPUR ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226014",
    "city": "TRANSPORT NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226015",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226016",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226017",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226018",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226019",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226020",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226021",
    "city": "LUCKNOW SITAPUR ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226022",
    "city": "LUCKNOW SITAPUR ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226023",
    "city": "TRANSPORT NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226024",
    "city": "LUCKNOW SITAPUR ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226025",
    "city": "TRANSPORT NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226026",
    "city": "LUCKNOW SITAPUR ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226027",
    "city": "LUCKNOW OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226028",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226029",
    "city": "TRANSPORT NAGAR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226030",
    "city": "LCK TRANS GOMTI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226031",
    "city": "LUCKNOW SITAPUR ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226101",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226102",
    "city": "LUCKNOW EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226103",
    "city": "LUCKNOW EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226104",
    "city": "LUCKNOW EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226201",
    "city": "LUCKNOW SITAPUR ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226202",
    "city": "LUCKNOW SITAPUR ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226203",
    "city": "LUCKNOW SITAPUR ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226301",
    "city": "TRANSPORT NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226302",
    "city": "LCT EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226303",
    "city": "LCT EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226401",
    "city": "TRANSPORT NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "226501",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227005",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227101",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227105",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227107",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227111",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227115",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227116",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227125",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227131",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227132",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227202",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227205",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227207",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227208",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227301",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227302",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227304",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227305",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227308",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227309",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227405",
    "city": "AMETHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227406",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227408",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227412",
    "city": "AMETHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227802",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227805",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227806",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227807",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227808",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227812",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227813",
    "city": "AMETHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227814",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227815",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "227816",
    "city": "AMETHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "228001",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "228118",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "228119",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "228120",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "228121",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "228124",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "228125",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "228131",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "228132",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "228133",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "228141",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "228142",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "228145",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "228151",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "228155",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "228159",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "228161",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "228171",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "228178",
    "city": "SULTANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "228411",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "228820",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229001",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229010",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229103",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229120",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229121",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229122",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229123",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229124",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229125",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229126",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229127",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229128",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229129",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229130",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229135",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229201",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229202",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229203",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229204",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229205",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229206",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229207",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229208",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229209",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229210",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229211",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229212",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229215",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229216",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229301",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229302",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229303",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229304",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229305",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229306",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229307",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229308",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229309",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229310",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229311",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229315",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229316",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229401",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229402",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229403",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229404",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229405",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229406",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229407",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229408",
    "city": "PRATAPGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229410",
    "city": "PRATAPGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229411",
    "city": "PRAYAGRAJ EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229412",
    "city": "PRAYAGRAJ EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229413",
    "city": "PRAYAGRAJ EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229415",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229416",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229417",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229418",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229419",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229502",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229503",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229504",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229801",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229802",
    "city": "RAEBARELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229841",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "229881",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230001",
    "city": "PRATAPGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230002",
    "city": "PRATAPGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230121",
    "city": "PRATAPGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230122",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230123",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230124",
    "city": "PRATAPGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230125",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230126",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230131",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230133",
    "city": "PRATAPGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230134",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230138",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230139",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230140",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230141",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230143",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230145",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230146",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230201",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230202",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230204",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230305",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230306",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230404",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "230406",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231001",
    "city": "MIRZAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231002",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231205",
    "city": "ROBERTGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231206",
    "city": "ROBERTGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231207",
    "city": "ROBERTGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231208",
    "city": "RENUKOOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231209",
    "city": "ROBERTGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231210",
    "city": "ROBERTGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231211",
    "city": "MIRZAPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231212",
    "city": "RENUKOOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231213",
    "city": "ROBERTGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231214",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231215",
    "city": "ROBERTGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231216",
    "city": "ROBERTGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231217",
    "city": "RENUKOOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231218",
    "city": "RENUKOOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231219",
    "city": "RENUKOOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231220",
    "city": "RENUKOOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231221",
    "city": "RENUKOOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231222",
    "city": "RENUKOOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231223",
    "city": "RENUKOOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231224",
    "city": "RENUKOOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231225",
    "city": "RENUKOOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231226",
    "city": "ROBERTGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231301",
    "city": "ROBERTGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231302",
    "city": "MIRZAPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231303",
    "city": "MIRZAPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231304",
    "city": "MIRZAPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231305",
    "city": "MUGHALSARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231306",
    "city": "MIRZAPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231307",
    "city": "MIRZAPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231309",
    "city": "MIRZAPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231310",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231311",
    "city": "MIRZAPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231312",
    "city": "BHADOHI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231313",
    "city": "MIRZAPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231314",
    "city": "MIRZAPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "231501",
    "city": "BHADOHI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232101",
    "city": "MUGHALSARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232102",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232103",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232104",
    "city": "MUGHALSARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232105",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232106",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232107",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232108",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232109",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232110",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232111",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232116",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232117",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232118",
    "city": "VRS APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232120",
    "city": "MUGHALSARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232221",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232325",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232326",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232327",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232328",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232330",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232331",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232332",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232333",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232336",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232338",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "232339",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233001",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233002",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233221",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233222",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233223",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233224",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233225",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233226",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233227",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233228",
    "city": "BALLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233229",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233230",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233231",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233232",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233233",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233234",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233235",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233236",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233300",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233301",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233302",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233303",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233304",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233305",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233306",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233307",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "233311",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241001",
    "city": "HARDOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241121",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241122",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241125",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241126",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241127",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241201",
    "city": "HARDOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241202",
    "city": "HARDOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241203",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241301",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241302",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241303",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241304",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241305",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241401",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241402",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241403",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241404",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241405",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241406",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241407",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241501",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241502",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241503",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "241504",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242001",
    "city": "SHAHJAHANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242021",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242042",
    "city": "SHAHJAHANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242103",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242123",
    "city": "SHAHJAHANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242127",
    "city": "SHAHJAHANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242220",
    "city": "SHAHJAHANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242221",
    "city": "SHAHJAHANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242223",
    "city": "SHAHJAHANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242226",
    "city": "SHAHJAHANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242301",
    "city": "SHAHJAHANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242302",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242303",
    "city": "SHAHJAHANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242305",
    "city": "SHAHJAHANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242306",
    "city": "SHAHJAHANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242307",
    "city": "SHAHJAHANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242308",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242309",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242310",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242311",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242401",
    "city": "SHAHJAHANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242405",
    "city": "SHAHJAHANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242406",
    "city": "SHAHJAHANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242407",
    "city": "SHAHJAHANPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242409",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242410",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242416",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242417",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242418",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242420",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "242421",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243001",
    "city": "BAREILLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243002",
    "city": "BAREILLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243003",
    "city": "BAREILLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243005",
    "city": "BAREILLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243006",
    "city": "BAREILLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243122",
    "city": "BAREILLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243201",
    "city": "KICHHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243215",
    "city": "BAREILLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243301",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243302",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243303",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243304",
    "city": "BAREILLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243401",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243402",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243403",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243406",
    "city": "BAREILLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243502",
    "city": "BAREILLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243601",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243621",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243630",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243631",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243632",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243633",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243634",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243635",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243636",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243637",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243638",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243639",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243640",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243641",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243701",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243702",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243720",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243722",
    "city": "SAMBHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243723",
    "city": "SAMBHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243724",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243725",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243726",
    "city": "BADAUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243727",
    "city": "SAMBHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "243751",
    "city": "ALIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244001",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244102",
    "city": "MORADABAD EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244103",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244104",
    "city": "MORADABAD EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244105",
    "city": "MORADABAD EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244221",
    "city": "AMROHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244222",
    "city": "MORADABAD EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244223",
    "city": "GAJRAULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244224",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244225",
    "city": "DHANAURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244226",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244227",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244231",
    "city": "DHANAURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244235",
    "city": "GAJRAULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244236",
    "city": "AMROHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244241",
    "city": "GAJRAULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244242",
    "city": "GAJRAULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244245",
    "city": "AMROHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244251",
    "city": "AMROHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244255",
    "city": "AMROHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244301",
    "city": "SAMBHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244302",
    "city": "SAMBHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244303",
    "city": "SAMBHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244304",
    "city": "SAMBHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244401",
    "city": "KASHIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244402",
    "city": "MORADABAD EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244410",
    "city": "SAMBHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244411",
    "city": "SAMBHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244412",
    "city": "CHANDAUSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244413",
    "city": "SAMBHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244414",
    "city": "SAMBHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244415",
    "city": "SAMBHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244501",
    "city": "MORADABAD EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244504",
    "city": "MORADABAD EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244601",
    "city": "KASHIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244602",
    "city": "KASHIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244701",
    "city": "RAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244711",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244712",
    "city": "KASHIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244713",
    "city": "KASHIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244714",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244715",
    "city": "RAM NAGAR -UTTARANCHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244717",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244718",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244901",
    "city": "RAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244921",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244922",
    "city": "RAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244923",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244924",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244925",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244926",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244927",
    "city": "RAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "244928",
    "city": "BILASPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "245101",
    "city": "HAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "245201",
    "city": "HAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "245205",
    "city": "MEERUT  EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "245206",
    "city": "HAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "245207",
    "city": "HAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "245208",
    "city": "MEERUT  EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "245301",
    "city": "HAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "245304",
    "city": "PILKHUWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "245401",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "245402",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "245403",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "245405",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "245407",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "245408",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "245409",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "245411",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "245412",
    "city": "GHAZIABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246001",
    "city": "PAURI GARHWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246113",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246121",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246122",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246123",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246124",
    "city": "KOTDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246125",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246127",
    "city": "KOTDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246128",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246129",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246130",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246131",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246132",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246135",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246141",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246142",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246144",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246146",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246147",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246148",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246149",
    "city": "KOTDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246155",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246159",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246161",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246162",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246163",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246164",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246165",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246166",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246167",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246168",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246169",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246170",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246171",
    "city": "RUDRAPRAYAG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246172",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246173",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246174",
    "city": "SRINAGAR GARHWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246175",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246176",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246177",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246185",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246186",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246188",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246189",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246191",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246192",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246193",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246194",
    "city": "PAURI GARHWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246275",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246276",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246277",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246278",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246279",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246280",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246281",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246285",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246419",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246421",
    "city": "RUDRAPRAYAG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246422",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246423",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246425",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246427",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246428",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246429",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246431",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246437",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246438",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246439",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246440",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246441",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246442",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246443",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246444",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246446",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246447",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246448",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246449",
    "city": "GOPESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246450",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246451",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246452",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246453",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246454",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246455",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246456",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246458",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246469",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246471",
    "city": "RUDRAPRAYAG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246473",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246474",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246475",
    "city": "RUDRAPRAYAG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246476",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246481",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246482",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246486",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246487",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246488",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246489",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246495",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246701",
    "city": "BIJNORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246721",
    "city": "BIJNORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246722",
    "city": "NAJIBABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246723",
    "city": "NAJIBABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246724",
    "city": "NAJIBABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246725",
    "city": "BIJNORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246726",
    "city": "BIJNORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246727",
    "city": "BIJNORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246728",
    "city": "BIJNORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246729",
    "city": "BIJNORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246731",
    "city": "BIJNORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246732",
    "city": "NAJIBABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246733",
    "city": "BIJNORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246734",
    "city": "BIJNORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246735",
    "city": "BIJNORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246736",
    "city": "BIJNORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246737",
    "city": "BIJNORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246738",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246745",
    "city": "BIJNORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246746",
    "city": "BIJNORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246747",
    "city": "NAJIBABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246749",
    "city": "NAJIBABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246761",
    "city": "BIJNORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246762",
    "city": "BIJNORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246763",
    "city": "NAJIBABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246764",
    "city": "BIJNORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246765",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "246768",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247001",
    "city": "SAHRANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247002",
    "city": "SAHRANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247122",
    "city": "SAHRANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247231",
    "city": "SAHRANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247232",
    "city": "SAHRANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247235",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247340",
    "city": "SAHRANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247341",
    "city": "SAHRANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247342",
    "city": "SAHRANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247343",
    "city": "SAHRANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247451",
    "city": "SAHRANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247452",
    "city": "SAHRANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247453",
    "city": "SAHRANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247551",
    "city": "DEOBAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247554",
    "city": "DEOBAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247656",
    "city": "ROORKEE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247661",
    "city": "ROORKEE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247663",
    "city": "HARIDWAR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247664",
    "city": "ROORKEE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247665",
    "city": "ROORKEE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247666",
    "city": "ROORKEE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247667",
    "city": "ROORKEE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247668",
    "city": "ROORKEE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247670",
    "city": "ROORKEE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247671",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247769",
    "city": "AMBALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247771",
    "city": "SHAMLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247772",
    "city": "SHAMLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247773",
    "city": "SHAMLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247774",
    "city": "SHAMLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247775",
    "city": "SHAMLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247776",
    "city": "SHAMLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247777",
    "city": "SHAMLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "247778",
    "city": "SHAMLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248001",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248002",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248003",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248005",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248006",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248007",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248008",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248009",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248010",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248011",
    "city": "SELAQUI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248012",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248013",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248014",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248015",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248016",
    "city": "DOIWALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248102",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248110",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248115",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248119",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248121",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248122",
    "city": "DEHRADUN EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248123",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248124",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248125",
    "city": "VIKAS NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248126",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248140",
    "city": "DOIWALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248141",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248142",
    "city": "VIKAS NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248143",
    "city": "DOIWALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248145",
    "city": "DOIWALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248146",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248148",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248152",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248159",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248160",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248161",
    "city": "DOIWALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248164",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248165",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248167",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248171",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248195",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248196",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248197",
    "city": "SELAQUI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248198",
    "city": "VIKAS NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248199",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248202",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248252",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "248258",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249103",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249106",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249121",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249122",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249123",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249126",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249130",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249131",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249132",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249134",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249135",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249137",
    "city": "RISHIKESH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249141",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249146",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249147",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249151",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249152",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249156",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249161",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249165",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249171",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249175",
    "city": "RISHIKESH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249180",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249181",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249185",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249186",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249191",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249192",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249193",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249194",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249195",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249196",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249199",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249201",
    "city": "RISHIKESH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249202",
    "city": "RISHIKESH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249203",
    "city": "RISHIKESH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249204",
    "city": "RISHIKESH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249205",
    "city": "RISHIKESH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249301",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249302",
    "city": "RISHIKESH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249304",
    "city": "DEHRADUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249306",
    "city": "HARIDWAR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249401",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249402",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249403",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249404",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249405",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249407",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249408",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249409",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249410",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "249411",
    "city": "HARIDWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250001",
    "city": "CIVIL LINE SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250002",
    "city": "CIVIL LINE SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250003",
    "city": "CIVIL LINE SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250004",
    "city": "CIVIL LINE SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250005",
    "city": "CIVIL LINE SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250101",
    "city": "BAGHPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250103",
    "city": "MEERUT  EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250104",
    "city": "MEERUT  EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250105",
    "city": "CIVIL LINE SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250106",
    "city": "MEERUT  EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250110",
    "city": "MODIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250205",
    "city": "MEERUT  EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250221",
    "city": "MEERUT  EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250222",
    "city": "MEERUT  EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250223",
    "city": "MEERUT  EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250341",
    "city": "MEERUT  EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250342",
    "city": "MEERUT  EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250344",
    "city": "MEERUT  EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250345",
    "city": "BAGHPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250401",
    "city": "MEERUT  EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250402",
    "city": "MEERUT  EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250404",
    "city": "MEERUT  EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250406",
    "city": "MEERUT  EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250501",
    "city": "MEERUT  EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250502",
    "city": "MEERUT  EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250515",
    "city": "CIVIL LINE SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250601",
    "city": "BAGHPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250602",
    "city": "CIVIL LINE SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250606",
    "city": "BAGHPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250609",
    "city": "BAGHPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250611",
    "city": "BARAUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250615",
    "city": "BAGHPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250617",
    "city": "BAGHPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250619",
    "city": "BAGHPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250620",
    "city": "BAGHPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250621",
    "city": "BAGHPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250622",
    "city": "BAGHPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250623",
    "city": "BAGHPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250625",
    "city": "BAGHPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250626",
    "city": "BAGHPAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "250645",
    "city": "CIVIL LINE SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "251001",
    "city": "MUZAFFARNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "251201",
    "city": "MUZAFFARNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "251202",
    "city": "MUZAFFARNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "251203",
    "city": "MUZAFFARNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "251301",
    "city": "SHAMLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "251305",
    "city": "SHAMLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "251306",
    "city": "MUZAFFARNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "251307",
    "city": "MUZAFFARNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "251308",
    "city": "MUZAFFARNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "251309",
    "city": "SHAMLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "251310",
    "city": "MUZAFFARNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "251311",
    "city": "MUZAFFARNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "251314",
    "city": "MUZAFFARNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "251315",
    "city": "MUZAFFARNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "251316",
    "city": "MUZAFFARNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "251317",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "251318",
    "city": "MUZAFFARNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "251319",
    "city": "SHAMLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "251320",
    "city": "MUZAFFARNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "251327",
    "city": "MUZAFFARNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "254716",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261001",
    "city": "SITAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261121",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261125",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261131",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261135",
    "city": "LAKHIMPUR KHERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261136",
    "city": "LAKHIMPUR KHERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261141",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261145",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261151",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261201",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261202",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261203",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261204",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261205",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261206",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261207",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261208",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261301",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261302",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261303",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261401",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261402",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261403",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261404",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261405",
    "city": "SIDHAULI (SITAPUR)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261501",
    "city": "LAKHIMPUR KHERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261502",
    "city": "LAKHIMPUR KHERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261505",
    "city": "GOLA GORAKHNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "261506",
    "city": "LAKHIMPUR KHERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262001",
    "city": "PILIBHIT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262122",
    "city": "PURANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262123",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262124",
    "city": "PILIBHIT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262201",
    "city": "PILIBHIT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262308",
    "city": "SITARGANJ EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262310",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262311",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262312",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262401",
    "city": "BAZPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262402",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262403",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262404",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262405",
    "city": "SITARGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262407",
    "city": "BAREILLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262410",
    "city": "BAREILLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262501",
    "city": "PITHORAGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262502",
    "city": "PITHORAGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262519",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262520",
    "city": "PITHORAGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262521",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262522",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262523",
    "city": "CHAMPAWAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262524",
    "city": "CHAMPAWAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262525",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262526",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262527",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262529",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262530",
    "city": "PITHORAGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262531",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262532",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262533",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262534",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262541",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262542",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262543",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262544",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262545",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262546",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262547",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262550",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262551",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262552",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262553",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262554",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262555",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262561",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262571",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262572",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262573",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262574",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262575",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262576",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262580",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262701",
    "city": "LAKHIMPUR KHERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262702",
    "city": "LAKHIMPUR KHERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262721",
    "city": "LAKHIMPUR KHERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262722",
    "city": "LAKHIMPUR KHERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262723",
    "city": "LAKHIMPUR KHERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262724",
    "city": "LAKHIMPUR KHERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262725",
    "city": "LAKHIMPUR KHERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262726",
    "city": "LAKHIMPUR KHERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262727",
    "city": "GOLA GORAKHNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262728",
    "city": "LAKHIMPUR KHERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262801",
    "city": "GOLA GORAKHNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262802",
    "city": "GOLA GORAKHNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262803",
    "city": "GOLA GORAKHNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262804",
    "city": "GOLA GORAKHNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262805",
    "city": "GOLA GORAKHNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262901",
    "city": "GOLA GORAKHNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262902",
    "city": "GOLA GORAKHNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262903",
    "city": "LAKHIMPUR KHERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262904",
    "city": "GOLA GORAKHNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262905",
    "city": "LAKHIMPUR KHERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262906",
    "city": "LAKHIMPUR KHERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262907",
    "city": "LAKHIMPUR KHERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "262908",
    "city": "GOLA GORAKHNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263001",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263002",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263126",
    "city": "KATHGODAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263127",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263128",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263129",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263131",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263132",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263134",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263135",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263136",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263137",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263138",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263139",
    "city": "HALDWANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263140",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263141",
    "city": "HALDWANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263143",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263144",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263145",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263148",
    "city": "KICHHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263149",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263150",
    "city": "KASHIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263152",
    "city": "KICHHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263153",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263154",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263155",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263156",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263157",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263158",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263159",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263160",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263162",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263163",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263164",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263301",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263309",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263408",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263601",
    "city": "ALMORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263610",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263620",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263621",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263622",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263623",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263624",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263625",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263626",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263627",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263628",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263629",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263630",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263631",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263632",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263633",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263634",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263635",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263636",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263637",
    "city": "ALMORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263638",
    "city": "ALMORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263639",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263640",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263641",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263642",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263643",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263645",
    "city": "RANIKHET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263646",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263651",
    "city": "RANIKHET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263652",
    "city": "RANIKHET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263653",
    "city": "DWARAHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263654",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263655",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263656",
    "city": "DWARAHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263658",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263659",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263660",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263661",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263662",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263663",
    "city": "RANIKHET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263664",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263665",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263667",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263671",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263675",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263676",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263677",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263678",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263679",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263680",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263681",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263683",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263684",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263686",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263687",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263688",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "263689",
    "city": "RUDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271001",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271002",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271003",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271122",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271123",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271124",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271125",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271126",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271127",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271128",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271129",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271130",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271201",
    "city": "BALRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271202",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271203",
    "city": "BALRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271204",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271205",
    "city": "BALRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271206",
    "city": "BALRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271207",
    "city": "BALRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271208",
    "city": "BALRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271209",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271210",
    "city": "BALRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271211",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271214",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271215",
    "city": "BALRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271301",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271302",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271303",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271304",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271305",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271306",
    "city": "BALRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271307",
    "city": "BALRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271308",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271309",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271310",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271311",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271312",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271313",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271315",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271316",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271317",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271318",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271319",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271320",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271401",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271402",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271403",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271404",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271406",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271502",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271503",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271504",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271601",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271602",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271603",
    "city": "GONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271604",
    "city": "BALRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271605",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271606",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271607",
    "city": "BALRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271608",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271609",
    "city": "BALRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271801",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271802",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271803",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271804",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271805",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271806",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271821",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271824",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271825",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271830",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271831",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271835",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271840",
    "city": "BALRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271841",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271845",
    "city": "BALRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271851",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271855",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271861",
    "city": "BALRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271865",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271870",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271871",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271872",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271875",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271881",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271882",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271901",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271902",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271903",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "271904",
    "city": "BAHRAICH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272001",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272002",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272003",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272120",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272123",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272124",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272125",
    "city": "KHALILABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272126",
    "city": "KHALILABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272127",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272128",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272129",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272130",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272131",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272132",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272135",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272141",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272148",
    "city": "SIDDHARTH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272149",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272150",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272151",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272152",
    "city": "SIDDHARTH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272153",
    "city": "SIDDHARTH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272154",
    "city": "SIDDHARTH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272155",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272159",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272161",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272162",
    "city": "KHALILABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272163",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272164",
    "city": "KHALILABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272165",
    "city": "KHALILABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272171",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272172",
    "city": "KHALILABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272173",
    "city": "KHALILABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272175",
    "city": "KHALILABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272176",
    "city": "KHALILABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272177",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272178",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272181",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272182",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272189",
    "city": "SIDDHARTH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272190",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272191",
    "city": "SIDDHARTH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272192",
    "city": "SIDDHARTH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272193",
    "city": "SIDDHARTH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272194",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272195",
    "city": "SIDDHARTH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272196",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272199",
    "city": "KHALILABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272201",
    "city": "SIDDHARTH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272202",
    "city": "SIDDHARTH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272203",
    "city": "SIDDHARTH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272204",
    "city": "SIDDHARTH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272205",
    "city": "SIDDHARTH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272206",
    "city": "SIDDHARTH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272207",
    "city": "SIDDHARTH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272208",
    "city": "SIDDHARTH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272209",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272211",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272212",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272269",
    "city": "PRAYAGRAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272270",
    "city": "KHALILABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272271",
    "city": "KHALILABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272301",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "272302",
    "city": "BASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273001",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273002",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273003",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273004",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273005",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273006",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273007",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273008",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273009",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273010",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273012",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273013",
    "city": "GKP WALKIN & COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273014",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273015",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273016",
    "city": "GORAKHPUR TRANSPORT NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273017",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273149",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273151",
    "city": "MAHARAJGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273152",
    "city": "GKP WALKIN & COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273153",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273155",
    "city": "MAHARAJGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273157",
    "city": "GKP WALKIN & COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273158",
    "city": "GKP WALKIN & COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273161",
    "city": "MAHARAJGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273162",
    "city": "MAHARAJGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273163",
    "city": "MAHARAJGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273165",
    "city": "GKP WALKIN & COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273201",
    "city": "GKP WALKIN & COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273202",
    "city": "GKP WALKIN & COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273203",
    "city": "GKP WALKIN & COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273207",
    "city": "MAHARAJGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273209",
    "city": "KHALILABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273211",
    "city": "GKP WALKIN & COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273212",
    "city": "KAURIRAM GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273213",
    "city": "KAURIRAM GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273301",
    "city": "MAHARAJGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273302",
    "city": "MAHARAJGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273303",
    "city": "MAHARAJGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273304",
    "city": "MAHARAJGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273305",
    "city": "MAHARAJGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273306",
    "city": "GKP WALKIN & COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273307",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273309",
    "city": "MAHARAJGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273310",
    "city": "MAHARAJGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273311",
    "city": "MAHARAJGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273401",
    "city": "KAURIRAM GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273402",
    "city": "KAURIRAM GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273403",
    "city": "KAURIRAM GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273404",
    "city": "KAURIRAM GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273405",
    "city": "KAURIRAM GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273406",
    "city": "KAURIRAM GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273407",
    "city": "KAURIRAM GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273408",
    "city": "KAURIRAM GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273409",
    "city": "KAURIRAM GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273410",
    "city": "KAURIRAM GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273411",
    "city": "KAURIRAM GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273412",
    "city": "KAURIRAM GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273413",
    "city": "KAURIRAM GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273414",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "273415",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274001",
    "city": "DEORIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274039",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274121",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274132",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274149",
    "city": "KUSHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274182",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274201",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274202",
    "city": "DEORIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274203",
    "city": "KUSHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274204",
    "city": "DEORIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274205",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274206",
    "city": "KUSHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274207",
    "city": "KUSHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274208",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274249",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274301",
    "city": "KUSHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274302",
    "city": "KUSHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274303",
    "city": "KUSHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274304",
    "city": "KUSHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274305",
    "city": "KUSHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274306",
    "city": "KUSHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274307",
    "city": "KUSHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274308",
    "city": "KUSHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274309",
    "city": "KUSHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274401",
    "city": "KUSHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274402",
    "city": "KUSHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274403",
    "city": "KUSHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274404",
    "city": "DEORIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274405",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274406",
    "city": "KUSHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274407",
    "city": "KUSHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274408",
    "city": "DEORIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274409",
    "city": "KUSHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274501",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274502",
    "city": "SALEMPUR LAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274505",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274506",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274508",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274509",
    "city": "SALEMPUR LAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274601",
    "city": "SALEMPUR LAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274602",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274603",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274604",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274701",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274702",
    "city": "SALEMPUR LAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274703",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274704",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274705",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274801",
    "city": "KUSHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274802",
    "city": "KUSHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274806",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274807",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "274808",
    "city": "GORAKHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "275101",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "275102",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "275103",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "275105",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "275201",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "275202",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "275205",
    "city": "GAZIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "275207",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "275208",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "275301",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "275302",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "275303",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "275304",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "275305",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "275306",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "275307",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "275501",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276001",
    "city": "AZAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276121",
    "city": "AZAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276122",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276123",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276124",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276125",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276126",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276127",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276128",
    "city": "AZAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276129",
    "city": "AZAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276131",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276135",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276136",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276137",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276138",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276139",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276140",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276141",
    "city": "AZAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276142",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276143",
    "city": "AZAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276201",
    "city": "AZAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276202",
    "city": "AZAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276203",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276204",
    "city": "AZAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276205",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276206",
    "city": "AZAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276207",
    "city": "AZAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276208",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276288",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276301",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276302",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276303",
    "city": "AZAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276304",
    "city": "AZAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276305",
    "city": "AZAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276306",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276401",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276402",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276403",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276404",
    "city": "AZAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276405",
    "city": "MAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "276406",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "277001",
    "city": "BALLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "277122",
    "city": "VARANASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "277123",
    "city": "BALLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "277202",
    "city": "BALLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "277209",
    "city": "BALLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "277211",
    "city": "BALLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "277212",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "277218",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "277303",
    "city": "BALLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "277304",
    "city": "BALLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "277305",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "277306",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "277307",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "277401",
    "city": "BALLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "277405",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "277407",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "277501",
    "city": "BALLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "277503",
    "city": "BALLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "277817",
    "city": "LUCKNOW SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "281104",
    "city": "HATHRAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "281302",
    "city": "HATHRAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "281306",
    "city": "HATHRAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "281307",
    "city": "HATHRAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "281308",
    "city": "HATHRAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "281403",
    "city": "HODAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "282001",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "282002",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "282003",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "282004",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "282005",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "282006",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "282007",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "282008",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "282009",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "282010",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283101",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283102",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283103",
    "city": "FIROZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283104",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283105",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283110",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283111",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283112",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283113",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283114",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283115",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283119",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283121",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283122",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283123",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283124",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283125",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283126",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283130",
    "city": "FIROZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283135",
    "city": "FIROZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283136",
    "city": "FIROZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283141",
    "city": "FIROZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283142",
    "city": "ETAWAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283145",
    "city": "FIROZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283151",
    "city": "FIROZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283152",
    "city": "FIROZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283201",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283202",
    "city": "AGRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283203",
    "city": "FIROZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283204",
    "city": "FIROZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283205",
    "city": "FIROZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283206",
    "city": "FIROZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "283207",
    "city": "FIROZABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284001",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284002",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284003",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284120",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284121",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284122",
    "city": "LALITPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284123",
    "city": "LALITPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284124",
    "city": "LALITPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284125",
    "city": "LALITPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284126",
    "city": "LALITPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284127",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284128",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284135",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284136",
    "city": "LALITPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284201",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284202",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284203",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284204",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284205",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284206",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284301",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284302",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284303",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284304",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284305",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284306",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284401",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284402",
    "city": "LALITPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284403",
    "city": "LALITPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284404",
    "city": "LALITPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284405",
    "city": "LALITPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284406",
    "city": "LALITPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284419",
    "city": "JHANSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "284501",
    "city": "LALITPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285001",
    "city": "ORAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285121",
    "city": "ORAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285122",
    "city": "ORAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285123",
    "city": "ORAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285124",
    "city": "ORAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285125",
    "city": "ORAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285126",
    "city": "ORAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285127",
    "city": "ORAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285128",
    "city": "ORAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285129",
    "city": "ORAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285130",
    "city": "ORAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285131",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285134",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285196",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285201",
    "city": "ORAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285202",
    "city": "ORAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285203",
    "city": "ORAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285204",
    "city": "ORAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285205",
    "city": "ORAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285206",
    "city": "ORAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285211",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285223",
    "city": "ORAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285231",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "285251",
    "city": "KANPUR AREA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301001",
    "city": "KISHANGARH KHERTHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301002",
    "city": "ALWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301011",
    "city": "KUSHKHERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301016",
    "city": "KUSHKHERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301018",
    "city": "KUSHKHERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301019",
    "city": "KUSHKHERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301020",
    "city": "NEEMRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301021",
    "city": "KISHANGARH KHERTHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301022",
    "city": "KOTPUTALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301023",
    "city": "ALWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301024",
    "city": "KOTPUTALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301025",
    "city": "ALWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301026",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301027",
    "city": "ALWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301030",
    "city": "KISHANGARH KHERTHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301077",
    "city": "DELHI WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301401",
    "city": "NEEMRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301402",
    "city": "KOTPUTALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301403",
    "city": "NEEMRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301404",
    "city": "KISHANGARH KHERTHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301405",
    "city": "KISHANGARH KHERTHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301406",
    "city": "ALWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301407",
    "city": "NEEMRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301408",
    "city": "ALWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301409",
    "city": "ALWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301410",
    "city": "ALWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301411",
    "city": "KUSHKHERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301412",
    "city": "NEEMRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301413",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301414",
    "city": "ALWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301416",
    "city": "KOTPUTALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301427",
    "city": "NEEMRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301604",
    "city": "ALWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301701",
    "city": "NEEMRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301702",
    "city": "KUSHKHERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301703",
    "city": "NEEMRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301704",
    "city": "NEEMRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301705",
    "city": "NEEMRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301706",
    "city": "NEEMRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301707",
    "city": "KUSHKHERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301708",
    "city": "NEEMRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301709",
    "city": "NEEMRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301712",
    "city": "ALWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301713",
    "city": "NEEMRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "301714",
    "city": "NEEMRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302001",
    "city": "M I ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302002",
    "city": "M I ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302003",
    "city": "M I ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302004",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302005",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302006",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302007",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302008",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302009",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302010",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302011",
    "city": "JAIPUR SANGANER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302012",
    "city": "JAIPUR KALWAR ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302013",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302014",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302015",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302016",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302017",
    "city": "JAIPUR MALVIYA NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302018",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302019",
    "city": "VAISHALI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302020",
    "city": "JAIPUR MANSAROVAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302021",
    "city": "VAISHALI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302023",
    "city": "JAIPUR VIDHADHAR NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302024",
    "city": "VAISHALI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302025",
    "city": "JAIPUR MALVIYA NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302026",
    "city": "VAISHALI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302027",
    "city": "JAIPUR KANOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302028",
    "city": "JAIPUR KANOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302029",
    "city": "JAIPUR SANGANER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302031",
    "city": "JAIPUR KANOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302032",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302034",
    "city": "VAISHALI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302036",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302037",
    "city": "JAIPUR BAGRU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302038",
    "city": "M I ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302039",
    "city": "JAIPUR VIDHADHAR NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302041",
    "city": "VAISHALI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302042",
    "city": "JAIPUR BAGRU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302043",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302106",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302111",
    "city": "JAIPUR ETAIL CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "302119",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303001",
    "city": "DAUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303002",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303003",
    "city": "KOTPUTALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303004",
    "city": "DAUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303005",
    "city": "SHIVDASPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303006",
    "city": "SHIVDASPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303007",
    "city": "JAIPUR BAGRU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303008",
    "city": "KISHANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303009",
    "city": "JAIPUR BAGRU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303010",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303012",
    "city": "JAIPUR KANOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303101",
    "city": "JAIPUR KANOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303102",
    "city": "KOTPUTALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303103",
    "city": "SHAHPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303104",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303105",
    "city": "KOTPUTALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303106",
    "city": "SHAHPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303107",
    "city": "KOTPUTALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303108",
    "city": "KOTPUTALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303109",
    "city": "DAUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303110",
    "city": "KOTPUTALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303119",
    "city": "KOTPUTALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303120",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303301",
    "city": "JAIPUR KANOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303302",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303303",
    "city": "DAUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303304",
    "city": "DAUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303305",
    "city": "DAUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303313",
    "city": "DAUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303315",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303323",
    "city": "DAUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303325",
    "city": "DAUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303326",
    "city": "DAUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303327",
    "city": "DAUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303328",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303329",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303331",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303338",
    "city": "JAIPUR BAGRU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303339",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303348",
    "city": "KUCHAMAN CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303501",
    "city": "DAUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303502",
    "city": "DAUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303503",
    "city": "LALSOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303504",
    "city": "LALSOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303505",
    "city": "LALSOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303506",
    "city": "DAUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303507",
    "city": "DAUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303508",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303509",
    "city": "DAUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303510",
    "city": "LALSOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303511",
    "city": "LALSOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303601",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303602",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303603",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303604",
    "city": "KUCHAMAN CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303701",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303702",
    "city": "JAIPUR CHOMU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303704",
    "city": "JAIPUR CHOMU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303706",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303712",
    "city": "JAIPUR CHOMU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303801",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303802",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303803",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303804",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303805",
    "city": "JAIPUR CHOMU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303806",
    "city": "JAIPUR CHOMU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303807",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303901",
    "city": "NIWAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303903",
    "city": "SHIVDASPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303904",
    "city": "SHIVDASPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303905",
    "city": "SHIVDASPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303908",
    "city": "NIWAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "303999",
    "city": "JAIPUR WAREHOUSE PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "304001",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "304020",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "304021",
    "city": "NIWAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "304022",
    "city": "NIWAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "304023",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "304024",
    "city": "NIWAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "304025",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "304501",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "304502",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "304503",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "304504",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "304505",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "304507",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "304801",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "304802",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "304803",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "304804",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305001",
    "city": "AJMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305002",
    "city": "AJMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305003",
    "city": "AJMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305004",
    "city": "AJMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305005",
    "city": "AJMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305006",
    "city": "AJMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305007",
    "city": "AJMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305008",
    "city": "AJMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305009",
    "city": "AJMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305011",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305012",
    "city": "KISHANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305021",
    "city": "KISHANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305022",
    "city": "PUSHKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305023",
    "city": "KISHANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305024",
    "city": "KISHANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305026",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305201",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305202",
    "city": "AJMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305203",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305205",
    "city": "KISHANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305206",
    "city": "AJMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305207",
    "city": "AJMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305403",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305404",
    "city": "KEKRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305406",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305407",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305408",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305410",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305411",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305412",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305413",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305414",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305415",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305621",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305622",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305623",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305624",
    "city": "GULABPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305625",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305626",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305627",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305801",
    "city": "KISHANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305802",
    "city": "KISHANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305811",
    "city": "KISHANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305812",
    "city": "KISHANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305813",
    "city": "KISHANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305814",
    "city": "KISHANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305815",
    "city": "KISHANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305816",
    "city": "KISHANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305817",
    "city": "KISHANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305818",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305819",
    "city": "KISHANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305820",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305901",
    "city": "BEAWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305903",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305921",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305922",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305923",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305924",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305925",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305927",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "305928",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306001",
    "city": "PALI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306021",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306022",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306023",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306027",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306102",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306103",
    "city": "PALI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306104",
    "city": "PALI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306105",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306114",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306115",
    "city": "PALI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306116",
    "city": "PALI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306119",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306126",
    "city": "PALI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306128",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306302",
    "city": "BILARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306303",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306304",
    "city": "PALI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306305",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306306",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306307",
    "city": "PALI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306401",
    "city": "PALI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306421",
    "city": "PALI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306422",
    "city": "PALI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306501",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306502",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306503",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306504",
    "city": "SIROHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306601",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306602",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306603",
    "city": "PALI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306701",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306702",
    "city": "PALI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306703",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306704",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306705",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306706",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306707",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306708",
    "city": "PALI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306709",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306901",
    "city": "JAISALMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306902",
    "city": "SHEOGANJ AND SUMERPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "306912",
    "city": "JAISALMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307001",
    "city": "SIROHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307005",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307019",
    "city": "SIROHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307020",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307021",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307022",
    "city": "SIROHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307023",
    "city": "ABU ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307024",
    "city": "ABU ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307025",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307026",
    "city": "ABU ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307027",
    "city": "SIROHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307028",
    "city": "SIROHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307029",
    "city": "JALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307030",
    "city": "JALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307031",
    "city": "SIROHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307032",
    "city": "SIROHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307043",
    "city": "SIROHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307501",
    "city": "ABU ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307510",
    "city": "ABU ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307511",
    "city": "SIROHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307512",
    "city": "SIROHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307513",
    "city": "ABU ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307514",
    "city": "ABU ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307515",
    "city": "SIROHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307801",
    "city": "SIROHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307802",
    "city": "SIROHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "307803",
    "city": "SIROHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "310029",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311001",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311011",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311012",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311013",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311021",
    "city": "GULABPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311022",
    "city": "GULABPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311023",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311024",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311025",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311026",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311028",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311029",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311031",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311032",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311201",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311202",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311203",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311204",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311301",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311302",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311401",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311402",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311403",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311404",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311405",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311408",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311601",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311602",
    "city": "BUNDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311603",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311604",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311606",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311607",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311609",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311801",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311802",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311803",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311805",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311806",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311807",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311808",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311809",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "311810",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312001",
    "city": "CHITTORGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312021",
    "city": "CHITTORGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312022",
    "city": "CHITTORGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312023",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312024",
    "city": "CHITTORGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312025",
    "city": "CHITTORGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312026",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312201",
    "city": "CHITTORGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312202",
    "city": "CHITTORGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312203",
    "city": "CHITTORGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312204",
    "city": "CHITTORGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312205",
    "city": "CHITTORGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312206",
    "city": "CHITTORGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312207",
    "city": "CHITTORGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312401",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312402",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312403",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312404",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312601",
    "city": "NIMBAHERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312602",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312603",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312604",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312605",
    "city": "PRATAPGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312606",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312612",
    "city": "NIMBAHERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312613",
    "city": "CHITTORGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312614",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312617",
    "city": "NIMBAHERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312618",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312620",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312621",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312622",
    "city": "NIMBAHERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312627",
    "city": "CHITTORGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "312901",
    "city": "CHITTORGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313001",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313002",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313003",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313004",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313005",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313011",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313013",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313015",
    "city": "UDAIPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313022",
    "city": "UDAIPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313024",
    "city": "UDAIPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313025",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313026",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313027",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313031",
    "city": "UDAIPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313032",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313038",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313201",
    "city": "UDAIPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313202",
    "city": "UDAIPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313203",
    "city": "FATEHNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313204",
    "city": "FATEHNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313205",
    "city": "FATEHNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313206",
    "city": "FATEHNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313207",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313209",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313210",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313211",
    "city": "FATEHNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313301",
    "city": "NATHDWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313321",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313322",
    "city": "UDAIPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313323",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313324",
    "city": "RAJSAMAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313325",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313326",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313328",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313329",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313331",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313332",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313333",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313334",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313337",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313338",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313341",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313342",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313601",
    "city": "FATEHNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313602",
    "city": "FATEHNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313603",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313604",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313605",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313606",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313608",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313611",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313613",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313701",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313702",
    "city": "UDAIPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313703",
    "city": "UDAIPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313704",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313705",
    "city": "UDAIPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313707",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313708",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313801",
    "city": "UDAIPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313802",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313803",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313804",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313805",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313806",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313901",
    "city": "UDAIPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313902",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313903",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313904",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313905",
    "city": "UDAIPUR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "313906",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314001",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314004",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314011",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314012",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314013",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314021",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314022",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314023",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314024",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314025",
    "city": "SAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314026",
    "city": "SAGWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314027",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314028",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314029",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314030",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314031",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314032",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314034",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314035",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314036",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314037",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314038",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314401",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314402",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314403",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314404",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314405",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314406",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314407",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314801",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314803",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "314804",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321001",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321006",
    "city": "ALWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321021",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321023",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321024",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321025",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321026",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321028",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321201",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321202",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321203",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321204",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321205",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321206",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321301",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321302",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321303",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321305",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321401",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321402",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321403",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321404",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321405",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321406",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321407",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321408",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321409",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321410",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321411",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321601",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321602",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321603",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321604",
    "city": "ALWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321605",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321606",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321607",
    "city": "ALWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321608",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321609",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321610",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321611",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321612",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321613",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321614",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321615",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321633",
    "city": "ALWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "321642",
    "city": "BHARATPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322001",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322021",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322023",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322024",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322025",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322026",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322027",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322028",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322029",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322030",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322033",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322034",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322201",
    "city": "KARAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322202",
    "city": "KARAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322203",
    "city": "KARAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322204",
    "city": "KARAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322205",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322211",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322212",
    "city": "KARAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322213",
    "city": "KARAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322214",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322215",
    "city": "KARAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322216",
    "city": "KARAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322218",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322219",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322220",
    "city": "KARAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322230",
    "city": "KARAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322234",
    "city": "KARAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322236",
    "city": "KARAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322238",
    "city": "KARAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322240",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322241",
    "city": "KARAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322242",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322243",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322249",
    "city": "KARAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322251",
    "city": "KARAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322252",
    "city": "KARAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322254",
    "city": "KARAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322255",
    "city": "KARAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322701",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322702",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322703",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "322704",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323002",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323021",
    "city": "BUNDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323023",
    "city": "BUNDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323024",
    "city": "BUNDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323025",
    "city": "BUNDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323026",
    "city": "BUNDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323301",
    "city": "BUNDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323302",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323303",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323304",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323305",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323306",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323307",
    "city": "BHILWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323601",
    "city": "BUNDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323602",
    "city": "BUNDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323603",
    "city": "BUNDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323604",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323613",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323614",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323615",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323801",
    "city": "BUNDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323802",
    "city": "BUNDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "323803",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "324001",
    "city": "KOTA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "324002",
    "city": "KOTA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "324003",
    "city": "KOTA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "324004",
    "city": "KOTA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "324005",
    "city": "KOTA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "324006",
    "city": "KOTA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "324007",
    "city": "KOTA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "324008",
    "city": "KOTA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "324009",
    "city": "KOTA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "324010",
    "city": "KOTA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "324025",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325001",
    "city": "KOTA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325003",
    "city": "JHALAWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325009",
    "city": "SAWAI MADHOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325201",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325202",
    "city": "KOTA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325203",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325204",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325205",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325206",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325207",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325208",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325209",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325214",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325215",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325216",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325217",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325218",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325219",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325220",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325221",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325222",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325223",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325225",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325601",
    "city": "JHALAWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "325602",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326001",
    "city": "JHALAWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326003",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326021",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326023",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326030",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326034",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326036",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326037",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326038",
    "city": "JHALAWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326039",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326501",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326502",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326510",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326512",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326513",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326514",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326515",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326516",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326517",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326518",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326519",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326520",
    "city": "JHALAWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326529",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "326530",
    "city": "JHALAWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "327001",
    "city": "BANSWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "327007",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "327015",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "327021",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "327022",
    "city": "PRATAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "327023",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "327024",
    "city": "PRATAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "327025",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "327026",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "327027",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "327031",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "327032",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "327034",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "327041",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "327601",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "327602",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "327604",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "327605",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "327606",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "327608",
    "city": "UDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "327801",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "328001",
    "city": "DHOLPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "328021",
    "city": "DHOLPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "328022",
    "city": "DHOLPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "328023",
    "city": "DHOLPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "328024",
    "city": "DHOLPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "328025",
    "city": "DHOLPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "328026",
    "city": "DHOLPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "328027",
    "city": "DHOLPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "328028",
    "city": "DHOLPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "328029",
    "city": "DHOLPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "328030",
    "city": "DHOLPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "328031",
    "city": "DHOLPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "328035",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "328041",
    "city": "DHOLPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "329090",
    "city": "KOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331001",
    "city": "CHURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331002",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331021",
    "city": "CHURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331022",
    "city": "CHURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331023",
    "city": "PILANI VK PLAZA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331024",
    "city": "CHURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331025",
    "city": "JHUNJHUNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331026",
    "city": "JHUNJHUNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331027",
    "city": "CHURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331028",
    "city": "JHUNJHUNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331029",
    "city": "CHURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331030",
    "city": "JHUNJHUNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331031",
    "city": "CHURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331033",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331301",
    "city": "PILANI VK PLAZA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331302",
    "city": "CHURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331303",
    "city": "PILANI VK PLAZA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331304",
    "city": "CHURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331305",
    "city": "PILANI VK PLAZA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331402",
    "city": "CHURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331403",
    "city": "SARDARSAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331404",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331411",
    "city": "SARDARSAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331501",
    "city": "SUJANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331502",
    "city": "SUJANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331503",
    "city": "SUJANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331504",
    "city": "SARDARSAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331505",
    "city": "SUJANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331506",
    "city": "SUJANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331507",
    "city": "SUJANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331517",
    "city": "SUJANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331518",
    "city": "SUJANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331701",
    "city": "PILANI VK PLAZA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331801",
    "city": "SHRIDUNGARGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331802",
    "city": "SARDARSAHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331803",
    "city": "SHRIDUNGARGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "331811",
    "city": "SHRIDUNGARGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332001",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332002",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332021",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332023",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332024",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332025",
    "city": "KUCHAMAN CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332026",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332027",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332028",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332029",
    "city": "SUJANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332030",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332031",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332041",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332042",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332045",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332301",
    "city": "CHURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332302",
    "city": "CHURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332303",
    "city": "NAWALGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332304",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332305",
    "city": "NAWALGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332307",
    "city": "NAWALGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332311",
    "city": "LAXMANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332312",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332315",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332316",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332317",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332318",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332401",
    "city": "NAWALGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332403",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332405",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332406",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332411",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332601",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332602",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332603",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332701",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332702",
    "city": "KUCHAMAN CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332703",
    "city": "KUCHAMAN CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332705",
    "city": "KOTPUTALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332706",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332707",
    "city": "KOTPUTALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332708",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332709",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332710",
    "city": "KUCHAMAN CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332711",
    "city": "KOTPUTALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332712",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332713",
    "city": "KOTPUTALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332714",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332716",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332718",
    "city": "KOTPUTALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332719",
    "city": "KOTPUTALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332721",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332722",
    "city": "SIKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332742",
    "city": "KUCHAMAN CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "332746",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333001",
    "city": "JHUNJHUNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333011",
    "city": "JHUNJHUNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333012",
    "city": "NAWALGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333021",
    "city": "JHUNJHUNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333022",
    "city": "JHUNJHUNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333023",
    "city": "JHUNJHUNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333024",
    "city": "JHUNJHUNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333025",
    "city": "JHUNJHUNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333026",
    "city": "PILANI VK PLAZA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333027",
    "city": "PILANI VK PLAZA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333028",
    "city": "PILANI VK PLAZA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333029",
    "city": "PILANI VK PLAZA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333030",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333031",
    "city": "PILANI VK PLAZA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333032",
    "city": "NAWALGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333033",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333035",
    "city": "PILANI VK PLAZA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333036",
    "city": "KOTPUTALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333037",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333041",
    "city": "JHUNJHUNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333042",
    "city": "NAWALGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333053",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333302",
    "city": "NAWALGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333303",
    "city": "NAWALGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333304",
    "city": "NAWALGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333305",
    "city": "NAWALGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333307",
    "city": "NAWALGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333308",
    "city": "NAWALGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333310",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333333",
    "city": "NORTH-REGIONAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333501",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333502",
    "city": "JHUNJHUNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333503",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333504",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333514",
    "city": "NAWALGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333515",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333516",
    "city": "PILANI VK PLAZA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333701",
    "city": "NAWALGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333702",
    "city": "NAWALGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333704",
    "city": "JHUNJHUNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333705",
    "city": "NAWALGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333707",
    "city": "JHUNJHUNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "333801",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334001",
    "city": "BIKANER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334003",
    "city": "BIKANER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334004",
    "city": "BIKANER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334006",
    "city": "BIKANER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334007",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334008",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334022",
    "city": "BIKANER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334023",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334201",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334202",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334302",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334303",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334305",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334401",
    "city": "BIKANER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334402",
    "city": "BIKANER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334403",
    "city": "BIKANER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334601",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334602",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334603",
    "city": "SHRIDUNGARGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334604",
    "city": "SURATGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334801",
    "city": "NOKHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334802",
    "city": "NOKHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334803",
    "city": "NOKHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "334804",
    "city": "NOKHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335001",
    "city": "SRIGANGANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335002",
    "city": "SRIGANGANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335021",
    "city": "SRIGANGANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335022",
    "city": "SRIGANGANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335023",
    "city": "SRIGANGANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335024",
    "city": "SRIGANGANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335025",
    "city": "SRIGANGANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335027",
    "city": "SRIGANGANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335037",
    "city": "SRIGANGANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335038",
    "city": "SRIGANGANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335039",
    "city": "SRIGANGANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335040",
    "city": "SRIGANGANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335041",
    "city": "SRIGANGANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335051",
    "city": "SRIGANGANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335061",
    "city": "SRIGANGANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335062",
    "city": "HANUMANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335063",
    "city": "HANUMANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335064",
    "city": "HANUMANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335065",
    "city": "HANUMANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335073",
    "city": "SRIGANGANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335501",
    "city": "NOHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335502",
    "city": "NOHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335503",
    "city": "BIKANER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335504",
    "city": "NOHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335505",
    "city": "MANDI ADAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335511",
    "city": "MANDI ADAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335512",
    "city": "HANUMANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335513",
    "city": "HANUMANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335514",
    "city": "MANDI ADAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335523",
    "city": "NOHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335524",
    "city": "HANUMANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335525",
    "city": "ELLENABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335526",
    "city": "HANUMANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335701",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335702",
    "city": "SURATGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335703",
    "city": "SURATGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335704",
    "city": "SURATGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335705",
    "city": "SURATGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335707",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335771",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335801",
    "city": "HANUMANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335802",
    "city": "HANUMANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335803",
    "city": "HANUMANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335804",
    "city": "SURATGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335805",
    "city": "SURATGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "335901",
    "city": "SRIGANGANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341001",
    "city": "NAGAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341021",
    "city": "NAGAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341022",
    "city": "NAGAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341023",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341024",
    "city": "NAGAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341026",
    "city": "NAGAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341027",
    "city": "NAGAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341028",
    "city": "NAGAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341029",
    "city": "NAGAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341030",
    "city": "NAGAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341031",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341301",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341302",
    "city": "KUCHAMAN CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341304",
    "city": "SUJANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341305",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341306",
    "city": "SUJANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341316",
    "city": "SUJANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341317",
    "city": "BIKANER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341318",
    "city": "BIKANER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341319",
    "city": "KUCHAMAN CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341501",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341502",
    "city": "KUCHAMAN CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341503",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341504",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341505",
    "city": "KUCHAMAN CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341506",
    "city": "KUCHAMAN CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341507",
    "city": "KUCHAMAN CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341508",
    "city": "KUCHAMAN CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341509",
    "city": "KUCHAMAN CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341510",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341511",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341512",
    "city": "KISHANGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341513",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341514",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341515",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341516",
    "city": "KUCHAMAN CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341517",
    "city": "KUCHAMAN CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341519",
    "city": "KUCHAMAN CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341520",
    "city": "KUCHAMAN CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341533",
    "city": "KUCHAMAN CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341542",
    "city": "KUCHAMAN CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "341551",
    "city": "BIKANER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342001",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342004",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342005",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342006",
    "city": "JODHPUR PAOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342007",
    "city": "JODHPUR PAOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342008",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342009",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342010",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342015",
    "city": "JODHPUR PAOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342022",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342025",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342026",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342027",
    "city": "JODHPUR PAOTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342028",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342301",
    "city": "PHALODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342302",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342303",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342304",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342306",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342307",
    "city": "PHALODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342308",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342309",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342310",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342311",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342312",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342314",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342601",
    "city": "BILARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342602",
    "city": "BILARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342605",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342606",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342801",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342802",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342901",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "342902",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "343001",
    "city": "JALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "343002",
    "city": "JALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "343003",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "343005",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "343021",
    "city": "JALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "343022",
    "city": "JALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "343023",
    "city": "JALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "343024",
    "city": "JALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "343025",
    "city": "JAISALMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "343027",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "343028",
    "city": "SIROHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "343029",
    "city": "JALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "343032",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "343041",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "343042",
    "city": "JALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "343048",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "343049",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344001",
    "city": "BARMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344011",
    "city": "BARMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344021",
    "city": "BALOTRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344022",
    "city": "BALOTRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344024",
    "city": "BALOTRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344025",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344026",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344027",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344031",
    "city": "BARMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344032",
    "city": "BALOTRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344033",
    "city": "BALOTRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344034",
    "city": "BARMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344035",
    "city": "BARMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344037",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344043",
    "city": "JAISALMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344044",
    "city": "JAISALMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344501",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344502",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344701",
    "city": "BARMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344702",
    "city": "BARMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344703",
    "city": "BARMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344704",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344705",
    "city": "BARMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344706",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344708",
    "city": "BARMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "344801",
    "city": "JAISALMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "345001",
    "city": "JAISALMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "345002",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "345021",
    "city": "PHALODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "345022",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "345023",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "345024",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "345025",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "345026",
    "city": "JAISALMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "345027",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "345028",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "345031",
    "city": "JODHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "345033",
    "city": "JAISALMER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360001",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360002",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360003",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360004",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360005",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360006",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360007",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360008",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360009",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360020",
    "city": "RAJKOT EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360021",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360022",
    "city": "RAJKOT EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360023",
    "city": "KUVADVA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360024",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360025",
    "city": "RAJKOT EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360026",
    "city": "RAJKOT EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360030",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360035",
    "city": "RAJKOT EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360040",
    "city": "VINCHHIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360050",
    "city": "VINCHHIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360055",
    "city": "VINCHHIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360060",
    "city": "VINCHHIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360070",
    "city": "GONDAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360080",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360110",
    "city": "RAJKOT EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360311",
    "city": "GONDAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360320",
    "city": "GONDAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360330",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360360",
    "city": "JETPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360375",
    "city": "JETPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360380",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360405",
    "city": "DHORAJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360410",
    "city": "DHORAJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360421",
    "city": "DHORAJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360430",
    "city": "DHORAJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360440",
    "city": "DHORAJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360450",
    "city": "DHORAJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360452",
    "city": "DHORAJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360460",
    "city": "DHORAJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360470",
    "city": "DHORAJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360480",
    "city": "DHORAJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360490",
    "city": "DHORAJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360510",
    "city": "DHROL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360515",
    "city": "DHORAJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360520",
    "city": "DHORAJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360530",
    "city": "DHORAJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360531",
    "city": "DHORAJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360540",
    "city": "DHORAJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360545",
    "city": "PORBANDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360550",
    "city": "PORBANDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360560",
    "city": "PORBANDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360570",
    "city": "PORBANDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360572",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360575",
    "city": "PORBANDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360576",
    "city": "PORBANDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360577",
    "city": "PORBANDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360578",
    "city": "PORBANDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360579",
    "city": "PORBANDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "360590",
    "city": "PORBANDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361001",
    "city": "JAMNAGAR DP OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361002",
    "city": "JAMNAGAR DP OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361003",
    "city": "JAMNAGAR DP OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361004",
    "city": "JAMNAGAR DP OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361005",
    "city": "JAMNAGAR DP OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361006",
    "city": "JAMNAGAR DP OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361007",
    "city": "JAMNAGAR DP OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361008",
    "city": "JAMNAGAR DP OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361009",
    "city": "JAMNAGAR DP OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361010",
    "city": "DHROL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361011",
    "city": "JAMNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361012",
    "city": "JAMNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361013",
    "city": "JAMNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361110",
    "city": "JAMNAGAR DP OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361120",
    "city": "JAMNAGAR DP OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361130",
    "city": "JAMNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361140",
    "city": "SIKKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361141",
    "city": "SIKKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361142",
    "city": "SIKKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361150",
    "city": "JAMNAGAR DP OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361160",
    "city": "DHORAJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361162",
    "city": "RAJKOT EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361170",
    "city": "DHROL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361210",
    "city": "JAMNAGAR DP OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361220",
    "city": "JAMNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361230",
    "city": "JAMNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361240",
    "city": "MORBI E-TAIL CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361250",
    "city": "JAMNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361280",
    "city": "SIKKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361305",
    "city": "DHROL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361306",
    "city": "DHROL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361310",
    "city": "DHROL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361315",
    "city": "DWARKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361320",
    "city": "DHROL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361325",
    "city": "DHROL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361330",
    "city": "DWARKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361335",
    "city": "DWARKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361336",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361345",
    "city": "DWARKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361347",
    "city": "DWARKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "361350",
    "city": "DWARKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362001",
    "city": "JUNAGADH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362002",
    "city": "JUNAGADH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362003",
    "city": "JUNAGADH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362004",
    "city": "JUNAGADH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362011",
    "city": "JUNAGADH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362015",
    "city": "JUNAGADH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362020",
    "city": "JUNAGADH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362030",
    "city": "JUNAGADH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362037",
    "city": "JUNAGADH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362110",
    "city": "JUNAGADH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362120",
    "city": "JUNAGADH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362130",
    "city": "JUNAGADH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362135",
    "city": "TALALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362140",
    "city": "TALALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362150",
    "city": "TALALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362205",
    "city": "JUNAGADH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362215",
    "city": "JUNAGADH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362220",
    "city": "KESHOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362222",
    "city": "KESHOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362225",
    "city": "MANGROL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362226",
    "city": "MANGROL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362227",
    "city": "KESHOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362229",
    "city": "KESHOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362230",
    "city": "KESHOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362231",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362235",
    "city": "MANGROL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362240",
    "city": "KESHOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362245",
    "city": "KESHOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362250",
    "city": "KESHOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362255",
    "city": "VERAVAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362260",
    "city": "JUNAGADH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362263",
    "city": "VERAVAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362266",
    "city": "VERAVAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362267",
    "city": "VERAVAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362268",
    "city": "VERAVAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362269",
    "city": "VERAVAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362275",
    "city": "VERAVAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362276",
    "city": "KODINAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362310",
    "city": "JUNAGADH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362315",
    "city": "JUNAGADH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362510",
    "city": "UNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362520",
    "city": "UNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362530",
    "city": "KODINAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362540",
    "city": "UNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362550",
    "city": "KODINAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362554",
    "city": "KODINAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362560",
    "city": "UNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362565",
    "city": "KODINAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362570",
    "city": "UNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362571",
    "city": "UNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362610",
    "city": "JUNAGADH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362620",
    "city": "KESHOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362624",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362625",
    "city": "KESHOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362630",
    "city": "KESHOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362640",
    "city": "KESHOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362650",
    "city": "PORBANDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362710",
    "city": "KODINAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362715",
    "city": "KODINAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362720",
    "city": "KODINAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362725",
    "city": "KODINAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "362730",
    "city": "RAJULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363001",
    "city": "SURENDRANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363002",
    "city": "SURENDRANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363020",
    "city": "SURENDRANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363030",
    "city": "SURENDRANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363035",
    "city": "SURENDRANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363040",
    "city": "SURENDRANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363041",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363045",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363110",
    "city": "SURENDRANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363115",
    "city": "SURENDRANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363310",
    "city": "DHANGDHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363312",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363315",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363320",
    "city": "DHANGDHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363330",
    "city": "HALVAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363331",
    "city": "DHANGDHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363351",
    "city": "DHANGDHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363410",
    "city": "BOTAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363415",
    "city": "BOTAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363421",
    "city": "SURENDRANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363423",
    "city": "DHANDHUKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363425",
    "city": "DHANDHUKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363426",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363427",
    "city": "SURENDRANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363430",
    "city": "SURENDRANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363435",
    "city": "SURENDRANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363440",
    "city": "SURENDRANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363510",
    "city": "SURENDRANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363520",
    "city": "CHOTILA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363530",
    "city": "CHOTILA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363535",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363610",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363621",
    "city": "WANKANER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363630",
    "city": "MORBI E-TAIL CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363635",
    "city": "MORBI E-TAIL CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363636",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363641",
    "city": "MORBI E-TAIL CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363642",
    "city": "MORBI E-TAIL CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363643",
    "city": "MORBI E-TAIL CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363650",
    "city": "MORBI E-TAIL CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363655",
    "city": "MORBI E-TAIL CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363660",
    "city": "MORBI E-TAIL CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "363670",
    "city": "MORBI WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364001",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364002",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364003",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364004",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364005",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364006",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364050",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364055",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364060",
    "city": "SIHOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364070",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364081",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364110",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364120",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364130",
    "city": "MAHUVA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364135",
    "city": "MAHUVA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364140",
    "city": "PALITANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364145",
    "city": "MAHUVA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364150",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364210",
    "city": "PALITANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364230",
    "city": "PALITANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364240",
    "city": "SIHOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364250",
    "city": "PALITANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364260",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364265",
    "city": "PALITANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364270",
    "city": "PALITANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364275",
    "city": "PALITANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364280",
    "city": "MAHUVA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364290",
    "city": "MAHUVA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364295",
    "city": "MAHUVA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364302",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364310",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364313",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364320",
    "city": "PALITANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364330",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364421",
    "city": "AMRELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364465",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364485",
    "city": "JETPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364490",
    "city": "GONDAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364505",
    "city": "PALITANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364510",
    "city": "PALITANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364515",
    "city": "SAVARKUNDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364519",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364521",
    "city": "SAVARKUNDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364522",
    "city": "RAJULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364525",
    "city": "PALITANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364530",
    "city": "RAJULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364535",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364540",
    "city": "AMRELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364545",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364601",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364630",
    "city": "AMRELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364633",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364635",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364710",
    "city": "BOTAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364720",
    "city": "BOTAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364730",
    "city": "BOTAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364740",
    "city": "BOTAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364750",
    "city": "BOTAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364760",
    "city": "BOTAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "364765",
    "city": "BOTAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365220",
    "city": "AMRELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365410",
    "city": "AMRELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365421",
    "city": "AMRELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365430",
    "city": "JUNAGADH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365435",
    "city": "AMRELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365440",
    "city": "SAVARKUNDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365450",
    "city": "JUNAGADH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365455",
    "city": "AMRELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365456",
    "city": "AMRELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365460",
    "city": "AMRELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365480",
    "city": "JETPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365535",
    "city": "AMRELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365540",
    "city": "RAJULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365541",
    "city": "RAJULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365545",
    "city": "RAJULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365550",
    "city": "RAJULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365555",
    "city": "RAJULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365560",
    "city": "RAJULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365565",
    "city": "RAJULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365601",
    "city": "AMRELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365610",
    "city": "AMRELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365616",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365620",
    "city": "AMRELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365630",
    "city": "SAVARKUNDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365632",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365635",
    "city": "SAVARKUNDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365640",
    "city": "SAVARKUNDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365645",
    "city": "SAVARKUNDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365650",
    "city": "SAVARKUNDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365660",
    "city": "SAVARKUNDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "365665",
    "city": "RAJKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "369025",
    "city": "VAPI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370001",
    "city": "BHUJ EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370007",
    "city": "GANDHIDHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370015",
    "city": "BHUJ EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370020",
    "city": "BHUJ EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370030",
    "city": "BHUJ EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370040",
    "city": "BHUJ EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370105",
    "city": "ANJAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370110",
    "city": "ANJAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370115",
    "city": "ANJAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370130",
    "city": "ANJAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370135",
    "city": "BHACHAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370140",
    "city": "BHACHAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370145",
    "city": "BHACHAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370147",
    "city": "GANDHIDHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370150",
    "city": "BHACHAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370155",
    "city": "ANJAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370160",
    "city": "BHACHAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370165",
    "city": "BHACHAU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370201",
    "city": "GANDHIDHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370203",
    "city": "GANDHIDHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370205",
    "city": "GANDHIDHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370210",
    "city": "GANDHIDHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370215",
    "city": "GANDHIDHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370230",
    "city": "GANDHIDHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370240",
    "city": "GANDHIDHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370405",
    "city": "MUNDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370410",
    "city": "MUNDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370411",
    "city": "GANDHIDHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370415",
    "city": "MUNDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370421",
    "city": "MUNDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370425",
    "city": "MUNDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370427",
    "city": "MUNDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370429",
    "city": "BHUJ EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370430",
    "city": "BHUJ EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370435",
    "city": "MANDVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370445",
    "city": "MANDVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370450",
    "city": "MANDVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370455",
    "city": "MANDVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370460",
    "city": "MANDVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370465",
    "city": "MANDVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370472",
    "city": "GANDHIDHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370475",
    "city": "MANDVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370485",
    "city": "BHUJ EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370490",
    "city": "NALIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370510",
    "city": "BHUJ EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370511",
    "city": "NALIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370601",
    "city": "NALIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370602",
    "city": "NALIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370605",
    "city": "NAKHATRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370610",
    "city": "NAKHATRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370615",
    "city": "NAKHATRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370620",
    "city": "NAKHATRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370625",
    "city": "NAKHATRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370627",
    "city": "NALIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370630",
    "city": "NALIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370635",
    "city": "GANDHIDHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370640",
    "city": "NALIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370645",
    "city": "NALIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370650",
    "city": "NALIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370655",
    "city": "NALIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370660",
    "city": "NALIYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370665",
    "city": "NAKHATRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370670",
    "city": "NAKHATRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "370675",
    "city": "NAKHATRANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380001",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380002",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380003",
    "city": "MEMCO OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380004",
    "city": "MEMCO OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380005",
    "city": "CHANDKHEDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380006",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380007",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380008",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380009",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380012",
    "city": "MEMCO OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380013",
    "city": "NARANPURA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380014",
    "city": "NARANPURA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380015",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380016",
    "city": "MEMCO OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380018",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380019",
    "city": "CHANDKHEDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380021",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380022",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380023",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380024",
    "city": "NARODA ETAIL CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380025",
    "city": "NARODA ETAIL CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380026",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380027",
    "city": "CHANDKHEDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380028",
    "city": "BAREJA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380049",
    "city": "BAREJA APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380050",
    "city": "BAREJA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380051",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380052",
    "city": "THALTEJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380053",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380054",
    "city": "THALTEJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380055",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380058",
    "city": "BOPAL SVC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380059",
    "city": "THALTEJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380060",
    "city": "THALTEJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380061",
    "city": "NARANPURA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "380063",
    "city": "NARANPURA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "381111",
    "city": "AHMEDABAD REGIONAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382001",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382002",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382003",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382004",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382005",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382006",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382007",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382008",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382009",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382010",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382011",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382012",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382013",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382014",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382015",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382016",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382017",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382018",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382019",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382020",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382021",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382022",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382023",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382024",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382025",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382026",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382027",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382028",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382029",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382030",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382041",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382042",
    "city": "DEHGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382044",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382045",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382050",
    "city": "GIFT CITY WORLD TRADE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382051",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382110",
    "city": "SANAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382115",
    "city": "SANAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382120",
    "city": "KADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382130",
    "city": "MEH SFC/APEX CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382140",
    "city": "MEH SFC/APEX CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382145",
    "city": "KADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382150",
    "city": "VIRAMGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382165",
    "city": "KADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382170",
    "city": "SANAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382210",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382213",
    "city": "BAVLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382220",
    "city": "BAVLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382225",
    "city": "BAVLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382230",
    "city": "BAVLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382240",
    "city": "BAVLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382245",
    "city": "BOTAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382250",
    "city": "DHANDHUKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382255",
    "city": "BOTAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382260",
    "city": "BAVLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382265",
    "city": "BAVLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382276",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382305",
    "city": "DEHGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382308",
    "city": "DEHGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382315",
    "city": "DEHGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382320",
    "city": "DEHGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382321",
    "city": "DEHGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382325",
    "city": "NARODA ETAIL CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382330",
    "city": "NARODA ETAIL CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382340",
    "city": "NARODA ETAIL CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382345",
    "city": "NARODA ETAIL CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382346",
    "city": "NARODA ETAIL CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382350",
    "city": "NARODA ETAIL CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382352",
    "city": "NARODA ETAIL CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382355",
    "city": "GIFT CITY WORLD TRADE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382405",
    "city": "BAREJA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382410",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382415",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382418",
    "city": "ODHAV",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382420",
    "city": "NARANPURA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382421",
    "city": "CHANDKHEDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382422",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382423",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382424",
    "city": "CHANDKHEDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382425",
    "city": "BAREJA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382426",
    "city": "CHANDKHEDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382427",
    "city": "BAREJA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382428",
    "city": "MEMCO OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382430",
    "city": "ODHAV",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382433",
    "city": "BAREJA APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382435",
    "city": "BAREJA APEX/SFC PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382440",
    "city": "BAREJA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382442",
    "city": "BAREJA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382443",
    "city": "BAREJA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382445",
    "city": "BAREJA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382449",
    "city": "ODHAV",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382450",
    "city": "BOTAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382451",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382455",
    "city": "DHANDHUKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382460",
    "city": "DHANDHUKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382463",
    "city": "DHANDHUKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382465",
    "city": "DHANDHUKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382470",
    "city": "AHD COD CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382475",
    "city": "MEMCO OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382480",
    "city": "AHD COD CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382481",
    "city": "AHD COD CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382610",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382620",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382625",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382630",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382640",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382644",
    "city": "MANSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382650",
    "city": "MANSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382655",
    "city": "BAVLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382705",
    "city": "KALOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382710",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382711",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382715",
    "city": "KADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382721",
    "city": "KALOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382725",
    "city": "KALOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382728",
    "city": "KADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382729",
    "city": "KALOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382730",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382732",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382735",
    "city": "KALOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382740",
    "city": "KALOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382745",
    "city": "SURENDRANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382750",
    "city": "MEH SFC/APEX CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382755",
    "city": "SURENDRANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382760",
    "city": "SURENDRANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382765",
    "city": "SURENDRANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382775",
    "city": "SURENDRANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382780",
    "city": "SURENDRANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382810",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382815",
    "city": "HIMMATNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382820",
    "city": "HIMMATNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382825",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382830",
    "city": "HIMMATNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382835",
    "city": "GANDHINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382840",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382845",
    "city": "MANSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382850",
    "city": "HIMMATNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382855",
    "city": "HIMMATNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382860",
    "city": "HIMMATNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382861",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382865",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382870",
    "city": "HIMMATNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382875",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "382960",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383001",
    "city": "HIMMATNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383006",
    "city": "HIMMATNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383010",
    "city": "HIMMATNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383030",
    "city": "HIMMATNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383110",
    "city": "IDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383120",
    "city": "HIMMATNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383205",
    "city": "HIMMATNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383210",
    "city": "HIMMATNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383215",
    "city": "HIMMATNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383220",
    "city": "HIMMATNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383230",
    "city": "IDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383235",
    "city": "IDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383240",
    "city": "HIMMATNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383245",
    "city": "IDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383246",
    "city": "IDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383250",
    "city": "IDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383251",
    "city": "IDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383255",
    "city": "IDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383260",
    "city": "MODASA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383270",
    "city": "IDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383275",
    "city": "IDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383276",
    "city": "MODASA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383305",
    "city": "DEHGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383307",
    "city": "MODASA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383310",
    "city": "MODASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383315",
    "city": "MODASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383316",
    "city": "MODASA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383317",
    "city": "MODASA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383320",
    "city": "MODASA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383325",
    "city": "MODASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383327",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383330",
    "city": "MODASA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383335",
    "city": "MODASA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383340",
    "city": "MODASA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383345",
    "city": "MODASA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383350",
    "city": "MODASA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383355",
    "city": "MODASA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383410",
    "city": "IDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383422",
    "city": "IDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383430",
    "city": "IDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383434",
    "city": "IDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383440",
    "city": "IDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383460",
    "city": "IDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "383462",
    "city": "IDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384001",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384002",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384003",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384011",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384012",
    "city": "MEH SFC/APEX CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384110",
    "city": "MEH SFC/APEX CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384120",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384130",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384132",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384140",
    "city": "MEH SFC/APEX CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384151",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384160",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384170",
    "city": "KHARALU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384176",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384205",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384206",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384210",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384212",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384215",
    "city": "MEH SFC/APEX CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384220",
    "city": "MEH SFC/APEX CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384221",
    "city": "PATAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384222",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384225",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384228",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384229",
    "city": "PATAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384230",
    "city": "PATAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384240",
    "city": "PATAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384241",
    "city": "RADHANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384245",
    "city": "RADHANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384246",
    "city": "RADHANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384255",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384260",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384265",
    "city": "PATAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384272",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384273",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384275",
    "city": "MEH SFC/APEX CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384285",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384290",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384305",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384310",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384315",
    "city": "KHARALU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384320",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384325",
    "city": "KHARALU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384330",
    "city": "IDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384335",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384340",
    "city": "PALANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384345",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384350",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384355",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384360",
    "city": "IDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384370",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384410",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384421",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384430",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "384435",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385001",
    "city": "PALANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385010",
    "city": "PALANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385110",
    "city": "PALANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385120",
    "city": "PALANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385130",
    "city": "PALANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385135",
    "city": "PALANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385210",
    "city": "PALANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385310",
    "city": "DEESA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385320",
    "city": "RADHANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385330",
    "city": "THARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385340",
    "city": "RADHANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385350",
    "city": "RADHANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385360",
    "city": "RADHANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385410",
    "city": "PALANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385505",
    "city": "PALANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385506",
    "city": "PALANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385510",
    "city": "PALANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385519",
    "city": "MEHSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385520",
    "city": "PALANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385530",
    "city": "DEESA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385535",
    "city": "DEESA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385540",
    "city": "DEESA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385545",
    "city": "DEESA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385550",
    "city": "DEESA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385555",
    "city": "PATAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385560",
    "city": "PATAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385565",
    "city": "THARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385566",
    "city": "THARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385570",
    "city": "THARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "385575",
    "city": "THARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387001",
    "city": "NADIAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387002",
    "city": "NADIAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387003",
    "city": "NADIAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387110",
    "city": "NADIAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387115",
    "city": "NADIAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387120",
    "city": "KHEDA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387130",
    "city": "KHEDA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387140",
    "city": "ANAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387210",
    "city": "KHEDA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387220",
    "city": "ANAND APEX/SFC CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387230",
    "city": "NADIAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387240",
    "city": "ANAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387250",
    "city": "ANAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387305",
    "city": "ANAND APEX/SFC CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387310",
    "city": "ANAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387315",
    "city": "NADIAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387320",
    "city": "NADIAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387325",
    "city": "ANAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387330",
    "city": "NADIAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387331",
    "city": "ANAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387335",
    "city": "NADIAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387340",
    "city": "UMRETH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387345",
    "city": "ANAND APEX/SFC CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387350",
    "city": "NADIAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387355",
    "city": "NADIAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387360",
    "city": "NADIAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387365",
    "city": "KAPADVANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387370",
    "city": "NADIAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387375",
    "city": "ANAND APEX/SFC CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387380",
    "city": "NADIAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387385",
    "city": "ANAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387411",
    "city": "KHEDA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387420",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387421",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387430",
    "city": "NADIAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387510",
    "city": "NADIAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387520",
    "city": "KHEDA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387530",
    "city": "KHEDA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387534",
    "city": "SURAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387540",
    "city": "KHEDA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387550",
    "city": "KHEDA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387560",
    "city": "KHEDA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387570",
    "city": "KHEDA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387610",
    "city": "KAPADVANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387620",
    "city": "KAPADVANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387630",
    "city": "KAPADVANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387635",
    "city": "KAPADVANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387640",
    "city": "KAPADVANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387650",
    "city": "KAPADVANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387710",
    "city": "NADIAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "387810",
    "city": "AHMEDABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388001",
    "city": "ANAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388110",
    "city": "ANAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388120",
    "city": "ANAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388121",
    "city": "ANAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388130",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388140",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388150",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388160",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388170",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388180",
    "city": "KHEDA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388205",
    "city": "UMRETH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388210",
    "city": "UMRETH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388215",
    "city": "UMRETH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388220",
    "city": "UMRETH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388225",
    "city": "UMRETH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388230",
    "city": "UMRETH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388235",
    "city": "KAPADVANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388239",
    "city": "KAPADVANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388245",
    "city": "GODHRA EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388250",
    "city": "UMRETH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388255",
    "city": "KAPADVANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388260",
    "city": "LUNAWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388265",
    "city": "KAPADVANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388270",
    "city": "GODHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388275",
    "city": "ANAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388305",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388306",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388307",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388310",
    "city": "ANAND APEX/SFC CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388315",
    "city": "ANAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388320",
    "city": "ANAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388325",
    "city": "ANAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388330",
    "city": "ANAND APEX/SFC CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388335",
    "city": "ANAND APEX/SFC CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388340",
    "city": "ANAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388345",
    "city": "ANAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388350",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388355",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388360",
    "city": "ANAND APEX/SFC CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388365",
    "city": "UMRETH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388370",
    "city": "ANAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388410",
    "city": "UMRETH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388421",
    "city": "CHANGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388430",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388440",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388450",
    "city": "PETLAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388460",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388465",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388470",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388480",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388510",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388520",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388530",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388540",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388543",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388545",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388550",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388560",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388570",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388580",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388590",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388610",
    "city": "BORSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388620",
    "city": "KHAMBHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388625",
    "city": "KHAMBHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388630",
    "city": "KHAMBHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388640",
    "city": "KHAMBHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388710",
    "city": "GODHRA EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388711",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388712",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388713",
    "city": "GODHRA EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388714",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "388715",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389001",
    "city": "GODHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389110",
    "city": "GODHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389111",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389115",
    "city": "GODHRA EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389120",
    "city": "GODHRA EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389121",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389122",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389123",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389130",
    "city": "PIPLOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389140",
    "city": "PIPLOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389145",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389146",
    "city": "DAHOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389151",
    "city": "DAHOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389152",
    "city": "DAHOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389154",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389155",
    "city": "DAHOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389156",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389157",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389158",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389160",
    "city": "DAHOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389170",
    "city": "JHALOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389172",
    "city": "JHALOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389175",
    "city": "JHALOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389180",
    "city": "JHALOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389190",
    "city": "JHALOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389210",
    "city": "LUNAWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389220",
    "city": "LUNAWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389230",
    "city": "LUNAWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389232",
    "city": "GODHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389235",
    "city": "ANAND APEX/SFC CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389240",
    "city": "GODHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389250",
    "city": "GODHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389260",
    "city": "LUNAWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389265",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389310",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389312",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389320",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389325",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389330",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389340",
    "city": "GODHRA EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389341",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389342",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389343",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389344",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389345",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389346",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389347",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389350",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389351",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389352",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389355",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389360",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389365",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389370",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389380",
    "city": "PIPLOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389382",
    "city": "DAHOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "389390",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390001",
    "city": "SAYAJIGUNJ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390002",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390003",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390004",
    "city": "SAYAJIGUNJ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390005",
    "city": "BDO E-TAIL SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390006",
    "city": "KARELIBAUGH CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390007",
    "city": "BDO E-TAIL SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390008",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390009",
    "city": "SAYAJIGUNJ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390010",
    "city": "SAYAJIGUNJ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390011",
    "city": "SAYAJIGUNJ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390012",
    "city": "SAYAJIGUNJ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390013",
    "city": "SAYAJIGUNJ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390014",
    "city": "SAYAJIGUNJ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390015",
    "city": "SAYAJIGUNJ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390016",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390017",
    "city": "SAYAJIGUNJ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390018",
    "city": "KARELIBAUGH CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390019",
    "city": "KARELIBAUGH CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390020",
    "city": "SAYAJIGUNJ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390021",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390022",
    "city": "KARELIBAUGH CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390023",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390024",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390025",
    "city": "KARELIBAUGH CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390440",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "390441",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391101",
    "city": "BARODA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391105",
    "city": "DABHOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391107",
    "city": "DABHOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391110",
    "city": "DABHOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391111",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391115",
    "city": "DABHOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391120",
    "city": "DABHOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391121",
    "city": "DABHOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391125",
    "city": "BODELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391126",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391130",
    "city": "BODELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391135",
    "city": "BODELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391140",
    "city": "BODELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391145",
    "city": "BODELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391150",
    "city": "BODELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391151",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391152",
    "city": "BODELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391155",
    "city": "BODELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391156",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391160",
    "city": "CHHOTAUDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391165",
    "city": "CHHOTAUDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391168",
    "city": "CHHOTAUDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391169",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391170",
    "city": "CHHOTAUDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391175",
    "city": "CHHOTAUDAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391210",
    "city": "KARJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391220",
    "city": "KARJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391230",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391240",
    "city": "KARJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391243",
    "city": "SAYAJIGUNJ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391244",
    "city": "KARJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391250",
    "city": "KARJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391310",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391320",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391330",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391340",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391345",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391346",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391347",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391350",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391410",
    "city": "SAYAJIGUNJ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391421",
    "city": "PADRA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391430",
    "city": "PADRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391440",
    "city": "PADRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391445",
    "city": "BARODA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391447",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391450",
    "city": "PADRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391460",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391510",
    "city": "HALOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391520",
    "city": "SAVLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391530",
    "city": "SAVLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391535",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391740",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391742",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391745",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391750",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391760",
    "city": "KARELIBAUGH CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391761",
    "city": "DABHOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391765",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391766",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391770",
    "city": "SAVLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391774",
    "city": "SAVLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391775",
    "city": "SAVLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391776",
    "city": "SAVLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391780",
    "city": "SAVLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "391810",
    "city": "PADRA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392001",
    "city": "BHARUCH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392002",
    "city": "BHARUCH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392011",
    "city": "BHARUCH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392012",
    "city": "BHARUCH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392015",
    "city": "BHARUCH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392020",
    "city": "BHARUCH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392021",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392025",
    "city": "KARJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392027",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392030",
    "city": "BHARUCH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392031",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392035",
    "city": "KARJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392040",
    "city": "PADRA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392102",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392110",
    "city": "KARJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392120",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392126",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392130",
    "city": "BHARUCH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392135",
    "city": "BHARUCH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392140",
    "city": "BHARUCH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392150",
    "city": "KARJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392155",
    "city": "PADRA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392160",
    "city": "BHARUCH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392161",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392162",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392165",
    "city": "BHARUCH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392170",
    "city": "PADRA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392180",
    "city": "PADRA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392210",
    "city": "BHARUCH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392215",
    "city": "BHARUCH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392220",
    "city": "KARJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392221",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392230",
    "city": "KARJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392240",
    "city": "BHARUCH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392280",
    "city": "VADODARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "392310",
    "city": "KARJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393001",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393002",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393010",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393017",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393020",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393025",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393028",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393030",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393040",
    "city": "RAJPIPLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393041",
    "city": "RAJPIPLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393050",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393105",
    "city": "KARJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393110",
    "city": "JHAGADIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393115",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393120",
    "city": "RAJPIPLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393125",
    "city": "RAJPIPLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393130",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393135",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393140",
    "city": "RAJPIPLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393145",
    "city": "RAJPIPLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393150",
    "city": "RAJPIPLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "393151",
    "city": "RAJPIPLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394003",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394006",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394101",
    "city": "KATARGAM OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394105",
    "city": "KATARGAM OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394107",
    "city": "KATARGAM OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394110",
    "city": "KIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394111",
    "city": "KIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394112",
    "city": "SURAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394115",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394116",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394120",
    "city": "KIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394125",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394130",
    "city": "KIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394140",
    "city": "KIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394145",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394150",
    "city": "KAMREJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394155",
    "city": "KIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394160",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394163",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394170",
    "city": "KIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394180",
    "city": "KAMREJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394185",
    "city": "KAMREJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394190",
    "city": "KAMREJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394210",
    "city": "SURAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394220",
    "city": "SURAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394221",
    "city": "SURAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394230",
    "city": "SURAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394235",
    "city": "PALSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394240",
    "city": "BARDOLI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394244",
    "city": "BHAVNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394245",
    "city": "NAVSARI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394246",
    "city": "NAVSARI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394248",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394250",
    "city": "BARDOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394270",
    "city": "HAZIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394305",
    "city": "PALSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394310",
    "city": "BARDOLI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394315",
    "city": "PALSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394317",
    "city": "PALSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394320",
    "city": "KAMREJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394325",
    "city": "PALSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394326",
    "city": "KAMREJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394327",
    "city": "PALSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394330",
    "city": "KAMREJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394335",
    "city": "BARDOLI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394340",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394345",
    "city": "BARDOLI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394350",
    "city": "BARDOLI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394352",
    "city": "PALSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394355",
    "city": "BARDOLI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394360",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394363",
    "city": "SURAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394364",
    "city": "SURAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394365",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394370",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394375",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394380",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394405",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394410",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394421",
    "city": "KIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394430",
    "city": "KIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394440",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394444",
    "city": "SURAT ETAIL RTO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394445",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394510",
    "city": "HAZIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394515",
    "city": "HAZIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394516",
    "city": "HAZIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394517",
    "city": "SURAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394518",
    "city": "HAZIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394520",
    "city": "KATARGAM OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394530",
    "city": "OLPAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394540",
    "city": "OLPAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394550",
    "city": "SURAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394601",
    "city": "BARDOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394602",
    "city": "BARDOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394620",
    "city": "BARDOLI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394630",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394633",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394635",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394640",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394641",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394650",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394651",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394652",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394655",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394660",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394670",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394680",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394690",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394710",
    "city": "AHWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394715",
    "city": "AHWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394716",
    "city": "AHWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394720",
    "city": "SURAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394730",
    "city": "SURAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "394810",
    "city": "ANKLESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "395001",
    "city": "NANPURA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "395002",
    "city": "SURAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "395003",
    "city": "KATARGAM OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "395004",
    "city": "KATARGAM OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "395005",
    "city": "ADAJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "395006",
    "city": "KATARGAM OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "395007",
    "city": "NANPURA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "395008",
    "city": "KATARGAM OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "395009",
    "city": "ADAJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "395010",
    "city": "KATARGAM OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "395011",
    "city": "SURAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "395012",
    "city": "SURAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "395013",
    "city": "KATARGAM OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "395017",
    "city": "NANPURA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "395023",
    "city": "SURAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "395345",
    "city": "SURAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "395620",
    "city": "SURAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396001",
    "city": "VALSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396002",
    "city": "VALSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396005",
    "city": "VAPI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396007",
    "city": "VALSAD REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396020",
    "city": "VALSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396025",
    "city": "VAPI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396030",
    "city": "VALSAD REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396031",
    "city": "VAPI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396035",
    "city": "VALSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396040",
    "city": "CHIKHLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396045",
    "city": "VALSAD REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396050",
    "city": "VALSAD REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396051",
    "city": "VALSAD REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396055",
    "city": "VALSAD REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396060",
    "city": "CHIKHLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396065",
    "city": "VAPI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396068",
    "city": "VAPI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396105",
    "city": "VAPI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396110",
    "city": "CHIKHLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396112",
    "city": "VAPI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396115",
    "city": "PARDI VALSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396120",
    "city": "UMARGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396125",
    "city": "VALSAD REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396126",
    "city": "VALSAD REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396130",
    "city": "UMARGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396135",
    "city": "UMARGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396140",
    "city": "VAPI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396145",
    "city": "VAPI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396150",
    "city": "UMARGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396155",
    "city": "VAPI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396165",
    "city": "UMARGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396170",
    "city": "UMARGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396171",
    "city": "UMARGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396175",
    "city": "PARDI VALSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396185",
    "city": "PARDI VALSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396191",
    "city": "VAPI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396193",
    "city": "SILVASSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396195",
    "city": "VAPI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396201",
    "city": "VAPI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396210",
    "city": "DAMAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396215",
    "city": "DAMAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396220",
    "city": "DAMAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396230",
    "city": "SILVASSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396235",
    "city": "SILVASSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396236",
    "city": "VAPI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396240",
    "city": "SILVASSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396310",
    "city": "BILLIMORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396321",
    "city": "BILLIMORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396325",
    "city": "BILLIMORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396350",
    "city": "NAVSARI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396360",
    "city": "BILLIMORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396370",
    "city": "BILLIMORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396375",
    "city": "VALSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396380",
    "city": "BILLIMORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396385",
    "city": "VALSAD REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396403",
    "city": "NAVSARI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396406",
    "city": "NAVSARI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396409",
    "city": "CHIKHLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396412",
    "city": "NAVSARI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396415",
    "city": "PALSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396418",
    "city": "NAVSARI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396421",
    "city": "NAVSARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396424",
    "city": "NAVSARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396427",
    "city": "NAVSARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396430",
    "city": "CHIKHLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396433",
    "city": "NAVSARI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396436",
    "city": "NAVSARI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396439",
    "city": "NAVSARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396440",
    "city": "NAVSARI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396445",
    "city": "NAVSARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396450",
    "city": "NAVSARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396460",
    "city": "NAVSARI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396463",
    "city": "NAVSARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396466",
    "city": "NAVSARI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396469",
    "city": "NAVSARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396472",
    "city": "NAVSARI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396475",
    "city": "PALSANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396510",
    "city": "CHIKHLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396521",
    "city": "CHIKHLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396530",
    "city": "CHIKHLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396540",
    "city": "CHIKHLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396560",
    "city": "CHIKHLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396570",
    "city": "CHIKHLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396580",
    "city": "CHIKHLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "396590",
    "city": "VYARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400000",
    "city": "ULWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400001",
    "city": "FORT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400002",
    "city": "MASJID",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400003",
    "city": "MASJID",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400004",
    "city": "TARDEO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400005",
    "city": "CHURCHGATE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400006",
    "city": "TARDEO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400007",
    "city": "TARDEO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400008",
    "city": "APSARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400009",
    "city": "MASJID",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400010",
    "city": "MASJID",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400011",
    "city": "LOWER PAREL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400013",
    "city": "SENAPATI BAPAT ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400014",
    "city": "WADALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400015",
    "city": "WADALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400016",
    "city": "DADAR MAHIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400017",
    "city": "DHARAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400018",
    "city": "WORLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400019",
    "city": "DHARAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400020",
    "city": "CHURCHGATE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400021",
    "city": "NARIMAN POINT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400022",
    "city": "CHEMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400023",
    "city": "CHURCHGATE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400024",
    "city": "CHEMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400025",
    "city": "WORLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400026",
    "city": "TARDEO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400028",
    "city": "DADAR MAHIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400029",
    "city": "BANDRA (EAST)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400030",
    "city": "WORLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400031",
    "city": "WADALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400032",
    "city": "NARIMAN POINT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400033",
    "city": "WADALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400034",
    "city": "TARDEO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400035",
    "city": "TARDEO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400036",
    "city": "TARDEO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400037",
    "city": "ANTOP HILL TRUCK TERMINAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400038",
    "city": "FORT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400039",
    "city": "FORT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400042",
    "city": "MULUND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400043",
    "city": "CHEMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400049",
    "city": "SANTACRUZ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400050",
    "city": "BANDRA KURLA COMPLEX",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400051",
    "city": "BANDRA (EAST)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400052",
    "city": "SANTACRUZ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400053",
    "city": "JUHU VERSOVA LINK ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400054",
    "city": "SANTACRUZ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400055",
    "city": "BANDRA (EAST)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400056",
    "city": "SANTACRUZ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400057",
    "city": "ADARSH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400058",
    "city": "ANDHERI WEST S/C",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400059",
    "city": "SEEPZ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400060",
    "city": "GOREGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400061",
    "city": "JUHU VERSOVA LINK ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400062",
    "city": "JOGESHWARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400063",
    "city": "GOREGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400064",
    "city": "JOGESHWARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400065",
    "city": "GOREGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400066",
    "city": "BORIVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400067",
    "city": "CHIKU WADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400068",
    "city": "BORIVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400069",
    "city": "ADARSH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400070",
    "city": "KURLA WEST DP CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400071",
    "city": "CHEMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400072",
    "city": "SAKINAKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400074",
    "city": "CHEMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400075",
    "city": "GHATKOPAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400076",
    "city": "SAKINAKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400077",
    "city": "GHATKOPAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400078",
    "city": "BHANDUP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400079",
    "city": "GHATKOPAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400080",
    "city": "MULUND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400081",
    "city": "MULUND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400082",
    "city": "MULUND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400083",
    "city": "GHATKOPAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400084",
    "city": "GHATKOPAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400085",
    "city": "CHEMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400086",
    "city": "GHATKOPAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400087",
    "city": "SAKINAKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400088",
    "city": "CHEMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400089",
    "city": "CHEMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400090",
    "city": "JOGESHWARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400091",
    "city": "CHIKU WADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400092",
    "city": "CHIKU WADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400093",
    "city": "SEEPZ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400094",
    "city": "CHEMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400095",
    "city": "MALVANI CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400096",
    "city": "SEEPZ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400097",
    "city": "GOREGOAN MALAD SER CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400098",
    "city": "BANDRA (EAST)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400099",
    "city": "ADARSH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400101",
    "city": "BORIVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400102",
    "city": "OSHIWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400103",
    "city": "CHIKU WADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400104",
    "city": "OSHIWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400218",
    "city": "PANVEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400601",
    "city": "THANE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400602",
    "city": "THANE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400603",
    "city": "THANE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400604",
    "city": "THANE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400605",
    "city": "THANE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400606",
    "city": "MANPADA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400607",
    "city": "MANPADA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400608",
    "city": "MANPADA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400609",
    "city": "MANPADA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400610",
    "city": "MANPADA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400611",
    "city": "THANE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400612",
    "city": "MUMBRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400614",
    "city": "BELAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400615",
    "city": "MANPADA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400701",
    "city": "MAHAPE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400702",
    "city": "URAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400703",
    "city": "NEW BOMBAY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400704",
    "city": "URAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400705",
    "city": "NEW BOMBAY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400706",
    "city": "BELAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400707",
    "city": "URAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400708",
    "city": "AIROLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400709",
    "city": "MAHAPE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "400710",
    "city": "MAHAPE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401101",
    "city": "BHAYANDER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401102",
    "city": "PALGHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401103",
    "city": "VANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401104",
    "city": "MEERA ROAD-BHAYANDER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401105",
    "city": "BHAYANDER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401106",
    "city": "BHAYANDER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401107",
    "city": "MEERA ROAD-BHAYANDER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401201",
    "city": "VASAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401202",
    "city": "VASAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401203",
    "city": "VIRAR WEST",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401204",
    "city": "BHIWANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401205",
    "city": "VASAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401206",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401207",
    "city": "VASAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401208",
    "city": "VASAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401209",
    "city": "VASAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401210",
    "city": "VASAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401301",
    "city": "VIRAR WEST",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401302",
    "city": "VIRAR WEST",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401303",
    "city": "VIRAR WEST",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401304",
    "city": "VIRAR WEST",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401305",
    "city": "VIRAR WEST",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401401",
    "city": "PALGHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401402",
    "city": "PALGHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401403",
    "city": "PALGHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401404",
    "city": "PALGHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401405",
    "city": "PALGHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401407",
    "city": "PALGHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401501",
    "city": "TARAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401502",
    "city": "TARAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401503",
    "city": "TARAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401504",
    "city": "TARAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401505",
    "city": "TARAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401506",
    "city": "TARAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401601",
    "city": "DAHANU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401602",
    "city": "DAHANU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401603",
    "city": "TARAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401604",
    "city": "BHIWANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401605",
    "city": "PADAGHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401606",
    "city": "THANE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401607",
    "city": "TARAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401608",
    "city": "DAHANU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401609",
    "city": "TARAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401610",
    "city": "TARAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401701",
    "city": "TARAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401702",
    "city": "TARAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "401703",
    "city": "TARAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402101",
    "city": "MANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402102",
    "city": "MAHAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402103",
    "city": "MANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402104",
    "city": "MANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402105",
    "city": "SHRIWARDHAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402106",
    "city": "NAGOTHANE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402107",
    "city": "PEN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402108",
    "city": "ALIBAUG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402109",
    "city": "NAGOTHANE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402110",
    "city": "SHRIWARDHAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402111",
    "city": "MANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402112",
    "city": "MANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402113",
    "city": "SHRIWARDHAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402114",
    "city": "SHRIWARDHAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402115",
    "city": "MAHAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402116",
    "city": "NAGOTHANE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402117",
    "city": "MANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402118",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402120",
    "city": "MANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402122",
    "city": "MANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402125",
    "city": "NAGOTHANE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402126",
    "city": "NAGOTHANE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402201",
    "city": "ALIBAUG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402202",
    "city": "JANJIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402203",
    "city": "ALIBAUG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402204",
    "city": "ALIBAUG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402207",
    "city": "ALIBAUG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402208",
    "city": "ALIBAUG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402209",
    "city": "ALIBAUG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402301",
    "city": "MAHAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402302",
    "city": "MAHAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402303",
    "city": "MAHAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402304",
    "city": "NAGOTHANE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402305",
    "city": "MAHAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402306",
    "city": "MAHAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402307",
    "city": "MAHAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402308",
    "city": "MANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402309",
    "city": "MAHAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402401",
    "city": "JANJIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402402",
    "city": "SHRIWARDHAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402403",
    "city": "SHRIWARDHAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402404",
    "city": "SHRIWARDHAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "402406",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403001",
    "city": "PANJIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403002",
    "city": "PANJIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403003",
    "city": "PANJIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403004",
    "city": "PANJIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403005",
    "city": "PANJIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403006",
    "city": "PANJIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403101",
    "city": "PORVORIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403103",
    "city": "PONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403104",
    "city": "PANJIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403105",
    "city": "BICHOLIM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403106",
    "city": "PANJIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403107",
    "city": "PANJIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403108",
    "city": "PANJIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403109",
    "city": "PORVORIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403110",
    "city": "PANJIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403114",
    "city": "PORVORIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403115",
    "city": "PANJIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403201",
    "city": "PANJIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403202",
    "city": "PANJIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403203",
    "city": "PANJIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403204",
    "city": "PANJIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403206",
    "city": "PANJIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403401",
    "city": "PONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403402",
    "city": "PANJIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403403",
    "city": "BICHOLIM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403404",
    "city": "PONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403405",
    "city": "PONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403406",
    "city": "PONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403407",
    "city": "PONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403409",
    "city": "PONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403410",
    "city": "QUEPEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403501",
    "city": "PORVORIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403502",
    "city": "MAPUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403503",
    "city": "BICHOLIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403504",
    "city": "BICHOLIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403505",
    "city": "BICHOLIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403506",
    "city": "BICHOLIM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403507",
    "city": "MAPUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403508",
    "city": "MAPUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403509",
    "city": "ARPORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403510",
    "city": "MAPUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403511",
    "city": "ARPORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403512",
    "city": "PERNEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403513",
    "city": "PERNEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403514",
    "city": "MAPUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403515",
    "city": "ARPORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403516",
    "city": "ARPORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403517",
    "city": "MAPUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403518",
    "city": "ARPORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403519",
    "city": "ARPORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403521",
    "city": "PORVORIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403523",
    "city": "MAPUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403524",
    "city": "PERNEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403526",
    "city": "MAPUSA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403527",
    "city": "PERNEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403529",
    "city": "BICHOLIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403530",
    "city": "BICHOLIM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403601",
    "city": "NAVELIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403602",
    "city": "NAVELIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403603",
    "city": "VERNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403604",
    "city": "VERNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403701",
    "city": "QUEPEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403702",
    "city": "QUEPEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403703",
    "city": "QUEPEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403704",
    "city": "QUEPEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403705",
    "city": "QUEPEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403706",
    "city": "QUEPEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403707",
    "city": "NAVELIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403708",
    "city": "NAVELIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403709",
    "city": "NAVELIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403710",
    "city": "VERNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403711",
    "city": "VASCO COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403712",
    "city": "VERNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403713",
    "city": "VERNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403714",
    "city": "QUEPEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403715",
    "city": "QUEPEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403716",
    "city": "NAVELIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403717",
    "city": "NAVELIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403718",
    "city": "VERNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403719",
    "city": "NAVELIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403720",
    "city": "NAVELIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403721",
    "city": "NAVELIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403722",
    "city": "VERNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403723",
    "city": "QUEPEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403724",
    "city": "NAVELIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403725",
    "city": "NAVELIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403726",
    "city": "VASCO COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403728",
    "city": "QUEPEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403729",
    "city": "NAVELIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403731",
    "city": "NAVELIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403801",
    "city": "VASCO COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403802",
    "city": "VASCO COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403803",
    "city": "VASCO COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403804",
    "city": "VASCO COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "403806",
    "city": "VASCO COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "404411",
    "city": "AHMEDNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410000",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410101",
    "city": "KARJAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410102",
    "city": "KARJAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410201",
    "city": "KARJAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410202",
    "city": "KHOPOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410203",
    "city": "KHOPOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410204",
    "city": "KHOPOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410205",
    "city": "NAGOTHANE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410206",
    "city": "PANVEL EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410207",
    "city": "PATALGANGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410208",
    "city": "PANVEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410209",
    "city": "PANVEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410210",
    "city": "KHARGHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410216",
    "city": "KHOPOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410217",
    "city": "ETAIL PANVEL WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410218",
    "city": "PANVEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410220",
    "city": "PATALGANGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410221",
    "city": "ETAIL PANVEL WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410222",
    "city": "PATALGANGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410301",
    "city": "LONAVALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410302",
    "city": "LONAVALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410401",
    "city": "LONAVALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410402",
    "city": "LONAVALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410403",
    "city": "LONAVALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410405",
    "city": "LONAVALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410406",
    "city": "TALEGAON PUD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410410",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410501",
    "city": "CHAKAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410502",
    "city": "NARAYANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410503",
    "city": "MANCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410504",
    "city": "NARAYANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410505",
    "city": "KHED CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410506",
    "city": "TALEGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410507",
    "city": "TALEGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410508",
    "city": "MANCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410509",
    "city": "MANCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410510",
    "city": "KHED CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410511",
    "city": "NARAYANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410512",
    "city": "KHED CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410513",
    "city": "KHED CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410514",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410515",
    "city": "MANCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410516",
    "city": "MANCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "410613",
    "city": "NEW BOMBAY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411001",
    "city": "BUND GARDEN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411002",
    "city": "PARVATI SERVICE CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411003",
    "city": "BUND GARDEN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411004",
    "city": "KOTHRUD(PUNE)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411005",
    "city": "KOTHRUD(PUNE)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411006",
    "city": "VIMAN NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411007",
    "city": "BANER SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411008",
    "city": "BANER SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411009",
    "city": "PARVATI SERVICE CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411010",
    "city": "KOTHRUD(PUNE)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411011",
    "city": "PARVATI SERVICE CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411012",
    "city": "SANGHVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411013",
    "city": "HADAPSAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411014",
    "city": "VIMAN NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411015",
    "city": "TINGRE NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411016",
    "city": "KOTHRUD(PUNE)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411018",
    "city": "PIMPRI AND CHINCHWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411019",
    "city": "PIMPRI AND CHINCHWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411020",
    "city": "KOTHRUD(PUNE)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411021",
    "city": "SUTARWADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411022",
    "city": "HADAPSAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411023",
    "city": "SINHAGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411024",
    "city": "SINHAGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411025",
    "city": "SINHAGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411026",
    "city": "PIMPRI AND CHINCHWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411027",
    "city": "SANGHVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411028",
    "city": "HADAPSAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411029",
    "city": "DHANUKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411030",
    "city": "SINHAGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411031",
    "city": "SANGHVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411032",
    "city": "LOHEGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411033",
    "city": "WALHEKARWADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411034",
    "city": "SANGHVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411035",
    "city": "NIGDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411036",
    "city": "VIMAN NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411037",
    "city": "PARVATI SERVICE CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411038",
    "city": "DHANUKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411039",
    "city": "PIMPRI AND CHINCHWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411041",
    "city": "SINHAGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411042",
    "city": "PARVATI SERVICE CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411043",
    "city": "DATTA NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411044",
    "city": "NIGDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411045",
    "city": "BANER SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411046",
    "city": "DATTA NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411047",
    "city": "LOHEGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411048",
    "city": "PARVATI SERVICE CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411051",
    "city": "SINHAGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411052",
    "city": "DHANUKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411053",
    "city": "KOTHRUD(PUNE)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411057",
    "city": "HINJEWADI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411058",
    "city": "DHANUKAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411060",
    "city": "UNDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411061",
    "city": "SANGHVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411062",
    "city": "MOSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411067",
    "city": "BANER SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411068",
    "city": "SINHAGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411070",
    "city": "MOSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411081",
    "city": "MOSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411111",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411201",
    "city": "HADAPSAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "411925",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412042",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412101",
    "city": "MUKAI CHOWK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412102",
    "city": "LONAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412103",
    "city": "PHALTAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412104",
    "city": "JEJURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412105",
    "city": "MOSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412106",
    "city": "TALEGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412107",
    "city": "KELEWADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412108",
    "city": "PIRANGUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412109",
    "city": "TALEGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412110",
    "city": "URULIKANCHAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412111",
    "city": "PIRANGUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412112",
    "city": "PIRANGUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412113",
    "city": "TALEGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412115",
    "city": "PIRANGUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412201",
    "city": "LONI KALBHOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412202",
    "city": "URULIKANCHAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412203",
    "city": "URULIKANCHAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412204",
    "city": "JEJURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412205",
    "city": "KELEWADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412206",
    "city": "KELEWADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412207",
    "city": "UBALE NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412208",
    "city": "SHIKRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412209",
    "city": "SHIKRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412210",
    "city": "SHIRUR RANJANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412211",
    "city": "SHIRUR RANJANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412212",
    "city": "KELEWADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412213",
    "city": "KELEWADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412214",
    "city": "URULIKANCHAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412215",
    "city": "DAUND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412216",
    "city": "SANASWADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412217",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412218",
    "city": "SHIRUR RANJANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412219",
    "city": "DAUND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412220",
    "city": "SHIKRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412301",
    "city": "JEJURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412302",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412303",
    "city": "JEJURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412304",
    "city": "JEJURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412305",
    "city": "JEJURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412306",
    "city": "LONAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412307",
    "city": "MANJARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412308",
    "city": "HADAPSAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412310",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412311",
    "city": "JEJURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412312",
    "city": "JEJURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412401",
    "city": "NARAYANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412402",
    "city": "KHED CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412403",
    "city": "KHED CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412404",
    "city": "KHED CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412405",
    "city": "MANCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412406",
    "city": "MANCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412408",
    "city": "MANCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412409",
    "city": "NARAYANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412410",
    "city": "NARAYANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412411",
    "city": "NARAYANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412412",
    "city": "NARAYANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412415",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412801",
    "city": "SHIRWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412802",
    "city": "SHIRWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412803",
    "city": "WAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412804",
    "city": "WAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412805",
    "city": "WAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412806",
    "city": "WAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "412809",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413001",
    "city": "SOLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413002",
    "city": "SOLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413003",
    "city": "SOLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413004",
    "city": "SOLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413005",
    "city": "SOLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413006",
    "city": "SOLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413007",
    "city": "SOLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413008",
    "city": "SOLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413033",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413101",
    "city": "AKLUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413102",
    "city": "BARAMATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413103",
    "city": "AKLUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413104",
    "city": "INDAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413105",
    "city": "BHIGWAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413106",
    "city": "INDAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413107",
    "city": "AKLUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413108",
    "city": "AKLUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413109",
    "city": "AKLUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413110",
    "city": "MALEGAON BUDRUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413111",
    "city": "AKLUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413112",
    "city": "AKLUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413113",
    "city": "AKLUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413114",
    "city": "INDAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413115",
    "city": "MALEGAON BUDRUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413116",
    "city": "MALEGAON BUDRUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413117",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413118",
    "city": "AKLUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413120",
    "city": "INDAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413124",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413129",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413130",
    "city": "BHIGWAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413132",
    "city": "INDAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413133",
    "city": "BARAMATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413201",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413202",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413203",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413204",
    "city": "BEED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413205",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413206",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413207",
    "city": "BEED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413208",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413209",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413210",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413211",
    "city": "AKLUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413212",
    "city": "AKLUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413213",
    "city": "KONDI SOLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413214",
    "city": "SOLAPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413215",
    "city": "SOLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413216",
    "city": "SOLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413217",
    "city": "SOLAPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413218",
    "city": "SOLAPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413219",
    "city": "SOLAPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413220",
    "city": "SOLAPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413221",
    "city": "SOLAPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413222",
    "city": "KONDI SOLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413223",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413224",
    "city": "SOLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413225",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413226",
    "city": "SOLAPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413227",
    "city": "SOLAPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413228",
    "city": "SOLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413229",
    "city": "BEED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413233",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413235",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413245",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413248",
    "city": "SOLAPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413249",
    "city": "BEED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413250",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413251",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413252",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413253",
    "city": "SOLAPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413255",
    "city": "KONDI SOLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413301",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413302",
    "city": "AKLUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413303",
    "city": "SOLAPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413304",
    "city": "AKLUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413305",
    "city": "SOLAPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413306",
    "city": "AKLUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413307",
    "city": "AKLUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413308",
    "city": "AKLUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413309",
    "city": "AKLUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413310",
    "city": "AKLUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413314",
    "city": "AKLUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413315",
    "city": "AKLUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413317",
    "city": "AKLUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413319",
    "city": "SOLAPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413322",
    "city": "SOLAPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413324",
    "city": "SOLAPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413401",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413402",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413403",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413404",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413405",
    "city": "OSMANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413406",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413409",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413410",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413411",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413412",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413432",
    "city": "UDGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413501",
    "city": "OSMANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413502",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413503",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413504",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413505",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413506",
    "city": "OSMANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413507",
    "city": "KAIJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413508",
    "city": "OSMANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413509",
    "city": "OSMANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413510",
    "city": "LATUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413511",
    "city": "LATUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413512",
    "city": "LATUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413513",
    "city": "LATUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413514",
    "city": "LATUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413515",
    "city": "LATUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413516",
    "city": "LATUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413517",
    "city": "UDGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413518",
    "city": "UDGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413519",
    "city": "UDGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413520",
    "city": "LATUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413521",
    "city": "LATUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413522",
    "city": "LATUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413523",
    "city": "UDGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413524",
    "city": "LATUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413525",
    "city": "KAIJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413526",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413527",
    "city": "LATUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413528",
    "city": "KAIJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413529",
    "city": "LATUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413530",
    "city": "LATUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413531",
    "city": "LATUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413532",
    "city": "UDGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413534",
    "city": "BARSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413536",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413540",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413544",
    "city": "LATUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413546",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413547",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413554",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413569",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413576",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413577",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413580",
    "city": "OSMANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413581",
    "city": "LATUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413582",
    "city": "OSMANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413601",
    "city": "OSMANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413602",
    "city": "SOLAPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413603",
    "city": "SOLAPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413604",
    "city": "OMERGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413605",
    "city": "OMERGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413606",
    "city": "OMERGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413607",
    "city": "LATUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413608",
    "city": "OSMANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413615",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413616",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413623",
    "city": "OSMANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413624",
    "city": "SOLAPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413701",
    "city": "SHRIGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413702",
    "city": "BELWANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413703",
    "city": "SHRIGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413704",
    "city": "AHMEDNAGAR ETAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413705",
    "city": "SHRIRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413706",
    "city": "SHRIRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413707",
    "city": "SHRIRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413708",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413709",
    "city": "SHRIRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413710",
    "city": "LONI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413711",
    "city": "LONI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413712",
    "city": "LONI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413713",
    "city": "LONI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413714",
    "city": "SANGAMNER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413715",
    "city": "SHRIRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413716",
    "city": "SHRIRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413717",
    "city": "SHRIRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413718",
    "city": "SHRIRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413719",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413720",
    "city": "SHRIRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413721",
    "city": "SHRIRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413722",
    "city": "SHRIRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413723",
    "city": "SHRIRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413725",
    "city": "SHRIRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413726",
    "city": "SHRIGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413728",
    "city": "SHRIGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413736",
    "city": "LONI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413737",
    "city": "LONI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413738",
    "city": "SANGAMNER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413739",
    "city": "SHRIRAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413801",
    "city": "DAUND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413802",
    "city": "KURKUMBH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "413832",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414001",
    "city": "AHMEDNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414002",
    "city": "AHMEDNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414003",
    "city": "AHMEDNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414005",
    "city": "AHMEDNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414006",
    "city": "AHMEDNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414101",
    "city": "SHRIGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414102",
    "city": "SHEVGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414103",
    "city": "SUPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414105",
    "city": "NEWASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414106",
    "city": "SHEVGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414110",
    "city": "AHMEDNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414111",
    "city": "AHMEDNAGAR ETAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414113",
    "city": "SHEVGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414201",
    "city": "AHMEDNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414202",
    "city": "BEED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414203",
    "city": "BEED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414204",
    "city": "BEED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414205",
    "city": "BEED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414208",
    "city": "BEED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414301",
    "city": "SUPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414302",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414303",
    "city": "SUPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414304",
    "city": "SUPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414305",
    "city": "SUPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414306",
    "city": "SHIRUR RANJANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414307",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414401",
    "city": "SHRIGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414402",
    "city": "SHRIGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414403",
    "city": "SHRIGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414501",
    "city": "SHEVGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414502",
    "city": "SHEVGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414503",
    "city": "SHEVGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414504",
    "city": "SHEVGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414505",
    "city": "SHEVGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414601",
    "city": "AHMEDNAGAR ETAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414602",
    "city": "NEWASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414603",
    "city": "NEWASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414604",
    "city": "NEWASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414605",
    "city": "NEWASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414606",
    "city": "NEWASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414607",
    "city": "NEWASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414609",
    "city": "NEWASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "414701",
    "city": "SHRIGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415001",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415002",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415003",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415004",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415010",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415011",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415012",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415013",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415014",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415015",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415019",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415020",
    "city": "WAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415021",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415022",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415023",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415101",
    "city": "PANAHLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415102",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415103",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415104",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415105",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415106",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415107",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415108",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415109",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415110",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415111",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415112",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415114",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415115",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415116",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415118",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415120",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415122",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415124",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415202",
    "city": "KHED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415203",
    "city": "DAPOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415205",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415206",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415207",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415208",
    "city": "KHED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415209",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415210",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415211",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415212",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415213",
    "city": "MAHAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415214",
    "city": "KHED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415301",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415302",
    "city": "PALUS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415303",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415304",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415305",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415306",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415307",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415308",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415309",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415310",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415311",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415312",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415313",
    "city": "PALUS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415315",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415401",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415402",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415403",
    "city": "PALUS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415404",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415405",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415406",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415407",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415408",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415409",
    "city": "URUN ISLAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415410",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415411",
    "city": "SHIROLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415412",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415413",
    "city": "PALUS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415414",
    "city": "URUN ISLAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415415",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415416",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415417",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415418",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415501",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415502",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415503",
    "city": "PHALTAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415504",
    "city": "PHALTAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415505",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415506",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415507",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415508",
    "city": "PHALTAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415509",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415510",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415511",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415512",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415513",
    "city": "WAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415514",
    "city": "WAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415515",
    "city": "WAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415516",
    "city": "WAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415517",
    "city": "WAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415518",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415519",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415520",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415521",
    "city": "LONAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415522",
    "city": "PHALTAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415523",
    "city": "PHALTAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415524",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415525",
    "city": "WAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415526",
    "city": "SHIRWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415527",
    "city": "SATARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415528",
    "city": "PHALTAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415529",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415530",
    "city": "WAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415536",
    "city": "WAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415537",
    "city": "LONAND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415538",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415539",
    "city": "KARAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415540",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415601",
    "city": "CHIPLUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415602",
    "city": "CHIPLUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415603",
    "city": "CHIPLUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415604",
    "city": "CHIPLUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415605",
    "city": "CHIPLUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415606",
    "city": "CHIPLUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415607",
    "city": "CHIPLUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415608",
    "city": "CHIPLUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415609",
    "city": "DEVRUKH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415610",
    "city": "DEVRUKH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415611",
    "city": "DEVRUKH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415612",
    "city": "RATNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415613",
    "city": "GUHAGHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415614",
    "city": "RATNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415615",
    "city": "RATNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415616",
    "city": "RATNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415617",
    "city": "RATNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415619",
    "city": "RATNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415620",
    "city": "RATNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415621",
    "city": "KHED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415626",
    "city": "LANJA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415628",
    "city": "GUHAGHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415629",
    "city": "RATNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415630",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415634",
    "city": "GUHAGHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415637",
    "city": "DEVRUKH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415639",
    "city": "RATNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415640",
    "city": "KHED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415641",
    "city": "CHIPLUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415643",
    "city": "LANJA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415701",
    "city": "CHIPLUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415702",
    "city": "GUHAGHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415703",
    "city": "GUHAGHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415704",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415705",
    "city": "GUHAGHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415706",
    "city": "DAPOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415708",
    "city": "KHED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415709",
    "city": "KHED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415710",
    "city": "KHED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415711",
    "city": "DAPOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415712",
    "city": "DAPOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415713",
    "city": "DAPOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415714",
    "city": "DAPOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415715",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415716",
    "city": "DAPOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415717",
    "city": "DAPOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415718",
    "city": "CHIPLUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415719",
    "city": "GUHAGHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415720",
    "city": "DAPOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415722",
    "city": "CHIPLUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415724",
    "city": "GUHAGHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415726",
    "city": "GUHAGHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415727",
    "city": "KHED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415728",
    "city": "GUHAGHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415729",
    "city": "GUHAGHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415730",
    "city": "CHIPLUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415801",
    "city": "DEVRUKH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415802",
    "city": "DEVRUKH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415803",
    "city": "LANJA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415804",
    "city": "DEVRUKH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415805",
    "city": "LANJA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415806",
    "city": "LANJA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "415807",
    "city": "LANJA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416001",
    "city": "KOLHAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416002",
    "city": "KOLHAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416003",
    "city": "KOLHAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416004",
    "city": "KOLHAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416005",
    "city": "KOLHAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416006",
    "city": "KOLHAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416007",
    "city": "KOLHAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416008",
    "city": "KOLHAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416009",
    "city": "KOLHAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416010",
    "city": "KOLHAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416011",
    "city": "EX KOLHAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416012",
    "city": "KOLHAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416013",
    "city": "KOLHAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416058",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416101",
    "city": "JAYSHINGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416105",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416107",
    "city": "ICHALKARANJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416108",
    "city": "ICHALKARANJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416109",
    "city": "ICHALKARANJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416110",
    "city": "ICHALKARANJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416111",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416112",
    "city": "SHIROLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416113",
    "city": "PANAHLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416114",
    "city": "PANAHLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416115",
    "city": "ICHALKARANJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416116",
    "city": "ICHALKARANJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416117",
    "city": "ICHALKARANJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416118",
    "city": "ICHALKARANJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416119",
    "city": "KOLHAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416121",
    "city": "ICHALKARANJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416122",
    "city": "SHIROLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416127",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416129",
    "city": "ICHALKARANJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416130",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416138",
    "city": "ICHALKARANJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416143",
    "city": "ICHALKARANJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416144",
    "city": "JAYSHINGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416146",
    "city": "ICHALKARANJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416201",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416202",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416203",
    "city": "KAGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416204",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416205",
    "city": "PANAHLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416206",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416207",
    "city": "KAGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416208",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416209",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416210",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416211",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416212",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416213",
    "city": "PANAHLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416214",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416215",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416216",
    "city": "KAGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416217",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416218",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416219",
    "city": "GADHINGLAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416220",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416221",
    "city": "KAGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416222",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416223",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416224",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416228",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416229",
    "city": "PANAHLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416230",
    "city": "PANAHLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416231",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416232",
    "city": "KAGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416234",
    "city": "KOLHAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416235",
    "city": "KAGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416236",
    "city": "KAGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416301",
    "city": "ASHTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416302",
    "city": "ASHTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416303",
    "city": "ASHTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416304",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416305",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416306",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416307",
    "city": "TASGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416308",
    "city": "PALUS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416309",
    "city": "PALUS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416310",
    "city": "PALUS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416311",
    "city": "TASGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416312",
    "city": "TASGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416313",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416314",
    "city": "TASGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416315",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416316",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416317",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416319",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416320",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416321",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416401",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416402",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416403",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416404",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416405",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416406",
    "city": "SANGLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416407",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416408",
    "city": "TASGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416409",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416410",
    "city": "SANGLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416411",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416412",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416413",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416414",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416415",
    "city": "SANGLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416416",
    "city": "SANGLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416418",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416419",
    "city": "TASGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416420",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416421",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416422",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416423",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416425",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416426",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416428",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416429",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416436",
    "city": "SANGLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416437",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416501",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416502",
    "city": "GADHINGLAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416503",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416504",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416505",
    "city": "GADHINGLAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416506",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416507",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416508",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416509",
    "city": "GADHINGLAJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416510",
    "city": "SAWANTWADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416511",
    "city": "SAWANTWADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416512",
    "city": "SAWANTWADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416513",
    "city": "SAWANTWADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416514",
    "city": "SAWANTWADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416515",
    "city": "SAWANTWADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416516",
    "city": "KUDAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416517",
    "city": "SAWANTWADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416518",
    "city": "SAWANTWADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416519",
    "city": "KUDAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416520",
    "city": "KUDAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416521",
    "city": "KUDAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416522",
    "city": "KUDAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416523",
    "city": "KUDAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416524",
    "city": "KUDAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416525",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416526",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416527",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416528",
    "city": "KUDAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416529",
    "city": "SAWANTWADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416530",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416531",
    "city": "SAWANTWADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416532",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416534",
    "city": "KUDAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416536",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416538",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416541",
    "city": "SAWANTWADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416549",
    "city": "SAWANTWADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416550",
    "city": "KUDAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416551",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416552",
    "city": "KOLHAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416601",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416602",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416603",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416604",
    "city": "KUDAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416605",
    "city": "KUDAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416606",
    "city": "KUDAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416608",
    "city": "KUDAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416609",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416610",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416611",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416612",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416613",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416614",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416615",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416616",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416620",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416622",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416623",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416626",
    "city": "KUDAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416628",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416630",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416632",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416701",
    "city": "LANJA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416702",
    "city": "LANJA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416703",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416704",
    "city": "LANJA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416705",
    "city": "LANJA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416707",
    "city": "LANJA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416709",
    "city": "LANJA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416712",
    "city": "LANJA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416713",
    "city": "LANJA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416801",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416803",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416804",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416805",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416806",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416807",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416810",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416811",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416812",
    "city": "KUDAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "416813",
    "city": "KANKAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421001",
    "city": "ULHAS NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421002",
    "city": "ULHAS NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421003",
    "city": "ULHAS NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421004",
    "city": "AMBERNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421005",
    "city": "AMBERNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421101",
    "city": "PADAGHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421102",
    "city": "ULHAS NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421103",
    "city": "ULHAS NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421201",
    "city": "DOMBIVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421202",
    "city": "DOMBIVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421203",
    "city": "DOMBIVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421204",
    "city": "DOMBIVALI-PALAVA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421222",
    "city": "MINI BHIWANDI WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421300",
    "city": "AMZ- BHIWANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421301",
    "city": "KALYAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421302",
    "city": "BHIWANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421303",
    "city": "WADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421304",
    "city": "KALYAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421305",
    "city": "BHIWANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421306",
    "city": "ULHAS NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421308",
    "city": "BHIWANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421311",
    "city": "BHIWANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421312",
    "city": "WADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421401",
    "city": "AMBERNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421402",
    "city": "BHIWANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421403",
    "city": "BHIWANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421501",
    "city": "AMBERNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421502",
    "city": "AMBERNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421503",
    "city": "BADLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421504",
    "city": "AMBERNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421505",
    "city": "AMBERNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421506",
    "city": "AMBERNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421601",
    "city": "SAHAHAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421602",
    "city": "AMBERNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421603",
    "city": "BHIWANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421604",
    "city": "BHIWANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "421605",
    "city": "ULHAS NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422001",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422002",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422003",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422004",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422005",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422006",
    "city": "NASHIK ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422007",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422008",
    "city": "NSK CIDCO SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422009",
    "city": "NSK CIDCO SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422010",
    "city": "NSK CIDCO SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422011",
    "city": "NASHIK ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422012",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422013",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422101",
    "city": "NASHIK ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422102",
    "city": "NASHIK ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422103",
    "city": "SINNAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422104",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422105",
    "city": "NASHIK ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422112",
    "city": "SINNAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422113",
    "city": "SINNAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422201",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422202",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422203",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422204",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422205",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422206",
    "city": "PIMPALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422207",
    "city": "PIMPALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422208",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422209",
    "city": "PIMPALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422210",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422211",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422212",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422213",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422214",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422215",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422221",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422222",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422301",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422302",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422304",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422305",
    "city": "MANMAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422306",
    "city": "MANMAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422401",
    "city": "NASHIK ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422402",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422403",
    "city": "IGATPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422501",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422502",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422601",
    "city": "SANGAMNER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422602",
    "city": "SANGAMNER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422603",
    "city": "SANGAMNER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422604",
    "city": "SANGAMNER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422605",
    "city": "SANGAMNER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422606",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422608",
    "city": "SANGAMNER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422610",
    "city": "SANGAMNER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422611",
    "city": "SANGAMNER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422620",
    "city": "SANGAMNER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "422622",
    "city": "SANGAMNER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423101",
    "city": "MANMAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423102",
    "city": "MANMAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423104",
    "city": "MANMAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423105",
    "city": "MALEGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423106",
    "city": "MANMAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423107",
    "city": "SHIRDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423108",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423109",
    "city": "SHIRDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423110",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423111",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423117",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423201",
    "city": "MALEGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423202",
    "city": "MALEGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423203",
    "city": "MALEGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423204",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423205",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423206",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423208",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423212",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423213",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423301",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423302",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423303",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423401",
    "city": "YEOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423402",
    "city": "YEOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423403",
    "city": "YEOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423501",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423502",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423601",
    "city": "KOPARGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423602",
    "city": "KOPARGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423603",
    "city": "KOPARGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423604",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423605",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423607",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423701",
    "city": "VAIJAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423702",
    "city": "VAIJAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "423703",
    "city": "VAIJAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424001",
    "city": "DHULE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424002",
    "city": "DHULE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424004",
    "city": "DHULE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424005",
    "city": "DHULE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424006",
    "city": "DHULE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424101",
    "city": "CHALISGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424102",
    "city": "CHALISGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424103",
    "city": "CHALISGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424104",
    "city": "CHALISGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424105",
    "city": "PACHORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424106",
    "city": "CHALISGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424107",
    "city": "CHALISGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424108",
    "city": "CHALISGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424109",
    "city": "NASHIK MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424116",
    "city": "CHALISGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424119",
    "city": "CHALISGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424201",
    "city": "PACHORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424202",
    "city": "PACHORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424203",
    "city": "PACHORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424208",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424209",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424301",
    "city": "DHULE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424302",
    "city": "DHULE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424303",
    "city": "DHULE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424304",
    "city": "DHULE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424305",
    "city": "NANDURBAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424306",
    "city": "DHULE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424307",
    "city": "DHULE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424308",
    "city": "DHULE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424309",
    "city": "DHULE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424310",
    "city": "DHULE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424311",
    "city": "DHULE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "424318",
    "city": "DHULE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425001",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425002",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425003",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425004",
    "city": "ERANDOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425101",
    "city": "ERANDOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425102",
    "city": "ERANDOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425103",
    "city": "ERANDOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425104",
    "city": "ERANDOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425105",
    "city": "ERANDOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425106",
    "city": "ERANDOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425107",
    "city": "CHOPDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425108",
    "city": "ERANDOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425109",
    "city": "ERANDOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425110",
    "city": "ERANDOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425111",
    "city": "ERANDOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425112",
    "city": "ERANDOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425113",
    "city": "DHULE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425115",
    "city": "ERANDOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425116",
    "city": "ERANDOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425120",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425121",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425124",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425127",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425135",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425201",
    "city": "BHUSAWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425203",
    "city": "BHUSAWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425301",
    "city": "BUSAWAL OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425302",
    "city": "BUSAWAL OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425303",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425304",
    "city": "BUSAWAL OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425305",
    "city": "BHUSAWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425306",
    "city": "BHUSAWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425307",
    "city": "BHUSAWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425308",
    "city": "BHUSAWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425309",
    "city": "BHUSAWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425310",
    "city": "BHUSAWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425311",
    "city": "BHUSAWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425318",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425326",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425327",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425336",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425401",
    "city": "AMALNER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425402",
    "city": "DHULE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425403",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425404",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425405",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425406",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425407",
    "city": "DHULE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425408",
    "city": "NANDURBAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425409",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425410",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425411",
    "city": "NANDURBAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425412",
    "city": "NANDURBAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425413",
    "city": "NANDURBAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425414",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425415",
    "city": "NANDURBAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425416",
    "city": "NANDURBAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425417",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425418",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425419",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425420",
    "city": "DHULE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425421",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425422",
    "city": "NANDURBAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425423",
    "city": "NANDURBAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425424",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425426",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425427",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425428",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425432",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425434",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425442",
    "city": "NANDURBAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425444",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425452",
    "city": "NANDURBAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425501",
    "city": "BUSAWAL OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425502",
    "city": "BUSAWAL OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425503",
    "city": "BUSAWAL OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425504",
    "city": "BUSAWAL OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425505",
    "city": "BUSAWAL OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425506",
    "city": "BUSAWAL OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425507",
    "city": "BUSAWAL OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425508",
    "city": "BUSAWAL OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425509",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425510",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425511",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425519",
    "city": "BUSAWAL OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425523",
    "city": "BUSAWAL OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "425524",
    "city": "BUSAWAL OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431001",
    "city": "AURANGABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431002",
    "city": "AURANGABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431003",
    "city": "CHIKALTHANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431004",
    "city": "AURANGABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431005",
    "city": "AURANGABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431006",
    "city": "CHIKALTHANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431007",
    "city": "CHIKALTHANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431008",
    "city": "CHIKALTHANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431009",
    "city": "AURANGABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431010",
    "city": "AURANGABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431101",
    "city": "WALUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431102",
    "city": "WALUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431103",
    "city": "KANNAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431104",
    "city": "KANNAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431105",
    "city": "WALUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431106",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431107",
    "city": "SHEVGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431109",
    "city": "WALUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431110",
    "city": "WALUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431111",
    "city": "WALUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431112",
    "city": "SILLOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431113",
    "city": "SILLOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431114",
    "city": "SILLOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431115",
    "city": "KANNAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431116",
    "city": "VAIJAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431117",
    "city": "SILLOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431118",
    "city": "SILLOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431120",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431121",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431122",
    "city": "BEED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431123",
    "city": "KAIJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431124",
    "city": "KAIJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431125",
    "city": "BEED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431126",
    "city": "BEED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431127",
    "city": "BEED OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431128",
    "city": "PARLI VAIJNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431129",
    "city": "BEED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431130",
    "city": "BEED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431131",
    "city": "BEED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431132",
    "city": "SILLOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431133",
    "city": "WALUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431134",
    "city": "SILLOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431135",
    "city": "SILLOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431136",
    "city": "WALUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431137",
    "city": "SHEVGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431142",
    "city": "BEED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431143",
    "city": "BEED OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431144",
    "city": "BEED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431147",
    "city": "KANNAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431148",
    "city": "WALUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431150",
    "city": "KANNAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431151",
    "city": "SILLOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431152",
    "city": "WALUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431153",
    "city": "BEED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431154",
    "city": "CHIKALTHANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431202",
    "city": "EX JALANA LOC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431203",
    "city": "JALNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431204",
    "city": "JALNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431205",
    "city": "EX JALANA LOC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431206",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431207",
    "city": "EX JALANA LOC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431208",
    "city": "EX JALANA LOC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431209",
    "city": "EX JALANA LOC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431210",
    "city": "CHIKALTHANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431211",
    "city": "WALUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431212",
    "city": "EX JALANA LOC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431213",
    "city": "JALNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431214",
    "city": "EX JALANA LOC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431215",
    "city": "EX JALANA LOC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431401",
    "city": "PARBHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431402",
    "city": "PARBHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431501",
    "city": "WALUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431502",
    "city": "SELU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431503",
    "city": "SELU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431504",
    "city": "WALUJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431505",
    "city": "SELU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431506",
    "city": "SELU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431507",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431508",
    "city": "JINTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431509",
    "city": "JINTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431510",
    "city": "JINTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431511",
    "city": "NANDED RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431512",
    "city": "NANDED RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431513",
    "city": "HINGOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431514",
    "city": "PARLI VAIJNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431515",
    "city": "PARLI VAIJNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431516",
    "city": "PARLI VAIJNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431517",
    "city": "AMBEJOGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431518",
    "city": "AMBEJOGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431519",
    "city": "AMBEJOGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431520",
    "city": "PARLI VAIJNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431521",
    "city": "PARBHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431522",
    "city": "AMBEJOGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431523",
    "city": "AMBEJOGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431530",
    "city": "PARLI VAIJNATH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431536",
    "city": "PARBHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431537",
    "city": "PARBHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431540",
    "city": "PARBHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431541",
    "city": "PARBHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431542",
    "city": "HINGOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431601",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431602",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431603",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431604",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431605",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431606",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431646",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431701",
    "city": "HINGOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431702",
    "city": "HINGOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431703",
    "city": "HINGOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431704",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431705",
    "city": "HINGOLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431707",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431708",
    "city": "NANDED RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431709",
    "city": "NANDED RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431710",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431711",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431712",
    "city": "NANDED RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431713",
    "city": "NANDED RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431714",
    "city": "NANDED RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431715",
    "city": "NANDED RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431716",
    "city": "UDGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431717",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431718",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431719",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431720",
    "city": "NANDED RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431721",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431722",
    "city": "NANDED RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431723",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431731",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431736",
    "city": "NANDED RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431741",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431742",
    "city": "NANDED RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431743",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431745",
    "city": "NANDED RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431746",
    "city": "NANDED RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431750",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431801",
    "city": "NANDED RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431802",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431803",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431804",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431805",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431806",
    "city": "NANDED RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431807",
    "city": "NANDED RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431808",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431809",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431810",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431811",
    "city": "NANDED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "431815",
    "city": "PUNE WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440001",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440002",
    "city": "GHAT ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440003",
    "city": "GHAT ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440004",
    "city": "LASHKARIBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440005",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440006",
    "city": "LASHKARIBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440007",
    "city": "LASHKARIBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440008",
    "city": "GHAT ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440009",
    "city": "HUDKESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440010",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440011",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440012",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440013",
    "city": "LASHKARIBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440014",
    "city": "LASHKARIBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440015",
    "city": "GHAT ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440016",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440017",
    "city": "LASHKARIBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440018",
    "city": "GHAT ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440019",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440020",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440021",
    "city": "GONDKHAIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440022",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440024",
    "city": "HUDKESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440025",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440026",
    "city": "LASHKARIBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440027",
    "city": "HUDKESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440029",
    "city": "LASHKARIBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440030",
    "city": "LASHKARIBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440032",
    "city": "GHAT ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440033",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440034",
    "city": "HUDKESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440035",
    "city": "GHAT ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440036",
    "city": "WARDHA ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "440037",
    "city": "HUDKESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441001",
    "city": "KAMPTEE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441002",
    "city": "KAMPTEE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441101",
    "city": "WARDHA ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441102",
    "city": "WARDHA ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441103",
    "city": "WARDHA ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441104",
    "city": "WARDHA ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441105",
    "city": "KAMPTEE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441106",
    "city": "KAMPTEE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441107",
    "city": "WARDHA ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441108",
    "city": "BUTIBORI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441109",
    "city": "KAMPTEE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441110",
    "city": "WARDHA ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441111",
    "city": "WARDHA ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441112",
    "city": "WARDHA ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441113",
    "city": "KAMPTEE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441114",
    "city": "GHAT ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441115",
    "city": "GHAT ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441116",
    "city": "GHAT ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441117",
    "city": "GHAT ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441122",
    "city": "BUTIBORI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441123",
    "city": "KAMPTEE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441201",
    "city": "UMRED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441202",
    "city": "UMRED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441203",
    "city": "UMRED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441204",
    "city": "HUDKESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441205",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441206",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441207",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441208",
    "city": "GADCHIROLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441209",
    "city": "GADCHIROLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441210",
    "city": "UMRED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441212",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441214",
    "city": "UMRED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441215",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441217",
    "city": "GADCHIROLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441221",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441222",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441223",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441224",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441225",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441226",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441227",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441228",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441301",
    "city": "WARUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441302",
    "city": "WARUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441303",
    "city": "WARUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441304",
    "city": "WARUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441305",
    "city": "WARUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441306",
    "city": "WARUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441401",
    "city": "KAMPTEE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441403",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441404",
    "city": "KAMPTEE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441406",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441408",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441409",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441501",
    "city": "GONDKHAIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441502",
    "city": "GONDKHAIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441503",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441504",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441601",
    "city": "GONDIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441701",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441702",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441801",
    "city": "GONDIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441802",
    "city": "BHANDARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441803",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441804",
    "city": "BHANDARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441805",
    "city": "BHANDARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441806",
    "city": "GONDIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441807",
    "city": "GONDIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441808",
    "city": "GHAT ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441809",
    "city": "BHANDARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441811",
    "city": "GHAT ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441901",
    "city": "GHAT ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441902",
    "city": "GONDIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441903",
    "city": "BHANDARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441904",
    "city": "BHANDARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441905",
    "city": "BHANDARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441906",
    "city": "BHANDARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441907",
    "city": "BHANDARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441908",
    "city": "BHANDARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441909",
    "city": "BHANDARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441910",
    "city": "UMRED",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441911",
    "city": "GONDIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441912",
    "city": "BHANDARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441913",
    "city": "GHAT ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441914",
    "city": "BHANDARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441915",
    "city": "BHANDARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441916",
    "city": "GONDIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441917",
    "city": "GHAT ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441918",
    "city": "GHAT ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441919",
    "city": "GHAT ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441920",
    "city": "GHAT ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441923",
    "city": "GHAT ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "441924",
    "city": "BHANDARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442001",
    "city": "WARDHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442003",
    "city": "WARDHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442005",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442006",
    "city": "WARDHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442010",
    "city": "WARDHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442101",
    "city": "WARDHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442102",
    "city": "WARDHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442103",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442104",
    "city": "WARDHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442105",
    "city": "WARDHA ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442106",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442108",
    "city": "WARDHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442110",
    "city": "GHAT ROAD OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442111",
    "city": "WARDHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442153",
    "city": "WARDHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442201",
    "city": "WARDHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442202",
    "city": "WARUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442203",
    "city": "WARDHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442204",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442205",
    "city": "WARDHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442301",
    "city": "HINGHANGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442302",
    "city": "WARDHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442303",
    "city": "WARDHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442304",
    "city": "HINGHANGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442305",
    "city": "HINGHANGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442306",
    "city": "WARDHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442307",
    "city": "HINGHANGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442310",
    "city": "WARDHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442401",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442402",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442403",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442404",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442406",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442501",
    "city": "BHADRAWATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442502",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442503",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442505",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442506",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442507",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442603",
    "city": "GADCHIROLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442604",
    "city": "GADCHIROLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442605",
    "city": "GADCHIROLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442606",
    "city": "GADCHIROLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442701",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442702",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442703",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442704",
    "city": "WARDHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442705",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442706",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442707",
    "city": "GADCHIROLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442709",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442710",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442901",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442902",
    "city": "BHADRAWATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442903",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442904",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442905",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442906",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442907",
    "city": "BHADRAWATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442908",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442912",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442914",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442916",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442917",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "442918",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443001",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443002",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443101",
    "city": "MALKAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443102",
    "city": "MALKAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443103",
    "city": "NANDURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443104",
    "city": "MALKAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443105",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443106",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443108",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443112",
    "city": "BHUSAWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443201",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443202",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443203",
    "city": "EX JALANA LOC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443204",
    "city": "JALNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443206",
    "city": "JALNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443209",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443301",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443302",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443303",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443304",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443305",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443306",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443307",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443308",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443401",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443402",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443403",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443404",
    "city": "NANDURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443405",
    "city": "NANDURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "443406",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444001",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444002",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444003",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444004",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444005",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444006",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444101",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444102",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444103",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444104",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444105",
    "city": "MURTIZAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444106",
    "city": "MURTIZAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444107",
    "city": "MURTIZAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444108",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444109",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444110",
    "city": "MURTIZAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444111",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444112",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444115",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444117",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444118",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444121",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444122",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444123",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444124",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444126",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444201",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444202",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444203",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444204",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444301",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444302",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444303",
    "city": "KHAMGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444304",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444305",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444306",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444307",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444308",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444311",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444312",
    "city": "KHAMGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444401",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444402",
    "city": "EX WASHIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444403",
    "city": "EX WASHIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444404",
    "city": "MURTIZAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444405",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444407",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444409",
    "city": "EX WASHIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444501",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444502",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444503",
    "city": "EX WASHIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444504",
    "city": "EX WASHIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444505",
    "city": "WASHIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444506",
    "city": "EX WASHIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444507",
    "city": "EX WASHIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444508",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444510",
    "city": "EX WASHIM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444511",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444512",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444601",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444602",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444603",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444604",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444605",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444606",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444607",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444701",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444702",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444704",
    "city": "PARATWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444705",
    "city": "PARATWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444706",
    "city": "MURTIZAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444707",
    "city": "EX AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444708",
    "city": "EX AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444709",
    "city": "EX AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444710",
    "city": "EX AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444711",
    "city": "EX AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444713",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444716",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444717",
    "city": "PARATWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444718",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444719",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444720",
    "city": "PARATWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444721",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444723",
    "city": "PARATWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444726",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444728",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444801",
    "city": "EX AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444802",
    "city": "PARATWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444803",
    "city": "EX AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444804",
    "city": "PARATWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444805",
    "city": "PARATWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444806",
    "city": "PARATWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444807",
    "city": "PARATWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444808",
    "city": "PARATWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444809",
    "city": "PARATWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444810",
    "city": "PARATWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444811",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444812",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444813",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444814",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444815",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444818",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444819",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444821",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444826",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444827",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444901",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444902",
    "city": "EX AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444903",
    "city": "EX AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444904",
    "city": "EX AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444905",
    "city": "WARUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444906",
    "city": "WARUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444907",
    "city": "WARUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444908",
    "city": "WARUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444909",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444911",
    "city": "NAGPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444913",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444914",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444915",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "444921",
    "city": "AMRAVATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445001",
    "city": "YAWATMAL OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445002",
    "city": "YAWATMAL OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445101",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445102",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445103",
    "city": "ARNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445105",
    "city": "ARNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445106",
    "city": "ARNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445109",
    "city": "AKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445110",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445201",
    "city": "YAWATMAL OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445202",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445203",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445204",
    "city": "PUSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445205",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445206",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445207",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445208",
    "city": "YAWATMAL OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445209",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445211",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445213",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445215",
    "city": "PUSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445216",
    "city": "PUSAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445301",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445302",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445303",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445304",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445305",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445306",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445307",
    "city": "CHANDRAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445308",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445309",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445311",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445323",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445401",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "445402",
    "city": "YAVATMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "450001",
    "city": "KHANDWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "450051",
    "city": "KHANDWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "450110",
    "city": "KHANDWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "450112",
    "city": "KHANDWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "450113",
    "city": "KHANDWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "450114",
    "city": "KHANDWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "450116",
    "city": "KHANDWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "450117",
    "city": "KHANDWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "450119",
    "city": "KHANDWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "450221",
    "city": "BURHANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "450331",
    "city": "BURHANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "450332",
    "city": "BURHANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "450337",
    "city": "KHANDWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "450339",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "450445",
    "city": "BURHANPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "450551",
    "city": "SANAWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "450554",
    "city": "SANAWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "450661",
    "city": "KHANDWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "450771",
    "city": "KHANDWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "450881",
    "city": "KHANDWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "450991",
    "city": "KHANDWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451001",
    "city": "KHARGONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451111",
    "city": "SANAWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451113",
    "city": "SANAWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451115",
    "city": "SANAWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451117",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451220",
    "city": "SANAWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451221",
    "city": "DHAMNOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451224",
    "city": "MAHESHWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451225",
    "city": "SANAWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451228",
    "city": "DHAMNOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451331",
    "city": "KHARGONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451332",
    "city": "KHANDWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451335",
    "city": "KHARGONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451337",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451440",
    "city": "KHARGONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451441",
    "city": "KHARGONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451442",
    "city": "KHARGONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451443",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451444",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451447",
    "city": "BARWANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451449",
    "city": "SINDHWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451551",
    "city": "BARWANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451556",
    "city": "BARWANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451660",
    "city": "DHAMNOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451661",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451665",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451666",
    "city": "SINDHWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451667",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451770",
    "city": "SINDHWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "451881",
    "city": "SINDHWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452001",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452002",
    "city": "INDORE PREM NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452003",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452004",
    "city": "INDORE PREM NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452005",
    "city": "INDORE PREM NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452006",
    "city": "VGR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452007",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452008",
    "city": "VGR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452009",
    "city": "INDORE PREM NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452010",
    "city": "VGR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452011",
    "city": "VGR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452012",
    "city": "INDORE PREM NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452013",
    "city": "INDORE PREM NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452014",
    "city": "INDORE PREM NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452015",
    "city": "VGR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452016",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452017",
    "city": "INDORE PREM NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452018",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452019",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452020",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452111",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452389",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "452463",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "453001",
    "city": "VIJAYNAGAR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "453111",
    "city": "VIJAYNAGAR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "453112",
    "city": "VIJAYNAGAR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "453115",
    "city": "VIJAYNAGAR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "453220",
    "city": "VIJAYNAGAR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "453236",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "453331",
    "city": "PITHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "453332",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "453441",
    "city": "MHOW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "453446",
    "city": "PITHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "453551",
    "city": "VIJAYNAGAR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "453552",
    "city": "PITHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "453555",
    "city": "VIJAYNAGAR EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "453556",
    "city": "PITHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "453661",
    "city": "PITHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "453771",
    "city": "PALASIA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "453777",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454001",
    "city": "DHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454020",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454111",
    "city": "DHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454115",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454116",
    "city": "DHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454129",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454221",
    "city": "KUKSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454331",
    "city": "KUKSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454333",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454335",
    "city": "KUKSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454339",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454341",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454345",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454350",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454365",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454435",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454441",
    "city": "DHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454446",
    "city": "KUKSHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454448",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454449",
    "city": "DHAMNOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454552",
    "city": "DHAMNOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454554",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454571",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454648",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454660",
    "city": "BADNAWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454665",
    "city": "BADNAWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454667",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454668",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454669",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454729",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454730",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454749",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454772",
    "city": "PITHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454773",
    "city": "DHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454774",
    "city": "PITHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "454775",
    "city": "PITHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "455001",
    "city": "DEWAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "455003",
    "city": "DEWAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "455111",
    "city": "DEWAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "455115",
    "city": "DEWAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "455116",
    "city": "DEWAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "455118",
    "city": "DEWAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "455119",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "455221",
    "city": "DEWAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "455223",
    "city": "DEWAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "455225",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "455227",
    "city": "DEWAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "455332",
    "city": "KHATEGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "455336",
    "city": "KHATEGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "455339",
    "city": "HARDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "455440",
    "city": "ASHTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "455459",
    "city": "ASHTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456001",
    "city": "UJJAIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456003",
    "city": "UJJAIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456006",
    "city": "UJJAIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456010",
    "city": "UJJAIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456221",
    "city": "NAGDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456222",
    "city": "BADNAWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456224",
    "city": "NAGDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456313",
    "city": "NAGDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456331",
    "city": "NAGDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456335",
    "city": "NAGDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456337",
    "city": "NAGDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456440",
    "city": "NAGDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456441",
    "city": "NAGDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456443",
    "city": "NAGDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456550",
    "city": "UJJAIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456661",
    "city": "UJJAIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456664",
    "city": "UJJAIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456665",
    "city": "SHAJAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456668",
    "city": "SHAJAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456770",
    "city": "SHAJAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456771",
    "city": "BADNAWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "456776",
    "city": "BADNAWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457001",
    "city": "RATLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457114",
    "city": "NAGDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457118",
    "city": "JAORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457119",
    "city": "NAGDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457222",
    "city": "BADNAWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457226",
    "city": "JAORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457227",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457331",
    "city": "JAORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457333",
    "city": "JAORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457336",
    "city": "JAORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457339",
    "city": "JAORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457340",
    "city": "JAORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457441",
    "city": "RATLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457550",
    "city": "RATLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457551",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457555",
    "city": "RATLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457661",
    "city": "JHABUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457769",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457770",
    "city": "JHABUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457772",
    "city": "JHABUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457773",
    "city": "JHABUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457775",
    "city": "JHABUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457777",
    "city": "JHABUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457779",
    "city": "JHABUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457882",
    "city": "ALIRAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457885",
    "city": "ALIRAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457887",
    "city": "ALIRAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457888",
    "city": "ALIRAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457893",
    "city": "RATLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457990",
    "city": "ALIRAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "457993",
    "city": "JHABUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458001",
    "city": "MANDSAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458002",
    "city": "MANDSAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458110",
    "city": "NEEMUCH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458113",
    "city": "NEEMUCH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458116",
    "city": "NEEMUCH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458118",
    "city": "NEEMUCH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458220",
    "city": "NEEMUCH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458226",
    "city": "NEEMUCH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458228",
    "city": "NEEMUCH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458330",
    "city": "NEEMUCH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458336",
    "city": "NEEMUCH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458339",
    "city": "MANDSAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458389",
    "city": "MANDSAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458441",
    "city": "NEEMUCH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458468",
    "city": "NEEMUCH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458470",
    "city": "NEEMUCH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458474",
    "city": "RATLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458553",
    "city": "MANDSAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458556",
    "city": "MANDSAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458558",
    "city": "MANDSAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458660",
    "city": "RATLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458664",
    "city": "MANDSAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458667",
    "city": "MANDSAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458669",
    "city": "MANDSAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458771",
    "city": "MANDSAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458775",
    "city": "MANDSAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458778",
    "city": "MANDSAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458880",
    "city": "MANDSAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458883",
    "city": "MANDSAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458888",
    "city": "MANDSAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458895",
    "city": "MANDSAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "458990",
    "city": "MANDSAUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460001",
    "city": "BETUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460002",
    "city": "BETUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460004",
    "city": "BETUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460005",
    "city": "BETUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460006",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460065",
    "city": "JAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460110",
    "city": "BETUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460220",
    "city": "BETUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460225",
    "city": "BETUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460330",
    "city": "BETUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460440",
    "city": "BETUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460443",
    "city": "BETUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460444",
    "city": "BETUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460447",
    "city": "BETUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460449",
    "city": "BETUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460551",
    "city": "MULTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460553",
    "city": "MULTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460554",
    "city": "MULTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460557",
    "city": "BETUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460660",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460661",
    "city": "MULTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460663",
    "city": "MULTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460665",
    "city": "MULTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460666",
    "city": "MULTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460668",
    "city": "MULTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "460669",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461001",
    "city": "NARMADAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461005",
    "city": "NARMADAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461110",
    "city": "ITARSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461111",
    "city": "ITARSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461114",
    "city": "ITARSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461115",
    "city": "ITARSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461116",
    "city": "ITARSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461122",
    "city": "ITARSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461221",
    "city": "NARMADAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461222",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461223",
    "city": "NARMADAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461228",
    "city": "NARMADAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461251",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461331",
    "city": "HARDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461335",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461441",
    "city": "HARDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461444",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461446",
    "city": "ITARSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461551",
    "city": "ITARSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461661",
    "city": "ITARSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461668",
    "city": "NARMADAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461771",
    "city": "PIPARIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461772",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461775",
    "city": "PIPARIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461881",
    "city": "PIPARIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "461990",
    "city": "PIPARIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462001",
    "city": "GOVINDPURA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462002",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462003",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462004",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462007",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462008",
    "city": "GOVINDPURA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462010",
    "city": "GOVINDPURA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462011",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462012",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462013",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462015",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462016",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462018",
    "city": "GOVINDPURA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462020",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462021",
    "city": "GOVINDPURA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462022",
    "city": "GOVINDPURA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462023",
    "city": "GOVINDPURA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462024",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462026",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462027",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462030",
    "city": "GOVINDPURA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462031",
    "city": "KAROND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462032",
    "city": "GOVINDPURA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462033",
    "city": "KAROND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462036",
    "city": "KAROND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462037",
    "city": "KAROND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462038",
    "city": "KAROND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462039",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462040",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462041",
    "city": "GOVINDPURA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462042",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462043",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462044",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462045",
    "city": "MANDIDEEP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462046",
    "city": "MANDIDEEP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462047",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462066",
    "city": "KAROND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462100",
    "city": "KAROND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462101",
    "city": "KAROND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462120",
    "city": "KAROND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "462420",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "463106",
    "city": "KAROND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "463111",
    "city": "KAROND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464001",
    "city": "VIDISHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464002",
    "city": "VIDISHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464111",
    "city": "VIDISHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464112",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464113",
    "city": "GANJBASODA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464114",
    "city": "VIDISHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464220",
    "city": "GANJBASODA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464221",
    "city": "GANJBASODA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464224",
    "city": "BINA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464226",
    "city": "VIDISHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464228",
    "city": "GANJBASODA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464240",
    "city": "BINA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464258",
    "city": "GANJBASODA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464331",
    "city": "VIDISHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464334",
    "city": "VIDISHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464337",
    "city": "BINA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464551",
    "city": "RAISIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464570",
    "city": "RAISIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464573",
    "city": "RAISIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464651",
    "city": "VIDISHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464661",
    "city": "VIDISHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464665",
    "city": "RAISIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464668",
    "city": "RAISIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464670",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464671",
    "city": "RAISIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464672",
    "city": "RAISIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464770",
    "city": "RAISIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464774",
    "city": "RAISIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464776",
    "city": "RAISIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464881",
    "city": "RAISIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464884",
    "city": "RAISIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464886",
    "city": "RAISIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464986",
    "city": "RAISIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464990",
    "city": "MANDIDEEP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464993",
    "city": "MANDIDEEP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "464995",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465001",
    "city": "SHAJAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465106",
    "city": "SHAJAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465110",
    "city": "SHAJAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465111",
    "city": "RATLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465113",
    "city": "SHAJAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465116",
    "city": "SHAJAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465118",
    "city": "SHAJAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465220",
    "city": "SHAJAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465223",
    "city": "SHAJAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465226",
    "city": "SHAJAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465227",
    "city": "SHAJAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465230",
    "city": "SHAJAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465331",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465333",
    "city": "ASHTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465335",
    "city": "JALGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465337",
    "city": "SEHORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465339",
    "city": "SEHORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465440",
    "city": "INDORE MAIN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465441",
    "city": "AGARMALWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465445",
    "city": "AGARMALWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465447",
    "city": "AGARMALWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465449",
    "city": "AGARMALWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465516",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465550",
    "city": "AGARMALWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465661",
    "city": "BIAORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465667",
    "city": "SEHORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465668",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465669",
    "city": "BIAORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465671",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465674",
    "city": "BIAORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465677",
    "city": "BIAORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465679",
    "city": "BIAORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465680",
    "city": "BIAORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465683",
    "city": "BIAORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465685",
    "city": "BIAORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465687",
    "city": "BIAORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465689",
    "city": "BIAORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465691",
    "city": "BIAORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465693",
    "city": "BIAORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465695",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "465697",
    "city": "SHAJAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466001",
    "city": "SEHORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466111",
    "city": "SEHORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466113",
    "city": "SEHORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466114",
    "city": "ASHTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466115",
    "city": "SEHORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466116",
    "city": "ASHTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466117",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466118",
    "city": "ASHTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466119",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466120",
    "city": "ASHTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466125",
    "city": "ASHTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466221",
    "city": "ASHTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466331",
    "city": "SEHORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466445",
    "city": "NARMADAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466446",
    "city": "NARMADAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466448",
    "city": "NARMADAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466554",
    "city": "NARMADAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466651",
    "city": "SEHORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466661",
    "city": "SEHORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466665",
    "city": "SEHORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466666",
    "city": "PANVEL WAREOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "466680",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470001",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470002",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470003",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470004",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470005",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470021",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470051",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470113",
    "city": "BINA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470115",
    "city": "BINA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470117",
    "city": "BINA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470118",
    "city": "BINA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470119",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470120",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470122",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470124",
    "city": "BINA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470125",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470221",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470223",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470226",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470227",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470228",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470229",
    "city": "DAMOH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470232",
    "city": "DAMOH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470235",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470335",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470337",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470339",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470441",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470442",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470661",
    "city": "DAMOH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470662",
    "city": "DAMOH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470663",
    "city": "DAMOH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470664",
    "city": "DAMOH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470666",
    "city": "DAMOH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470669",
    "city": "SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470672",
    "city": "DAMOH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470673",
    "city": "DAMOH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470675",
    "city": "DAMOH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470771",
    "city": "DAMOH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470772",
    "city": "DAMOH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470775",
    "city": "DAMOH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470880",
    "city": "DAMOH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "470881",
    "city": "DAMOH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "471001",
    "city": "CHHATTARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "471101",
    "city": "KHAJURAHO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "471105",
    "city": "KHAJURAHO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "471111",
    "city": "CHHATTARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "471201",
    "city": "CHHATTARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "471301",
    "city": "CHHATTARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "471311",
    "city": "CHHATTARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "471313",
    "city": "TIKAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "471315",
    "city": "CHHATTARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "471318",
    "city": "DAMOH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "471405",
    "city": "CHHATTARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "471408",
    "city": "CHHATTARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "471411",
    "city": "CHHATTARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "471501",
    "city": "CHHATTARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "471510",
    "city": "CHHATTARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "471515",
    "city": "KHAJURAHO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "471516",
    "city": "KHAJURAHO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "471525",
    "city": "KHAJURAHO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "471606",
    "city": "KHAJURAHO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "471625",
    "city": "KHAJURAHO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "472001",
    "city": "TIKAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "472005",
    "city": "TIKAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "472010",
    "city": "TIKAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "472101",
    "city": "TIKAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "472111",
    "city": "TIKAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "472115",
    "city": "TIKAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "472118",
    "city": "TIKAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "472221",
    "city": "TIKAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "472246",
    "city": "DATIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "472331",
    "city": "TIKAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "472336",
    "city": "TIKAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "472337",
    "city": "TIKAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "472338",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "472339",
    "city": "TIKAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "472442",
    "city": "TIKAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "472445",
    "city": "TIKAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "472446",
    "city": "TIKAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "472447",
    "city": "TIKAMGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473001",
    "city": "GUNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473002",
    "city": "GUNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473101",
    "city": "GUNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473105",
    "city": "GUNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473110",
    "city": "RAGHOGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473111",
    "city": "RAGHOGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473112",
    "city": "RAGHOGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473113",
    "city": "GUNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473115",
    "city": "BIAORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473118",
    "city": "RAGHOGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473222",
    "city": "RAGHOGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473226",
    "city": "RAGHOGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473249",
    "city": "GUNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473287",
    "city": "RAGHOGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473330",
    "city": "ASHOK NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473331",
    "city": "ASHOK NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473332",
    "city": "ASHOK NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473335",
    "city": "ASHOK NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473338",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473440",
    "city": "ASHOK NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473443",
    "city": "ASHOK NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473444",
    "city": "ASHOK NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473445",
    "city": "ASHOK NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473446",
    "city": "CHANDERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473551",
    "city": "SHIVPURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473583",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473585",
    "city": "SHIVPURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473638",
    "city": "SHIVPURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473660",
    "city": "SHIVPURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473662",
    "city": "SHIVPURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473665",
    "city": "SHIVPURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473670",
    "city": "SHIVPURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473770",
    "city": "SHIVPURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473774",
    "city": "SHIVPURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473775",
    "city": "SHIVPURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473781",
    "city": "SHIVPURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473785",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473793",
    "city": "SHIVPURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473865",
    "city": "SHIVPURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473880",
    "city": "SHIVPURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473885",
    "city": "SHIVPURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473990",
    "city": "SHIVPURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473993",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "473995",
    "city": "SHIVPURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "474001",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "474002",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "474003",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "474004",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "474005",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "474006",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "474007",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "474008",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "474009",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "474010",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "474011",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "474012",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "474015",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "474020",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "475001",
    "city": "DABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "475002",
    "city": "GWALIOR WH CUM PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "475005",
    "city": "DABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "475110",
    "city": "DABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "475115",
    "city": "DABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "475220",
    "city": "DABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "475228",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "475330",
    "city": "GWALIOR WH CUM PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "475335",
    "city": "DATIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "475336",
    "city": "DATIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "475530",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "475533",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "475661",
    "city": "DATIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "475668",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "475671",
    "city": "DATIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "475673",
    "city": "DATIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "475675",
    "city": "DATIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "475682",
    "city": "DATIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "475685",
    "city": "DATIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "475686",
    "city": "DATIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "476001",
    "city": "MORENA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "476110",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "476111",
    "city": "MORENA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "476115",
    "city": "MORENA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "476134",
    "city": "MORENA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "476219",
    "city": "MORENA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "476221",
    "city": "MORENA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "476224",
    "city": "KAILARAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "476228",
    "city": "MORENA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "476229",
    "city": "KAILARAS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "476332",
    "city": "SHEOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "476335",
    "city": "SHEOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "476337",
    "city": "SHEOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "476339",
    "city": "SHEOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "476355",
    "city": "SHEOPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "476444",
    "city": "MORENA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "476554",
    "city": "MORENA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "477001",
    "city": "BHIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "477105",
    "city": "BHIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "477111",
    "city": "BHIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "477116",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "477117",
    "city": "GWALIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "477222",
    "city": "BHIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "477227",
    "city": "BHIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "477331",
    "city": "BHIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "477332",
    "city": "BHIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "477333",
    "city": "BHIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "477335",
    "city": "BHIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "477441",
    "city": "BHIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "477445",
    "city": "BHIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "477446",
    "city": "BHIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "477447",
    "city": "BHIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "477449",
    "city": "BHIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "477555",
    "city": "BHIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "477556",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "477557",
    "city": "BHIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "477566",
    "city": "BHIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "477660",
    "city": "BHIND",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480001",
    "city": "CHHINDWARA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480002",
    "city": "CHHINDWARA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480003",
    "city": "CHHINDWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480105",
    "city": "PANDHURNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480106",
    "city": "PANDHURNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480107",
    "city": "CHHINDWARA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480108",
    "city": "PANDHURNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480109",
    "city": "PANDHURNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480110",
    "city": "CHHINDWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480111",
    "city": "CHHINDWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480112",
    "city": "CHHINDWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480115",
    "city": "CHHINDWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480221",
    "city": "CHHINDWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480223",
    "city": "CHHINDWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480224",
    "city": "CHHINDWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480331",
    "city": "CHHINDWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480334",
    "city": "PANDHURNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480337",
    "city": "PANDHURNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480338",
    "city": "MULTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480441",
    "city": "CHHINDWARA EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480447",
    "city": "CHHINDWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480449",
    "city": "CHHINDWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480551",
    "city": "CHHINDWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480555",
    "city": "CHHINDWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480557",
    "city": "CHHINDWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480559",
    "city": "CHHINDWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480661",
    "city": "SEONI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480667",
    "city": "SEONI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480669",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480771",
    "city": "SEONI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480880",
    "city": "SEONI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480881",
    "city": "SEONI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480882",
    "city": "SEONI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480884",
    "city": "LAKHNADON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480886",
    "city": "LAKHNADON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480887",
    "city": "LAKHNADON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480888",
    "city": "LAKHNADON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480990",
    "city": "SEONI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480991",
    "city": "SEONI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480994",
    "city": "SEONI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480996",
    "city": "BALAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480997",
    "city": "LAKHNADON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "480999",
    "city": "LAKHNADON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481001",
    "city": "BALAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481102",
    "city": "BALAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481111",
    "city": "CHHINDWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481115",
    "city": "BALAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481116",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481125",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481222",
    "city": "BALAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481224",
    "city": "BALAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481226",
    "city": "BALAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481331",
    "city": "BALAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481332",
    "city": "BALAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481335",
    "city": "BALAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481337",
    "city": "BALAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481441",
    "city": "BALAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481445",
    "city": "BALAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481449",
    "city": "BALAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481551",
    "city": "BALAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481556",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481584",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481661",
    "city": "MANDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481662",
    "city": "MANDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481663",
    "city": "MANDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481664",
    "city": "MANDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481665",
    "city": "MANDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481666",
    "city": "MANDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481668",
    "city": "MANDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481672",
    "city": "DINDORI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481768",
    "city": "MANDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481771",
    "city": "MANDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481776",
    "city": "MANDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481778",
    "city": "DINDORI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481879",
    "city": "DINDORI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481880",
    "city": "DINDORI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481882",
    "city": "DINDORI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481883",
    "city": "DINDORI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481884",
    "city": "DINDORI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481885",
    "city": "MANDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481980",
    "city": "BHOPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481990",
    "city": "DINDORI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481995",
    "city": "MANDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481996",
    "city": "MANDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "481998",
    "city": "MANDLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "482001",
    "city": "JABALPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "482002",
    "city": "JABALPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "482003",
    "city": "JABALPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "482004",
    "city": "JABALPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "482005",
    "city": "JABALPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "482006",
    "city": "JABALPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "482007",
    "city": "JABALPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "482008",
    "city": "JABALPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "482009",
    "city": "JABALPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "482010",
    "city": "JABALPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "482011",
    "city": "JABALPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "482012",
    "city": "JABALPUR WAREHOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "482020",
    "city": "JABALPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "482021",
    "city": "JABALPUR RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "482051",
    "city": "JABALPUR RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "482056",
    "city": "JABALPUR RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483001",
    "city": "JABALPUR RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483050",
    "city": "JABALPUR RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483053",
    "city": "JABALPUR RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483105",
    "city": "JABALPUR RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483110",
    "city": "JABALPUR RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483113",
    "city": "JABALPUR RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483119",
    "city": "JABALPUR RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483220",
    "city": "JABALPUR RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483222",
    "city": "SIHORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483225",
    "city": "SIHORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483330",
    "city": "SIHORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483331",
    "city": "SIHORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483332",
    "city": "SIHORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483334",
    "city": "SIHORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483336",
    "city": "SIHORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483440",
    "city": "SIHORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483442",
    "city": "SIHORA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483501",
    "city": "KATNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483503",
    "city": "KATNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483504",
    "city": "KATNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483507",
    "city": "KATNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483770",
    "city": "KATNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483773",
    "city": "KATNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483775",
    "city": "KATNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483880",
    "city": "KATNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "483990",
    "city": "KATNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484001",
    "city": "SHAHDOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484110",
    "city": "SHAHDOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484113",
    "city": "ANUPPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484114",
    "city": "SHAHDOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484116",
    "city": "ANUPPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484117",
    "city": "SHAHDOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484120",
    "city": "ANUPPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484220",
    "city": "ANUPPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484224",
    "city": "ANUPPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484330",
    "city": "ANUPPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484334",
    "city": "ANUPPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484336",
    "city": "ANUPPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484440",
    "city": "ANUPPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484444",
    "city": "ANUPPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484446",
    "city": "ANUPPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484447",
    "city": "ANUPPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484551",
    "city": "UMARIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484552",
    "city": "UMARIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484555",
    "city": "UMARIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484660",
    "city": "UMARIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484661",
    "city": "UMARIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484664",
    "city": "UMARIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484665",
    "city": "UMARIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484669",
    "city": "ANUPPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484770",
    "city": "SHAHDOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484771",
    "city": "BEOHARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484774",
    "city": "BEOHARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484776",
    "city": "BEOHARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484881",
    "city": "ANUPPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484886",
    "city": "ANUPPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "484887",
    "city": "ANUPPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485001",
    "city": "SATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485002",
    "city": "SATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485003",
    "city": "SATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485004",
    "city": "SATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485005",
    "city": "SATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485111",
    "city": "SATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485112",
    "city": "SATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485113",
    "city": "SATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485114",
    "city": "MAIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485115",
    "city": "SATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485221",
    "city": "SATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485226",
    "city": "SATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485331",
    "city": "SATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485334",
    "city": "SATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485336",
    "city": "SATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485441",
    "city": "SATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485446",
    "city": "SATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485447",
    "city": "SATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485551",
    "city": "SATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485661",
    "city": "MAIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485666",
    "city": "SATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485771",
    "city": "MAIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485772",
    "city": "MAIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485773",
    "city": "MAIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485774",
    "city": "MAIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485775",
    "city": "MAIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485778",
    "city": "MAIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "485881",
    "city": "MAIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486001",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486002",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486003",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486005",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486006",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486111",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486114",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486115",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486117",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486123",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486223",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486226",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486331",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486333",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486335",
    "city": "SIDHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486338",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486340",
    "city": "SIDHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486341",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486440",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486441",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486445",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486446",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486447",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486448",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486450",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486550",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486553",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486556",
    "city": "REWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486661",
    "city": "SIDHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486666",
    "city": "BEOHARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486669",
    "city": "SIDHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486670",
    "city": "SIDHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486675",
    "city": "SIDHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486771",
    "city": "SIDHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486775",
    "city": "SIDHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486776",
    "city": "SIDHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486881",
    "city": "SINGRAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486882",
    "city": "SINGRAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486884",
    "city": "WAIDHAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486885",
    "city": "WAIDHAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486886",
    "city": "WAIDHAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486887",
    "city": "WAIDHAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486888",
    "city": "WAIDHAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486889",
    "city": "SINGRAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486890",
    "city": "WAIDHAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "486892",
    "city": "SINGRAULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "487001",
    "city": "NARSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "487110",
    "city": "NARSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "487114",
    "city": "NARSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "487118",
    "city": "NARSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "487221",
    "city": "NARSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "487225",
    "city": "GADARWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "487330",
    "city": "NARSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "487334",
    "city": "GADARWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "487337",
    "city": "GADARWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "487441",
    "city": "GADARWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "487551",
    "city": "GADARWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "487555",
    "city": "GADARWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "487661",
    "city": "GADARWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "487770",
    "city": "GADARWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "487771",
    "city": "CHHINDWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "487881",
    "city": "GADARWARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "488001",
    "city": "PANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "488050",
    "city": "PANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "488051",
    "city": "PANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "488059",
    "city": "PANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "488220",
    "city": "PANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "488222",
    "city": "PANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "488333",
    "city": "PANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "488441",
    "city": "PANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "488442",
    "city": "PANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "488443",
    "city": "PANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "488446",
    "city": "PANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "488448",
    "city": "PANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "488888",
    "city": "BHIWANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "490001",
    "city": "BHILAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "490006",
    "city": "BHILAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "490009",
    "city": "BHILAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "490010",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "490011",
    "city": "BHILAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "490012",
    "city": "BHILAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "490013",
    "city": "BHILAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "490020",
    "city": "DURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "490021",
    "city": "BHILAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "490022",
    "city": "DURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "490023",
    "city": "BHILAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "490024",
    "city": "BHILAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "490025",
    "city": "BHILAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "490026",
    "city": "BHILAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "490027",
    "city": "BHILAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "490036",
    "city": "BHILAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "490042",
    "city": "BHILAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491001",
    "city": "DURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491002",
    "city": "DURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491009",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491107",
    "city": "DURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491111",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491221",
    "city": "BHILAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491222",
    "city": "BHILAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491223",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491225",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491226",
    "city": "DHAMTARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491227",
    "city": "DHAMTARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491228",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491229",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491230",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491331",
    "city": "DURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491332",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491335",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491336",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491337",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491338",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491340",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491441",
    "city": "RAJNANDGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491443",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491444",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491445",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491557",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491558",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491559",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491661",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491665",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491666",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491668",
    "city": "BHILAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491771",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491881",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491885",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491888",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491993",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491995",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "491996",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "492001",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "492002",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "492003",
    "city": "RAIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "492004",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "492005",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "492006",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "492007",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "492008",
    "city": "RAIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "492009",
    "city": "RAIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "492010",
    "city": "RAIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "492012",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "492013",
    "city": "RAIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "492014",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "492015",
    "city": "NAYA RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "492099",
    "city": "RAIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "492101",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "492109",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "492112",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493101",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493111",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493113",
    "city": "BILASPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493114",
    "city": "TILDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493116",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493118",
    "city": "BHATAPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493195",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493196",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493211",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493221",
    "city": "RAIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493222",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493225",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493228",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493229",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493331",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493332",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493335",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493338",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493344",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493441",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493445",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493448",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493449",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493526",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493551",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493554",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493555",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493558",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493559",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493661",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493662",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493663",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493770",
    "city": "DHAMTARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493773",
    "city": "DHAMTARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493776",
    "city": "DHAMTARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493778",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493881",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493885",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493887",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493888",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493889",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493890",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493891",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493992",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "493996",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494001",
    "city": "JAGDALPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494005",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494010",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494111",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494115",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494122",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494221",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494222",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494223",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494224",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494226",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494230",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494331",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494333",
    "city": "DHAMTARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494334",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494336",
    "city": "DHAMTARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494337",
    "city": "DHAMTARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494441",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494442",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494444",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494446",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494447",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494448",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494449",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494551",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494552",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494553",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494556",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494635",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494661",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494665",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494669",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494771",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494776",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "494777",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495001",
    "city": "BILASPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495003",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495004",
    "city": "BILASPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495005",
    "city": "BILASPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495006",
    "city": "BILASPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495009",
    "city": "BILASPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495112",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495113",
    "city": "BILASPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495115",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495116",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495117",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495118",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495119",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495220",
    "city": "BILASPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495221",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495222",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495223",
    "city": "BILASPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495224",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495330",
    "city": "BILASPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495334",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495335",
    "city": "BILASPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495442",
    "city": "BILASPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495445",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495446",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495447",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495448",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495449",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495450",
    "city": "KORBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495452",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495453",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495454",
    "city": "KORBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495455",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495549",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495550",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495551",
    "city": "BILASPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495552",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495553",
    "city": "CHAMPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495554",
    "city": "CHAMPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495555",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495556",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495557",
    "city": "CHAMPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495559",
    "city": "CHAMPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495660",
    "city": "BILASPUR ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495661",
    "city": "CHAMPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495663",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495668",
    "city": "CHAMPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495671",
    "city": "CHAMPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495674",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495677",
    "city": "KORBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495678",
    "city": "KORBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495682",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495683",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495684",
    "city": "KORBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495686",
    "city": "CHAMPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495687",
    "city": "CHAMPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495688",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495689",
    "city": "CHAMPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495690",
    "city": "CHAMPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495691",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495692",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "495695",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496001",
    "city": "RAIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496005",
    "city": "RAIGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496100",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496107",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496108",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496109",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496111",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496113",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496115",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496116",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496118",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496197",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496220",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496223",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496224",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496225",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496227",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496242",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496245",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496330",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496331",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496334",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496336",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496338",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496440",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496445",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496450",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496551",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496554",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496661",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "496665",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497001",
    "city": "AMBIKAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497101",
    "city": "AMBIKAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497111",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497114",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497116",
    "city": "AMBIKAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497117",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497118",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497119",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497220",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497223",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497224",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497225",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497226",
    "city": "AMBIKAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497229",
    "city": "AMBIKAPUR OUTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497231",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497235",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497331",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497333",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497335",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497339",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497442",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497446",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497447",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497448",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497449",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497451",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497553",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497555",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497557",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497559",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497773",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "497778",
    "city": "RAIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "499999",
    "city": "BHIWANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500000",
    "city": "BEGUMPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500001",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500002",
    "city": "SANTOSH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500003",
    "city": "SECUNDERABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500004",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500005",
    "city": "CHANDRYANGUTTA SVC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500006",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500007",
    "city": "HABSIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500008",
    "city": "TOLICHOWKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500009",
    "city": "BOWENPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500010",
    "city": "ALWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500011",
    "city": "BOWENPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500012",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500013",
    "city": "HABSIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500014",
    "city": "KOM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500015",
    "city": "TRIMULGHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500016",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500017",
    "city": "HABSIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500018",
    "city": "BALANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500019",
    "city": "GBL SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500020",
    "city": "VIDYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500021",
    "city": "TRIMULGHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500022",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500023",
    "city": "SANTOSH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500024",
    "city": "SANTOSH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500025",
    "city": "SECUNDERABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500026",
    "city": "TRIMULGHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500027",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500028",
    "city": "TOLICHOWKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500029",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500030",
    "city": "ATTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500031",
    "city": "TOLICHOWKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500032",
    "city": "GBL SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500033",
    "city": "BANJARA HILLS SERV.CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500034",
    "city": "BANJARA HILLS SERV.CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500035",
    "city": "VANASTHALIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500036",
    "city": "MALAKPET EXT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500037",
    "city": "BALANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500038",
    "city": "YOUSUFGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500039",
    "city": "HABSIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500040",
    "city": "NEREDMET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500041",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500042",
    "city": "BALANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500043",
    "city": "JEEDIMETLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500044",
    "city": "VIDYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500045",
    "city": "YOUSUFGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500046",
    "city": "GBL SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500047",
    "city": "NEREDMET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500048",
    "city": "ATTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500049",
    "city": "MADINAGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500050",
    "city": "CHANDA NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500051",
    "city": "NEREDMET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500052",
    "city": "ATTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500053",
    "city": "CHANDRYANGUTTA SVC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500054",
    "city": "JEEDIMETLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500055",
    "city": "JEEDIMETLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500056",
    "city": "NEREDMET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500057",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500058",
    "city": "SANTOSH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500059",
    "city": "SANTOSH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500060",
    "city": "MALAKPET EXT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500061",
    "city": "SECUNDERABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500062",
    "city": "NEREDMET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500063",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500064",
    "city": "ATTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500065",
    "city": "SANTOSH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500066",
    "city": "SANTOSH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500067",
    "city": "KOM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500068",
    "city": "VANASTHALIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500069",
    "city": "SANTOSH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500070",
    "city": "VANASTHALIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500071",
    "city": "SECUNDERABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500072",
    "city": "KUKATPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500073",
    "city": "YOUSUFGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500074",
    "city": "VANASTHALIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500075",
    "city": "GANDIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500076",
    "city": "HABSIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500077",
    "city": "CHANDRYANGUTTA SVC",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500078",
    "city": "HAKIMPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500079",
    "city": "SANTOSH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500080",
    "city": "VIDYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500081",
    "city": "HITECH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500082",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500083",
    "city": "DAMMAIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500084",
    "city": "HITECH CITY KONDAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500085",
    "city": "KUKATPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500086",
    "city": "NARSINGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500087",
    "city": "DAMMAIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500088",
    "city": "BODUPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500089",
    "city": "TOLICHOWKI E-TAIL CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500090",
    "city": "BACHUPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500091",
    "city": "NARSINGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500092",
    "city": "BODUPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500093",
    "city": "NARSINGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500094",
    "city": "NEREDMET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500095",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500096",
    "city": "BANJARA HILLS SERV.CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500097",
    "city": "SANTOSH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500098",
    "city": "BODUPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500100",
    "city": "KOM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500101",
    "city": "HAKIMPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500102",
    "city": "VANASTHALIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500103",
    "city": "NEREDMET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500104",
    "city": "TOLICHOWKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500105",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500107",
    "city": "GBL SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500108",
    "city": "SHAMSHABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500110",
    "city": "BANJARA HILLS EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500111",
    "city": "GBL SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500123",
    "city": "MADINAGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500146",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500170",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500177",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500178",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500195",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500409",
    "city": "SHAMSHABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500472",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500475",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500476",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500484",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500486",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500488",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500605",
    "city": "HABSIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500768",
    "city": "SECUNDERABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500789",
    "city": "SECUNDERABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500890",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500960",
    "city": "BASHEERBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "500991",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501101",
    "city": "VIKARABAD REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501102",
    "city": "VIKARABAD REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501103",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501104",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501105",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501106",
    "city": "TOLICHOWKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501108",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501109",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501110",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501111",
    "city": "TOLICHOWKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501113",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501114",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501115",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501121",
    "city": "TOLICHOWKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501141",
    "city": "TOLICHOWKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501142",
    "city": "TOLICHOWKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501143",
    "city": "TOLICHOWKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501144",
    "city": "TOLICHOWKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501145",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501146",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501147",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501148",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501149",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501150",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501151",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501152",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501153",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501154",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501155",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501156",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501157",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501158",
    "city": "TOLICHOWKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501201",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501202",
    "city": "SADASIVPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501204",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501205",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501206",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501208",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501218",
    "city": "SHAMSHABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501301",
    "city": "GHATKESAR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501323",
    "city": "BALANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501359",
    "city": "SHAMSHABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501401",
    "city": "SOMAVARAM VILLAGE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501403",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501501",
    "city": "TOLICHOWKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501502",
    "city": "TOLICHOWKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501503",
    "city": "CHEVELLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501505",
    "city": "VANASTHALIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501506",
    "city": "IBRAHIMPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501507",
    "city": "HABSIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501508",
    "city": "IBRAHIMPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501510",
    "city": "TURKA YAMJAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501511",
    "city": "VANASTHALIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501512",
    "city": "VANASTHALIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501513",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501514",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501516",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501520",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501521",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501522",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501523",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501525",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501526",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501528",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501531",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501533",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501534",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501535",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "501537",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502001",
    "city": "SANGAREDDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502032",
    "city": "MADINAGUDA E-TAIL CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502102",
    "city": "SIDDIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502103",
    "city": "SIDDIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502107",
    "city": "SIDDIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502110",
    "city": "MEDAK REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502113",
    "city": "KOM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502125",
    "city": "KOM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502130",
    "city": "KOM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502201",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502205",
    "city": "PATENCHERU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502210",
    "city": "ZEHEERABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502211",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502212",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502213",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502220",
    "city": "ZEHEERABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502221",
    "city": "ZEHEERABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502228",
    "city": "ZEHEERABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502246",
    "city": "ZEHEERABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502247",
    "city": "SIDDIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502248",
    "city": "MEDAK REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502249",
    "city": "ZEHEERABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502251",
    "city": "ZEHEERABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502256",
    "city": "ZEHEERABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502257",
    "city": "ZEHEERABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502267",
    "city": "SIDDIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502269",
    "city": "NARAYANKED REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502270",
    "city": "MEDAK REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502271",
    "city": "KOM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502273",
    "city": "SANGAREDDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502277",
    "city": "SIDDIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502280",
    "city": "SIDDIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502281",
    "city": "SOMAVARAM VILLAGE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502285",
    "city": "PATENCHERU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502286",
    "city": "NARAYANKED REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502287",
    "city": "KOM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502288",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502289",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502290",
    "city": "NARAYANKED REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502291",
    "city": "SADASIVPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502293",
    "city": "SADASIVPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502294",
    "city": "SANGAREDDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502295",
    "city": "SANGAREDDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502296",
    "city": "SANGAREDDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502297",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502299",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502300",
    "city": "PATENCHERU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502301",
    "city": "SIDDIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502302",
    "city": "KOM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502304",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502305",
    "city": "PATENCHERU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502306",
    "city": "SADASIVPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502307",
    "city": "PATENCHERU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502310",
    "city": "SIDDIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502312",
    "city": "GAJWEL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502313",
    "city": "JEEDIMETLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502314",
    "city": "KOM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502316",
    "city": "KOM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502318",
    "city": "ZEHEERABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502319",
    "city": "MADINAGUDA E-TAIL CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502321",
    "city": "ZEHEERABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502322",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502323",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502324",
    "city": "MADINAGUDA E-TAIL CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502325",
    "city": "BACHUPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502329",
    "city": "PATENCHERU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502330",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502331",
    "city": "KOM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502335",
    "city": "KOM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502336",
    "city": "KOM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502345",
    "city": "SADASIVPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502371",
    "city": "KOM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502372",
    "city": "SIDDIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502374",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502375",
    "city": "SIDDIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "502381",
    "city": "KOM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503001",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503002",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503003",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503164",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503165",
    "city": "ARMOOR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503174",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503175",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503185",
    "city": "BODHAN REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503186",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503187",
    "city": "BODHAN REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503202",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503206",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503207",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503213",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503217",
    "city": "ARMOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503218",
    "city": "ARMOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503219",
    "city": "NIRMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503223",
    "city": "ARMOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503224",
    "city": "ARMOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503230",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503235",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503245",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503301",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503305",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503306",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503309",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503310",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503311",
    "city": "ARMOOR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "503321",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "504101",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "504102",
    "city": "NIZAMABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "504104",
    "city": "NIRMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "504105",
    "city": "NIRMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "504106",
    "city": "NIRMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "504109",
    "city": "NIRMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "504110",
    "city": "NIRMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "504202",
    "city": "NIRMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "504208",
    "city": "MANCHERIAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "504209",
    "city": "MANCHERIAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "504220",
    "city": "BELLAMPALLY REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "504231",
    "city": "BELLAMPALLY REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "504251",
    "city": "BELLAMPALLY REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "504302",
    "city": "BELLAMPALLY REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "504303",
    "city": "MANCHERIAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "504306",
    "city": "NIRMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "504307",
    "city": "ICHODA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "504309",
    "city": "NIRMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "504310",
    "city": "NIRMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505001",
    "city": "KARIMNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505002",
    "city": "KARIMNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505101",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505122",
    "city": "JAMMIKUNTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505129",
    "city": "KARIMNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505172",
    "city": "PEDAPALLI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505184",
    "city": "RAMAGUDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505186",
    "city": "CHOPPADANDI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505187",
    "city": "PEDAPALLI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505188",
    "city": "RAMAGUDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505208",
    "city": "RAMAGUDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505209",
    "city": "RAMAGUDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505210",
    "city": "RAMAGUDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505211",
    "city": "RAMAGUDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505214",
    "city": "RAMAGUDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505215",
    "city": "RAMAGUDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505301",
    "city": "SIRICILLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505302",
    "city": "SIRSILLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505305",
    "city": "SIRSILLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505307",
    "city": "SIRSILLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505325",
    "city": "KORUTLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505326",
    "city": "KORUTLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505327",
    "city": "JAGTIAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505330",
    "city": "KORUTLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505401",
    "city": "SIRSILLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505402",
    "city": "SIRSILLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505403",
    "city": "SIRSILLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505404",
    "city": "SIRSILLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505405",
    "city": "SIRSILLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505407",
    "city": "KARIMNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505415",
    "city": "CHOPPADANDI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505425",
    "city": "JAGTIAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505445",
    "city": "KARIMNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505450",
    "city": "KORUTLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505451",
    "city": "KARIMNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505454",
    "city": "JAGTIAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505455",
    "city": "JAGTIAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505460",
    "city": "KORUTLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505466",
    "city": "HUSNABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505467",
    "city": "HUSNABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505468",
    "city": "KESHAVAPATNAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505470",
    "city": "KESHAVAPATNAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505471",
    "city": "HUSNABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505472",
    "city": "HUSNABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505473",
    "city": "SIDDIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505474",
    "city": "KARIMNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505475",
    "city": "JAMMIKUNTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505476",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505481",
    "city": "HUSNABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505490",
    "city": "KESHAVAPATNAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505497",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505504",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505505",
    "city": "KARIMNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505514",
    "city": "RAMAGUDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505524",
    "city": "SIRSILLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505526",
    "city": "JAGTIAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505527",
    "city": "KARIMNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505528",
    "city": "SIDDIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505529",
    "city": "JAGTIAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505530",
    "city": "KARIMNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505532",
    "city": "JAGTIAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "505533",
    "city": "KARIMNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506001",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506002",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506003",
    "city": "GHANPUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506004",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506005",
    "city": "WARDHANNAPET REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506006",
    "city": "MULUGU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506007",
    "city": "WARANGAL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506008",
    "city": "WARDHANNAPET REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506009",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506010",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506011",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506012",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506013",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506015",
    "city": "ELAKATHURTHI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506101",
    "city": "MAHABUBABAD REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506102",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506104",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506105",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506112",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506122",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506132",
    "city": "MULUGU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506134",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506135",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506142",
    "city": "GHANPUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506145",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506146",
    "city": "JANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506163",
    "city": "WARDHANNAPET REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506164",
    "city": "PARKAL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506165",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506166",
    "city": "WARDHANNAPET REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506167",
    "city": "JANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506168",
    "city": "BHUPALAPALLI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506169",
    "city": "BHUPALAPALLI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506172",
    "city": "BHUPALAPALLI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506175",
    "city": "JANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506201",
    "city": "JANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506221",
    "city": "JANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506222",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506223",
    "city": "SIDDIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506224",
    "city": "JANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506244",
    "city": "JANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506252",
    "city": "JANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506301",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506302",
    "city": "JANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506303",
    "city": "JANGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506310",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506314",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506315",
    "city": "KHAMMAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506316",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506317",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506318",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506319",
    "city": "PARKAL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506324",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506329",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506331",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506342",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506344",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506347",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506348",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506349",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506352",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506355",
    "city": "SIDDIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506356",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506358",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506365",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506366",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506367",
    "city": "SIDDIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506368",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506369",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506370",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506371",
    "city": "ELAKATHURTHI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506381",
    "city": "MAHABUBABAD REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "506391",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507001",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507002",
    "city": "KHAMMAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507003",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507004",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507101",
    "city": "KOTHAGUDEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507103",
    "city": "KOTHAGUDEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507106",
    "city": "KOTHAGUDEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507111",
    "city": "BHADRACHALAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507112",
    "city": "BHADRACHALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507113",
    "city": "BHADRACHALAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507114",
    "city": "BHADRACHALAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507115",
    "city": "PALONCHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507116",
    "city": "PALONCHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507117",
    "city": "BHADRACHALAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507118",
    "city": "KOTHAGUDEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507119",
    "city": "KOTHAGUDEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507120",
    "city": "KOTHAGUDEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507121",
    "city": "BHADRACHALAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507122",
    "city": "KOTHAGUDEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507123",
    "city": "MAHABUBABAD REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507124",
    "city": "KOTHAGUDEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507125",
    "city": "PALONCHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507127",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507128",
    "city": "BHADRACHALAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507129",
    "city": "BHADRACHALAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507130",
    "city": "BHADRACHALAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507131",
    "city": "PALONCHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507132",
    "city": "PALONCHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507133",
    "city": "BHADRACHALAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507134",
    "city": "BHADRACHALAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507135",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507136",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507137",
    "city": "BHADRACHALAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507138",
    "city": "PALONCHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507140",
    "city": "BHADRACHALAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507141",
    "city": "PALONCHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507152",
    "city": "BHADRACHALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507154",
    "city": "KOTHAGUDEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507157",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507158",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507159",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507160",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507161",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507163",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507164",
    "city": "PALONCHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507165",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507166",
    "city": "KOTHAGUDEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507167",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507168",
    "city": "KHAMMAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507169",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507170",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507172",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507173",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507177",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507182",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507183",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507201",
    "city": "NANDIGAMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507202",
    "city": "NANDIGAMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507203",
    "city": "NANDIGAMA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507204",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507208",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507209",
    "city": "KOTHAGUDEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507210",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507211",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507212",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507214",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507301",
    "city": "PALONCHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507302",
    "city": "PALONCHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507303",
    "city": "SATHUPALLI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507304",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507305",
    "city": "KHAMMAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507306",
    "city": "PALONCHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507316",
    "city": "KOTHAGUDEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "507318",
    "city": "KHAMMAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508001",
    "city": "NALGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508002",
    "city": "NALGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508004",
    "city": "NALGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508013",
    "city": "NALGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508101",
    "city": "BHONGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508105",
    "city": "BHONGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508111",
    "city": "BHONGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508112",
    "city": "BHONGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508113",
    "city": "NALGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508114",
    "city": "NALGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508115",
    "city": "BHONGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508116",
    "city": "BHONGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508117",
    "city": "SURYAPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508121",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508123",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508125",
    "city": "NALGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508126",
    "city": "GHATKESAR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508201",
    "city": "MIRYALGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508202",
    "city": "MIRYALGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508203",
    "city": "MIRYALGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508204",
    "city": "KODAD REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508205",
    "city": "NALGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508206",
    "city": "KODAD REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508207",
    "city": "MIRYALGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508210",
    "city": "NALGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508211",
    "city": "SURYAPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508212",
    "city": "SURYAPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508213",
    "city": "SURYAPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508215",
    "city": "NALGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508217",
    "city": "MIRYALGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508218",
    "city": "MIRYALGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508219",
    "city": "NALGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508221",
    "city": "SURYAPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508222",
    "city": "SURYAPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508223",
    "city": "WARANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508224",
    "city": "SURYAPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508225",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508227",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508229",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508233",
    "city": "KODAD REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508234",
    "city": "KODAD REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508238",
    "city": "KODAD REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508243",
    "city": "SANTOSH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508244",
    "city": "NALGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508245",
    "city": "SANTOSH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508247",
    "city": "MIRYALGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508248",
    "city": "SANTOSH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508250",
    "city": "SANTOSH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508252",
    "city": "CHOUTUPPAL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508253",
    "city": "TOLICHOWKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508254",
    "city": "NALGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508255",
    "city": "NALGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508256",
    "city": "SANTOSH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508257",
    "city": "NALGONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508258",
    "city": "SHADNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508266",
    "city": "SANTOSH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508268",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508278",
    "city": "MIRYALGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508279",
    "city": "SURYAPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508280",
    "city": "SURYAPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508284",
    "city": "TOLICHOWKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508285",
    "city": "BHONGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508301",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508333",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508336",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508337",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508346",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508350",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508351",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508355",
    "city": "MIRYALGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508357",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508364",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508365",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508373",
    "city": "SANTOSH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508374",
    "city": "SURYAPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508375",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "508376",
    "city": "SURYAPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509001",
    "city": "MAHBUB NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509002",
    "city": "MAHBUB NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509016",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509102",
    "city": "WANAPARTHY REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509103",
    "city": "WANAPARTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509104",
    "city": "WANAPARTHY REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509106",
    "city": "WANAPARTHY REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509110",
    "city": "WANAPARTHY REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509113",
    "city": "MAHBUB NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509116",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509120",
    "city": "WANAPARTHY REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509125",
    "city": "GADWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509126",
    "city": "GADWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509127",
    "city": "GADWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509128",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509129",
    "city": "GADWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509131",
    "city": "MARIKAL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509132",
    "city": "GADWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509133",
    "city": "MAHBUB NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509134",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509135",
    "city": "GADWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509136",
    "city": "GADWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509144",
    "city": "BALANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509149",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509152",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509153",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509171",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509201",
    "city": "NAGARKURNOOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509202",
    "city": "BALANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509203",
    "city": "NAGARKURNOOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509204",
    "city": "MAHBUB NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509205",
    "city": "NARAYANPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509206",
    "city": "WANAPARTHY REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509207",
    "city": "SHADNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509208",
    "city": "MARIKAL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509209",
    "city": "NAGARKURNOOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509210",
    "city": "NARAYANPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509211",
    "city": "NARAYANPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509215",
    "city": "NAGARKURNOOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509216",
    "city": "SHADNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509217",
    "city": "HYTHABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509219",
    "city": "MARIKAL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509222",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509223",
    "city": "KOTHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509228",
    "city": "KOTHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509235",
    "city": "JADCHERALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509241",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509301",
    "city": "JADCHERALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509302",
    "city": "JADCHERALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509309",
    "city": "GADWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509311",
    "city": "NARAYANPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509320",
    "city": "GADWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509321",
    "city": "SHADNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509323",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509324",
    "city": "JADCHERALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509325",
    "city": "KOTHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509326",
    "city": "BALANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509327",
    "city": "SANTOSH NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509333",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509334",
    "city": "MAHBUB NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509335",
    "city": "MAHBUB NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509336",
    "city": "MAHBUB NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509337",
    "city": "MAHBUB NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509338",
    "city": "TOLICHOWKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509339",
    "city": "TOLICHOWKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509340",
    "city": "BALANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509349",
    "city": "GADWAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509350",
    "city": "MAHBUB NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509351",
    "city": "MARIKAL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509352",
    "city": "NARAYANPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509353",
    "city": "NARAYANPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509357",
    "city": "JADCHERALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509358",
    "city": "SHADNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509359",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509360",
    "city": "JADCHERALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509365",
    "city": "SOMAJIGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509371",
    "city": "MAHBUB NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509376",
    "city": "NAGARKURNOOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509380",
    "city": "MAHBUB NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509381",
    "city": "WANAPARTHY REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509382",
    "city": "MAHBUB NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509401",
    "city": "NAGARKURNOOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509406",
    "city": "JADCHERALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509407",
    "city": "NARAYANPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509408",
    "city": "SHADNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509409",
    "city": "MAHBUB NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509410",
    "city": "SHADNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509411",
    "city": "NARAYANPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "509412",
    "city": "WANAPARTHY REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "513380",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515001",
    "city": "ANANTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515002",
    "city": "ANANTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515003",
    "city": "ANANTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515004",
    "city": "ANANTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515005",
    "city": "ANANTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515101",
    "city": "DHARMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515102",
    "city": "DHARMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515110",
    "city": "PENUKONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515122",
    "city": "PENUKONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515123",
    "city": "PENUKONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515124",
    "city": "PENUKONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515133",
    "city": "PUTTAPARTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515134",
    "city": "PUTTAPARTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515144",
    "city": "PUTTAPARTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515154",
    "city": "PUTTAPARTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515159",
    "city": "DHARMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515164",
    "city": "PENUKONDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515201",
    "city": "HINDUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515202",
    "city": "HINDUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515211",
    "city": "HINDUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515212",
    "city": "HINDUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515213",
    "city": "HINDUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515231",
    "city": "GORANTLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515241",
    "city": "GORANTLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515261",
    "city": "HINDUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515271",
    "city": "MADAKASIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515281",
    "city": "MADAKASIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515286",
    "city": "MADAKASIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515291",
    "city": "MADAKASIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515301",
    "city": "MADAKASIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515303",
    "city": "MADAKASIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515305",
    "city": "MADAKASIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515311",
    "city": "MADAKASIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515321",
    "city": "MADAKASIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515331",
    "city": "HINDUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515341",
    "city": "HINDUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515401",
    "city": "GOOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515402",
    "city": "GOOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515404",
    "city": "DHARMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515405",
    "city": "GOOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515408",
    "city": "TADIPATRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515411",
    "city": "TADIPATRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515413",
    "city": "TADIPATRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515414",
    "city": "TADIPATRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515415",
    "city": "TADIPATRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515425",
    "city": "ANANTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515427",
    "city": "ANANTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515435",
    "city": "ANANTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515445",
    "city": "TADIPATRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515446",
    "city": "TADIPATRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515455",
    "city": "GOOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515457",
    "city": "BANAGANAPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515465",
    "city": "TADIPATRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515466",
    "city": "TADIPATRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515501",
    "city": "PUTTAPARTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515502",
    "city": "PUTTAPARTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515511",
    "city": "KADIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515521",
    "city": "KADIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515531",
    "city": "GORANTLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515541",
    "city": "KADIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515551",
    "city": "KADIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515556",
    "city": "GORANTLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515561",
    "city": "GORANTLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515571",
    "city": "KADIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515572",
    "city": "KADIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515581",
    "city": "KADIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515591",
    "city": "KADIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515601",
    "city": "GORANTLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515611",
    "city": "ANANTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515621",
    "city": "DHARMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515631",
    "city": "DHARMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515641",
    "city": "DHARMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515651",
    "city": "DHARMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515661",
    "city": "DHARMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515662",
    "city": "DHARMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515671",
    "city": "DHARMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515672",
    "city": "DHARMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515701",
    "city": "ANANTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515711",
    "city": "ANANTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515712",
    "city": "ANANTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515721",
    "city": "ANANTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515722",
    "city": "ANANTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515731",
    "city": "ANANTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515741",
    "city": "KALYANDURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515751",
    "city": "ANANTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515761",
    "city": "KALYANDURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515763",
    "city": "KALYANDURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515765",
    "city": "KALYANDURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515766",
    "city": "KALYANDURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515767",
    "city": "KALYANDURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515774",
    "city": "ANANTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515775",
    "city": "ANANTAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515787",
    "city": "KALYANDURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515801",
    "city": "GUNTAKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515803",
    "city": "GUNTAKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515812",
    "city": "GUNTAKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515822",
    "city": "GUNTAKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515832",
    "city": "GUNTAKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515834",
    "city": "GUNTAKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515842",
    "city": "GUNTAKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515843",
    "city": "GUNTAKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515863",
    "city": "RAYADURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515865",
    "city": "RAYADURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515867",
    "city": "RAYADURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515870",
    "city": "GUNTAKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "515871",
    "city": "RAYADURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516001",
    "city": "KADAPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516002",
    "city": "KADAPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516003",
    "city": "KADAPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516004",
    "city": "KADAPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516005",
    "city": "KADAPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516104",
    "city": "RAJAMPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516107",
    "city": "RAJAMPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516115",
    "city": "RAJAMPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516120",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516126",
    "city": "RAJAMPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516127",
    "city": "RAJAMPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516128",
    "city": "RAJAMPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516129",
    "city": "KADAPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516130",
    "city": "RAYACHOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516150",
    "city": "RAJAMPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516151",
    "city": "RAJAMPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516152",
    "city": "RAJAMPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516162",
    "city": "KADAPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516163",
    "city": "KADAPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516172",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516173",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516175",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516193",
    "city": "BADVEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516203",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516213",
    "city": "KADAPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516214",
    "city": "RAYACHOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516215",
    "city": "RAYACHOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516216",
    "city": "KADAPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516217",
    "city": "BADVEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516218",
    "city": "KADAPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516223",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516227",
    "city": "BADVEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516228",
    "city": "BADVEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516233",
    "city": "BADVEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516237",
    "city": "KADAPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516247",
    "city": "KADAPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516257",
    "city": "RAYACHOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516259",
    "city": "RAYACHOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516267",
    "city": "RAYACHOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516268",
    "city": "RAYACHOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516269",
    "city": "RAYACHOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516270",
    "city": "RAYACHOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516289",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516293",
    "city": "KADAPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516309",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516310",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516311",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516312",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516319",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516321",
    "city": "PULIVENDULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516329",
    "city": "PULIVENDULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516330",
    "city": "PULIVENDULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516339",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516349",
    "city": "PULIVENDULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516350",
    "city": "PULIVENDULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516355",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516356",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516359",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516360",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516361",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516362",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516366",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516380",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516390",
    "city": "PULIVENDULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516391",
    "city": "PULIVENDULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516396",
    "city": "PULIVENDULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516401",
    "city": "PULIVENDULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516411",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516421",
    "city": "PULIVENDULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516431",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516432",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516433",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516434",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516438",
    "city": "KADAPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516439",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516444",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516454",
    "city": "PULIVENDULA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516464",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516474",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516486",
    "city": "KADAPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516501",
    "city": "BADVEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516502",
    "city": "BADVEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516503",
    "city": "PRODDATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516504",
    "city": "RAYACHOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "516505",
    "city": "BADVEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517001",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517002",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517003",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517004",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517101",
    "city": "CHANDRAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517102",
    "city": "CHANDRAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517112",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517113",
    "city": "PILERU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517123",
    "city": "PILERU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517124",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517125",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517126",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517127",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517128",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517129",
    "city": "BANGARUPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517130",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517131",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517132",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517143",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517152",
    "city": "PILERU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517167",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517172",
    "city": "TIRUPATI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517192",
    "city": "PILERU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517193",
    "city": "PILERU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517194",
    "city": "TIRUPATI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517213",
    "city": "TIRUPATI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517214",
    "city": "PILERU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517234",
    "city": "PILERU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517235",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517236",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517237",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517247",
    "city": "PALAMANER REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517257",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517277",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517280",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517291",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517297",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517299",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517305",
    "city": "RAYACHOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517319",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517325",
    "city": "MADANAPALLE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517326",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517330",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517350",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517351",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517352",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517370",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517390",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517391",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517401",
    "city": "KUPPAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517403",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517408",
    "city": "PALAMANER REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517414",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517415",
    "city": "PALAMANER REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517416",
    "city": "BANGARUPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517417",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517418",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517419",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517421",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517422",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517423",
    "city": "KUPPAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517424",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517425",
    "city": "KUPPAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517426",
    "city": "KUPPAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517429",
    "city": "BANGARUPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517432",
    "city": "PALAMANER REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517501",
    "city": "TIRUPATI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517502",
    "city": "TIRUPATI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517503",
    "city": "TIRUPATI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517504",
    "city": "TIRUPATI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517505",
    "city": "CHANDRAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517506",
    "city": "RENIGUNTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517507",
    "city": "RENIGUNTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517520",
    "city": "RENIGUNTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517526",
    "city": "RENIGUNTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517536",
    "city": "SRIKALAHASTI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517541",
    "city": "SRICITY EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517551",
    "city": "RENIGUNTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517561",
    "city": "RENIGUNTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517569",
    "city": "RENIGUNTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517571",
    "city": "RENIGUNTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517581",
    "city": "NAGARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517582",
    "city": "NAGARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517583",
    "city": "NAGARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517584",
    "city": "NAGARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517586",
    "city": "NAGARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517587",
    "city": "NAGARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517588",
    "city": "SRICITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517589",
    "city": "NAGARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517590",
    "city": "NAGARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517591",
    "city": "NAGARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517592",
    "city": "NAGARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517599",
    "city": "SHOLINGHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517620",
    "city": "VENKATAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517621",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517640",
    "city": "SRIKALAHASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517641",
    "city": "SRIKALAHASTI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517643",
    "city": "SRIKALAHASTI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517644",
    "city": "SRIKALAHASTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517645",
    "city": "SRIKALAHASTI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "517646",
    "city": "SRICITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518001",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518002",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518003",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518004",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518005",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518006",
    "city": "KURNOOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518007",
    "city": "KURNOOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518010",
    "city": "KURNOOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518011",
    "city": "DHONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518017",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518018",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518019",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518021",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518023",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518026",
    "city": "CHITTOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518030",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518101",
    "city": "BALANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518102",
    "city": "BALANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518112",
    "city": "NANDYAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518116",
    "city": "NANDYAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518122",
    "city": "BANAGANAPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518123",
    "city": "BANAGANAPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518124",
    "city": "BANAGANAPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518134",
    "city": "BANAGANAPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518135",
    "city": "NANDYAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518137",
    "city": "NANDYAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518155",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518165",
    "city": "BANAGANAPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518166",
    "city": "BANAGANAPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518176",
    "city": "BANAGANAPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518186",
    "city": "BANAGANAPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518196",
    "city": "BANAGANAPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518206",
    "city": "BANAGANAPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518217",
    "city": "DHONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518218",
    "city": "DHONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518220",
    "city": "DHONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518221",
    "city": "DHONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518222",
    "city": "DHONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518225",
    "city": "DHONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518301",
    "city": "ADONI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518308",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518313",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518323",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518333",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518344",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518346",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518347",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518348",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518349",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518350",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518360",
    "city": "YEMMIGANUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518362",
    "city": "BANAGANAPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518380",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518385",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518390",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518395",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518396",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518397",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518399",
    "city": "KURNOOL JUNCTION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518401",
    "city": "ATMAKUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518405",
    "city": "DHONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518411",
    "city": "DHONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518412",
    "city": "DHONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518422",
    "city": "ATMAKUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518432",
    "city": "DHONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518442",
    "city": "ATMAKUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518452",
    "city": "KURNOOL REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518462",
    "city": "DHONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518465",
    "city": "DHONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518466",
    "city": "DHONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518467",
    "city": "DHONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518468",
    "city": "DHONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518501",
    "city": "NANDYAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518502",
    "city": "NANDYAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518503",
    "city": "NANDYAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518508",
    "city": "NANDYAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518510",
    "city": "NANDYAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518511",
    "city": "NANDYAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518512",
    "city": "NANDYAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518513",
    "city": "NANDYAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518517",
    "city": "DHONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518523",
    "city": "NANDYAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518533",
    "city": "NANDYAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518593",
    "city": "NANDYAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518594",
    "city": "NANDYAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518596",
    "city": "NANDYAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518599",
    "city": "DHONE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518673",
    "city": "NANDYAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518674",
    "city": "NANDYAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "518675",
    "city": "NANDYAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "520001",
    "city": "VIJAYAWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "520002",
    "city": "VIJAYAWADA COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "520003",
    "city": "VIJAYAWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "520004",
    "city": "VIJAYAWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "520005",
    "city": "VIJAYAWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "520006",
    "city": "PATAMATA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "520007",
    "city": "PATAMATA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "520008",
    "city": "PATAMATA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "520009",
    "city": "VIJAYAWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "520010",
    "city": "VIJAYAWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "520011",
    "city": "VIJAYAWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "520012",
    "city": "VIJAYAWADA BHAVANI PURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "520013",
    "city": "VIJAYAWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "520014",
    "city": "VIJAYAWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "520015",
    "city": "VIJAYAWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521001",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521002",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521003",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521101",
    "city": "GANNAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521102",
    "city": "ENIKEPADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521104",
    "city": "CHALLAPALLI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521105",
    "city": "HANUMAN JUNCTION REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521106",
    "city": "HANUMAN JUNCTION REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521107",
    "city": "VIJAYAWADA EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521108",
    "city": "ENIKEPADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521109",
    "city": "HANUMAN JUNCTION REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521110",
    "city": "HANUMAN JUNCTION REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521111",
    "city": "HANUMAN JUNCTION REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521113",
    "city": "HANUMAN JUNCTION REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521114",
    "city": "HANUMAN JUNCTION REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521121",
    "city": "AVANIGADDA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521122",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521125",
    "city": "AVANIGADDA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521130",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521131",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521132",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521133",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521134",
    "city": "VIJAYAWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521135",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521136",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521137",
    "city": "PORANKI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521138",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521139",
    "city": "PORANKI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521148",
    "city": "GUDIWADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521149",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521150",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521151",
    "city": "CHALLAPALLI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521153",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521156",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521157",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521158",
    "city": "GUDIWADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521162",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521163",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521164",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521165",
    "city": "CHALLAPALLI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521170",
    "city": "NANDIGAMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521171",
    "city": "NANDIGAMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521175",
    "city": "JAGGAIAHPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521176",
    "city": "JAGGAIAHPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521180",
    "city": "NANDIGAMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521181",
    "city": "NANDIGAMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521182",
    "city": "NANDIGAMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521183",
    "city": "NANDIGAMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521184",
    "city": "JAGGAIAHPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521185",
    "city": "NANDIGAMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521201",
    "city": "NUZVID",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521202",
    "city": "NUZVID",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521207",
    "city": "NUZVID",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521212",
    "city": "VIJAYAWADA EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521213",
    "city": "NUZVID",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521215",
    "city": "NUZIVIDU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521225",
    "city": "VIJAYAWADA BHAVANI PURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521226",
    "city": "NUZVID",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521227",
    "city": "NUZVID",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521228",
    "city": "IBRAHIMPATAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521229",
    "city": "IBRAHIMPATAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521230",
    "city": "NUZIVIDU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521241",
    "city": "IBRAHIMPATAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521245",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521246",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521247",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521250",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521255",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521256",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521260",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521261",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521263",
    "city": "GUDIWADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521286",
    "city": "HANUMAN JUNCTION REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521301",
    "city": "GUDIWADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521311",
    "city": "GUDIWADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521312",
    "city": "GUDIWADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521321",
    "city": "GUDIWADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521322",
    "city": "GUDIWADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521323",
    "city": "GUDIWADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521324",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521325",
    "city": "GUDIWADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521326",
    "city": "GUDIWADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521327",
    "city": "GUDIWADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521329",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521330",
    "city": "GUDIWADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521331",
    "city": "GUDIWADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521332",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521333",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521340",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521343",
    "city": "GUDIWADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521344",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521345",
    "city": "GUDIWADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521356",
    "city": "GUDIWADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521358",
    "city": "GUDIWADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521366",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521369",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521390",
    "city": "MACHILIPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521401",
    "city": "NUZVID",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521402",
    "city": "NANDIGAMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521444",
    "city": "HANUMAN JUNCTION REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521452",
    "city": "NANDIGAMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521456",
    "city": "IBRAHIMPATAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521457",
    "city": "JAGGAIAHPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "521504",
    "city": "NANDIGAMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522001",
    "city": "GUNTUR AUTO NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522002",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522003",
    "city": "GUNTUR AUTO NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522004",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522005",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522006",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522007",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522008",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522009",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522015",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522016",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522017",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522018",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522019",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522020",
    "city": "MANGALGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522021",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522022",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522034",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522101",
    "city": "BAPATLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522102",
    "city": "BAPATLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522111",
    "city": "BAPATLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522113",
    "city": "BAPATLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522123",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522124",
    "city": "PONNUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522125",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522201",
    "city": "TENALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522202",
    "city": "TENALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522211",
    "city": "TENALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522212",
    "city": "PONNUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522213",
    "city": "TENALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522215",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522234",
    "city": "NARSARAOPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522235",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522236",
    "city": "MANGALGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522237",
    "city": "MANGALGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522238",
    "city": "MANGALGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522257",
    "city": "TENALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522258",
    "city": "TENALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522259",
    "city": "TENALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522261",
    "city": "TENALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522264",
    "city": "TENALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522265",
    "city": "REPALLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522268",
    "city": "TENALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522282",
    "city": "TENALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522297",
    "city": "TENALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522301",
    "city": "TENALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522302",
    "city": "MANGALGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522303",
    "city": "MANGALGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522304",
    "city": "TENALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522305",
    "city": "MANGALGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522306",
    "city": "TENALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522307",
    "city": "TENALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522308",
    "city": "TENALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522312",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522313",
    "city": "TENALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522314",
    "city": "REPALLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522315",
    "city": "PONNUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522317",
    "city": "BAPATLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522318",
    "city": "TENALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522324",
    "city": "TENALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522329",
    "city": "PONNUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522330",
    "city": "TENALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522401",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522402",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522403",
    "city": "SATTENAPALLI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522407",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522408",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522409",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522410",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522411",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522412",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522413",
    "city": "PIDUGURALLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522421",
    "city": "MIRYALGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522426",
    "city": "MIRYALGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522435",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522436",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522437",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522438",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522439",
    "city": "NARSARAOPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522501",
    "city": "TADEPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522502",
    "city": "TADEPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522503",
    "city": "MANGALGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522508",
    "city": "TADEPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522509",
    "city": "GUNTUR AUTO NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522510",
    "city": "MANGALGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522529",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522549",
    "city": "NARSARAOPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522601",
    "city": "NARSARAOPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522603",
    "city": "NARSARAOPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522611",
    "city": "NARSARAOPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522612",
    "city": "NARSARAOPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522613",
    "city": "NARSARAOPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522614",
    "city": "PIDUGURALLA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522615",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522616",
    "city": "CHILAKALURIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522617",
    "city": "NARSARAOPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522620",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522626",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522630",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522631",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522661",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "522663",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523001",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523002",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523101",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523104",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523105",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523108",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523109",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523110",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523111",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523112",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523113",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523114",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523115",
    "city": "KAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523116",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523117",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523135",
    "city": "CHIRALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523153",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523155",
    "city": "CHIRALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523156",
    "city": "CHIRALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523157",
    "city": "CHIRALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523165",
    "city": "CHIRALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523166",
    "city": "CHIRALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523167",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523168",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523169",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523170",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523171",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523180",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523181",
    "city": "CHIRALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523182",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523183",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523184",
    "city": "CHIRALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523185",
    "city": "CHIRALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523186",
    "city": "CHIRALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523187",
    "city": "CHIRALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523190",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523201",
    "city": "ADDANKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523211",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523212",
    "city": "MUPPAVARAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523213",
    "city": "ADDANKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523214",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523223",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523224",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523225",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523226",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523227",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523228",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523230",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523240",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523241",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523245",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523246",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523247",
    "city": "DARSI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523253",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523254",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523260",
    "city": "ADDANKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523261",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523262",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523263",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523264",
    "city": "ADDANKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523265",
    "city": "ADDANKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523270",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523271",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523272",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523273",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523274",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523279",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523280",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523281",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523286",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523291",
    "city": "KAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523292",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523301",
    "city": "PARCHOOR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523302",
    "city": "NARSARAOPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523303",
    "city": "GUNTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523305",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523316",
    "city": "MARKAPUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523332",
    "city": "CUMBUM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523333",
    "city": "CUMBUM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523335",
    "city": "CUMBUM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523345",
    "city": "ONGOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523346",
    "city": "CUMBUM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523356",
    "city": "CUMBUM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523357",
    "city": "CUMBUM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523367",
    "city": "GIDDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523368",
    "city": "GIDDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523369",
    "city": "GIDDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523370",
    "city": "CUMBUM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523372",
    "city": "GIDDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "523373",
    "city": "GIDDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524001",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524002",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524003",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524004",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524005",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524010",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524101",
    "city": "GUDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524102",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524121",
    "city": "SULLURPETA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524123",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524124",
    "city": "SULLURPETA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524126",
    "city": "NAYUDUPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524127",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524129",
    "city": "SRIKALAHASTI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524131",
    "city": "GUDUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524132",
    "city": "VENKATAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524134",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524137",
    "city": "RAJUPALEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524142",
    "city": "KAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524152",
    "city": "KAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524201",
    "city": "KAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524202",
    "city": "KAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524203",
    "city": "KAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524218",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524221",
    "city": "VINJAMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524222",
    "city": "VINJAMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524223",
    "city": "KAVALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524224",
    "city": "VINJAMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524225",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524226",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524227",
    "city": "VINJAMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524228",
    "city": "VINJAMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524230",
    "city": "VINJAMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524234",
    "city": "ATMAKUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524236",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524239",
    "city": "VINJAMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524240",
    "city": "RAJUPALEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524301",
    "city": "ATMAKUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524302",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524303",
    "city": "ATMAKUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524304",
    "city": "ATMAKUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524305",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524306",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524307",
    "city": "ATMAKUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524308",
    "city": "ATMAKUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524309",
    "city": "ATMAKUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524310",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524311",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524312",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524313",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524314",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524315",
    "city": "RAJUPALEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524316",
    "city": "RAJUPALEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524317",
    "city": "RAJUPALEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524318",
    "city": "RAJUPALEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524319",
    "city": "RAJUPALEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524320",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524321",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524322",
    "city": "ATMAKUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524323",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524341",
    "city": "ATMAKUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524342",
    "city": "ATMAKUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524343",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524344",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524345",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524346",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524347",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524366",
    "city": "RAJUPALEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524401",
    "city": "SULLURPETA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524402",
    "city": "GUDUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524403",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524404",
    "city": "GUDUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524405",
    "city": "GUDUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524406",
    "city": "GUDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524407",
    "city": "GUDUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524408",
    "city": "GUDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524409",
    "city": "GUDUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524410",
    "city": "GUDUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524411",
    "city": "GUDUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524412",
    "city": "GUDUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524413",
    "city": "GUDUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524414",
    "city": "NELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524415",
    "city": "GUDUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "524421",
    "city": "NAYUDUPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "528101",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530001",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530002",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530003",
    "city": "MUVVALAVANIPALEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530004",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530005",
    "city": "GAJUWAKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530006",
    "city": "NAD KOTHA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530007",
    "city": "NAD KOTHA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530008",
    "city": "NAD KOTHA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530009",
    "city": "NAD KOTHA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530010",
    "city": "MUVVALAVANIPALEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530011",
    "city": "GAJUWAKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530012",
    "city": "GAJUWAKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530013",
    "city": "MUVVALAVANIPALEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530014",
    "city": "GAJUWAKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530015",
    "city": "GAJUWAKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530016",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530017",
    "city": "MUVVALAVANIPALEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530018",
    "city": "NAD KOTHA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530020",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530021",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530022",
    "city": "MUVVALAVANIPALEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530023",
    "city": "MUVVALAVANIPALEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530024",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530025",
    "city": "GAJUWAKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530026",
    "city": "GAJUWAKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530027",
    "city": "NAD KOTHA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530028",
    "city": "NAD KOTHA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530029",
    "city": "NAD KOTHA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530031",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530032",
    "city": "PARWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530035",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530037",
    "city": "NAD KOTHA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530040",
    "city": "MUVVALAVANIPALEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530041",
    "city": "MUVVALAVANIPALEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530042",
    "city": "MADHURAWADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530043",
    "city": "MUVVALAVANIPALEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530044",
    "city": "GAJUWAKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530045",
    "city": "MADHURAWADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530046",
    "city": "VADLAPUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530047",
    "city": "NAD KOTHA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530048",
    "city": "MADHURAWADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530049",
    "city": "VADLAPUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530051",
    "city": "NAD KOTHA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "530053",
    "city": "VADLAPUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531001",
    "city": "ANAKAPALLE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531011",
    "city": "ATCHUTAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531019",
    "city": "PARWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531020",
    "city": "PARWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531021",
    "city": "PARWADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531022",
    "city": "PENDURTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531029",
    "city": "PENDURTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531031",
    "city": "TUNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531033",
    "city": "ATCHUTAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531034",
    "city": "PENDURTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531035",
    "city": "PENDURTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531040",
    "city": "PENDURTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531055",
    "city": "TUNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531061",
    "city": "ATCHUTAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531077",
    "city": "PENDURTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531081",
    "city": "TUNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531082",
    "city": "TUNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531083",
    "city": "TUNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531085",
    "city": "TUNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531110",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531116",
    "city": "NARSIPATNAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531126",
    "city": "TUNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531127",
    "city": "TUNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531145",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531148",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531149",
    "city": "PENDURTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531151",
    "city": "PENDURTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531152",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531160",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531161",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531162",
    "city": "GAJAPATHINAGARAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531163",
    "city": "GAJAPATHINAGARAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531172",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531173",
    "city": "PENDURTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531183",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531201",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531202",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531203",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531204",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531211",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531214",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531215",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531216",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531217",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531218",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531219",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531220",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531221",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531230",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531240",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531242",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531250",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531260",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531270",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531273",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531280",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531281",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "531303",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532001",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532005",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532015",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532101",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532102",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532122",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532123",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532127",
    "city": "GARIVIDI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532128",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532145",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532148",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532168",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532185",
    "city": "AMADALAVALASA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532186",
    "city": "AMADALAVALASA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532190",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532195",
    "city": "TEKKALI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532201",
    "city": "TEKKALI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532203",
    "city": "TEKKALI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532208",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532209",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532211",
    "city": "TEKKALI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532212",
    "city": "TEKKALI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532213",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532214",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532215",
    "city": "PALASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532216",
    "city": "PALASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532218",
    "city": "PALASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532219",
    "city": "PALASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532220",
    "city": "PALASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532221",
    "city": "PALASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532222",
    "city": "PALASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532242",
    "city": "PALASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532243",
    "city": "PALASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532263",
    "city": "PALASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532264",
    "city": "PALASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532265",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532284",
    "city": "PALASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532290",
    "city": "PALASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532291",
    "city": "PALASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532292",
    "city": "PALASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532312",
    "city": "PALASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532322",
    "city": "PALASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532323",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532401",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532402",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532403",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532404",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532405",
    "city": "AMADALAVALASA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532406",
    "city": "AMADALAVALASA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532407",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532408",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532409",
    "city": "PYDIBHEEMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532410",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532421",
    "city": "AMADALAVALASA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532425",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532426",
    "city": "PALASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532427",
    "city": "PALASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532428",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532429",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532430",
    "city": "TEKKALI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532432",
    "city": "PALASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532440",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532443",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532445",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532455",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532456",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532457",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532458",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532459",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532460",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532461",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532462",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532464",
    "city": "YANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532474",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532484",
    "city": "AMADALAVALASA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532485",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532501",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532502",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532521",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532522",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532546",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532547",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532552",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532568",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532573",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532578",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532580",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532582",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532591",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532592",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "532593",
    "city": "SRIKAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533001",
    "city": "KAKINADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533002",
    "city": "KAKINADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533003",
    "city": "KAKINADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533004",
    "city": "KAKINADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533005",
    "city": "KAKINADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533006",
    "city": "KAKINADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533007",
    "city": "KAKINADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533008",
    "city": "KAKINADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533016",
    "city": "KAKINADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533101",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533102",
    "city": "RAJANAGARAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533103",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533104",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533105",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533106",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533107",
    "city": "KADIYAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533124",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533125",
    "city": "KADIYAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533126",
    "city": "KADIYAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533137",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533156",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533201",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533210",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533211",
    "city": "MUMMIDIVARAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533212",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533213",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533214",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533215",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533216",
    "city": "MUMMIDIVARAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533217",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533218",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533220",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533221",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533222",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533223",
    "city": "MUMMIDIVARAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533228",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533229",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533232",
    "city": "ANAPARTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533233",
    "city": "ANAPARTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533234",
    "city": "ANAPARTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533235",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533236",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533237",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533238",
    "city": "TANUKU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533239",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533240",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533241",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533242",
    "city": "MUMMIDIVARAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533244",
    "city": "PALAKOLLU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533247",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533248",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533249",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533250",
    "city": "PALAKOLLU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533251",
    "city": "PALAKOLLU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533252",
    "city": "NARSAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533253",
    "city": "PALAKOLLU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533254",
    "city": "PALAKOLLU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533255",
    "city": "ANAPARTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533256",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533260",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533261",
    "city": "ANAPARTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533263",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533264",
    "city": "ANAPARTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533265",
    "city": "ANAPARTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533274",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533284",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533285",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533288",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533290",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533291",
    "city": "RAJANAGARAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533292",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533293",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533294",
    "city": "RAJANAGARAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533295",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533296",
    "city": "RAJANAGARAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533297",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533305",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533306",
    "city": "KAKINADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533307",
    "city": "ANAPARTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533308",
    "city": "ANAPARTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533309",
    "city": "ANAPARTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533321",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533339",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533340",
    "city": "ANAPARTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533341",
    "city": "ANAPARTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533342",
    "city": "ANAPARTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533343",
    "city": "ANAPARTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533344",
    "city": "ANAPARTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533345",
    "city": "ANAPARTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533346",
    "city": "ANAPARTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533347",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533348",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533349",
    "city": "RAJANAGARAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533350",
    "city": "RAJANAGARAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533351",
    "city": "RAJANAGARAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533352",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533384",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533401",
    "city": "TUNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533406",
    "city": "PITHAPURAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533407",
    "city": "TUNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533408",
    "city": "TUNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533428",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533429",
    "city": "TUNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533430",
    "city": "TUNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533431",
    "city": "TUNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533432",
    "city": "TUNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533435",
    "city": "TUNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533437",
    "city": "TUNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533440",
    "city": "TUNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533444",
    "city": "PITHAPURAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533445",
    "city": "PITHAPURAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533446",
    "city": "TUNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533447",
    "city": "PITHAPURAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533448",
    "city": "TUNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533449",
    "city": "TUNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533450",
    "city": "PITHAPURAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533461",
    "city": "KAKINADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533462",
    "city": "KAKINADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533463",
    "city": "MUMMIDIVARAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533464",
    "city": "YANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533468",
    "city": "KAKINADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533482",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533483",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "533577",
    "city": "AMALAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534001",
    "city": "ELURU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534002",
    "city": "ELURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534003",
    "city": "ELURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534004",
    "city": "ELURU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534005",
    "city": "ELURU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534006",
    "city": "ELURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534007",
    "city": "ELURU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534101",
    "city": "TADEPALLY GUDEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534102",
    "city": "TADEPALLIGUDEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534111",
    "city": "TADEPALLIGUDEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534112",
    "city": "TADEPALLIGUDEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534122",
    "city": "NARSAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534123",
    "city": "NARSAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534124",
    "city": "NARSAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534126",
    "city": "NARSAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534134",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534136",
    "city": "TANUKU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534145",
    "city": "TADEPALLIGUDEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534146",
    "city": "TADEPALLIGUDEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534156",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534165",
    "city": "TADEPALLIGUDEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534166",
    "city": "TADEPALLIGUDEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534186",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534195",
    "city": "TADEPALLIGUDEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534196",
    "city": "TADEPALLIGUDEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534197",
    "city": "TADEPALLIGUDEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534198",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534199",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534201",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534202",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534203",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534204",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534206",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534207",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534208",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534209",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534210",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534211",
    "city": "TANUKU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534215",
    "city": "TANUKU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534216",
    "city": "TANUKU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534217",
    "city": "NARSAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534218",
    "city": "TANUKU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534222",
    "city": "TANUKU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534225",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534227",
    "city": "TANUKU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534229",
    "city": "TANUKU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534230",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534236",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534237",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534238",
    "city": "NARSAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534239",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534240",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534243",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534244",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534245",
    "city": "BHIMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534247",
    "city": "PALAKOLLU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534250",
    "city": "PALAKOLLU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534251",
    "city": "PALAKOLLU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534260",
    "city": "PALAKOLLU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534265",
    "city": "PALAKOLLU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534266",
    "city": "PALAKOLLU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534267",
    "city": "NARSAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534268",
    "city": "PALAKOLLU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534269",
    "city": "NARSAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534272",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534275",
    "city": "NARSAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534280",
    "city": "NARSAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534281",
    "city": "PALAKOLLU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534301",
    "city": "NIDADAVOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534313",
    "city": "NIDADAVOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534316",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534318",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534320",
    "city": "NARSAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534324",
    "city": "NARSAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534326",
    "city": "NARSAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534327",
    "city": "PALAKOLLU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534328",
    "city": "NARSAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534329",
    "city": "TANUKU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534330",
    "city": "NARSAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534331",
    "city": "TANUKU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534338",
    "city": "PALAKOLLU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534340",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534342",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534350",
    "city": "NIDADAVOLE REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534401",
    "city": "TADEPALLIGUDEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534406",
    "city": "TADEPALLIGUDEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534411",
    "city": "TADEPALLIGUDEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534416",
    "city": "TADEPALLIGUDEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534425",
    "city": "ELURU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534426",
    "city": "ELURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534427",
    "city": "ELURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534432",
    "city": "ELURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534435",
    "city": "ELURU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534437",
    "city": "ELURU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534442",
    "city": "ELURU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534444",
    "city": "TADEPALLIGUDEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534449",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534450",
    "city": "ELURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534451",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534452",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534455",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534456",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534460",
    "city": "SATHUPALLI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534461",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534462",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534467",
    "city": "TADEPALLIGUDEM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "534475",
    "city": "ELURU REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535001",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535002",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535003",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535004",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535005",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535006",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535101",
    "city": "GARIVIDI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535102",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535117",
    "city": "PENDURTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535124",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535125",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535126",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535128",
    "city": "GARIVIDI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535160",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535183",
    "city": "PENDURTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535204",
    "city": "PYDIBHEEMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535213",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535214",
    "city": "PENDURTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535215",
    "city": "PENDURTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535216",
    "city": "PYDIBHEEMAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535217",
    "city": "GARIVIDI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535218",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535220",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535221",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535240",
    "city": "PENDURTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535250",
    "city": "PENDURTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535260",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535270",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535273",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535280",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535281",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535342",
    "city": "VISHAKAPATNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535350",
    "city": "RAJAHMAHENDRAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535463",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535501",
    "city": "PARVATHIPURAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535502",
    "city": "PARVATHIPURAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535521",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535523",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535525",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535526",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535527",
    "city": "PARVATHIPURAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535534",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535547",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535557",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535559",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535568",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535578",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535580",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535581",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535592",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535593",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "535594",
    "city": "VIZIANAGARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "536201",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "555555",
    "city": "KVY KARVY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560000",
    "city": "BLR GROUND HUB",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560001",
    "city": "TRINITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560002",
    "city": "CENTRAL DEPOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560003",
    "city": "YESHWANTPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560004",
    "city": "JAYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560005",
    "city": "WHEELER ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560006",
    "city": "R T NAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560007",
    "city": "ULSOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560008",
    "city": "INDIRA NAGAR COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560009",
    "city": "INF SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560010",
    "city": "YESHWANTPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560011",
    "city": "JAYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560012",
    "city": "YESHWANTPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560013",
    "city": "PEENYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560014",
    "city": "PEENYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560015",
    "city": "PEENYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560016",
    "city": "RAM MURTHY NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560017",
    "city": "AIRPORT SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560018",
    "city": "JAYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560019",
    "city": "JAYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560020",
    "city": "INF SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560021",
    "city": "YESHWANTPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560022",
    "city": "YESHWANTPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560023",
    "city": "BASWESHWAR NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560024",
    "city": "MANYATHA TECH PARK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560025",
    "city": "ULSOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560026",
    "city": "BANASHANKARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560027",
    "city": "CENTRAL DEPOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560028",
    "city": "JAYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560029",
    "city": "BANNERGHATA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560030",
    "city": "KORAMANGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560031",
    "city": "PEENYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560032",
    "city": "R T NAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560033",
    "city": "WHEELER ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560034",
    "city": "KORAMANGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560035",
    "city": "SARJAPUR ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560036",
    "city": "THAMBU CHETTY PALYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560037",
    "city": "MARATHALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560038",
    "city": "INDIRA NAGAR COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560039",
    "city": "RAJARAJESHWARI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560040",
    "city": "BASWESHWAR NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560041",
    "city": "JAYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560042",
    "city": "ULSOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560043",
    "city": "CUNNINGHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560044",
    "city": "BASWESHWAR NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560045",
    "city": "MANYATHA TECH PARK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560046",
    "city": "R T NAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560047",
    "city": "KORAMANGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560048",
    "city": "MAHADEVAPURA INDUS. AREA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560049",
    "city": "THAMBU CHETTY PALYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560050",
    "city": "BANASHANKARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560051",
    "city": "TRINITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560052",
    "city": "INF SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560053",
    "city": "CENTRAL DEPOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560054",
    "city": "YESHWANTPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560055",
    "city": "YESHWANTPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560056",
    "city": "RAJARAJESHWARI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560057",
    "city": "PEENYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560058",
    "city": "PEENYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560059",
    "city": "RAJARAJESHWARI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560060",
    "city": "RAJARAJESHWARI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560061",
    "city": "BANASHANKARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560062",
    "city": "DODDAKALLASANDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560063",
    "city": "KATTIGENAHALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560064",
    "city": "YELAHANKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560065",
    "city": "VIDYARANYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560066",
    "city": "INTERNATIONAL TECH PARK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560067",
    "city": "SOUKYA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560068",
    "city": "HSR LAYOUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560069",
    "city": "JAYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560070",
    "city": "JAYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560071",
    "city": "EMBASSY GOLF LINK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560072",
    "city": "BASWESHWAR NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560073",
    "city": "NELAMANGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560074",
    "city": "BIDADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560075",
    "city": "NEW THIPPASANDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560076",
    "city": "BANNERGHATA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560077",
    "city": "MANYATHA TECH PARK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560078",
    "city": "J P NAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560079",
    "city": "BASWESHWAR NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560080",
    "city": "YESHWANTPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560081",
    "city": "BANNERGHATA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560082",
    "city": "JAYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560083",
    "city": "GOTTIGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560084",
    "city": "WHEELER ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560085",
    "city": "BANASHANKARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560086",
    "city": "BASWESHWAR NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560087",
    "city": "VARTHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560088",
    "city": "DODBALLAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560089",
    "city": "DODBALLAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560090",
    "city": "NELAMANGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560091",
    "city": "PEENYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560092",
    "city": "VIDYARANYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560093",
    "city": "NEW THIPPASANDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560094",
    "city": "YESHWANTPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560095",
    "city": "KORAMANGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560096",
    "city": "PEENYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560097",
    "city": "VIDYARANYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560098",
    "city": "RAJARAJESHWARI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560099",
    "city": "ELECTRONIC CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560100",
    "city": "ELECTRONIC CITY COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560102",
    "city": "HSR 5TH SECTOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560103",
    "city": "PNR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560104",
    "city": "BASWESHWAR NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560105",
    "city": "JIGANI - OPS FROM ELE/BLR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560106",
    "city": "YELAHANKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560107",
    "city": "NELAMANGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560108",
    "city": "DODDAKALLASANDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560109",
    "city": "DODDAKALLASANDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560110",
    "city": "RAJARAJESHWARI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560111",
    "city": "J P NAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560112",
    "city": "PEENYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560300",
    "city": "DEVANHALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "560500",
    "city": "ELECTRONIC CITY COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "561101",
    "city": "TUMAKURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "561201",
    "city": "BIDADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "561202",
    "city": "PAVAGADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "561203",
    "city": "DODBALLAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "561204",
    "city": "DODBALLAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "561205",
    "city": "DODBALLAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "561206",
    "city": "GAURIBIDANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "561207",
    "city": "BAGEPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "561208",
    "city": "GAURIBIDANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "561209",
    "city": "BAGEPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "561210",
    "city": "GAURIBIDANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "561211",
    "city": "GAURIBIDANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "561212",
    "city": "BAGEPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "561213",
    "city": "GAURIBIDANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "561228",
    "city": "GAURIBIDANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562101",
    "city": "CHIKBALLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562102",
    "city": "CHIKBALLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562103",
    "city": "CHIKBALLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562104",
    "city": "BAGEPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562105",
    "city": "CHIKBALLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562106",
    "city": "JIGANI - OPS FROM ELE/BLR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562107",
    "city": "ATTIBELE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562108",
    "city": "RAMNAGARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562109",
    "city": "BIDADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562110",
    "city": "DEVANHALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562111",
    "city": "DOBBASPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562112",
    "city": "HAROHALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562114",
    "city": "HOSKOTE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562115",
    "city": "CHIKBALLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562116",
    "city": "MALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562117",
    "city": "HAROHALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562119",
    "city": "HAROHALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562120",
    "city": "SOLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562121",
    "city": "HAROHALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562122",
    "city": "HOSKOTE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562123",
    "city": "NELAMANGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562125",
    "city": "SARJAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562126",
    "city": "RAMNAGARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562127",
    "city": "SOLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562128",
    "city": "BIDADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562129",
    "city": "DEVANHALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562130",
    "city": "SOLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562131",
    "city": "KUNIGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562132",
    "city": "TAVAREKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562135",
    "city": "DEVANHALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562137",
    "city": "RAMNAGARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562138",
    "city": "RAMNAGARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562149",
    "city": "KATTIGENAHALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562151",
    "city": "RAMNAGARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562152",
    "city": "DEVANHALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562157",
    "city": "KATTIGENAHALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562159",
    "city": "RAMNAGARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562160",
    "city": "RAMNAGARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562161",
    "city": "RAMNAGARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562162",
    "city": "NELAMANGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "562163",
    "city": "DODBALLAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563101",
    "city": "KOLAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563102",
    "city": "KOLAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563103",
    "city": "KOLAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563109",
    "city": "KOLAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563113",
    "city": "KOLAR GOLD FIELDS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563114",
    "city": "MALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563115",
    "city": "KOLAR GOLD FIELDS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563116",
    "city": "MULBAGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563117",
    "city": "KOLAR GOLD FIELDS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563118",
    "city": "KOLAR GOLD FIELDS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563119",
    "city": "KOLAR GOLD FIELDS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563120",
    "city": "KOLAR GOLD FIELDS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563121",
    "city": "KOLAR GOLD FIELDS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563122",
    "city": "KOLAR GOLD FIELDS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563123",
    "city": "CHINTHAMANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563124",
    "city": "BAGEPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563126",
    "city": "KOLAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563127",
    "city": "KOLAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563128",
    "city": "CHINTHAMANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563129",
    "city": "KOLAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563130",
    "city": "MALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563131",
    "city": "MULBAGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563132",
    "city": "KOLAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563133",
    "city": "MALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563134",
    "city": "KOLAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563135",
    "city": "KOLAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563136",
    "city": "KOLAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563137",
    "city": "KOLAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563138",
    "city": "KOLAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563139",
    "city": "KOLAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563146",
    "city": "CHINTHAMANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563158",
    "city": "KOLAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563159",
    "city": "CHINTHAMANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563160",
    "city": "KOLAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563161",
    "city": "CHINTHAMANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563162",
    "city": "KOLAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "563333",
    "city": "MALUR ETAIL RTO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "566105",
    "city": "XMI RTOS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "566666",
    "city": "SOUKYA ROAD ETAIL RTO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "566667",
    "city": "ETAIL PROCESSING UNIT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "567233",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "567777",
    "city": "ETAIL RTO PROCESSING-BLR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "569999",
    "city": "BLR REGIONAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570001",
    "city": "JLB SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570002",
    "city": "HEBAL ROAD  CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570003",
    "city": "HEBAL ROAD  CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570004",
    "city": "JLB SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570005",
    "city": "JLB SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570006",
    "city": "JLB SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570007",
    "city": "MYSURU RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570008",
    "city": "JLB SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570009",
    "city": "JLB SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570010",
    "city": "MYSURU RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570011",
    "city": "MYSURU RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570012",
    "city": "HEBAL ROAD  CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570013",
    "city": "JLB SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570014",
    "city": "JLB SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570015",
    "city": "JLB SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570016",
    "city": "HEBAL ROAD  CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570017",
    "city": "HEBAL ROAD  CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570018",
    "city": "HEBAL ROAD  CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570019",
    "city": "MYSURU RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570020",
    "city": "HEBAL ROAD  CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570021",
    "city": "JLB SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570022",
    "city": "JLB SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570023",
    "city": "JLB SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570024",
    "city": "JLB SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570025",
    "city": "JLB SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570026",
    "city": "HEBAL ROAD  CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570027",
    "city": "HEBAL ROAD  CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570028",
    "city": "MYSURU RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570029",
    "city": "MYSURU RURAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570030",
    "city": "HEBAL ROAD  CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570031",
    "city": "JLB SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570041",
    "city": "MANDYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570221",
    "city": "TIPTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "570301",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571101",
    "city": "T NARASIPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571102",
    "city": "HUNSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571103",
    "city": "HUNSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571104",
    "city": "KUSHALNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571105",
    "city": "HUNSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571106",
    "city": "HUNSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571107",
    "city": "KUSHALNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571108",
    "city": "HUNSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571109",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571110",
    "city": "T NARASIPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571111",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571114",
    "city": "HUNSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571115",
    "city": "CHAMRAJNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571116",
    "city": "HUNSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571117",
    "city": "CHAMRAJNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571118",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571119",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571120",
    "city": "T NARASIPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571121",
    "city": "HUNSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571122",
    "city": "T NARASIPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571123",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571124",
    "city": "T NARASIPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571125",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571126",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571127",
    "city": "CHAMRAJNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571128",
    "city": "CHAMRAJNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571129",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571130",
    "city": "HEBAL ROAD  CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571134",
    "city": "HUNSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571139",
    "city": "BAILHONGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571156",
    "city": "CHAMRAJNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571159",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571166",
    "city": "HUNSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571186",
    "city": "HEBAL ROAD  CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571187",
    "city": "KUSHALNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571188",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571189",
    "city": "HUNSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571201",
    "city": "MADIKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571211",
    "city": "MADIKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571212",
    "city": "GONIGOPPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571213",
    "city": "GONIGOPPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571214",
    "city": "MADIKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571215",
    "city": "GONIGOPPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571216",
    "city": "GONIGOPPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571217",
    "city": "GONIGOPPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571218",
    "city": "GONIGOPPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571219",
    "city": "GONIGOPPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571221",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571231",
    "city": "SOMWERPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571232",
    "city": "KUSHALNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571233",
    "city": "KUSHALNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571234",
    "city": "KUSHALNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571235",
    "city": "SOMWERPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571236",
    "city": "SOMWERPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571237",
    "city": "KUSHALNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571247",
    "city": "MADIKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571248",
    "city": "KUSHALNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571249",
    "city": "GONIGOPPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571250",
    "city": "GONIGOPPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571251",
    "city": "SOMWERPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571252",
    "city": "MADIKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571253",
    "city": "KUSHALNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571254",
    "city": "GONIGOPPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571301",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571302",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571304",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571311",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571312",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571313",
    "city": "CHAMRAJNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571314",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571315",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571316",
    "city": "CHAMRAJNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571319",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571320",
    "city": "KOLLEGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571321",
    "city": "KUSHALNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571322",
    "city": "JLB SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571325",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571329",
    "city": "CHAMRAJNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571331",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571337",
    "city": "KAVALANDE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571342",
    "city": "CHAMRAJNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571401",
    "city": "MANDYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571402",
    "city": "MANDYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571403",
    "city": "MANDYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571404",
    "city": "MANDYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571405",
    "city": "MANDYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571415",
    "city": "SRIRANGAPATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571416",
    "city": "MANDYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571417",
    "city": "T NARASIPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571418",
    "city": "NAGAMANGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571419",
    "city": "MADDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571421",
    "city": "MADDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571422",
    "city": "MADDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571423",
    "city": "K R PETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571424",
    "city": "MADDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571425",
    "city": "MADDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571426",
    "city": "K R PETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571427",
    "city": "SRIRANGAPATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571428",
    "city": "MADDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571429",
    "city": "MADDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571430",
    "city": "MADDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571431",
    "city": "K R PETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571432",
    "city": "NAGAMANGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571433",
    "city": "MADDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571434",
    "city": "SRIRANGAPATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571435",
    "city": "SRIRANGAPATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571436",
    "city": "K R PETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571437",
    "city": "KOLLEGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571438",
    "city": "SRIRANGAPATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571439",
    "city": "KOLLEGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571440",
    "city": "KOLLEGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571441",
    "city": "CHAMRAJNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571442",
    "city": "KOLLEGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571443",
    "city": "KOLLEGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571444",
    "city": "KOLLEGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571445",
    "city": "NAGAMANGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571446",
    "city": "MANDYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571448",
    "city": "NAGAMANGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571450",
    "city": "MANDYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571454",
    "city": "K R PETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571455",
    "city": "K R PETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571457",
    "city": "KOLLEGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571463",
    "city": "T NARASIPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571475",
    "city": "MADDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571476",
    "city": "MADDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571477",
    "city": "SRIRANGAPATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571478",
    "city": "MANDYA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571480",
    "city": "KOLLEGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571483",
    "city": "HUNSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571490",
    "city": "KOLLEGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571491",
    "city": "KOLLEGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571501",
    "city": "RAMNAGARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571502",
    "city": "RAMNAGARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571511",
    "city": "RAMNAGARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571512",
    "city": "HAROHALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571601",
    "city": "HUNSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571602",
    "city": "HUNSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571603",
    "city": "HUNSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571604",
    "city": "HUNSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571605",
    "city": "K R PETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571606",
    "city": "SRIRANGAPATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571607",
    "city": "SRIRANGAPATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571608",
    "city": "HUNSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571610",
    "city": "HUNSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571617",
    "city": "HUNSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571802",
    "city": "NAGAMANGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571807",
    "city": "JLB SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571810",
    "city": "K R PETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571811",
    "city": "NAGAMANGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "571812",
    "city": "K R PETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572101",
    "city": "TUMAKURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572102",
    "city": "TUMAKURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572103",
    "city": "TUMAKURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572104",
    "city": "TUMAKURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572105",
    "city": "TUMAKURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572106",
    "city": "TUMAKURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572107",
    "city": "TUMAKURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572108",
    "city": "TUMAKURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572111",
    "city": "KUNIGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572112",
    "city": "SIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572113",
    "city": "SIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572114",
    "city": "TIPTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572115",
    "city": "SIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572116",
    "city": "PAVAGADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572117",
    "city": "SIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572118",
    "city": "KUNIGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572119",
    "city": "TIPTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572120",
    "city": "KUNIGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572121",
    "city": "GAURIBIDANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572122",
    "city": "KUNIGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572123",
    "city": "KUNIGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572124",
    "city": "SIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572125",
    "city": "SIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572126",
    "city": "TUMAKURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572127",
    "city": "TUMAKURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572128",
    "city": "TUMAKURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572129",
    "city": "TUMAKURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572130",
    "city": "KUNIGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572132",
    "city": "SIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572133",
    "city": "SIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572134",
    "city": "KUNIGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572135",
    "city": "SIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572136",
    "city": "PAVAGADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572137",
    "city": "SIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572138",
    "city": "TUMAKURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572139",
    "city": "SIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572140",
    "city": "TUMAKURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572141",
    "city": "PAVAGADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572142",
    "city": "KUNIGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572143",
    "city": "HIRIYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572144",
    "city": "HIRIYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572145",
    "city": "KUNIGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572151",
    "city": "GAURIBIDANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572154",
    "city": "TUMAKURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572160",
    "city": "TUMAKURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572163",
    "city": "SIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572168",
    "city": "TUMAKURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572170",
    "city": "TUMAKURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572171",
    "city": "TUMAKURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572175",
    "city": "SIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572201",
    "city": "TIPTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572202",
    "city": "TIPTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572211",
    "city": "TIPTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572212",
    "city": "TIPTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572213",
    "city": "KUNIGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572214",
    "city": "TIPTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572215",
    "city": "TIPTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572216",
    "city": "KUNIGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572217",
    "city": "TIPTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572218",
    "city": "TIPTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572219",
    "city": "TUMAKURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572220",
    "city": "SIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572221",
    "city": "TIPTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572222",
    "city": "SIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572223",
    "city": "TIPTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572224",
    "city": "TIPTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572225",
    "city": "TIPTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572226",
    "city": "TIPTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572227",
    "city": "TIPTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572228",
    "city": "TIPTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572239",
    "city": "SIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "572441",
    "city": "MADIKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573101",
    "city": "BELUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573102",
    "city": "ARAKALGUDU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573103",
    "city": "ARSIKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573111",
    "city": "CHANNRAYAPATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573112",
    "city": "KADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573113",
    "city": "BELUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573114",
    "city": "TIPTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573115",
    "city": "BELUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573116",
    "city": "CHANNRAYAPATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573117",
    "city": "CHANNRAYAPATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573118",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573119",
    "city": "CHANNRAYAPATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573120",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573121",
    "city": "BELUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573122",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573123",
    "city": "MADIKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573124",
    "city": "CHANNRAYAPATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573125",
    "city": "ARSIKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573126",
    "city": "CHANNRAYAPATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573127",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573128",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573129",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573130",
    "city": "ARAKALGUDU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573131",
    "city": "CHANNRAYAPATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573132",
    "city": "HOSADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573133",
    "city": "ARAKALGUDU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573134",
    "city": "SAKLESHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573135",
    "city": "CHANNRAYAPATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573136",
    "city": "ARAKALGUDU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573137",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573139",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573141",
    "city": "CHANNRAYAPATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573142",
    "city": "ARAKALGUDU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573143",
    "city": "BELUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573144",
    "city": "ARSIKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573145",
    "city": "HUNSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573146",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573147",
    "city": "ARAKALGUDU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573150",
    "city": "ARAKALGUDU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573157",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573160",
    "city": "ARSIKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573162",
    "city": "ARSIKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573164",
    "city": "ARSIKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573165",
    "city": "SAKLESHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573201",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573202",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573210",
    "city": "HOLENARSIPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573211",
    "city": "HOLENARSIPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573212",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573213",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573214",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573215",
    "city": "BELUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573216",
    "city": "BELUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573217",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573218",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573219",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573220",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573225",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573226",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573228",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573425",
    "city": "MADDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573445",
    "city": "NAGAMANGALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "573628",
    "city": "HASSAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574101",
    "city": "HEBRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574103",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574104",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574105",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574106",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574107",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574108",
    "city": "HEBRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574109",
    "city": "UJIRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574110",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574111",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574112",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574113",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574114",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574115",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574116",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574117",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574118",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574119",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574120",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574121",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574122",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574123",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574126",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574127",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574129",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574130",
    "city": "MANGALAGANGOTHRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574131",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574134",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574138",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574139",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574140",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574141",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574142",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574143",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574144",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574145",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574146",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574148",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574150",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574151",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574152",
    "city": "MANGALAGANGOTHRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574153",
    "city": "MANGALAGANGOTHRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574154",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574157",
    "city": "MANGALORE COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574159",
    "city": "MANGALAGANGOTHRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574160",
    "city": "MANGALAGANGOTHRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574161",
    "city": "ATTAVARA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574162",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574163",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574164",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574165",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574166",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574167",
    "city": "MANGALAGANGOTHRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574168",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574169",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574171",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574172",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574173",
    "city": "MANGALORE COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574175",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574179",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574180",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574181",
    "city": "MANGALAGANGOTHRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574182",
    "city": "MANGALAGANGOTHRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574183",
    "city": "MANGALAGANGOTHRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574184",
    "city": "MANGALAGANGOTHRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574187",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574188",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574189",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574194",
    "city": "ATTAVARA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574197",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574198",
    "city": "UPPINANGADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574199",
    "city": "MANGALAGANGOTHRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574201",
    "city": "PUTTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574202",
    "city": "PUTTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574203",
    "city": "PUTTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574210",
    "city": "PUTTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574211",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574212",
    "city": "SULLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574213",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574214",
    "city": "UJIRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574216",
    "city": "UJIRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574217",
    "city": "UJIRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574218",
    "city": "SULLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574219",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574220",
    "city": "PUTTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574221",
    "city": "UPPINANGADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574222",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574223",
    "city": "PUTTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574224",
    "city": "UJIRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574225",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574226",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574227",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574228",
    "city": "UJIRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574229",
    "city": "UPPINANGADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574230",
    "city": "UPPINANGADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574231",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574232",
    "city": "SULLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574233",
    "city": "UJIRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574234",
    "city": "MADIKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574235",
    "city": "UPPINANGADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574236",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574237",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574238",
    "city": "SULLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574239",
    "city": "SULLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574240",
    "city": "UJIRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574241",
    "city": "UPPINANGADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574242",
    "city": "UJIRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574243",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574245",
    "city": "SULLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574248",
    "city": "SULLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574250",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574251",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574253",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574258",
    "city": "PUTTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574259",
    "city": "PUTTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574260",
    "city": "UPPINANGADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574261",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574262",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574263",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574264",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574265",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574266",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574267",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574269",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574270",
    "city": "UPPINANGADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574272",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574274",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574275",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574276",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574277",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574279",
    "city": "UPPINANGADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574280",
    "city": "UPPINANGADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574282",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574284",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574285",
    "city": "UPPINANGADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574287",
    "city": "UPPINANGADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574289",
    "city": "UPPINANGADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574291",
    "city": "UJIRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574294",
    "city": "UJIRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574296",
    "city": "UJIRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574297",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574299",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574301",
    "city": "UPPINANGADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574309",
    "city": "PUTTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574310",
    "city": "PUTTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574311",
    "city": "SULLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574312",
    "city": "PUTTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574313",
    "city": "PUTTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574314",
    "city": "SULLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574315",
    "city": "SULLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574317",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574318",
    "city": "PUTTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574319",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574323",
    "city": "UPPINANGADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574324",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574325",
    "city": "UPPINANGADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574326",
    "city": "UPPINANGADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574327",
    "city": "SULLIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574328",
    "city": "PUTTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574335",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574337",
    "city": "PUTTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574371",
    "city": "UPPINANGADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574504",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574509",
    "city": "ATTAVARA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "574561",
    "city": "ATTAVARA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575001",
    "city": "ATTAVARA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575002",
    "city": "ATTAVARA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575003",
    "city": "ATTAVARA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575004",
    "city": "ATTAVARA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575005",
    "city": "ATTAVARA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575006",
    "city": "ATTAVARA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575007",
    "city": "ATTAVARA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575008",
    "city": "ATTAVARA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575009",
    "city": "ATTAVARA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575010",
    "city": "MANGALORE COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575011",
    "city": "MANGALORE COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575012",
    "city": "ATTAVARA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575013",
    "city": "MANGALORE COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575014",
    "city": "MANGALORE COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575015",
    "city": "ATTAVARA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575016",
    "city": "ATTAVARA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575017",
    "city": "MANGALAGANGOTHRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575018",
    "city": "MANGALAGANGOTHRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575019",
    "city": "MANGALORE COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575020",
    "city": "MANGALAGANGOTHRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575021",
    "city": "MANGALORE COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575022",
    "city": "MANGALAGANGOTHRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575023",
    "city": "MANGALAGANGOTHRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575025",
    "city": "MANGALORE COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575026",
    "city": "MANGALORE COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575027",
    "city": "ATTAVARA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575028",
    "city": "ATTAVARA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575029",
    "city": "ATTAVARA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575030",
    "city": "MANGALORE COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575130",
    "city": "ARAKALGUDU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575220",
    "city": "CHIKBALLAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575221",
    "city": "ATTAVARA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575253",
    "city": "B C ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575551",
    "city": "CHANNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "575889",
    "city": "MANGALORE COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576001",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576003",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576101",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576102",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576103",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576104",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576105",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576106",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576107",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576108",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576111",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576112",
    "city": "HEBRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576113",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576114",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576115",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576116",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576117",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576118",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576119",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576121",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576122",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576123",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576124",
    "city": "HEBRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576125",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576126",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576127",
    "city": "MULKY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576128",
    "city": "MOODBIDRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576129",
    "city": "HEBRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576131",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576135",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576136",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576145",
    "city": "HEBRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576201",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576210",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576211",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576212",
    "city": "HEBRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576213",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576214",
    "city": "BHATKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576215",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576216",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576217",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576218",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576219",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576220",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576221",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576222",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576223",
    "city": "HEBRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576224",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576225",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576226",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576227",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576228",
    "city": "BHATKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576229",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576230",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576231",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576232",
    "city": "BHATKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576233",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576234",
    "city": "HEBRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576235",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576238",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576241",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576243",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576244",
    "city": "BHATKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576247",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576249",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576252",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576253",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576254",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576257",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576262",
    "city": "MANIPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576266",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576282",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576283",
    "city": "KUNDAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576425",
    "city": "HEBRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "576445",
    "city": "HIRIYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577001",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577002",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577003",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577004",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577005",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577006",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577101",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577102",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577111",
    "city": "MUDIGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577112",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577113",
    "city": "MUDIGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577114",
    "city": "MUDIGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577115",
    "city": "BHADRAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577116",
    "city": "KADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577117",
    "city": "MUDIGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577118",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577119",
    "city": "SAKLESHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577120",
    "city": "MUDIGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577121",
    "city": "MUDIGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577122",
    "city": "MUDIGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577123",
    "city": "MUDIGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577124",
    "city": "MUDIGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577125",
    "city": "MUDIGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577126",
    "city": "MUDIGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577127",
    "city": "MUDIGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577128",
    "city": "SHIVAMOGGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577129",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577130",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577131",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577132",
    "city": "MUDIGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577133",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577134",
    "city": "SHIVAMOGGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577135",
    "city": "KADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577136",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577137",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577138",
    "city": "MUDIGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577139",
    "city": "MUDIGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577140",
    "city": "ARSIKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577142",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577144",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577145",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577146",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577147",
    "city": "SAKLESHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577148",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577149",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577156",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577160",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577163",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577164",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577168",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577175",
    "city": "KADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577179",
    "city": "MUDIGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577180",
    "city": "HOSADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577181",
    "city": "CHIKKAMAGALURU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577182",
    "city": "HOSADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577201",
    "city": "SHIVAMOGGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577202",
    "city": "SHIVAMOGGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577203",
    "city": "SHIVAMOGGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577204",
    "city": "SHIVAMOGGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577205",
    "city": "SHIVAMOGGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577211",
    "city": "SHIVAMOGGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577213",
    "city": "CHANNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577214",
    "city": "SHIKARIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577215",
    "city": "CHANNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577216",
    "city": "SHIVAMOGGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577217",
    "city": "CHANNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577218",
    "city": "CHANNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577219",
    "city": "CHANNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577221",
    "city": "CHANNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577222",
    "city": "SHIVAMOGGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577223",
    "city": "CHANNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577224",
    "city": "CHANNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577225",
    "city": "SHIVAMOGGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577226",
    "city": "SHIVAMOGGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577227",
    "city": "BHADRAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577228",
    "city": "HOSADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577229",
    "city": "BHADRAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577230",
    "city": "CHANNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577231",
    "city": "CHANNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577232",
    "city": "THIRTHAHALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577233",
    "city": "BHADRAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577234",
    "city": "CHANNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577235",
    "city": "SHIVAMOGGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577236",
    "city": "SHIKARIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577237",
    "city": "BHADRAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577238",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577243",
    "city": "BHADRAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577244",
    "city": "SHIKARIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577245",
    "city": "BHADRAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577301",
    "city": "BHADRAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577302",
    "city": "BHADRAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577303",
    "city": "BHADRAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577321",
    "city": "BHADRAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577401",
    "city": "GANDHINAGAR SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577411",
    "city": "THIRTHAHALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577412",
    "city": "GANDHINAGAR SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577413",
    "city": "SORABHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577414",
    "city": "THIRTHAHALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577415",
    "city": "THIRTHAHALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577416",
    "city": "SHIVAMOGGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577417",
    "city": "GANDHINAGAR SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577418",
    "city": "SHIKARIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577419",
    "city": "SORABHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577421",
    "city": "GANDHINAGAR SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577422",
    "city": "THIRTHAHALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577423",
    "city": "SHIVAMOGGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577424",
    "city": "THIRTHAHALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577425",
    "city": "SHIKARIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577426",
    "city": "SHIKARIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577427",
    "city": "SHIKARIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577428",
    "city": "SHIKARIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577429",
    "city": "SORABHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577430",
    "city": "GANDHINAGAR SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577431",
    "city": "GANDHINAGAR SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577432",
    "city": "THIRTHAHALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577433",
    "city": "SHIKARIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577434",
    "city": "SORABHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577435",
    "city": "GANDHINAGAR SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577436",
    "city": "SHIKARIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577437",
    "city": "SORABHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577438",
    "city": "SHIKARIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577439",
    "city": "GANDHINAGAR SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577441",
    "city": "SHIKARIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577442",
    "city": "SHIVAMOGGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577443",
    "city": "GANDHINAGAR SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577444",
    "city": "SORABHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577445",
    "city": "SHIKARIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577447",
    "city": "SHIKARIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577448",
    "city": "HEBRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577450",
    "city": "SHIKARIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577451",
    "city": "BHADRAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577452",
    "city": "SORABHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577453",
    "city": "GANDHINAGAR SAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577501",
    "city": "CHITRADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577502",
    "city": "CHITRADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577511",
    "city": "HIRIYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577512",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577513",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577514",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577515",
    "city": "CHITRADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577516",
    "city": "HARIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577517",
    "city": "CHITRADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577518",
    "city": "CHITRADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577519",
    "city": "CHITRADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577520",
    "city": "CHITRADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577521",
    "city": "CHITRADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577522",
    "city": "CHALLAKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577523",
    "city": "CHITRADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577524",
    "city": "CHITRADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577525",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577526",
    "city": "HOLALKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577527",
    "city": "HOSADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577528",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577529",
    "city": "CHALLAKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577530",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577531",
    "city": "CHITRADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577532",
    "city": "HIRIYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577533",
    "city": "HOSADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577534",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577535",
    "city": "CHALLAKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577536",
    "city": "CHALLAKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577537",
    "city": "CHALLAKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577538",
    "city": "CHALLAKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577539",
    "city": "CHITRADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577540",
    "city": "TORANAGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577541",
    "city": "CHITRADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577542",
    "city": "HOSADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577543",
    "city": "CHALLAKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577544",
    "city": "CHANNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577545",
    "city": "HIRIYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577546",
    "city": "CHALLAKERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577547",
    "city": "KADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577548",
    "city": "KADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577549",
    "city": "KADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577550",
    "city": "KADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577551",
    "city": "CHANNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577552",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577553",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577554",
    "city": "HOSADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577555",
    "city": "CHITRADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577556",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577557",
    "city": "HOSADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577558",
    "city": "HIRIYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577566",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577577",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577579",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577583",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577589",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577596",
    "city": "HIRIYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577598",
    "city": "HIRIYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577599",
    "city": "HIRIYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577601",
    "city": "HARIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "577602",
    "city": "HARIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "578162",
    "city": "KOLAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "578228",
    "city": "HOSADURGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580001",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580002",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580003",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580004",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580005",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580006",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580007",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580008",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580009",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580010",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580011",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580020",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580021",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580022",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580023",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580024",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580025",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580026",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580028",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580029",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580030",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580031",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580032",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580112",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580114",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580116",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580118",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580211",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580212",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580213",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580214",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "580215",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581047",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581101",
    "city": "HANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581102",
    "city": "HANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581103",
    "city": "DANDELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581104",
    "city": "HANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581105",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581106",
    "city": "RANEBENNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581107",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581108",
    "city": "RANEBENNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581109",
    "city": "HIREKERUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581110",
    "city": "HAVERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581111",
    "city": "HIREKERUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581112",
    "city": "HAVERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581113",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581115",
    "city": "RANEBENNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581116",
    "city": "HIREKERUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581117",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581118",
    "city": "HAVERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581119",
    "city": "RANEBENNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581120",
    "city": "HAVERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581121",
    "city": "DANDELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581123",
    "city": "HARIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581124",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581125",
    "city": "HIREKERUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581126",
    "city": "HAVERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581127",
    "city": "HANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581128",
    "city": "HAVERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581129",
    "city": "DANDELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581131",
    "city": "RANEBENNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581132",
    "city": "HAVERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581134",
    "city": "HAVERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581137",
    "city": "RANEBENNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581138",
    "city": "HANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581139",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581140",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581145",
    "city": "RANEBENNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581147",
    "city": "RANEBENNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581148",
    "city": "HAVERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581149",
    "city": "HAVERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581150",
    "city": "HANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581153",
    "city": "HAVERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581154",
    "city": "HAVERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581155",
    "city": "RANEBENNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581157",
    "city": "SINDHNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581158",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581160",
    "city": "HAVERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581161",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581162",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581163",
    "city": "HARIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581164",
    "city": "HAVERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581167",
    "city": "HANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581168",
    "city": "HONNAVARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581169",
    "city": "HAVERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581170",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581171",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581177",
    "city": "BAILHONGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581180",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581181",
    "city": "HAVERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581182",
    "city": "HAVERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581183",
    "city": "HAVERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581185",
    "city": "BHATKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581186",
    "city": "DANDELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581187",
    "city": "DANDELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581189",
    "city": "HANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581191",
    "city": "MUNDGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581193",
    "city": "MUNDGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581197",
    "city": "MUNDGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581198",
    "city": "HAVERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581199",
    "city": "HANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581201",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581202",
    "city": "MUNDGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581203",
    "city": "HANGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581204",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581205",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581206",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581207",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581208",
    "city": "RANEBENNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581209",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581210",
    "city": "HIREKERUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581211",
    "city": "RANEBENNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581212",
    "city": "MUNDGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581213",
    "city": "RANEBENNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581214",
    "city": "MUNDGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581218",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581219",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581223",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581224",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581225",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581226",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581228",
    "city": "MUNDGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581230",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581231",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581232",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581234",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581301",
    "city": "KARWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581302",
    "city": "KARWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581303",
    "city": "KARWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581304",
    "city": "KARWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581305",
    "city": "KARWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581306",
    "city": "KARWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581307",
    "city": "KARWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581308",
    "city": "KARWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581314",
    "city": "ANKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581315",
    "city": "SIRSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581316",
    "city": "ANKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581317",
    "city": "KARWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581318",
    "city": "SORABHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581319",
    "city": "ANKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581320",
    "city": "BHATKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581321",
    "city": "ANKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581322",
    "city": "SIRSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581323",
    "city": "HONNAVARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581324",
    "city": "KARWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581325",
    "city": "DANDELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581326",
    "city": "ANKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581327",
    "city": "HONNAVARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581328",
    "city": "KARWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581329",
    "city": "DANDELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581330",
    "city": "HONNAVARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581331",
    "city": "SIRSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581332",
    "city": "HONNAVARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581333",
    "city": "HONNAVARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581334",
    "city": "HONNAVARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581335",
    "city": "HONNAVARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581336",
    "city": "SIRSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581337",
    "city": "MUNDGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581338",
    "city": "HONNAVARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581339",
    "city": "KARWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581340",
    "city": "SIRSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581341",
    "city": "HONNAVARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581342",
    "city": "HONNAVARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581343",
    "city": "HONNAVARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581344",
    "city": "ANKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581345",
    "city": "KARWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581346",
    "city": "SIRSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581347",
    "city": "SIRSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581348",
    "city": "HONNAVARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581349",
    "city": "MUNDGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581350",
    "city": "BHATKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581351",
    "city": "HONNAVARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581352",
    "city": "KARWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581353",
    "city": "ANKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581354",
    "city": "BHATKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581355",
    "city": "SIRSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581356",
    "city": "DANDELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581357",
    "city": "ANKOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581358",
    "city": "MUNDGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581359",
    "city": "MUNDGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581360",
    "city": "KARWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581361",
    "city": "HONNAVARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581362",
    "city": "HONNAVARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581363",
    "city": "DANDELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581365",
    "city": "DANDELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581384",
    "city": "HONNAVARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581396",
    "city": "KARWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581400",
    "city": "KARWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581401",
    "city": "SIRSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581402",
    "city": "SIRSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581403",
    "city": "SIRSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581405",
    "city": "SIRSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581411",
    "city": "MUNDGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581412",
    "city": "MUNDGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581421",
    "city": "BHATKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581423",
    "city": "HONNAVARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581431",
    "city": "HONNAVARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581440",
    "city": "HONNAVARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581450",
    "city": "SIRSI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "581453",
    "city": "DANDELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582101",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582102",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582103",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582111",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582112",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582113",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582114",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582115",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582116",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582117",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582118",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582119",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582120",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582121",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582122",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582123",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582125",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582127",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582132",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582135",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582140",
    "city": "CHIKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582142",
    "city": "HUBLI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582143",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582201",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582202",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582203",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582204",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582205",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582206",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582207",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582208",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582209",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582210",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582211",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582212",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582214",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582215",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582216",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582217",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582218",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582219",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582220",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582222",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582223",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582225",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582227",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582228",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582231",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582232",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582234",
    "city": "BAILHONGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582235",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582236",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582237",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582239",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582240",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582241",
    "city": "GADAG-BETIGERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "582243",
    "city": "JAMKHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583101",
    "city": "BALLARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583102",
    "city": "BALLARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583103",
    "city": "BALLARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583104",
    "city": "BALLARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583105",
    "city": "BALLARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583111",
    "city": "BALLARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583112",
    "city": "TORANAGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583113",
    "city": "GANGAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583114",
    "city": "SIRUGUPPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583115",
    "city": "BALLARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583116",
    "city": "BALLARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583117",
    "city": "BALLARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583118",
    "city": "TORANAGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583119",
    "city": "TORANAGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583120",
    "city": "SIRUGUPPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583121",
    "city": "SIRUGUPPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583122",
    "city": "SIRUGUPPA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583123",
    "city": "TORANAGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583124",
    "city": "TORANAGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583125",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583126",
    "city": "TORANAGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583127",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583128",
    "city": "TORANAGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583129",
    "city": "TORANAGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583130",
    "city": "TORANAGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583131",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583132",
    "city": "GANGAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583134",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583135",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583136",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583137",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583138",
    "city": "BALLARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583140",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583144",
    "city": "GANGAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583147",
    "city": "GANGAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583148",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583152",
    "city": "BALLARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583201",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583202",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583203",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583204",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583211",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583212",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583213",
    "city": "DAVANGERE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583214",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583215",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583216",
    "city": "HAVERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583217",
    "city": "HAVERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583218",
    "city": "TORANAGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583219",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583220",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583221",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583222",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583223",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583224",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583225",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583226",
    "city": "KOPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583227",
    "city": "GANGAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583228",
    "city": "KOPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583229",
    "city": "GANGAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583230",
    "city": "KOPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583231",
    "city": "KOPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583232",
    "city": "KOPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583233",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583234",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583235",
    "city": "KOPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583236",
    "city": "KOPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583237",
    "city": "KOPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583238",
    "city": "KOPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583239",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583240",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583242",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583244",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583245",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583250",
    "city": "KOPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583252",
    "city": "KOPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583253",
    "city": "KOPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583255",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583263",
    "city": "KOPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583265",
    "city": "KOPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583268",
    "city": "GANGAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583269",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583271",
    "city": "GANGAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583272",
    "city": "GANGAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583273",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583275",
    "city": "TORANAGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583276",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "583286",
    "city": "HOSAPETE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584101",
    "city": "RAICHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584102",
    "city": "RAICHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584103",
    "city": "RAICHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584104",
    "city": "RAICHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584111",
    "city": "SHAHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584112",
    "city": "ILKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584113",
    "city": "RAICHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584114",
    "city": "RAICHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584115",
    "city": "LINGASUGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584116",
    "city": "SHAHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584118",
    "city": "SIRWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584119",
    "city": "GANGAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584120",
    "city": "SIRWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584121",
    "city": "ILKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584122",
    "city": "LINGASUGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584123",
    "city": "SIRWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584124",
    "city": "SINDHNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584125",
    "city": "LINGASUGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584126",
    "city": "SHAHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584127",
    "city": "LINGASUGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584128",
    "city": "SINDHNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584129",
    "city": "SIRWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584130",
    "city": "GANGAVATHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584131",
    "city": "KOPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584132",
    "city": "SINDHNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584133",
    "city": "RAICHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584134",
    "city": "RAICHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584135",
    "city": "RAICHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584136",
    "city": "RAICHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584138",
    "city": "SINDHNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584139",
    "city": "LINGASUGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584140",
    "city": "RAICHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584142",
    "city": "SIRWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584143",
    "city": "SIRWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584166",
    "city": "ILKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584167",
    "city": "SINDHNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584170",
    "city": "RAICHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584202",
    "city": "RAICHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "584203",
    "city": "SIRWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585101",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585102",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585103",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585104",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585105",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585152",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585154",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585201",
    "city": "YADGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585202",
    "city": "YADGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585210",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585212",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585213",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585214",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585215",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585216",
    "city": "YADGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585217",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585218",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585219",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585220",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585221",
    "city": "YADGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585222",
    "city": "SEDAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585223",
    "city": "SHAHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585224",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585225",
    "city": "WADI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585229",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585236",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585237",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585239",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585240",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585245",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585248",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585256",
    "city": "KOPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585262",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585265",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585287",
    "city": "SHAHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585290",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585291",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585301",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585302",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585303",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585304",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585305",
    "city": "TOLICHOWKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585306",
    "city": "SEDAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585307",
    "city": "TOLICHOWKI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585308",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585309",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585311",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585312",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585313",
    "city": "HUMNABAD REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585314",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585315",
    "city": "YADGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585316",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585318",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585319",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585320",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585321",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585322",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585323",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585324",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585325",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585326",
    "city": "BIDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585327",
    "city": "BASAVKALYAN REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585329",
    "city": "BIDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585330",
    "city": "HUMNABAD REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585331",
    "city": "BIDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585337",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585338",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585339",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585340",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585341",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585342",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585343",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585344",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585351",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585353",
    "city": "BIDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585355",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585359",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585361",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585372",
    "city": "KALABURAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585401",
    "city": "BIDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585402",
    "city": "BIDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585403",
    "city": "BIDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585411",
    "city": "BIDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585414",
    "city": "BIDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585415",
    "city": "BIDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585416",
    "city": "BIDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585417",
    "city": "BIDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585418",
    "city": "BIDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585419",
    "city": "BIDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585421",
    "city": "BIDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585436",
    "city": "BIDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585437",
    "city": "BIDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "585443",
    "city": "BIDAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586101",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586102",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586103",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586104",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586105",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586106",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586107",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586108",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586109",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586111",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586112",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586113",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586114",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586115",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586116",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586117",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586118",
    "city": "SINDAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586119",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586120",
    "city": "SINDAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586121",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586122",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586123",
    "city": "SINDAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586124",
    "city": "LINGASUGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586125",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586126",
    "city": "JAMKHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586127",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586128",
    "city": "SINDAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586129",
    "city": "ILKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586130",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586144",
    "city": "SINDAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586148",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586149",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586151",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586161",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586163",
    "city": "SINDAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586166",
    "city": "SINDAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586169",
    "city": "SINDAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586201",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586202",
    "city": "SINDAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586203",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586204",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586205",
    "city": "INDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586206",
    "city": "SINDAGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586207",
    "city": "INDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586208",
    "city": "INDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586209",
    "city": "INDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586210",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586211",
    "city": "INDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586212",
    "city": "MUDDEBIHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586213",
    "city": "MUDDEBIHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586214",
    "city": "MUDDEBIHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586215",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586216",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586217",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586218",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586223",
    "city": "INDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586231",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586235",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586236",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586242",
    "city": "VIJAYAPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "586245",
    "city": "MUDDEBIHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587101",
    "city": "BAGALKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587102",
    "city": "BAGALKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587103",
    "city": "BAGALKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587104",
    "city": "BAGALKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587111",
    "city": "BAGALKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587112",
    "city": "BAGALKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587113",
    "city": "MUDHOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587114",
    "city": "BADAMI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587115",
    "city": "BAGALKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587116",
    "city": "BILLGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587117",
    "city": "BAGALKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587118",
    "city": "ILKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587119",
    "city": "JAMKHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587120",
    "city": "BAGALKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587121",
    "city": "BAGALKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587122",
    "city": "MUDHOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587124",
    "city": "ILKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587125",
    "city": "ILKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587126",
    "city": "BILLGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587143",
    "city": "RANEBENNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587145",
    "city": "ILKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587154",
    "city": "ILKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587155",
    "city": "BAGALKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587201",
    "city": "BADAMI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587202",
    "city": "ILKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587203",
    "city": "BADAMI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587204",
    "city": "BAGALKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587205",
    "city": "BADAMI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587206",
    "city": "BADAMI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587207",
    "city": "BILLGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587212",
    "city": "BANAHATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587213",
    "city": "BAGALKOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587301",
    "city": "JAMKHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587302",
    "city": "JAMKHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587311",
    "city": "BANAHATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587312",
    "city": "BANAHATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587313",
    "city": "MUDHOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587314",
    "city": "BANAHATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587315",
    "city": "BANAHATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587316",
    "city": "BANAHATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587320",
    "city": "BANAHATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "587322",
    "city": "JAMKHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "590001",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "590002",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "590003",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "590004",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "590005",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "590006",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "590007",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "590008",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "590009",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "590010",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "590011",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "590012",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "590013",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "590014",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "590015",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "590016",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "590017",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "590018",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "590019",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "590543",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591101",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591102",
    "city": "BAILHONGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591103",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591104",
    "city": "BAILHONGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591106",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591107",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591108",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591109",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591110",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591111",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591112",
    "city": "BAILHONGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591113",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591114",
    "city": "MUDHOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591115",
    "city": "BAILHONGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591116",
    "city": "MUDHOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591117",
    "city": "MUDHOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591118",
    "city": "BAILHONGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591119",
    "city": "BAILHONGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591121",
    "city": "BAILHONGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591122",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591123",
    "city": "MUDHOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591124",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591125",
    "city": "BAILHONGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591126",
    "city": "BAILHONGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591127",
    "city": "MUDHOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591128",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591129",
    "city": "MUDHOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591130",
    "city": "MUDHOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591131",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591132",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591133",
    "city": "BAILHONGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591136",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591138",
    "city": "BAILHONGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591139",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591141",
    "city": "BAILHONGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591143",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591147",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591148",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591149",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591153",
    "city": "BAILHONGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591156",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591157",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591159",
    "city": "BAILHONGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591168",
    "city": "MUDHOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591177",
    "city": "BAILHONGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591181",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591183",
    "city": "BAILHONGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591184",
    "city": "ATHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591187",
    "city": "MUDHOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591188",
    "city": "BAILHONGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591190",
    "city": "BAILHONGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591196",
    "city": "DHARWAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591201",
    "city": "CHIKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591211",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591212",
    "city": "ATHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591213",
    "city": "CHIKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591214",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591215",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591216",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591217",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591218",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591219",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591220",
    "city": "BANAHATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591221",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591222",
    "city": "CHIKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591223",
    "city": "ATHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591224",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591225",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591226",
    "city": "CHIKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591227",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591228",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591229",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591230",
    "city": "ATHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591231",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591232",
    "city": "ATHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591233",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591234",
    "city": "ATHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591235",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591236",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591237",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591238",
    "city": "CHIKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591239",
    "city": "CHIKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591240",
    "city": "ATHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591241",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591242",
    "city": "CHIKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591243",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591244",
    "city": "CHIKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591245",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591246",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591247",
    "city": "CHIKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591248",
    "city": "ATHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591252",
    "city": "CHIKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591254",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591261",
    "city": "ATHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591263",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591265",
    "city": "ATHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591266",
    "city": "ATHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591267",
    "city": "CHIKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591270",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591272",
    "city": "CHIKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591279",
    "city": "CHIKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591280",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591284",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591285",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591286",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591287",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591288",
    "city": "CHIKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591296",
    "city": "CHIKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591301",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591302",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591303",
    "city": "ATHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591304",
    "city": "ATHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591305",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591306",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591307",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591308",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591309",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591310",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591311",
    "city": "ATHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591312",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591313",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591314",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591315",
    "city": "ATHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591316",
    "city": "ATHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591317",
    "city": "CHIKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591318",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591321",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591322",
    "city": "BELAGAVI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591332",
    "city": "CHIKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591340",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591341",
    "city": "ATHANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591343",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591344",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591506",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591511",
    "city": "CHIKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591512",
    "city": "CHIKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591513",
    "city": "GOKAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591514",
    "city": "NIPANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591516",
    "city": "BANAHATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591702",
    "city": "MUDHOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "591812",
    "city": "MUDHOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "599991",
    "city": "HYD ICICI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600000",
    "city": "MADRAS REGIONAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600001",
    "city": "PARRYS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600002",
    "city": "EGMORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600003",
    "city": "PARRYS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600004",
    "city": "ALWARPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600005",
    "city": "EGMORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600006",
    "city": "EGMORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600007",
    "city": "PURASAWALKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600008",
    "city": "MPC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600009",
    "city": "PARRYS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600010",
    "city": "KILPAUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600011",
    "city": "VYASARPADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600012",
    "city": "KELLYS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600013",
    "city": "PARRYS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600014",
    "city": "ALWARPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600015",
    "city": "NANDANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600016",
    "city": "GUINDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600017",
    "city": "TNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600018",
    "city": "ALWARPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600019",
    "city": "MANALI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600020",
    "city": "ADYAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600021",
    "city": "PARRYS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600022",
    "city": "GUINDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600023",
    "city": "KELLYS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600024",
    "city": "VADAPALANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600025",
    "city": "NANDANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600026",
    "city": "VADAPALANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600027",
    "city": "GUINDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600028",
    "city": "ALWARPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600029",
    "city": "KILPAUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600030",
    "city": "KILPAUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600031",
    "city": "KILPAUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600032",
    "city": "GUINDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600033",
    "city": "TNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600034",
    "city": "LAKE AREA NUNGAMBAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600035",
    "city": "NANDANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600036",
    "city": "ADYAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600037",
    "city": "ANNA NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600038",
    "city": "ANNA NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600039",
    "city": "VYASARPADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600040",
    "city": "ANNA NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600041",
    "city": "ADYAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600042",
    "city": "VELACHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600043",
    "city": "CHROMPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600044",
    "city": "CHROMPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600045",
    "city": "TAMBARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600046",
    "city": "TAMBARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600047",
    "city": "TAMBARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600048",
    "city": "URAPAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600049",
    "city": "ANNA NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600050",
    "city": "AMBATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600051",
    "city": "MADHAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600052",
    "city": "REDHILLS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600053",
    "city": "AMBATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600054",
    "city": "AVADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600055",
    "city": "THIRUNINRAVUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600056",
    "city": "PORUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600057",
    "city": "MANALI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600058",
    "city": "AMBATTUR INDL ESTATE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600059",
    "city": "TAMBARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600060",
    "city": "MADHAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600061",
    "city": "GUINDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600062",
    "city": "AVADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600063",
    "city": "TAMBARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600064",
    "city": "CHROMPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600065",
    "city": "AVADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600066",
    "city": "PERAMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600067",
    "city": "REDHILLS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600068",
    "city": "MADHAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600069",
    "city": "MANGADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600070",
    "city": "CHROMPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600071",
    "city": "AVADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600072",
    "city": "THIRUNINRAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600073",
    "city": "SELAIYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600074",
    "city": "CHROMPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600075",
    "city": "CHROMPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600076",
    "city": "AMBATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600077",
    "city": "PORUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600078",
    "city": "GUINDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600079",
    "city": "PARRYS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600080",
    "city": "AMBATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600081",
    "city": "MANALI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600082",
    "city": "PERAMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600083",
    "city": "TNAGAR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600084",
    "city": "PURASAWALKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600085",
    "city": "ADYAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600086",
    "city": "ALWARPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600087",
    "city": "VADAPALANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600088",
    "city": "VELACHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600089",
    "city": "GUINDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600090",
    "city": "ADYAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600091",
    "city": "KEELKATTALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600092",
    "city": "VADAPALANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600093",
    "city": "VADAPALANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600094",
    "city": "LAKE AREA NUNGAMBAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600095",
    "city": "ANNA NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600096",
    "city": "PERUNGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600097",
    "city": "PERUNGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600098",
    "city": "AMBATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600099",
    "city": "PERAMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600100",
    "city": "PALLIKARNAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600101",
    "city": "AMBATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600102",
    "city": "ANNA NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600103",
    "city": "MANALI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600104",
    "city": "PARRYS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600105",
    "city": "MPC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600106",
    "city": "KILPAUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600107",
    "city": "ANNA NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600108",
    "city": "PARRYS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600109",
    "city": "AVADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600110",
    "city": "PERAMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600111",
    "city": "LAKE AREA NUNGAMBAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600112",
    "city": "PARRYS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600113",
    "city": "ADYAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600114",
    "city": "GUINDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600115",
    "city": "ADYAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600116",
    "city": "MUGALIVAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600117",
    "city": "KEELKATTALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600118",
    "city": "MADHAVARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600119",
    "city": "SHOLINGANALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600120",
    "city": "MINJUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600122",
    "city": "MANGADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600123",
    "city": "MANGADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600124",
    "city": "THIRUMAZHAISAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600125",
    "city": "MUGALIVAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600126",
    "city": "SELAIYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600127",
    "city": "VENGADAMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600128",
    "city": "MANGADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600129",
    "city": "PALLIKARNAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600130",
    "city": "SHOLINGANALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600132",
    "city": "CHROMPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "600704",
    "city": "AMBATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "601101",
    "city": "PERIYAPALAYAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "601102",
    "city": "PERIYAPALAYAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "601103",
    "city": "PERIYAPALAYAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "601201",
    "city": "GUMMIDIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "601202",
    "city": "PONNERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "601203",
    "city": "MINJUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "601204",
    "city": "PERIYAPALAYAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "601205",
    "city": "PONNERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "601206",
    "city": "PONNERI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "601301",
    "city": "URAPAKKAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "601302",
    "city": "PORUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602000",
    "city": "DELL INDIA CHENNAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602001",
    "city": "TIRUVALLUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602002",
    "city": "TIRUVALLUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602003",
    "city": "TIRUVALLUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602004",
    "city": "TIRUVALLUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602010",
    "city": "AMBATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602017",
    "city": "AMBATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602021",
    "city": "TIRUVALLUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602022",
    "city": "PORUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602023",
    "city": "TIRUVALLUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602024",
    "city": "THIRUNINRAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602025",
    "city": "THIRUNINRAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602026",
    "city": "PERIYAPALAYAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602027",
    "city": "PORUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602031",
    "city": "GUINDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602101",
    "city": "GUINDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602103",
    "city": "IRUNGATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602105",
    "city": "SRIPERUMBUDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602106",
    "city": "SRIPERUMBUDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602107",
    "city": "IRUNGATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602108",
    "city": "PERAMBAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602109",
    "city": "PORUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602117",
    "city": "SRIPERUMBUDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602204",
    "city": "AMBATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "602205",
    "city": "AMBATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603001",
    "city": "TIRUKALUKUNDRAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603002",
    "city": "TIRUKALUKUNDRAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603003",
    "city": "TIRUKALUKUNDRAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603004",
    "city": "MARAIMALAI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603101",
    "city": "TIRUKALUKUNDRAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603102",
    "city": "MARAIMALAI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603103",
    "city": "KELAMBAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603104",
    "city": "MAHABALIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603105",
    "city": "MAHABALIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603106",
    "city": "TIRUKALUKUNDRAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603107",
    "city": "MARAIMALAI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603108",
    "city": "TIRUKALUKUNDRAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603109",
    "city": "TIRUKALUKUNDRAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603110",
    "city": "KELAMBAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603111",
    "city": "TIRUKALUKUNDRAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603112",
    "city": "KOVALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603127",
    "city": "TIRUKALUKUNDRAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603201",
    "city": "ACHIRAPAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603202",
    "city": "URAPAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603203",
    "city": "URAPAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603204",
    "city": "MARAIMALAI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603209",
    "city": "MARAIMALAI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603210",
    "city": "URAPAKKAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603211",
    "city": "URAPAKKAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603301",
    "city": "ACHIRAPAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603302",
    "city": "ACHIRAPAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603303",
    "city": "ACHIRAPAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603304",
    "city": "ACHIRAPAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603305",
    "city": "MARAIMALAI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603306",
    "city": "ACHIRAPAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603307",
    "city": "TINDIVANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603309",
    "city": "ACHIRAPAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603310",
    "city": "ACHIRAPAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603311",
    "city": "ACHIRAPAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603312",
    "city": "MARAIMALAI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603313",
    "city": "ACHIRAPAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603314",
    "city": "MARAIMALAI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603319",
    "city": "ACHIRAPAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603401",
    "city": "ACHIRAPAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603402",
    "city": "MARAIMALAI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603403",
    "city": "KANCHIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603404",
    "city": "PORUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603405",
    "city": "TIRUKALUKUNDRAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "603406",
    "city": "MARAIMALAI NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604001",
    "city": "TINDIVANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604002",
    "city": "TINDIVANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604101",
    "city": "TINDIVANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604102",
    "city": "TINDIVANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604151",
    "city": "KILPENNATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604152",
    "city": "KILPENNATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604153",
    "city": "KILPENNATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604154",
    "city": "TINDIVANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604201",
    "city": "KILPENNATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604202",
    "city": "KILPENNATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604203",
    "city": "TINDIVANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604204",
    "city": "KILPENNATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604205",
    "city": "KILPENNATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604206",
    "city": "TINDIVANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604207",
    "city": "TINDIVANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604208",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604210",
    "city": "KILPENNATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604301",
    "city": "TINDIVANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604302",
    "city": "TINDIVANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604303",
    "city": "PILLAYARKUPPAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604304",
    "city": "TINDIVANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604305",
    "city": "TINDIVANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604306",
    "city": "TINDIVANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604307",
    "city": "TINDIVANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604401",
    "city": "KANCHIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604402",
    "city": "KANCHIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604403",
    "city": "ACHIRAPAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604404",
    "city": "KANCHIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604405",
    "city": "ACHIRAPAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604406",
    "city": "ACHIRAPAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604407",
    "city": "KANCHIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604408",
    "city": "KANCHIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604409",
    "city": "KANCHIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604410",
    "city": "BALU CHETTY CHATRAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604413",
    "city": "CUDDALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604501",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604502",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604503",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604504",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604505",
    "city": "KANCHIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "604601",
    "city": "KILPENNATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605001",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605002",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605003",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605004",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605005",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605006",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605007",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605008",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605009",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605010",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605011",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605012",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605013",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605014",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605101",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605102",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605103",
    "city": "VILLUPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605104",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605105",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605106",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605107",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605108",
    "city": "VILLUPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605109",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605110",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605111",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605201",
    "city": "KILPENNATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605202",
    "city": "VILLUPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605203",
    "city": "VILLUPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605301",
    "city": "VILLUPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605302",
    "city": "VILLUPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605401",
    "city": "VILLUPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605402",
    "city": "VILLUPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605501",
    "city": "PILLAYARKUPPAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605502",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605601",
    "city": "VILLUPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605602",
    "city": "VILLUPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605604",
    "city": "VILLUPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605606",
    "city": "VILLUPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605651",
    "city": "TINDIVANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605652",
    "city": "VILLUPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605701",
    "city": "THIRUKOILUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605702",
    "city": "THIRUKOILUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605751",
    "city": "THIRUKOILUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605752",
    "city": "THIRUKOILUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605754",
    "city": "THIRUKOILUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605755",
    "city": "THIRUKOILUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605756",
    "city": "THIRUKOILUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605757",
    "city": "THIRUKOILUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605758",
    "city": "THIRUKOILUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605759",
    "city": "THIRUKOILUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605766",
    "city": "THIRUKOILUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605801",
    "city": "THIRUKOILUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605802",
    "city": "THIRUKOILUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "605803",
    "city": "THIRUKOILUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606001",
    "city": "VIRUDHACHALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606003",
    "city": "VIRUDHACHALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606102",
    "city": "ULUNDURPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606103",
    "city": "VIRUDHACHALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606104",
    "city": "ULUNDURPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606105",
    "city": "VIRUDHACHALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606106",
    "city": "VIRUDHACHALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606107",
    "city": "ULUNDURPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606108",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606109",
    "city": "THALAIVASAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606110",
    "city": "VIRUDHACHALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606111",
    "city": "VIRUDHACHALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606115",
    "city": "ULUNDURPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606120",
    "city": "CUDDALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606123",
    "city": "CUDDALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606201",
    "city": "KALLAKURCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606202",
    "city": "KALLAKURCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606203",
    "city": "KALLAKURCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606204",
    "city": "KALLAKURCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606205",
    "city": "THIRUKOILUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606206",
    "city": "KALLAKURCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606207",
    "city": "THALAIVASAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606208",
    "city": "KALLAKURCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606213",
    "city": "KALLAKURCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606301",
    "city": "THALAIVASAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606302",
    "city": "VIRUDHACHALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606303",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606304",
    "city": "VIRUDHACHALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606305",
    "city": "ULUNDURPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606306",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606401",
    "city": "KALLAKURCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606402",
    "city": "KALLAKURCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606601",
    "city": "TIRUVANNAMALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606602",
    "city": "TIRUVANNAMALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606603",
    "city": "TIRUVANNAMALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606604",
    "city": "TIRUVANNAMALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606611",
    "city": "KILPENNATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606702",
    "city": "CHENGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606703",
    "city": "CHENGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606704",
    "city": "CHENGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606705",
    "city": "CHENGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606706",
    "city": "CHENGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606707",
    "city": "CHENGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606708",
    "city": "CHENGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606709",
    "city": "CHENGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606710",
    "city": "CHENGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606751",
    "city": "TIRUVANNAMALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606752",
    "city": "KILPENNATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606753",
    "city": "TIRUVANNAMALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606754",
    "city": "TIRUVANNAMALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606755",
    "city": "TIRUVANNAMALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606801",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606802",
    "city": "TIRUVANNAMALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606803",
    "city": "TIRUVANNAMALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606804",
    "city": "THIRUKOILUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606805",
    "city": "TIRUVANNAMALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606806",
    "city": "THIRUKOILUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606807",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606808",
    "city": "KILPENNATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606811",
    "city": "THIRUKOILUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606901",
    "city": "CHENGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606902",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606903",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606904",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606905",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606906",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606907",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606908",
    "city": "CHENGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "606914",
    "city": "CUDDALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607001",
    "city": "CUDDALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607002",
    "city": "CUDDALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607003",
    "city": "CUDDALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607004",
    "city": "CUDDALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607005",
    "city": "CUDDALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607006",
    "city": "KONDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607101",
    "city": "VILLUPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607102",
    "city": "KONDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607103",
    "city": "NEYVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607104",
    "city": "KONDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607105",
    "city": "CUDDALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607106",
    "city": "PANRUTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607107",
    "city": "VILLUPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607108",
    "city": "PANRUTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607109",
    "city": "KONDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607110",
    "city": "CUDDALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607112",
    "city": "KONDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607201",
    "city": "ULUNDURPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607202",
    "city": "ULUNDURPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607203",
    "city": "VILLUPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607204",
    "city": "ULUNDURPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607205",
    "city": "VILLUPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607207",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607209",
    "city": "VILLUPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607301",
    "city": "NEYVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607302",
    "city": "NEYVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607303",
    "city": "NEYVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607308",
    "city": "NEYVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607401",
    "city": "KONDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607402",
    "city": "PUDUCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607403",
    "city": "PILLAYARKUPPAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607801",
    "city": "NEYVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607802",
    "city": "NEYVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607803",
    "city": "NEYVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607804",
    "city": "NEYVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607805",
    "city": "NEYVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "607807",
    "city": "NEYVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "608001",
    "city": "CHIDAMBARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "608002",
    "city": "CHIDAMBARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "608102",
    "city": "CHIDAMBARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "608201",
    "city": "BUVANAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "608301",
    "city": "BUVANAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "608302",
    "city": "BUVANAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "608303",
    "city": "BUVANAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "608304",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "608305",
    "city": "BUVANAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "608306",
    "city": "SIRKALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "608401",
    "city": "CHIDAMBARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "608501",
    "city": "BUVANAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "608502",
    "city": "CHIDAMBARAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "608601",
    "city": "BUVANAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "608602",
    "city": "BUVANAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "608701",
    "city": "BUVANAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "608702",
    "city": "BUVANAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "608703",
    "city": "BUVANAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "608704",
    "city": "BUVANAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "608801",
    "city": "BUVANAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "608901",
    "city": "JAYANKONDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609001",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609002",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609003",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609101",
    "city": "SIRKALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609102",
    "city": "SIRKALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609103",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609104",
    "city": "SIRKALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609105",
    "city": "SEMBANARKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609106",
    "city": "SIRKALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609107",
    "city": "SIRKALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609108",
    "city": "SIRKALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609109",
    "city": "SIRKALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609110",
    "city": "SIRKALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609111",
    "city": "SIRKALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609112",
    "city": "SIRKALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609113",
    "city": "SIRKALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609115",
    "city": "SIRKALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609116",
    "city": "SIRKALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609117",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609118",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609120",
    "city": "SIRKALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609123",
    "city": "SIRKALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609124",
    "city": "CUDDALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609128",
    "city": "SIRKALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609130",
    "city": "SIRKALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609201",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609202",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609203",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609204",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609205",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609301",
    "city": "SEMBANARKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609302",
    "city": "SEMBANARKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609303",
    "city": "SEMBANARKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609304",
    "city": "SEMBANARKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609305",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609306",
    "city": "SEMBANARKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609307",
    "city": "SEMBANARKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609308",
    "city": "KARAIKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609309",
    "city": "SEMBANARKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609310",
    "city": "SEMBANARKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609311",
    "city": "SEMBANARKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609312",
    "city": "SEMBANARKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609313",
    "city": "SEMBANARKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609314",
    "city": "SEMBANARKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609401",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609402",
    "city": "SEMBANARKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609403",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609404",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609406",
    "city": "SEMBANARKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609501",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609502",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609503",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609504",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609505",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609506",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609601",
    "city": "KARAIKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609602",
    "city": "KARAIKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609603",
    "city": "KARAIKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609604",
    "city": "KARAIKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609605",
    "city": "KARAIKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609606",
    "city": "KARAIKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609607",
    "city": "KARAIKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609608",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609609",
    "city": "KARAIKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609701",
    "city": "NAGAPATTINAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609702",
    "city": "KARAIKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609703",
    "city": "KARAIKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609704",
    "city": "NAGAPATTINAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609801",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609802",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609803",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609804",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609805",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609806",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609807",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609808",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609809",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609810",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "609811",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610001",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610002",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610003",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610004",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610005",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610051",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610101",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610102",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610103",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610104",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610105",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610106",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610107",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610109",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610110",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610113",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610114",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610201",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610202",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610203",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610205",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610206",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610207",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610210",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610211",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "610212",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "611001",
    "city": "NAGAPATTINAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "611002",
    "city": "NAGAPATTINAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "611003",
    "city": "NAGAPATTINAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "611006",
    "city": "NAGAPATTINAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "611101",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "611102",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "611103",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "611104",
    "city": "NAGAPATTINAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "611105",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "611106",
    "city": "NAGAPATTINAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "611108",
    "city": "NAGAPATTINAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "611109",
    "city": "NAGAPATTINAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "611110",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "611111",
    "city": "NAGAPATTINAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "611112",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "611117",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "611118",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612001",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612002",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612101",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612103",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612104",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612105",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612106",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612107",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612108",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612201",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612202",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612203",
    "city": "MYLADUTHURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612204",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612205",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612206",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612301",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612303",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612401",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612501",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612502",
    "city": "JAYANKONDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612503",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612504",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612601",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612602",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612603",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612604",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612605",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612610",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612701",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612702",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612703",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612704",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612715",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612801",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612802",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612803",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612804",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612901",
    "city": "JAYANKONDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612902",
    "city": "JAYANKONDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612903",
    "city": "JAYANKONDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612904",
    "city": "JAYANKONDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "612905",
    "city": "JAYANKONDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613001",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613002",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613003",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613004",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613005",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613006",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613007",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613008",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613009",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613010",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613101",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613102",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613103",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613104",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613105",
    "city": "SRIRANGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613201",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613202",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613203",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613204",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613205",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613301",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613303",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613401",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613402",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613403",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613501",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613502",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613503",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613504",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613601",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613602",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613702",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613703",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613704",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "613705",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614001",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614010",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614013",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614014",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614015",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614016",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614017",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614018",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614020",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614024",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614028",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614101",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614102",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614103",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614201",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614202",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614203",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614204",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614205",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614206",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614207",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614208",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614209",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614210",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614211",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614301",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614302",
    "city": "KUMBAKONAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614303",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614401",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614402",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614403",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614404",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614601",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614602",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614612",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614613",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614614",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614615",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614616",
    "city": "ARANTHANGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614617",
    "city": "ARANTHANGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614618",
    "city": "ARANTHANGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614619",
    "city": "ARANTHANGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614620",
    "city": "ARANTHANGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614621",
    "city": "ARANTHANGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614622",
    "city": "ARANTHANGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614623",
    "city": "ARANTHANGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614624",
    "city": "ARANTHANGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614625",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614626",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614627",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614628",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614629",
    "city": "THONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614630",
    "city": "ARANTHANGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614631",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614632",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614701",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614702",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614704",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614705",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614706",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614707",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614708",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614711",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614712",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614713",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614714",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614715",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614716",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614717",
    "city": "MANNARGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614719",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614722",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614723",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614728",
    "city": "CUDDALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614738",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614801",
    "city": "ARANTHANGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614802",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614803",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614804",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614805",
    "city": "ARANTHANGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614806",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614807",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614808",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614810",
    "city": "THIRUTHURAIPOONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614820",
    "city": "TIRUVARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614901",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614902",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614904",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614905",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "614906",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620001",
    "city": "TIRUCHIRAPALLI CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620002",
    "city": "TRZ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620003",
    "city": "TRZ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620004",
    "city": "TRICHY KK NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620005",
    "city": "TRZ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620006",
    "city": "TRZ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620007",
    "city": "TRICHY KK NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620008",
    "city": "TRZ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620009",
    "city": "TIRUCHIRAPALLI CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620010",
    "city": "TRZ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620011",
    "city": "TRZ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620012",
    "city": "TIRUCHIRAPALLI CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620013",
    "city": "THIRUVERUMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620014",
    "city": "THIRUVERUMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620015",
    "city": "THIRUVERUMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620016",
    "city": "TRICHY KK NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620017",
    "city": "TRZ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620018",
    "city": "TRZ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620019",
    "city": "THIRUVERUMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620020",
    "city": "TRICHY KK NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620021",
    "city": "TRICHY KK NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620022",
    "city": "THIRUVERUMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620023",
    "city": "TRICHY KK NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620024",
    "city": "TRICHY KK NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620025",
    "city": "TRICHY KK NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620026",
    "city": "TRICHY KK NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620027",
    "city": "TRICHY APX/SFC PUD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620052",
    "city": "THIRUVERUMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620101",
    "city": "TRZ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620102",
    "city": "TRZ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "620114",
    "city": "TRICHY KK NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621001",
    "city": "THURAIYURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621002",
    "city": "THURAIYURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621003",
    "city": "THURAIYURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621004",
    "city": "THURAIYURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621005",
    "city": "SRIRANGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621006",
    "city": "THURAIYURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621007",
    "city": "THURAIYURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621008",
    "city": "THURAIYURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621009",
    "city": "THURAIYURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621010",
    "city": "THURAIYURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621011",
    "city": "THURAIYURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621012",
    "city": "THURAIYURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621014",
    "city": "THURAIYURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621015",
    "city": "THURAIYURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621016",
    "city": "THURAIYURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621018",
    "city": "THURAIYURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621022",
    "city": "THURAIYURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621101",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621102",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621103",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621104",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621105",
    "city": "SRIRANGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621106",
    "city": "ARIYALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621107",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621108",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621109",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621110",
    "city": "THALAIVASAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621111",
    "city": "SRIRANGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621112",
    "city": "SRIRANGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621113",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621114",
    "city": "THURAIYURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621115",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621116",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621117",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621118",
    "city": "THURAIYURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621119",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621121",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621126",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621127",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621132",
    "city": "SRIRANGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621133",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621201",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621202",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621203",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621204",
    "city": "SRIRANGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621205",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621206",
    "city": "THURAIYURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621207",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621208",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621209",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621210",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621211",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621212",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621213",
    "city": "SRIRANGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621214",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621215",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621216",
    "city": "SRIRANGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621217",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621218",
    "city": "SRIRANGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621219",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621220",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621221",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621229",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621301",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621302",
    "city": "MANAPARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621304",
    "city": "MANAPARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621305",
    "city": "MANAPARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621306",
    "city": "MANAPARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621307",
    "city": "MANAPARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621308",
    "city": "MANAPARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621310",
    "city": "MANAPARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621311",
    "city": "MANAPARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621312",
    "city": "MANAPARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621313",
    "city": "MANAPARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621314",
    "city": "MANAPARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621315",
    "city": "MANAPARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621316",
    "city": "MANAPARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621516",
    "city": "CUMBAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621591",
    "city": "SANKARANKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621601",
    "city": "SRIRANGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621651",
    "city": "ARIYALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621652",
    "city": "ARIYALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621653",
    "city": "ARIYALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621701",
    "city": "JAYANKONDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621702",
    "city": "SRIRANGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621703",
    "city": "SRIRANGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621704",
    "city": "ARIYALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621705",
    "city": "ARIYALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621706",
    "city": "SRIRANGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621707",
    "city": "ARIYALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621708",
    "city": "PERAMBALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621709",
    "city": "JAYANKONDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621710",
    "city": "JAYANKONDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621711",
    "city": "ARIYALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621712",
    "city": "SRIRANGAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621713",
    "city": "ARIYALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621715",
    "city": "ARIYALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621716",
    "city": "ARIYALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621717",
    "city": "ARIYALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621718",
    "city": "ARIYALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621719",
    "city": "JAYANKONDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621722",
    "city": "ARIYALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621729",
    "city": "ARIYALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621730",
    "city": "JAYANKONDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621731",
    "city": "ARIYALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621801",
    "city": "JAYANKONDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621802",
    "city": "JAYANKONDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621803",
    "city": "JAYANKONDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621804",
    "city": "JAYANKONDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621805",
    "city": "JAYANKONDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621806",
    "city": "JAYANKONDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "621851",
    "city": "ARIYALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622001",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622002",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622003",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622004",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622005",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622054",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622101",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622102",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622103",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622104",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622201",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622202",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622203",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622204",
    "city": "ARANTHANGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622209",
    "city": "ARANTHANGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622301",
    "city": "ARANTHANGI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622302",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622303",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622304",
    "city": "PATTUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622401",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622402",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622403",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622404",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622406",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622407",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622408",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622409",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622411",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622412",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622419",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622422",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622501",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622502",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622503",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622504",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622505",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622506",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622507",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "622515",
    "city": "TRICHY KK NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623097",
    "city": "KAMUTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623115",
    "city": "KAMUTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623120",
    "city": "KADALADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623135",
    "city": "KADALADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623215",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623308",
    "city": "DEVAKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623309",
    "city": "THONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623315",
    "city": "THONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623318",
    "city": "CUDDALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623401",
    "city": "DEVAKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623402",
    "city": "THONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623403",
    "city": "THONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623404",
    "city": "THONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623406",
    "city": "THONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623407",
    "city": "THONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623409",
    "city": "THONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623501",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623502",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623503",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623504",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623512",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623513",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623514",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623515",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623516",
    "city": "MANDAPAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623517",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623518",
    "city": "MANDAPAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623519",
    "city": "MANDAPAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623520",
    "city": "MANDAPAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623521",
    "city": "MANDAPAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623522",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623523",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623524",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623525",
    "city": "THONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623526",
    "city": "MANDAPAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623527",
    "city": "PARAMAKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623528",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623529",
    "city": "MANDAPAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623530",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623531",
    "city": "THONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623532",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623533",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623534",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623536",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623537",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623538",
    "city": "THONDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623539",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623544",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623566",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623601",
    "city": "KAMUTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623603",
    "city": "KAMUTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623604",
    "city": "KAMUTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623605",
    "city": "KAMUTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623608",
    "city": "KAMUTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623701",
    "city": "PARAMAKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623703",
    "city": "KADALADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623704",
    "city": "KADALADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623705",
    "city": "PARAMAKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623706",
    "city": "KADALADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623707",
    "city": "PARAMAKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623708",
    "city": "KADALADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623711",
    "city": "KADALADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623712",
    "city": "KADALADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623719",
    "city": "PARAMAKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623801",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623802",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623804",
    "city": "MANDAPAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623806",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623807",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "623808",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624001",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624002",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624003",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624004",
    "city": "BALAKRISHNAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624005",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624006",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624007",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624008",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624009",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624010",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624054",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624101",
    "city": "KODAIKANAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624102",
    "city": "KODAIKANAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624103",
    "city": "KODAIKANAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624201",
    "city": "BALAKRISHNAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624202",
    "city": "NILAKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624204",
    "city": "BATALAGUNDU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624205",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624206",
    "city": "BALAKRISHNAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624208",
    "city": "NILAKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624211",
    "city": "BATALAGUNDU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624212",
    "city": "ODDANCHATRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624213",
    "city": "NILAKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624215",
    "city": "NILAKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624216",
    "city": "BATALAGUNDU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624219",
    "city": "NILAKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624220",
    "city": "BATALAGUNDU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624224",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624228",
    "city": "BATALAGUNDU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624301",
    "city": "BALAKRISHNAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624302",
    "city": "BALAKRISHNAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624303",
    "city": "BATALAGUNDU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624304",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624306",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624307",
    "city": "BALAKRISHNAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624308",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624312",
    "city": "BALAKRISHNAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624314",
    "city": "BALAKRISHNAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624316",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624401",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624402",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624403",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624404",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624601",
    "city": "PALANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624610",
    "city": "PALANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624612",
    "city": "ODDANCHATRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624613",
    "city": "PALANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624614",
    "city": "ODDANCHATRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624615",
    "city": "PALANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624616",
    "city": "ODDANCHATRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624617",
    "city": "PALANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624618",
    "city": "PALANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624619",
    "city": "ODDANCHATRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624620",
    "city": "BALAKRISHNAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624621",
    "city": "PALANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624622",
    "city": "ODDANCHATRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624624",
    "city": "BALAKRISHNAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624701",
    "city": "BALAKRISHNAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624702",
    "city": "BALAKRISHNAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624703",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624704",
    "city": "ODDANCHATRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624705",
    "city": "ODDANCHATRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624706",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624707",
    "city": "BALAKRISHNAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624708",
    "city": "NILAKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624709",
    "city": "BALAKRISHNAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624710",
    "city": "BALAKRISHNAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624711",
    "city": "BALAKRISHNAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624712",
    "city": "ODDANCHATRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624714",
    "city": "ODDANCHATRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624771",
    "city": "BALAKRISHNAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624801",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624802",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624803",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624881",
    "city": "DINDIGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624885",
    "city": "THENI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "624890",
    "city": "BODINAYAKKANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625001",
    "city": "MADURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625002",
    "city": "MADURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625003",
    "city": "MADURAI BYE-PASS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625004",
    "city": "MADURAI BYE-PASS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625005",
    "city": "MADURAI BYE-PASS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625006",
    "city": "MADURAI BYE-PASS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625007",
    "city": "MADURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625008",
    "city": "MADURAI BYE-PASS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625009",
    "city": "SULAIMAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625010",
    "city": "MADURAI BYE-PASS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625011",
    "city": "MADURAI BYE-PASS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625012",
    "city": "SULAIMAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625013",
    "city": "MADURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625014",
    "city": "MADURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625015",
    "city": "MADURAI BYE-PASS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625016",
    "city": "MADURAI BYE-PASS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625017",
    "city": "MADURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625018",
    "city": "MADURAI BYE-PASS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625019",
    "city": "MADURAI BYE-PASS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625020",
    "city": "MADURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625021",
    "city": "MADURAI BYE-PASS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625022",
    "city": "SULAIMAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625023",
    "city": "MADURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625101",
    "city": "MELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625102",
    "city": "MELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625103",
    "city": "MELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625104",
    "city": "MADURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625105",
    "city": "MELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625106",
    "city": "MELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625107",
    "city": "MADURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625108",
    "city": "MELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625109",
    "city": "MELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625110",
    "city": "MELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625122",
    "city": "MELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625201",
    "city": "SULAIMAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625203",
    "city": "THENI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625205",
    "city": "SAMAYANALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625207",
    "city": "SAMAYANALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625209",
    "city": "SAMAYANALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625214",
    "city": "SAMAYANALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625217",
    "city": "SAMAYANALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625218",
    "city": "SAMAYANALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625221",
    "city": "SAMAYANALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625234",
    "city": "SAMAYANALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625301",
    "city": "MADURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625401",
    "city": "MADURAI BYE-PASS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625402",
    "city": "MADURAI BYE-PASS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625501",
    "city": "SAMAYANALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625502",
    "city": "SAMAYANALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625503",
    "city": "SAMAYANALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625512",
    "city": "THENI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625513",
    "city": "BODINAYAKKANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625514",
    "city": "TIRUMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625515",
    "city": "CUMBAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625516",
    "city": "CUMBAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625517",
    "city": "THENI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625518",
    "city": "CUMBAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625519",
    "city": "BODINAYAKKANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625520",
    "city": "THENI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625521",
    "city": "CUMBAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625522",
    "city": "CUMBAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625523",
    "city": "THENI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625524",
    "city": "CUMBAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625525",
    "city": "CUMBAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625526",
    "city": "CUMBAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625527",
    "city": "TIRUMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625528",
    "city": "BODINAYAKKANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625529",
    "city": "TIRUMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625530",
    "city": "BODINAYAKKANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625531",
    "city": "THENI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625532",
    "city": "TIRUMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625533",
    "city": "CUMBAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625534",
    "city": "THENI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625535",
    "city": "TIRUMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625536",
    "city": "THENI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625537",
    "city": "BATALAGUNDU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625538",
    "city": "THENI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625540",
    "city": "THENI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625547",
    "city": "THENI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625552",
    "city": "CUMBAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625556",
    "city": "CUMBAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625562",
    "city": "THENI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625566",
    "city": "TIRUMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625572",
    "city": "THENI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625579",
    "city": "THENI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625582",
    "city": "BODINAYAKKANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625589",
    "city": "TIRUMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625601",
    "city": "THENI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625602",
    "city": "THENI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625603",
    "city": "THENI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625604",
    "city": "THENI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625605",
    "city": "THENI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625621",
    "city": "CUMBAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625701",
    "city": "TIRUMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625702",
    "city": "TIRUMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625703",
    "city": "TIRUMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625704",
    "city": "TIRUMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625705",
    "city": "TIRUMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625706",
    "city": "TIRUMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625707",
    "city": "TIRUMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "625708",
    "city": "TIRUMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626001",
    "city": "VIRUDHUNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626002",
    "city": "VIRUDHUNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626003",
    "city": "VIRUDHUNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626004",
    "city": "VIRUDHUNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626005",
    "city": "VIRUDHUNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626008",
    "city": "ARUPPUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626053",
    "city": "VIRUDHUNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626100",
    "city": "RAJAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626101",
    "city": "ARUPPUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626102",
    "city": "RAJAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626103",
    "city": "VIRUDHUNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626104",
    "city": "ARUPPUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626105",
    "city": "ARUPPUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626106",
    "city": "ARUPPUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626107",
    "city": "ARUPPUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626108",
    "city": "RAJAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626109",
    "city": "VIRUDHUNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626110",
    "city": "SRIVILLIPUTHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626111",
    "city": "RAJAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626112",
    "city": "ARUPPUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626113",
    "city": "ARUPPUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626114",
    "city": "KAMUTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626115",
    "city": "ARUPPUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626116",
    "city": "SRIVILLIPUTHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626117",
    "city": "RAJAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626118",
    "city": "KAMUTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626119",
    "city": "SIVAKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626121",
    "city": "RAJAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626122",
    "city": "RAJAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626123",
    "city": "SIVAKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626124",
    "city": "SIVAKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626125",
    "city": "SRIVILLIPUTHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626126",
    "city": "SRIVILLIPUTHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626127",
    "city": "RAJAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626128",
    "city": "SIVAKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626129",
    "city": "KAMUTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626130",
    "city": "SIVAKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626131",
    "city": "SRIVILLIPUTHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626132",
    "city": "SRIVILLIPUTHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626133",
    "city": "SRIVILLIPUTHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626134",
    "city": "ARUPPUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626135",
    "city": "SRIVILLIPUTHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626136",
    "city": "RAJAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626137",
    "city": "RAJAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626138",
    "city": "SRIVILLIPUTHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626139",
    "city": "RAJAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626140",
    "city": "KOVILPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626141",
    "city": "SIVAKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626142",
    "city": "RAJAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626143",
    "city": "RAJAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626145",
    "city": "RAJAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626149",
    "city": "SRIVILLIPUTHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626150",
    "city": "SRIVILLIPUTHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626154",
    "city": "SRIVILLIPUTHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626159",
    "city": "ARUPPUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626160",
    "city": "ARUPPUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626161",
    "city": "ARUPPUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626169",
    "city": "SIVAKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626171",
    "city": "KAMUTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626177",
    "city": "KAMUTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626188",
    "city": "RAJAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626189",
    "city": "SIVAKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626190",
    "city": "SRIVILLIPUTHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626201",
    "city": "KOVILPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626202",
    "city": "SIVAKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626203",
    "city": "SIVAKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626204",
    "city": "SIVAKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626205",
    "city": "KOVILPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626331",
    "city": "SIVAKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626542",
    "city": "BODINAYAKKANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626558",
    "city": "THENI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626607",
    "city": "ARUPPUKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626612",
    "city": "KAMUTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "626881",
    "city": "TIRUMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627001",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627002",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627003",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627004",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627005",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627006",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627007",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627008",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627009",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627010",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627011",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627012",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627051",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627101",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627102",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627103",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627104",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627105",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627106",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627107",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627108",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627109",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627110",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627111",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627112",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627113",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627114",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627115",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627116",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627117",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627118",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627119",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627120",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627121",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627124",
    "city": "KANYAKUMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627127",
    "city": "KANYAKUMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627129",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627130",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627131",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627133",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627151",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627152",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627201",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627202",
    "city": "VAGAIKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627252",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627331",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627351",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627352",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627353",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627354",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627355",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627356",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627357",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627358",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627359",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627401",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627412",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627413",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627414",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627415",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627416",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627417",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627418",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627420",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627421",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627422",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627423",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627424",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627425",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627426",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627427",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627428",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627431",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627435",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627436",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627445",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627451",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627452",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627453",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627501",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627502",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627551",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627601",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627602",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627603",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627604",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627651",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627652",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627654",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627657",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627658",
    "city": "PANAGUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627659",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627713",
    "city": "KOVILPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627719",
    "city": "SANKARANKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627724",
    "city": "SANKARANKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627751",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627753",
    "city": "SANKARANKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627754",
    "city": "SANKARANKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627755",
    "city": "SANKARANKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627756",
    "city": "SANKARANKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627757",
    "city": "RAJAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627758",
    "city": "SANKARANKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627759",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627760",
    "city": "SANKARANKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627761",
    "city": "SANKARANKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627763",
    "city": "RAJAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627764",
    "city": "SANKARANKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627765",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627770",
    "city": "RAJAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627773",
    "city": "SANKARANKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627778",
    "city": "AMBASAMUDRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627801",
    "city": "TUTICORIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627802",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627803",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627804",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627805",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627806",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627807",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627808",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627809",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627810",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627811",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627812",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627813",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627814",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627817",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627818",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627821",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627851",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627852",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627853",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627854",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627855",
    "city": "SANKARANKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627856",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627857",
    "city": "SANKARANKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627858",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627859",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627860",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627861",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627862",
    "city": "SANKARANKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627867",
    "city": "TENKASI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627907",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627909",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627951",
    "city": "SANKARANKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627953",
    "city": "SANKARANKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627954",
    "city": "SANKARANKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "627956",
    "city": "SANKARANKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628001",
    "city": "TUTICORIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628002",
    "city": "TUTICORIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628003",
    "city": "TUTICORIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628004",
    "city": "TUTICORIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628005",
    "city": "TUTICORIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628006",
    "city": "TUTICORIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628007",
    "city": "TUTICORIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628008",
    "city": "TUTICORIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628101",
    "city": "VAGAIKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628102",
    "city": "TUTICORIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628103",
    "city": "VAGAIKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628104",
    "city": "VAGAIKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628105",
    "city": "TUTICORIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628151",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628152",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628155",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628201",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628202",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628203",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628204",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628205",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628206",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628207",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628208",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628209",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628210",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628211",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628212",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628213",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628214",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628215",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628216",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628217",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628218",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628219",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628221",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628223",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628228",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628229",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628251",
    "city": "TUTICORIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628252",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628301",
    "city": "VAGAIKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628302",
    "city": "VAGAIKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628303",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628304",
    "city": "TUTICORIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628313",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628401",
    "city": "VAGAIKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628402",
    "city": "VAGAIKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628408",
    "city": "VAGAIKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628501",
    "city": "KOVILPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628502",
    "city": "KOVILPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628503",
    "city": "KOVILPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628552",
    "city": "SANKARANKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628601",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628612",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628613",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628614",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628615",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628616",
    "city": "NAZERETH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628617",
    "city": "NAZERETH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628618",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628619",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628620",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628621",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628622",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628623",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628624",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628625",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628653",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628655",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628656",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628701",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628702",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628703",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628704",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628705",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628712",
    "city": "KOVILPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628714",
    "city": "KOVILPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628716",
    "city": "KOVILPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628717",
    "city": "KOVILPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628718",
    "city": "VAGAIKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628720",
    "city": "KOVILPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628721",
    "city": "KOVILPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628722",
    "city": "TUTICORIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628723",
    "city": "KOVILPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628724",
    "city": "KOVILPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628726",
    "city": "TUTICORIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628751",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628752",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628753",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628801",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628802",
    "city": "TIRUCHENDUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628809",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628851",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628901",
    "city": "VAGAIKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628902",
    "city": "KOVILPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628903",
    "city": "TUTICORIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628904",
    "city": "KAMUTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628905",
    "city": "KAMUTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628906",
    "city": "TUTICORIN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628907",
    "city": "KAMUTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628908",
    "city": "KOVILPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628911",
    "city": "KAMUTHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "628952",
    "city": "KOVILPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629001",
    "city": "NAGERCOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629002",
    "city": "NAGERCOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629003",
    "city": "NAGERCOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629004",
    "city": "NAGERCOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629051",
    "city": "NAGERCOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629058",
    "city": "TIRUNELVELI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629101",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629102",
    "city": "THUCKALAY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629106",
    "city": "KANYAKUMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629151",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629152",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629153",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629154",
    "city": "S T MANKAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629155",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629156",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629157",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629158",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629159",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629160",
    "city": "S T MANKAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629161",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629162",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629163",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629164",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629165",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629166",
    "city": "THUCKALAY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629167",
    "city": "THUCKALAY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629168",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629169",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629170",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629171",
    "city": "S T MANKAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629172",
    "city": "S T MANKAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629173",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629174",
    "city": "THUCKALAY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629175",
    "city": "THUCKALAY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629176",
    "city": "S T MANKAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629177",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629178",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629179",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629180",
    "city": "THUCKALAY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629181",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629183",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629187",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629188",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629189",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629190",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629191",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629193",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629194",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629195",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629197",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629201",
    "city": "THUCKALAY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629202",
    "city": "NAGERCOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629203",
    "city": "THUCKALAY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629204",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629251",
    "city": "THUCKALAY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629252",
    "city": "THUCKALAY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629253",
    "city": "THUCKALAY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629301",
    "city": "THUCKALAY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629302",
    "city": "NAGERCOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629303",
    "city": "NAGERCOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629304",
    "city": "THUCKALAY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629305",
    "city": "NAGERCOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629306",
    "city": "KANYAKUMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629401",
    "city": "KANYAKUMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629402",
    "city": "KANYAKUMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629403",
    "city": "KANYAKUMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629501",
    "city": "NAGERCOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629502",
    "city": "NAGERCOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629504",
    "city": "KANYAKUMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629551",
    "city": "KANYAKUMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629601",
    "city": "NAGERCOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629602",
    "city": "KANYAKUMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629603",
    "city": "KANYAKUMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629667",
    "city": "KANYAKUMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629701",
    "city": "KANYAKUMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629702",
    "city": "KANYAKUMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629703",
    "city": "KANYAKUMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629707",
    "city": "KANYAKUMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629708",
    "city": "KANYAKUMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629801",
    "city": "NAGERCOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629802",
    "city": "THUCKALAY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629803",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629804",
    "city": "THUCKALAY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629805",
    "city": "THUCKALAY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629806",
    "city": "NAGERCOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629807",
    "city": "NAGERCOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629808",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629809",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629810",
    "city": "MARTHANDAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629851",
    "city": "NAGERCOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629852",
    "city": "NAGERCOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629854",
    "city": "KANYAKUMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629855",
    "city": "NAGERCOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629901",
    "city": "NAGERCOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "629902",
    "city": "NAGERCOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630001",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630002",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630003",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630004",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630005",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630006",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630010",
    "city": "KADALADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630101",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630102",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630103",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630104",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630105",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630106",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630107",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630108",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630201",
    "city": "MELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630202",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630203",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630204",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630205",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630206",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630207",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630208",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630210",
    "city": "MELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630211",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630212",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630214",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630215",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630301",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630302",
    "city": "DEVAKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630303",
    "city": "DEVAKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630305",
    "city": "DEVAKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630306",
    "city": "DEVAKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630307",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630309",
    "city": "MELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630310",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630311",
    "city": "DEVAKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630312",
    "city": "DEVAKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630313",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630314",
    "city": "DEVAKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630317",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630318",
    "city": "DEVAKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630321",
    "city": "DEVAKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630405",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630407",
    "city": "PARAMAKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630408",
    "city": "DEVAKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630409",
    "city": "SIVAGANGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630410",
    "city": "MELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630411",
    "city": "DEVAKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630413",
    "city": "PUDUKKOTTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630501",
    "city": "MELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630502",
    "city": "MELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630505",
    "city": "MELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630551",
    "city": "SIVAGANGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630552",
    "city": "SIVAGANGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630553",
    "city": "SIVAGANGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630554",
    "city": "SIVAGANGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630555",
    "city": "SIVAGANGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630556",
    "city": "SIVAGANGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630557",
    "city": "SIVAGANGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630558",
    "city": "SIVAGANGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630559",
    "city": "SIVAGANGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630560",
    "city": "KARAIKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630561",
    "city": "SIVAGANGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630562",
    "city": "SIVAGANGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630565",
    "city": "SIVAGANGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630566",
    "city": "MELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630602",
    "city": "SIVAGANGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630605",
    "city": "SIVAGANGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630606",
    "city": "SIVAGANGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630609",
    "city": "SIVAGANGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630610",
    "city": "SIVAGANGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630611",
    "city": "SIVAGANGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630612",
    "city": "SIVAGANGAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630702",
    "city": "PARAMAKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630709",
    "city": "PARAMAKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630710",
    "city": "PARAMAKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "630713",
    "city": "PARAMAKUDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631001",
    "city": "ARAKKONAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631002",
    "city": "ARAKKONAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631003",
    "city": "ARAKKONAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631004",
    "city": "ARAKKONAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631005",
    "city": "ARAKKONAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631006",
    "city": "ARAKKONAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631051",
    "city": "ARAKKONAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631052",
    "city": "BALU CHETTY CHATRAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631101",
    "city": "ARAKKONAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631102",
    "city": "SHOLINGHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631104",
    "city": "THANJAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631122",
    "city": "SALEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631151",
    "city": "ARAKKONAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631152",
    "city": "ARAKKONAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631201",
    "city": "TIRUTHANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631202",
    "city": "TIRUTHANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631203",
    "city": "TIRUVALLUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631204",
    "city": "TIRUTHANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631205",
    "city": "TIRUTHANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631206",
    "city": "TIRUTHANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631207",
    "city": "TIRUTHANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631208",
    "city": "TIRUTHANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631209",
    "city": "TIRUTHANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631210",
    "city": "ARAKKONAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631211",
    "city": "TIRUTHANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631212",
    "city": "TIRUTHANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631213",
    "city": "TIRUTHANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631301",
    "city": "SHOLINGHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631302",
    "city": "SHOLINGHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631303",
    "city": "SHOLINGHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631304",
    "city": "TIRUTHANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631402",
    "city": "PERAMBAKKAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631501",
    "city": "KANCHIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631502",
    "city": "KANCHIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631503",
    "city": "KANCHIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631551",
    "city": "BALU CHETTY CHATRAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631552",
    "city": "KANCHIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631553",
    "city": "ARAKKONAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631561",
    "city": "BALU CHETTY CHATRAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631601",
    "city": "BALU CHETTY CHATRAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631603",
    "city": "KANCHIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631604",
    "city": "ORAGADAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631605",
    "city": "BALU CHETTY CHATRAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631606",
    "city": "KANCHIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631701",
    "city": "BALU CHETTY CHATRAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "631702",
    "city": "BALU CHETTY CHATRAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632001",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632002",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632003",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632004",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632005",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632006",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632007",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632008",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632009",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632010",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632011",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632012",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632013",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632014",
    "city": "VIT SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632055",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632057",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632058",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632059",
    "city": "VIRNJIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632101",
    "city": "VIRNJIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632102",
    "city": "VIRNJIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632103",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632104",
    "city": "VIRNJIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632105",
    "city": "VIRNJIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632106",
    "city": "VIT SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632107",
    "city": "GUDIYATHAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632113",
    "city": "VIRNJIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632114",
    "city": "VIRNJIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632115",
    "city": "VIT SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632116",
    "city": "RAMANATHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632201",
    "city": "VIRNJIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632202",
    "city": "VIRNJIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632203",
    "city": "VIRNJIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632204",
    "city": "VIRNJIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632209",
    "city": "GUDIYATHAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632301",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632311",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632312",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632313",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632314",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632315",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632316",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632317",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632318",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632319",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632320",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632326",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632401",
    "city": "RANIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632402",
    "city": "RANIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632403",
    "city": "RANIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632404",
    "city": "RANIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632405",
    "city": "RANIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632406",
    "city": "RANIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632408",
    "city": "RANIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632416",
    "city": "RANIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632442",
    "city": "RANIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632501",
    "city": "RANIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632502",
    "city": "ARAKKONAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632503",
    "city": "RANIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632504",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632505",
    "city": "SHOLINGHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632506",
    "city": "RANIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632507",
    "city": "RANIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632508",
    "city": "RANIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632509",
    "city": "RANIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632510",
    "city": "ARAKKONAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632511",
    "city": "KANCHIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632512",
    "city": "ARANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632513",
    "city": "RANIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632514",
    "city": "RANIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632515",
    "city": "RANIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632516",
    "city": "VIT SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632517",
    "city": "VIRNJIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632518",
    "city": "KANCHIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632519",
    "city": "VIT SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632520",
    "city": "RANIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632521",
    "city": "RANIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632524",
    "city": "RANIPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632531",
    "city": "KANCHIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632601",
    "city": "GUDIYATHAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632602",
    "city": "GUDIYATHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632603",
    "city": "GUDIYATHAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632604",
    "city": "GUDIYATHAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "632605",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "634441",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635001",
    "city": "KRISHNAGIRI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635002",
    "city": "KRISHNAGIRI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635101",
    "city": "KRISHNAGIRI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635102",
    "city": "HOSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635103",
    "city": "HOSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635104",
    "city": "KRISHNAGIRI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635105",
    "city": "HOSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635106",
    "city": "KRISHNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635107",
    "city": "HOSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635108",
    "city": "KRISHNAGIRI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635109",
    "city": "HOSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635110",
    "city": "HOSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635111",
    "city": "PALAKODU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635112",
    "city": "KRISHNAGIRI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635113",
    "city": "HOSUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635114",
    "city": "HOSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635115",
    "city": "KRISHNAGIRI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635116",
    "city": "HOSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635117",
    "city": "HOSUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635118",
    "city": "HOSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635119",
    "city": "HOSUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635120",
    "city": "KRISHNAGIRI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635121",
    "city": "KRISHNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635122",
    "city": "KRISHNAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635123",
    "city": "POCHAMPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635124",
    "city": "HOSUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635125",
    "city": "HOSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635126",
    "city": "HOSUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635138",
    "city": "POCHAMPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635201",
    "city": "POCHAMPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635202",
    "city": "DHARMAPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635203",
    "city": "POCHAMPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635204",
    "city": "POCHAMPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635205",
    "city": "DHARMAPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635206",
    "city": "POCHAMPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635207",
    "city": "POCHAMPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635208",
    "city": "POCHAMPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635301",
    "city": "BOMMIDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635302",
    "city": "BOMMIDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635303",
    "city": "BOMMIDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635304",
    "city": "POCHAMPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635305",
    "city": "BOMMIDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635306",
    "city": "POCHAMPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635307",
    "city": "POCHAMPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635313",
    "city": "BOMMIDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635601",
    "city": "TIRUPPATTUR (N.A)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635602",
    "city": "TIRUPPATTUR (N.A)",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635660",
    "city": "SALEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635701",
    "city": "VANIYAMBADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635702",
    "city": "VANIYAMBADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635703",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635707",
    "city": "SALEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635710",
    "city": "VANIYAMBADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635751",
    "city": "AMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635752",
    "city": "VANIYAMBADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635754",
    "city": "VANIYAMBADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635757",
    "city": "SALEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635801",
    "city": "VANIYAMBADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635802",
    "city": "AMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635803",
    "city": "GUDIYATHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635804",
    "city": "GUDIYATHAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635805",
    "city": "AMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635806",
    "city": "GUDIYATHAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635807",
    "city": "VANIYAMBADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635808",
    "city": "AMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635809",
    "city": "GUDIYATHAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635810",
    "city": "GUDIYATHAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635811",
    "city": "AMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635812",
    "city": "AMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635813",
    "city": "GUDIYATHAM REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635814",
    "city": "AMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635815",
    "city": "VANIYAMBADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635824",
    "city": "SALEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "635852",
    "city": "VANIYAMBADI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636001",
    "city": "HASTHAMPATTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636002",
    "city": "SALEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636003",
    "city": "HASTHAMPATTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636004",
    "city": "OMR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636005",
    "city": "OMR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636006",
    "city": "SALEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636007",
    "city": "HASTHAMPATTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636008",
    "city": "HASTHAMPATTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636009",
    "city": "SALEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636010",
    "city": "SALEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636011",
    "city": "OMR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636012",
    "city": "OMR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636013",
    "city": "OMR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636014",
    "city": "HASTHAMPATTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636015",
    "city": "HASTHAMPATTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636016",
    "city": "OMR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636017",
    "city": "HASTHAMPATTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636030",
    "city": "OMR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636101",
    "city": "THALAIVASAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636102",
    "city": "ATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636103",
    "city": "HASTHAMPATTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636104",
    "city": "VALAPADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636105",
    "city": "ATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636106",
    "city": "HASTHAMPATTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636107",
    "city": "ATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636108",
    "city": "ATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636109",
    "city": "ATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636110",
    "city": "ATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636111",
    "city": "VALAPADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636112",
    "city": "THALAIVASAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636113",
    "city": "ATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636114",
    "city": "VALAPADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636115",
    "city": "VALAPADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636116",
    "city": "THALAIVASAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636117",
    "city": "VALAPADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636118",
    "city": "ATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636119",
    "city": "VALAPADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636121",
    "city": "THALAIVASAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636122",
    "city": "HASTHAMPATTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636124",
    "city": "ATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636130",
    "city": "ATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636138",
    "city": "VALAPADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636139",
    "city": "VALAPADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636140",
    "city": "HASTHAMPATTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636141",
    "city": "ATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636142",
    "city": "ATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636201",
    "city": "SALEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636202",
    "city": "ATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636203",
    "city": "MALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636204",
    "city": "MALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636301",
    "city": "MALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636302",
    "city": "OMR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636303",
    "city": "METTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636304",
    "city": "OMALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636305",
    "city": "OMALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636306",
    "city": "OMALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636307",
    "city": "SALEM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636308",
    "city": "KAKAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636309",
    "city": "OMALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636319",
    "city": "OMALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636351",
    "city": "OMALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636352",
    "city": "DHARMAPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636354",
    "city": "BOMMIDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636400",
    "city": "OMALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636401",
    "city": "METTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636402",
    "city": "METTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636403",
    "city": "METTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636404",
    "city": "METTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636406",
    "city": "METTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636407",
    "city": "RASIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636451",
    "city": "OMALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636452",
    "city": "METTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636453",
    "city": "OMALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636454",
    "city": "METTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636455",
    "city": "OMALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636456",
    "city": "METTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636457",
    "city": "METTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636458",
    "city": "METTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636501",
    "city": "METTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636502",
    "city": "OMALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636503",
    "city": "OMALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636601",
    "city": "YERCAUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636602",
    "city": "YERCAUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636604",
    "city": "YERCAUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636701",
    "city": "DHARMAPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636702",
    "city": "DHARMAPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636703",
    "city": "DHARMAPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636704",
    "city": "DHARMAPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636705",
    "city": "DHARMAPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636771",
    "city": "VELLORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636801",
    "city": "PALAKODU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636802",
    "city": "PALAKODU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636803",
    "city": "PALAKODU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636804",
    "city": "DHARMAPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636805",
    "city": "PALAKODU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636806",
    "city": "PALAKODU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636807",
    "city": "DHARMAPURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636808",
    "city": "PALAKODU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636809",
    "city": "PALAKODU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636810",
    "city": "PALAKODU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636811",
    "city": "PALAKODU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636812",
    "city": "PALAKODU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636813",
    "city": "PALAKODU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636902",
    "city": "BOMMIDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636903",
    "city": "BOMMIDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636904",
    "city": "BOMMIDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636905",
    "city": "BOMMIDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "636906",
    "city": "BOMMIDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637001",
    "city": "NAMAKKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637002",
    "city": "NAMAKKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637003",
    "city": "NAMAKKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637013",
    "city": "NAMAKKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637014",
    "city": "RASIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637015",
    "city": "PARAMATHI VELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637017",
    "city": "PARAMATHI VELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637018",
    "city": "RASIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637019",
    "city": "NAMAKKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637021",
    "city": "NAMAKKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637101",
    "city": "SANKARIDURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637102",
    "city": "KAKAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637103",
    "city": "KAKAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637104",
    "city": "BHAVINI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637105",
    "city": "SANKARIDURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637107",
    "city": "METTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637201",
    "city": "TIRUCHENGODU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637202",
    "city": "TIRUCHENGODU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637203",
    "city": "TIRUCHENGODU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637204",
    "city": "PARAMATHI VELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637205",
    "city": "TIRUCHENGODU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637206",
    "city": "PARAMATHI VELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637207",
    "city": "PARAMATHI VELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637208",
    "city": "PARAMATHI VELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637209",
    "city": "TIRUCHENGODU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637210",
    "city": "TIRUCHENGODU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637211",
    "city": "TIRUCHENGODU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637212",
    "city": "NAMAKKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637213",
    "city": "PARAMATHI VELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637214",
    "city": "TIRUCHENGODU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637215",
    "city": "PALLIPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637216",
    "city": "RASIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637301",
    "city": "SANKARIDURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637302",
    "city": "SANKARIDURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637303",
    "city": "SANKARIDURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637304",
    "city": "TIRUCHENGODU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637306",
    "city": "SANKARIDURG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637401",
    "city": "RASIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637402",
    "city": "RASIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637403",
    "city": "RASIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637406",
    "city": "RASIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637407",
    "city": "RASIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637408",
    "city": "RASIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637410",
    "city": "RASIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637411",
    "city": "ATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637412",
    "city": "RASIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637415",
    "city": "ATTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637416",
    "city": "RASIPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637501",
    "city": "MALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637502",
    "city": "KAKAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637503",
    "city": "KAKAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637504",
    "city": "KAKAPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "637505",
    "city": "MALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638001",
    "city": "ERODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638002",
    "city": "KOLLAMPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638003",
    "city": "PALLIPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638004",
    "city": "ERODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638005",
    "city": "ERODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638006",
    "city": "PALLIPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638007",
    "city": "PALLIPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638008",
    "city": "PALLIPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638009",
    "city": "ERODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638010",
    "city": "PALLIPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638011",
    "city": "ERODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638012",
    "city": "ERODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638051",
    "city": "PERUNDURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638052",
    "city": "PERUNDURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638053",
    "city": "PERUNDURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638054",
    "city": "GOBICHETTIPALAYAM EXTENSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638055",
    "city": "PERUNDURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638056",
    "city": "PERUNDURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638057",
    "city": "PERUNDURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638058",
    "city": "PERUNDURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638060",
    "city": "PERUNDURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638101",
    "city": "KOLLAMPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638102",
    "city": "ERODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638103",
    "city": "GOBICHETTIPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638104",
    "city": "KOLLAMPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638105",
    "city": "VELLAKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638106",
    "city": "ARAVAKURICHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638107",
    "city": "ERODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638108",
    "city": "KANGEYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638110",
    "city": "PERUNDURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638111",
    "city": "VELLAKOIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638112",
    "city": "ERODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638115",
    "city": "KOLLAMPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638116",
    "city": "PERUNDURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638151",
    "city": "PARAMATHI VELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638152",
    "city": "PARAMATHI VELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638153",
    "city": "KOLLAMPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638154",
    "city": "KOLLAMPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638181",
    "city": "PARAMATHI VELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638182",
    "city": "PARAMATHI VELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638183",
    "city": "BHAVINI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638201",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638301",
    "city": "BHAVINI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638302",
    "city": "BHAVINI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638307",
    "city": "BHAVINI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638308",
    "city": "BHAVINI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638311",
    "city": "BHAVINI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638312",
    "city": "BHAVINI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638313",
    "city": "GOBICHETTIPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638314",
    "city": "BHAVINI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638315",
    "city": "BHAVINI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638316",
    "city": "BHAVINI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638327",
    "city": "BHAVINI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638401",
    "city": "SATHIAMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638402",
    "city": "SATHIAMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638451",
    "city": "SATHIAMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638452",
    "city": "GOBICHETTIPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638453",
    "city": "GOBICHETTIPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638454",
    "city": "SATHIAMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638455",
    "city": "GOBICHETTIPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638456",
    "city": "GOBICHETTIPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638457",
    "city": "GOBICHETTIPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638458",
    "city": "GOBICHETTIPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638459",
    "city": "SATHIAMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638460",
    "city": "GOBICHETTIPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638461",
    "city": "SATHIAMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638462",
    "city": "SATHIAMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638466",
    "city": "SATHIAMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638476",
    "city": "GOBICHETTIPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638501",
    "city": "BHAVINI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638502",
    "city": "BHAVINI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638503",
    "city": "SATHIAMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638504",
    "city": "BHAVINI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638505",
    "city": "GOBICHETTIPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638506",
    "city": "GOBICHETTIPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638649",
    "city": "KANGEYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638653",
    "city": "GANESHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638656",
    "city": "DHARAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638657",
    "city": "DHARAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638660",
    "city": "KANGEYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638661",
    "city": "DHARAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638672",
    "city": "DHARAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638673",
    "city": "DHARAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638697",
    "city": "GANESHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638701",
    "city": "KANGEYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638702",
    "city": "DHARAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638703",
    "city": "KANGEYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638706",
    "city": "DHARAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638751",
    "city": "PERUNDURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638752",
    "city": "PERUNDURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "638812",
    "city": "PERUNDURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639001",
    "city": "KARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639002",
    "city": "KARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639003",
    "city": "KARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639004",
    "city": "KARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639005",
    "city": "KARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639006",
    "city": "KARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639007",
    "city": "KARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639008",
    "city": "KARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639101",
    "city": "TRZ SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639102",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639103",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639104",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639105",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639106",
    "city": "KARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639107",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639108",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639109",
    "city": "ARAVAKURICHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639110",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639111",
    "city": "ARAVAKURICHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639112",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639113",
    "city": "PARAMATHI VELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639114",
    "city": "KARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639115",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639116",
    "city": "PARAMATHI VELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639117",
    "city": "PARAMATHI VELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639118",
    "city": "KARUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639119",
    "city": "MUSIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639120",
    "city": "MANAPARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639136",
    "city": "PARAMATHI VELLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639201",
    "city": "ARAVAKURICHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639202",
    "city": "ARAVAKURICHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639203",
    "city": "ARAVAKURICHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639204",
    "city": "ARAVAKURICHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639205",
    "city": "ARAVAKURICHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "639207",
    "city": "ARAVAKURICHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641001",
    "city": "COIMBATORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641002",
    "city": "COIMBATORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641003",
    "city": "COIMBATORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641004",
    "city": "AVINASHI ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641005",
    "city": "VELLALORE PATINAM S/C",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641006",
    "city": "COIMBATORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641007",
    "city": "COIMBATORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641008",
    "city": "COIMBATORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641009",
    "city": "COIMBATORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641010",
    "city": "COIMBATORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641011",
    "city": "KAVUNDAMPLAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641012",
    "city": "AVINASHI ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641013",
    "city": "KAVUNDAMPLAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641014",
    "city": "AVINASHI ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641015",
    "city": "VELLALORE PATINAM S/C",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641016",
    "city": "VELLALORE PATINAM S/C",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641017",
    "city": "KAVUNDAMPLAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641018",
    "city": "COIMBATORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641019",
    "city": "PERIYANAICKANPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641020",
    "city": "PERIYANAICKANPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641021",
    "city": "MALUMICHAMPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641022",
    "city": "KAVUNDAMPLAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641023",
    "city": "MALUMICHAMPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641024",
    "city": "MALUMICHAMPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641025",
    "city": "KAVUNDAMPLAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641026",
    "city": "COIMBATORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641027",
    "city": "COIMBATORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641028",
    "city": "VELLALORE PATINAM S/C",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641029",
    "city": "KAVUNDAMPLAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641030",
    "city": "KAVUNDAMPLAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641031",
    "city": "PERIYANAICKANPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641032",
    "city": "KINATHUKADAVU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641033",
    "city": "VELLALORE PATINAM S/C",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641034",
    "city": "KAVUNDAMPLAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641035",
    "city": "SARAVANAMPATTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641036",
    "city": "VELLALORE PATINAM S/C",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641037",
    "city": "COIMBATORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641038",
    "city": "KAVUNDAMPLAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641039",
    "city": "COIMBATORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641040",
    "city": "COIMBATORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641041",
    "city": "KAVUNDAMPLAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641042",
    "city": "COIMBATORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641043",
    "city": "KAVUNDAMPLAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641044",
    "city": "COIMBATORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641045",
    "city": "VELLALORE PATINAM S/C",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641046",
    "city": "KAVUNDAMPLAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641047",
    "city": "PERIYANAICKANPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641048",
    "city": "NEELAMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641049",
    "city": "SARAVANAMPATTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641050",
    "city": "MALUMICHAMPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641051",
    "city": "CJB APX/SFC PUD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641062",
    "city": "NEELAMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641063",
    "city": "CJB APX/SFC PUD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641065",
    "city": "NEELAMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641101",
    "city": "ALANDURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641103",
    "city": "NEELAMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641104",
    "city": "METTUPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641105",
    "city": "MALUMICHAMPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641106",
    "city": "METTUPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641107",
    "city": "GANESHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641108",
    "city": "KAVUNDAMPLAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641109",
    "city": "ALANDURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641110",
    "city": "SARAVANAMPATTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641111",
    "city": "VELLALORE PATINAM S/C",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641112",
    "city": "MALUMICHAMPATTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641113",
    "city": "METTUPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641114",
    "city": "ALANDURAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641117",
    "city": "CUDDALORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641122",
    "city": "UDUMALPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641201",
    "city": "KINATHUKADAVU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641202",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641221",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641301",
    "city": "METTUPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641302",
    "city": "METTUPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641305",
    "city": "METTUPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641401",
    "city": "SULUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641402",
    "city": "SULUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641404",
    "city": "SULUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641406",
    "city": "THENNAMPALYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641407",
    "city": "THENNAMPALYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641601",
    "city": "TIRUPUR COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641602",
    "city": "PERUMANALLUR ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641603",
    "city": "TIRUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641604",
    "city": "TIRUPUR PALADAM ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641605",
    "city": "TIRUPUR VEERAPANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641606",
    "city": "KANGEYAM ROAD TIRUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641607",
    "city": "PERUMANALLUR ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641608",
    "city": "TIRUPUR PALADAM ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641652",
    "city": "TIRUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641653",
    "city": "GANESHAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641654",
    "city": "AVINASHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641655",
    "city": "AVINASHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641658",
    "city": "PALLADAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641659",
    "city": "SOMANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641662",
    "city": "PALLADAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641663",
    "city": "SOMANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641664",
    "city": "PALLADAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641665",
    "city": "KANGEYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641666",
    "city": "PERUMANALLUR ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641667",
    "city": "PALLADAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641668",
    "city": "SOMANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641669",
    "city": "PALLADAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641670",
    "city": "AVINASHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641671",
    "city": "PALLADAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641687",
    "city": "TIRUPUR PALADAM ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "641697",
    "city": "METTUPALAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642001",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642002",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642003",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642004",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642005",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642006",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642007",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642054",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642101",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642102",
    "city": "UDUMALPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642103",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642104",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642105",
    "city": "VALPARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642106",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642107",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642108",
    "city": "VALPARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642109",
    "city": "KINATHUKADAVU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642110",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642111",
    "city": "UDUMALPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642112",
    "city": "UDUMALPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642113",
    "city": "UDUMALPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642114",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642117",
    "city": "VALPARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642118",
    "city": "VALPARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642120",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642122",
    "city": "UDUMALPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642123",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642125",
    "city": "VALPARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642126",
    "city": "UDUMALPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642127",
    "city": "VALPARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642128",
    "city": "UDUMALPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642129",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642130",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642132",
    "city": "UDUMALPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642133",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642134",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642138",
    "city": "UDUMALPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642140",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642142",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642143",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642144",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642145",
    "city": "KINATHUKADAVU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642147",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642148",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642149",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642154",
    "city": "UDUMALPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642201",
    "city": "UDUMALPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642202",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642203",
    "city": "UDUMALPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642204",
    "city": "UDUMALPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642205",
    "city": "UDUMALPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642206",
    "city": "UDUMALPET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "642207",
    "city": "POLLACHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643001",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643002",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643003",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643004",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643005",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643006",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643007",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643052",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643053",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643054",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643101",
    "city": "COONOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643102",
    "city": "COONOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643103",
    "city": "COONOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643104",
    "city": "COONOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643105",
    "city": "COONOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643106",
    "city": "COONOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643201",
    "city": "KOTHAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643202",
    "city": "COONOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643203",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643204",
    "city": "COONOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643205",
    "city": "GUDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643206",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643207",
    "city": "GUDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643209",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643210",
    "city": "GUDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643211",
    "city": "GUDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643212",
    "city": "GUDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643213",
    "city": "COONOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643214",
    "city": "KOTHAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643215",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643216",
    "city": "KOTHAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643217",
    "city": "KOTHAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643218",
    "city": "COONOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643219",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643220",
    "city": "GUDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643221",
    "city": "COONOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643223",
    "city": "GUDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643228",
    "city": "GUDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643229",
    "city": "GUDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643230",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643231",
    "city": "COONOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643232",
    "city": "COONOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643233",
    "city": "GUDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643234",
    "city": "COONOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643236",
    "city": "COONOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643237",
    "city": "GUDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643238",
    "city": "COONOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643239",
    "city": "GUDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643240",
    "city": "GUDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643242",
    "city": "KOTHAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643243",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643244",
    "city": "COONOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643245",
    "city": "KOTHAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643249",
    "city": "KOTHAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643251",
    "city": "GUDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643253",
    "city": "GUDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643255",
    "city": "GUDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643256",
    "city": "GUDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643257",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643258",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643259",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643260",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643261",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643264",
    "city": "KOTHAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643266",
    "city": "KOTHAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643267",
    "city": "GUDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643268",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643269",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643270",
    "city": "GUDALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643271",
    "city": "KOTHAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643272",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643273",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643277",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643278",
    "city": "COONOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "643282",
    "city": "OOTY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "666664",
    "city": "LENOVO INDIA P LTD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "666666",
    "city": "MAA HUB HAL DELIVERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "666677",
    "city": "PORUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "666777",
    "city": "CHANDRAN NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670001",
    "city": "KANNUR COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670002",
    "city": "KANNUR COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670003",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670004",
    "city": "KANNUR COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670005",
    "city": "KANNUR COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670006",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670007",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670008",
    "city": "KANNUR COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670009",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670010",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670011",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670012",
    "city": "KANNUR COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670013",
    "city": "KANNUR COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670014",
    "city": "KANNUR COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670015",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670016",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670017",
    "city": "KANNUR COUNTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670018",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670101",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670104",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670105",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670106",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670107",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670109",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670110",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670141",
    "city": "CHERUKUNNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670142",
    "city": "CHERUKUNNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670143",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670144",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670213",
    "city": "KANHANGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670301",
    "city": "CHERUKUNNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670302",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670303",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670304",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670305",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670306",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670307",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670308",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670309",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670310",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670325",
    "city": "TALIPARAMBA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670327",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670330",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670331",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670332",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670333",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670334",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670337",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670339",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670343",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670346",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670353",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670354",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670358",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670415",
    "city": "KANHANGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670501",
    "city": "CHERUKUNNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670502",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670503",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670511",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670521",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670522",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670561",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670562",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670564",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670565",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670566",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670567",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670571",
    "city": "CHERUKUNNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670581",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670582",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670591",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670592",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670593",
    "city": "KUTHUPARAMABA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670594",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670595",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670597",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670601",
    "city": "CHERUKUNNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670602",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670603",
    "city": "CHERUKUNNU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670604",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670611",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670612",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670613",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670614",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670621",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670622",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670631",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670632",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670633",
    "city": "KUTHUPARAMABA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670641",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670642",
    "city": "KUTHUPARAMABA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670643",
    "city": "KUTHUPARAMABA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670644",
    "city": "KUTTIADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670645",
    "city": "KALPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670646",
    "city": "KALPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670647",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670649",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670650",
    "city": "KUTHUPARAMABA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670651",
    "city": "KUTHUPARAMABA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670661",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670662",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670663",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670671",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670672",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670673",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670674",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670675",
    "city": "KUTHUPARAMABA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670676",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670677",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670678",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670679",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670691",
    "city": "KUTHUPARAMABA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670692",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670693",
    "city": "KUTHUPARAMABA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670694",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670701",
    "city": "KUTHUPARAMABA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670702",
    "city": "KUTHUPARAMABA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670703",
    "city": "KUTHUPARAMABA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670704",
    "city": "KUTHUPARAMABA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670705",
    "city": "KUTHUPARAMABA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670706",
    "city": "KUTHUPARAMABA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670721",
    "city": "KALPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670731",
    "city": "KALPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670732",
    "city": "KALPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "670741",
    "city": "KUTHUPARAMABA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671121",
    "city": "KASARGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671122",
    "city": "KASARGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671123",
    "city": "VIDYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671124",
    "city": "KASARGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671310",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671311",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671312",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671313",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671314",
    "city": "KASARGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671315",
    "city": "KANHANGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671316",
    "city": "KANHANGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671317",
    "city": "VIDYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671318",
    "city": "KANHANGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671319",
    "city": "VIDYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671321",
    "city": "VIDYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671322",
    "city": "VIDYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671323",
    "city": "VIDYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671324",
    "city": "VIDYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671326",
    "city": "KASARGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671328",
    "city": "KASARGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671329",
    "city": "KASARGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671341",
    "city": "KASARGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671348",
    "city": "VIDYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671349",
    "city": "KASARGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671350",
    "city": "KASARGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671351",
    "city": "PAYYANUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671353",
    "city": "KASARGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671357",
    "city": "KASARGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671531",
    "city": "KANHANGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671532",
    "city": "KASARGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671533",
    "city": "KASARGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671541",
    "city": "VIDYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671542",
    "city": "VIDYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671543",
    "city": "VIDYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671544",
    "city": "KASARGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671545",
    "city": "KASARGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671551",
    "city": "KASARGOD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "671552",
    "city": "VIDYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673001",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673002",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673003",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673004",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673005",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673006",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673007",
    "city": "PAMTHEERAKAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673008",
    "city": "MOOZHIKKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673009",
    "city": "MOOZHIKKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673010",
    "city": "MOOZHIKKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673011",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673012",
    "city": "MOOZHIKKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673013",
    "city": "PAMTHEERAKAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673014",
    "city": "PAMTHEERAKAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673015",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673016",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673017",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673018",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673019",
    "city": "PAMTHEERAKAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673020",
    "city": "MOOZHIKKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673021",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673023",
    "city": "KAKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673024",
    "city": "MOOZHIKKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673025",
    "city": "PAMTHEERAKAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673026",
    "city": "PAMTHEERAKAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673027",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673028",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673029",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673031",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673032",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673037",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673101",
    "city": "VADAKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673103",
    "city": "VADAKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673104",
    "city": "VADAKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673105",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673106",
    "city": "VADAKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673107",
    "city": "VADAKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673108",
    "city": "VADAKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673109",
    "city": "VADAKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673110",
    "city": "VADAKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673111",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673112",
    "city": "VADAKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673121",
    "city": "KALPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673122",
    "city": "KALPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673123",
    "city": "KALPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673124",
    "city": "KALPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673301",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673302",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673303",
    "city": "QUILANDI BAZAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673304",
    "city": "QUILANDI BAZAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673305",
    "city": "QUILANDI BAZAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673306",
    "city": "QUILANDI BAZAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673307",
    "city": "CALICUT APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673311",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673312",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673313",
    "city": "KANNUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673314",
    "city": "PAMTHEERAKAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673315",
    "city": "QUILANDI BAZAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673316",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673317",
    "city": "QUILANDI BAZAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673318",
    "city": "QUILANDI BAZAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673321",
    "city": "QUILANDI BAZAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673323",
    "city": "QUILANDI BAZAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673325",
    "city": "CALICUT APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673326",
    "city": "QUILANDI BAZAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673327",
    "city": "QUILANDI BAZAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673328",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673502",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673503",
    "city": "VADAKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673504",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673505",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673507",
    "city": "KUTTIADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673508",
    "city": "KUTTIADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673509",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673510",
    "city": "KUTTIADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673511",
    "city": "KUTTIADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673512",
    "city": "VIDYANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673513",
    "city": "KUTTIADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673514",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673515",
    "city": "VADAKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673516",
    "city": "KUTTIADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673517",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673518",
    "city": "KUTTIADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673519",
    "city": "KUTTIADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673520",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673521",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673522",
    "city": "VADAKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673523",
    "city": "VADAKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673524",
    "city": "CALICUT APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673527",
    "city": "KUTTIADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673529",
    "city": "VADAKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673530",
    "city": "THALASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673532",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673534",
    "city": "KAKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673544",
    "city": "VADAKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673570",
    "city": "MOOZHIKKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673571",
    "city": "MOOZHIKKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673572",
    "city": "KAKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673573",
    "city": "KAKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673574",
    "city": "MOOZHIKKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673575",
    "city": "KALPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673576",
    "city": "KALPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673577",
    "city": "KALPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673578",
    "city": "KALPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673579",
    "city": "SULTHAN BATHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673580",
    "city": "KAKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673582",
    "city": "MOOZHIKKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673583",
    "city": "KAKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673585",
    "city": "KAKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673586",
    "city": "KAKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673589",
    "city": "KALPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673591",
    "city": "SULTHAN BATHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673592",
    "city": "SULTHAN BATHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673593",
    "city": "SULTHAN BATHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673595",
    "city": "SULTHAN BATHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673596",
    "city": "SULTHAN BATHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673601",
    "city": "KAKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673602",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673603",
    "city": "KAKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673604",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673611",
    "city": "KAKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673612",
    "city": "QUILANDI BAZAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673613",
    "city": "KAKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673614",
    "city": "QUILANDI BAZAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673615",
    "city": "KUTTIADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673616",
    "city": "KAKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673617",
    "city": "KAKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673618",
    "city": "QUILANDI BAZAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673619",
    "city": "KAKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673620",
    "city": "QUILANDI BAZAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673621",
    "city": "QUILANDI BAZAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673623",
    "city": "QUILANDI BAZAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673624",
    "city": "QUILANDI BAZAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673631",
    "city": "PAMTHEERAKAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673632",
    "city": "PAMTHEERAKAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673633",
    "city": "PAMTHEERAKAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673634",
    "city": "PAMTHEERAKAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673635",
    "city": "PAMTHEERAKAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673637",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673639",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673640",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673641",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673642",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673643",
    "city": "PAMTHEERAKAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673644",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673645",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673648",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673649",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673651",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673652",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673653",
    "city": "PAMTHEERAKAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673655",
    "city": "VADAKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "673661",
    "city": "KAKKODI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676101",
    "city": "TIRUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676102",
    "city": "TIRUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676103",
    "city": "TIRUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676104",
    "city": "TIRUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676105",
    "city": "TIRUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676107",
    "city": "TIRUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676108",
    "city": "TIRUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676109",
    "city": "TIRUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676110",
    "city": "TIRUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676111",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676121",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676122",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676123",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676126",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676127",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676301",
    "city": "VALANCHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676303",
    "city": "PERINTALMANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676304",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676305",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676308",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676310",
    "city": "VALANCHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676311",
    "city": "CALICUT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676312",
    "city": "PAMTHEERAKAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676313",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676315",
    "city": "PAMTHEERAKAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676317",
    "city": "PAMTHEERAKAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676318",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676319",
    "city": "PAMTHEERAKAVE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676501",
    "city": "VALANCHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676502",
    "city": "TIRUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676503",
    "city": "TIRUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676504",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676505",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676506",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676507",
    "city": "CALICUT APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676509",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676511",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676512",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676513",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676514",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676515",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676517",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676519",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676523",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676525",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676528",
    "city": "VALANCHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676541",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676551",
    "city": "VALANCHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676552",
    "city": "VALANCHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676553",
    "city": "TIRUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676554",
    "city": "VALANCHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676556",
    "city": "VALANCHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676557",
    "city": "VALANCHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676561",
    "city": "TIRUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "676562",
    "city": "TIRUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678001",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678002",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678003",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678004",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678005",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678006",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678007",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678008",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678009",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678010",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678011",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678012",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678013",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678014",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678015",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678017",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678018",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678019",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678020",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678101",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678102",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678103",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678104",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678501",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678502",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678503",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678504",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678505",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678506",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678507",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678508",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678510",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678512",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678531",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678532",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678533",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678534",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678541",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678542",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678543",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678544",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678545",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678546",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678547",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678548",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678551",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678552",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678553",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678554",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678555",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678556",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678557",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678558",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678559",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678571",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678572",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678573",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678574",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678575",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678581",
    "city": "MANNARGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678582",
    "city": "MANNARGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678583",
    "city": "MANNARGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678589",
    "city": "MANNARGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678591",
    "city": "MANNARGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678592",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678593",
    "city": "MANNARGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678594",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678595",
    "city": "MANNARGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678596",
    "city": "MANNARGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678597",
    "city": "MANNARGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678598",
    "city": "MANNARGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678600",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678601",
    "city": "MANNARGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678605",
    "city": "MANNARGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678609",
    "city": "MANNARGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678611",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678612",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678613",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678614",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678615",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678616",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678621",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678622",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678623",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678624",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678631",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678632",
    "city": "CHERPULASERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678633",
    "city": "CHERPULASERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678634",
    "city": "CHERPULASERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678635",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678637",
    "city": "CHERPULASERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678641",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678642",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678651",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678661",
    "city": "CHITTUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678671",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678681",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678682",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678683",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678684",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678685",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678686",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678687",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678688",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678689",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678701",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678702",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678703",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678704",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678705",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678706",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678707",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678709",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678721",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678722",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678731",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678732",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678733",
    "city": "PALGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678752",
    "city": "MANNARGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678761",
    "city": "MANNARGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "678762",
    "city": "MANNARGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679101",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679102",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679103",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679104",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679105",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679106",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679121",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679122",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679123",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679124",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679125",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679301",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679302",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679303",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679304",
    "city": "VALANCHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679305",
    "city": "VALANCHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679307",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679308",
    "city": "VALANCHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679309",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679310",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679311",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679312",
    "city": "VALANCHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679313",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679314",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679321",
    "city": "PERINTALMANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679322",
    "city": "PERINTALMANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679323",
    "city": "PERINTALMANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679324",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679325",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679326",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679327",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679328",
    "city": "WANDOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679329",
    "city": "NILAMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679330",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679331",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679332",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679333",
    "city": "NILAMBUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679334",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679335",
    "city": "CHERPULASERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679336",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679337",
    "city": "CHERPULASERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679338",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679339",
    "city": "VALANCHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679340",
    "city": "PERINTALMANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679342",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679343",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679344",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679348",
    "city": "MALAPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679350",
    "city": "PERINTALMANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679351",
    "city": "PERINTALMANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679352",
    "city": "PERINTALMANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679354",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679355",
    "city": "AREEKODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679357",
    "city": "PERINTALMANNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679501",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679502",
    "city": "CHERPULASERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679503",
    "city": "CHERPULASERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679504",
    "city": "CHERPULASERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679505",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679506",
    "city": "CHERPULASERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679511",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679512",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679513",
    "city": "CHERPULASERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679514",
    "city": "CHERPULASERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679515",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679516",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679517",
    "city": "CHERPULASERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679518",
    "city": "CHERPULASERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679521",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679522",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679523",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679531",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679532",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679533",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679534",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679535",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679536",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679537",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679538",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679551",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679552",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679553",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679554",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679561",
    "city": "KUNNAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679562",
    "city": "KUNNAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679563",
    "city": "KUNNAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679564",
    "city": "GURUVAYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679571",
    "city": "VALANCHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679572",
    "city": "VALANCHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679573",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679574",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679575",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679576",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679577",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679578",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679579",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679580",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679581",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679582",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679583",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679584",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679585",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679586",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679587",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679588",
    "city": "VALANCHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679589",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679591",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679592",
    "city": "VALANCHERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "679594",
    "city": "EDAPPAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680001",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680002",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680003",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680004",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680005",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680006",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680007",
    "city": "KANIMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680008",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680009",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680010",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680011",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680012",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680014",
    "city": "KANIMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680015",
    "city": "KANIMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680016",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680017",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680018",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680020",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680021",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680022",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680026",
    "city": "KANIMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680027",
    "city": "KANIMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680028",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680101",
    "city": "GURUVAYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680102",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680103",
    "city": "KUNNAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680104",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680121",
    "city": "IRINJALAKUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680122",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680123",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680124",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680125",
    "city": "IRINJALAKUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680301",
    "city": "KALLETTUMKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680302",
    "city": "KALLETTUMKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680303",
    "city": "KALLETTUMKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680304",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680305",
    "city": "KALLETTUMKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680306",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680307",
    "city": "CHALAKUDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680308",
    "city": "CHALAKUDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680309",
    "city": "CHALAKUDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680310",
    "city": "KANIMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680311",
    "city": "CHALAKUDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680312",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680313",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680314",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680316",
    "city": "CHALAKUDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680317",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680319",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680321",
    "city": "CHALAKUDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680322",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680323",
    "city": "KALLETTUMKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680325",
    "city": "KALLETTUMKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680502",
    "city": "GURUVAYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680503",
    "city": "KUNNAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680504",
    "city": "GURUVAYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680505",
    "city": "GURUVAYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680506",
    "city": "GURUVAYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680507",
    "city": "GURUVAYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680508",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680509",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680510",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680511",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680512",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680513",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680514",
    "city": "THRIPRAYAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680515",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680516",
    "city": "GURUVAYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680517",
    "city": "GURUVAYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680518",
    "city": "GURUVAYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680519",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680520",
    "city": "KUNNAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680521",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680522",
    "city": "GURUVAYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680523",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680524",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680542",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680543",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680544",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680546",
    "city": "GURUVAYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680547",
    "city": "KANIMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680549",
    "city": "KANIMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680552",
    "city": "GURUVAYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680553",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680554",
    "city": "KANIMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680562",
    "city": "KANIMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680563",
    "city": "KANIMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680566",
    "city": "THRIPRAYAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680567",
    "city": "THRIPRAYAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680568",
    "city": "THRIPRAYAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680569",
    "city": "THRIPRAYAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680573",
    "city": "THRIPRAYAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680574",
    "city": "KANIMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680575",
    "city": "KANIMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680582",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680583",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680584",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680585",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680586",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680587",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680588",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680589",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680590",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680591",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680592",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680593",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680594",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680595",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680596",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680597",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680600",
    "city": "SHORNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680601",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680602",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680603",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680604",
    "city": "GURUVAYUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680608",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680610",
    "city": "ALATHUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680611",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680616",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680617",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680618",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680619",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680620",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680621",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680623",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680631",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680641",
    "city": "KANIMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680651",
    "city": "MANNUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680652",
    "city": "MANNUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680653",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680654",
    "city": "MANNUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680655",
    "city": "MANNUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680656",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680657",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680661",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680662",
    "city": "IRINJALAKUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680663",
    "city": "KODUNGALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680664",
    "city": "KODUNGALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680665",
    "city": "THRIPRAYAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680666",
    "city": "KODUNGALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680667",
    "city": "KODUNGALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680668",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680669",
    "city": "KODUNGALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680670",
    "city": "KODUNGALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680671",
    "city": "KODUNGALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680672",
    "city": "IRINJALAKUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680673",
    "city": "KODUNGALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680682",
    "city": "MALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680683",
    "city": "KALLETTUMKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680684",
    "city": "CHALAKUDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680685",
    "city": "KODUNGALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680688",
    "city": "THRIPRAYAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680689",
    "city": "KALLETTUMKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680692",
    "city": "CHALAKUDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680693",
    "city": "CHALAKUDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680695",
    "city": "THRIPRAYAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680697",
    "city": "KALLETTUMKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680699",
    "city": "KALLETTUMKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680701",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680702",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680704",
    "city": "TRICHUR APX/SFC PUD CENTR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680711",
    "city": "KANIMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680712",
    "city": "KANIMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680721",
    "city": "CHALAKUDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680722",
    "city": "CHALAKUDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680723",
    "city": "OTTAPALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680724",
    "city": "CHALAKUDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680731",
    "city": "KURUMASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680732",
    "city": "MALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680733",
    "city": "MALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680734",
    "city": "KURUMASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680735",
    "city": "KODUNGALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680741",
    "city": "KURUMASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680751",
    "city": "MANNUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680752",
    "city": "TRICHUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "680771",
    "city": "KANIMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682000",
    "city": "KALOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682001",
    "city": "KOCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682002",
    "city": "KOCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682003",
    "city": "ERNAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682005",
    "city": "KOCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682006",
    "city": "KOCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682007",
    "city": "KOCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682008",
    "city": "KOCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682009",
    "city": "ERNAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682010",
    "city": "KOCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682011",
    "city": "ERNAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682012",
    "city": "ERNAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682013",
    "city": "ERNAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682014",
    "city": "ERNAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682015",
    "city": "ERNAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682016",
    "city": "ERNAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682017",
    "city": "KALOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682018",
    "city": "ERNAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682019",
    "city": "VYTTILA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682020",
    "city": "VYTTILA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682021",
    "city": "KAKKANAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682022",
    "city": "EDAPPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682023",
    "city": "ERNAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682024",
    "city": "EDAPPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682025",
    "city": "KALOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682026",
    "city": "EDAPPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682027",
    "city": "ERNAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682028",
    "city": "VYTTILA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682029",
    "city": "ERNAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682030",
    "city": "KAKKANAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682031",
    "city": "ERNAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682032",
    "city": "VYTTILA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682033",
    "city": "EDAPPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682034",
    "city": "EDAPPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682035",
    "city": "ERNAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682036",
    "city": "VYTTILA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682037",
    "city": "KAKKANAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682038",
    "city": "MARADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682039",
    "city": "KAKKANAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682040",
    "city": "VYTTILA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682041",
    "city": "EDAPPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682042",
    "city": "KAKKANAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682044",
    "city": "PARAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682222",
    "city": "EDAPPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682301",
    "city": "TRIPUNITHURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682302",
    "city": "TRIPUNITHURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682303",
    "city": "KOLENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682305",
    "city": "THIRUVANKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682306",
    "city": "VYTTILA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682307",
    "city": "MULANTHURUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682308",
    "city": "KOLENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682309",
    "city": "TRIPUNITHURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682310",
    "city": "KOLENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682311",
    "city": "KOLENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682312",
    "city": "MULANTHURUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682313",
    "city": "PIRAVOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682314",
    "city": "MULANTHURUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682315",
    "city": "PIRAVOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682316",
    "city": "MUVATTUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682317",
    "city": "MULANTHURUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682319",
    "city": "PIRAVOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682320",
    "city": "MULANTHURUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682501",
    "city": "MALIPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682502",
    "city": "MALIPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682503",
    "city": "MALIPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682504",
    "city": "ERNAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682505",
    "city": "MALIPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682506",
    "city": "VYTTILA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682507",
    "city": "KOCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682508",
    "city": "MALIPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682509",
    "city": "MALIPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682510",
    "city": "MALIPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "682511",
    "city": "MALIPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683101",
    "city": "ALUWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683102",
    "city": "MUPPATHADAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683103",
    "city": "ALUWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683104",
    "city": "EDAPPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683105",
    "city": "ALUWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683106",
    "city": "ALUWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683107",
    "city": "ALUWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683108",
    "city": "ALUWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683109",
    "city": "EDAPPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683110",
    "city": "MUPPATHADAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683111",
    "city": "KALADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683112",
    "city": "ALUWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683211",
    "city": "KOLENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683305",
    "city": "CHALAKUDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683401",
    "city": "CHALAKUDY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683501",
    "city": "MUPPATHADAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683502",
    "city": "MUPPATHADAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683503",
    "city": "EDAPPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683511",
    "city": "ALANGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683512",
    "city": "PARAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683513",
    "city": "PARAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683514",
    "city": "MALIPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683515",
    "city": "MALIPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683516",
    "city": "ALANGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683517",
    "city": "ALANGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683518",
    "city": "ALANGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683519",
    "city": "ALANGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683520",
    "city": "PARAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683521",
    "city": "PARAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683522",
    "city": "PARAVUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683523",
    "city": "ALANGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683524",
    "city": "KURUMASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683541",
    "city": "PATTIMATTOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683542",
    "city": "PERUMBAVOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683543",
    "city": "PERUMBAVOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683544",
    "city": "PERUMBAVOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683545",
    "city": "PATTIMATTOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683546",
    "city": "PATTIMATTOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683547",
    "city": "PATTIMATTOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683548",
    "city": "ERNAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683549",
    "city": "PATTIMATTOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683550",
    "city": "PATTIMATTOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683553",
    "city": "KOLENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683554",
    "city": "PERUMBAVOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683555",
    "city": "KOLENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683556",
    "city": "PERUMBAVOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683557",
    "city": "KOLENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683561",
    "city": "PATTIMATTOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683562",
    "city": "PATTIMATTOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683563",
    "city": "NAVAL ARMAMENT DEPOT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683564",
    "city": "PATTIMATTOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683565",
    "city": "ALUWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683571",
    "city": "COCHIN APX/SFC PUD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683572",
    "city": "ANGAMALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683573",
    "city": "ANGAMALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683574",
    "city": "KALADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683575",
    "city": "KURUMASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683576",
    "city": "ANGAMALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683577",
    "city": "ANGAMALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683578",
    "city": "KURUMASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683579",
    "city": "KURUMASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683580",
    "city": "COCHIN APX/SFC PUD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683581",
    "city": "ALUWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683582",
    "city": "ANGAMALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683583",
    "city": "ANGAMALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683584",
    "city": "KALADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683585",
    "city": "KALADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683586",
    "city": "ANGAMALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683587",
    "city": "KALADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683589",
    "city": "ANGAMALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683591",
    "city": "ANGAMALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683592",
    "city": "KALADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683593",
    "city": "KURUMASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "683594",
    "city": "KURUMASSERY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685501",
    "city": "KANJIRAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685502",
    "city": "EERATTUPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685503",
    "city": "EERATTUPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685505",
    "city": "EERATTUPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685506",
    "city": "EERATTUPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685507",
    "city": "EERATTUPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685508",
    "city": "KATTAPPANA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685509",
    "city": "MULANTHURUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685510",
    "city": "KANJIRAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685511",
    "city": "EERATTUPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685512",
    "city": "EERATTUPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685514",
    "city": "KANJIRAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685515",
    "city": "KANJIRAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685531",
    "city": "KANJIRAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685532",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685533",
    "city": "KANJIRAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685535",
    "city": "EERATTUPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685536",
    "city": "MULANTHURUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685537",
    "city": "KANJIRAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685538",
    "city": "KANJIRAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685539",
    "city": "MUVATTUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685551",
    "city": "KANJIRAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685552",
    "city": "EERATTUPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685553",
    "city": "EERATTUPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685554",
    "city": "EERATTUPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685556",
    "city": "EERATTUPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685561",
    "city": "KOLENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685562",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685563",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685564",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685565",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685566",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685569",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685571",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685581",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685582",
    "city": "EDAPPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685583",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685584",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685585",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685586",
    "city": "MUVATTUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685587",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685588",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685589",
    "city": "KOLENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685590",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685591",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685592",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685595",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685601",
    "city": "EERATTUPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685602",
    "city": "KOLENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685603",
    "city": "EDAPPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685604",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685605",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685606",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685607",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685608",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685611",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685612",
    "city": "MUNNAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685613",
    "city": "MUVATTUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685614",
    "city": "EERATTUPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685615",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685616",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685617",
    "city": "MUNNAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685618",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685619",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685620",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "685621",
    "city": "MUVATTUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686001",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686002",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686003",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686004",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686005",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686006",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686007",
    "city": "CHINGAVANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686008",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686009",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686010",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686011",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686012",
    "city": "CHINGAVANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686013",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686014",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686015",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686016",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686017",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686018",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686019",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686020",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686021",
    "city": "KARUKACHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686022",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686023",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686024",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686025",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686026",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686027",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686029",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686030",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686032",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686033",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686034",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686035",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686036",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686037",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686038",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686039",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686041",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686101",
    "city": "CHANGANACHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686102",
    "city": "CHANGANACHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686103",
    "city": "CHANGANACHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686104",
    "city": "CHANGANACHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686105",
    "city": "CHANGANACHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686106",
    "city": "CHANGANACHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686121",
    "city": "EERATTUPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686122",
    "city": "PONKUNNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686123",
    "city": "KANJIRAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686124",
    "city": "PONKUNNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686141",
    "city": "THALAYOLAPARAMBU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686142",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686143",
    "city": "THALAYOLAPARAMBU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686144",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686145",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686146",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686501",
    "city": "PAMPADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686502",
    "city": "PAMPADY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686503",
    "city": "PONKUNNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686504",
    "city": "PONKUNNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686505",
    "city": "PONKUNNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686506",
    "city": "PONKUNNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686507",
    "city": "KANJIRAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686508",
    "city": "KANJIRAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686509",
    "city": "KANJIRAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686510",
    "city": "KOZHENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686511",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686512",
    "city": "KANJIRAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686513",
    "city": "KANJIRAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686514",
    "city": "KANJIRAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686515",
    "city": "PONKUNNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686516",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686517",
    "city": "PONKUNNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686518",
    "city": "KANJIRAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686519",
    "city": "PONKUNNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686520",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686521",
    "city": "KARUKACHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686522",
    "city": "PONKUNNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686523",
    "city": "PALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686524",
    "city": "KANJIRAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686529",
    "city": "KANJIRAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686531",
    "city": "CHINGAVANAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686532",
    "city": "CHANGANACHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686533",
    "city": "CHANGANACHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686534",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686535",
    "city": "CHANGANACHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686536",
    "city": "KARUKACHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686537",
    "city": "CHANGANACHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686538",
    "city": "CHANGANACHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686539",
    "city": "KARUKACHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686540",
    "city": "KARUKACHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686541",
    "city": "KARUKACHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686542",
    "city": "KARUKACHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686543",
    "city": "PONKUNNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686544",
    "city": "PONKUNNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686545",
    "city": "KARUKACHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686546",
    "city": "KARUKACHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686547",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686548",
    "city": "CHANGANACHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686549",
    "city": "CHANGANACHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686550",
    "city": "KARUKACHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686552",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686553",
    "city": "KARUKACHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686555",
    "city": "PONKUNNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686560",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686561",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686562",
    "city": "ETTUMANOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686563",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686564",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686566",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686567",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686568",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686571",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686572",
    "city": "KURAVILANGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686573",
    "city": "PALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686574",
    "city": "PALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686575",
    "city": "PALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686576",
    "city": "KOOTHATTUKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686577",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686578",
    "city": "PALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686579",
    "city": "PONKUNNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686580",
    "city": "PONKUNNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686581",
    "city": "PONKUNNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686582",
    "city": "PONKUNNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686583",
    "city": "KURAVILANGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686585",
    "city": "PONKUNNAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686586",
    "city": "EERATTUPETTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686587",
    "city": "KURAVILANGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686588",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686590",
    "city": "PALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686591",
    "city": "KOOTHATTUKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686592",
    "city": "PALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686594",
    "city": "PALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686595",
    "city": "ETTUMANOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686596",
    "city": "ETTUMANOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686600",
    "city": "KANJIRAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686601",
    "city": "ETTUMANOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686602",
    "city": "ETTUMANOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686603",
    "city": "KURAVILANGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686604",
    "city": "KADUTHURUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686605",
    "city": "THALAYOLAPARAMBU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686606",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686607",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686608",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686609",
    "city": "KADUTHURUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686610",
    "city": "KADUTHURUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686611",
    "city": "KADUTHURUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686612",
    "city": "KADUTHURUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686613",
    "city": "KADUTHURUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686614",
    "city": "THALAYOLAPARAMBU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686615",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686616",
    "city": "KADUTHURUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686617",
    "city": "KADUTHURUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686619",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686620",
    "city": "PALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686630",
    "city": "ETTUMANOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686631",
    "city": "ETTUMANOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686632",
    "city": "ETTUMANOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686633",
    "city": "KURAVILANGAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686634",
    "city": "KOOTHATTUKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686635",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686636",
    "city": "KOOTHATTUKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686637",
    "city": "ETTUMANOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686638",
    "city": "KOOTHATTUKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686640",
    "city": "KADUTHURUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686641",
    "city": "KOOTHATTUKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686642",
    "city": "KADUTHURUTHY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686651",
    "city": "PALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686652",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686653",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686655",
    "city": "PALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686661",
    "city": "MUVATTUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686662",
    "city": "KOOTHATTUKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686663",
    "city": "PIRAVOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686664",
    "city": "PIRAVOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686665",
    "city": "PIRAVOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686666",
    "city": "THODUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686667",
    "city": "KOOTHATTUKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686669",
    "city": "MUVATTUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686671",
    "city": "MUVATTUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686674",
    "city": "MUVATTUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686676",
    "city": "MUVATTUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686677",
    "city": "MUVATTUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686679",
    "city": "KOOTHATTUKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686680",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686681",
    "city": "MUVATTUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686686",
    "city": "KOOTHATTUKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686687",
    "city": "KOOTHATTUKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686689",
    "city": "MUVATTUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686692",
    "city": "PERUMBAVOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686693",
    "city": "MUVATTUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686695",
    "city": "PERUMBAVOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686696",
    "city": "MUVATTUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686698",
    "city": "PERUMBAVOOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686721",
    "city": "MUVATTUPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686723",
    "city": "KOOTHATTUKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686726",
    "city": "PIRAVOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "686730",
    "city": "PIRAVOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "687116",
    "city": "KOLENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688001",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688002",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688003",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688004",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688005",
    "city": "AMBALAPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688006",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688007",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688008",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688009",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688010",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688011",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688012",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688013",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688014",
    "city": "AMBALAPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688501",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688502",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688503",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688504",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688505",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688506",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688508",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688512",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688521",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688522",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688523",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688524",
    "city": "CHERTHALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688525",
    "city": "CHERTHALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688526",
    "city": "ERAMALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688527",
    "city": "CHERTHALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688528",
    "city": "ERAMALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688529",
    "city": "ERAMALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688530",
    "city": "CHERTHALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688531",
    "city": "ERAMALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688532",
    "city": "ERAMALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688533",
    "city": "ERAMALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688534",
    "city": "VYTTILA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688535",
    "city": "ERAMALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688536",
    "city": "CHERTHALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688537",
    "city": "ERAMALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688538",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688539",
    "city": "CHERTHALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688540",
    "city": "ERAMALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688541",
    "city": "ERAMALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688542",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688543",
    "city": "CHERTHALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688544",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688545",
    "city": "CHERTHALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688546",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688547",
    "city": "ERAMALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688548",
    "city": "ERAMALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688549",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688550",
    "city": "ERAMALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688552",
    "city": "CHERTHALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688554",
    "city": "CHERTHALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688555",
    "city": "CHERTHALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688556",
    "city": "ERAMALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688557",
    "city": "ERAMALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688558",
    "city": "ERAMALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688559",
    "city": "ERAMALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688561",
    "city": "AMBALAPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688562",
    "city": "AMBALAPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688563",
    "city": "AMBALAPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688564",
    "city": "AMBALAPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688565",
    "city": "AMBALAPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688566",
    "city": "ERAMALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688567",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688570",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688571",
    "city": "CHERTHALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688581",
    "city": "ERAMALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688582",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688583",
    "city": "CHERTHALAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688584",
    "city": "ERAMALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "688587",
    "city": "ERAMALLUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689101",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689102",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689103",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689104",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689105",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689106",
    "city": "CHENGANNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689107",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689108",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689109",
    "city": "CHENGANNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689110",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689111",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689112",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689113",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689114",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689115",
    "city": "CHENGANNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689121",
    "city": "CHENGANNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689122",
    "city": "CHENGANNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689123",
    "city": "CHENGANNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689124",
    "city": "CHENGANNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689125",
    "city": "CHENGANNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689126",
    "city": "CHENGANNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689501",
    "city": "ADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689502",
    "city": "ADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689504",
    "city": "CHENGANNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689505",
    "city": "CHENGANNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689506",
    "city": "CHENGANNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689507",
    "city": "KOZHENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689508",
    "city": "CHENGANNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689509",
    "city": "ADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689510",
    "city": "CHENGANNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689511",
    "city": "MAVELIKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689512",
    "city": "ADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689513",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689514",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689515",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689516",
    "city": "ADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689517",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689518",
    "city": "ADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689519",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689520",
    "city": "CHENGANNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689521",
    "city": "CHENGANNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689531",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689532",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689533",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689541",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689542",
    "city": "KOZHENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689543",
    "city": "KOZHENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689544",
    "city": "KOZHENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689545",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689546",
    "city": "CHENGANNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689547",
    "city": "KOZHENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689548",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689549",
    "city": "KOZHENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689550",
    "city": "KOZHENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689551",
    "city": "CHENGANNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689552",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689571",
    "city": "AMBALAPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689572",
    "city": "AMBALAPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689573",
    "city": "AMBALAPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689574",
    "city": "AMBALAPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689575",
    "city": "AMBALAPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689576",
    "city": "AMBALAPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689577",
    "city": "AMBALAPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689578",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689579",
    "city": "AMBALAPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689581",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689582",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689583",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689584",
    "city": "KARUKACHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689585",
    "city": "KARUKACHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689586",
    "city": "KOZHENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689587",
    "city": "KOZHENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689588",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689589",
    "city": "KARUKACHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689590",
    "city": "CHANGANACHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689591",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689592",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689593",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689594",
    "city": "CHANGANACHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689595",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689596",
    "city": "KARUKACHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689597",
    "city": "KOZHENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689598",
    "city": "ALAPPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689602",
    "city": "KOZHENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689603",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689611",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689612",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689613",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689614",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689615",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689616",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689620",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689621",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689622",
    "city": "HARIPAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689624",
    "city": "MAVELIKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689625",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689626",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689627",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689629",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689630",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689632",
    "city": "THIRUVALLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689641",
    "city": "KOZHENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689642",
    "city": "KOZHENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689643",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689644",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689645",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689646",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689647",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689648",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689649",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689650",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689652",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689653",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689654",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689656",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689657",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689659",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689660",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689661",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689662",
    "city": "KOTTAYAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689663",
    "city": "CHENGANNUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689664",
    "city": "KOZHENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689665",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689666",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689667",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689668",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689671",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689672",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689673",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689674",
    "city": "KOZHENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689675",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689676",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689677",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689678",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689680",
    "city": "KOZHENCHERRY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689681",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689682",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689691",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689692",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689693",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689694",
    "city": "ADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689695",
    "city": "PATHANAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689696",
    "city": "PATHANAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689698",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689699",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689703",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689705",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689706",
    "city": "PATHANAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689711",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689713",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689721",
    "city": "AMBALAPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689722",
    "city": "AMBALAPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "689723",
    "city": "AMBALAPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690101",
    "city": "MAVELIKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690102",
    "city": "MAVELIKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690103",
    "city": "MAVELIKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690104",
    "city": "MAVELIKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690105",
    "city": "HARIPAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690106",
    "city": "MAVELIKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690107",
    "city": "MAVELIKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690108",
    "city": "MAVELIKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690110",
    "city": "MAVELIKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690501",
    "city": "MAVELIKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690502",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690503",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690504",
    "city": "MAVELIKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690506",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690507",
    "city": "HARIPAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690509",
    "city": "MAVELIKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690510",
    "city": "MAVELIKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690511",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690512",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690513",
    "city": "HARIPAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690514",
    "city": "HARIPAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690515",
    "city": "HARIPAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690516",
    "city": "HARIPAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690517",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690518",
    "city": "KARUNAGAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690519",
    "city": "KARUNAGAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690520",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690521",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690522",
    "city": "KUNDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690523",
    "city": "KARUNAGAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690524",
    "city": "KAVANADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690525",
    "city": "KARUNAGAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690526",
    "city": "KARUNAGAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690527",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690528",
    "city": "KARUNAGAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690529",
    "city": "MAVELIKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690530",
    "city": "MAVELIKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690531",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690532",
    "city": "HARIPAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690533",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690534",
    "city": "MAVELIKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690535",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690536",
    "city": "KARUNAGAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690537",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690538",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690539",
    "city": "KARUNAGAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690540",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690541",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690542",
    "city": "KARUNAGAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690543",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690544",
    "city": "KARUNAGAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690546",
    "city": "KARUNAGAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690547",
    "city": "KARUNAGAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690548",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690549",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690550",
    "city": "HARIPAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690551",
    "city": "AMBALAPUZHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690552",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690553",
    "city": "HARIPAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690555",
    "city": "HARIPAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690556",
    "city": "HARIPAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690557",
    "city": "MAVELIKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690558",
    "city": "MAVELIKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690559",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690560",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690561",
    "city": "KUNDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690563",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690564",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690565",
    "city": "KANIMANGALAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690566",
    "city": "HARIPAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690567",
    "city": "ADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690568",
    "city": "KARUNAGAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690569",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690570",
    "city": "MAVELIKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690571",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690572",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690573",
    "city": "KARUNAGAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "690574",
    "city": "KAYAMKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691001",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691002",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691003",
    "city": "KAVANADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691004",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691005",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691006",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691007",
    "city": "KAVANADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691008",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691009",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691010",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691011",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691012",
    "city": "KAVANADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691013",
    "city": "KAVANADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691014",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691015",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691016",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691017",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691018",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691019",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691020",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691021",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691301",
    "city": "PARIPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691302",
    "city": "PARIPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691303",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691304",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691305",
    "city": "PUNALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691306",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691307",
    "city": "PUNALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691308",
    "city": "PUNALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691309",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691310",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691311",
    "city": "VARKALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691312",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691315",
    "city": "PUNALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691316",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691317",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691318",
    "city": "PUNALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691319",
    "city": "PARIPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691320",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691321",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691322",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691324",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691325",
    "city": "PUNALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691326",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691329",
    "city": "PUNALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691330",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691331",
    "city": "PUNALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691332",
    "city": "PATHANAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691333",
    "city": "PUNALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691334",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691378",
    "city": "PARIPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691500",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691501",
    "city": "KUNDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691502",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691503",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691504",
    "city": "KUNDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691505",
    "city": "KOTTARAKKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691506",
    "city": "KOTTARAKKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691507",
    "city": "KOTTARAKKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691508",
    "city": "PATHANAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691509",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691510",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691511",
    "city": "KUNDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691512",
    "city": "KOTTARAKKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691513",
    "city": "KOTTARAKKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691514",
    "city": "PATHANAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691515",
    "city": "KUNDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691516",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691517",
    "city": "PATHANAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691518",
    "city": "KOTTARAKKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691519",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691520",
    "city": "KOTTARAKKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691521",
    "city": "ADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691522",
    "city": "PUNALUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691523",
    "city": "ADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691524",
    "city": "KOTTARAKKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691525",
    "city": "ADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691526",
    "city": "ADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691527",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691528",
    "city": "ADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691529",
    "city": "ADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691530",
    "city": "ADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691531",
    "city": "KOTTARAKKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691532",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691533",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691534",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691535",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691536",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691537",
    "city": "KUNDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691538",
    "city": "KOTTARAKKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691539",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691540",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691541",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691542",
    "city": "KOTTARAKKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691543",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691544",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691545",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691546",
    "city": "KOTTARAKKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691547",
    "city": "KOTTARAKKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691548",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691550",
    "city": "KOTTARAKKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691551",
    "city": "ADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691552",
    "city": "ADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691553",
    "city": "ADUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691554",
    "city": "PATHANAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691555",
    "city": "PATHANAMTHITTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691556",
    "city": "PATHANAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691557",
    "city": "KOTTARAKKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691559",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691560",
    "city": "KOTTARAKKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691562",
    "city": "KARUNAGAPALLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691566",
    "city": "KOTTARAKKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691571",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691572",
    "city": "KUNDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691573",
    "city": "KUNDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691574",
    "city": "PARIPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691576",
    "city": "KUNDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691577",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691578",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691579",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691580",
    "city": "KUNDRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691581",
    "city": "KAVANADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691582",
    "city": "KAVANADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691583",
    "city": "KAVANADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691584",
    "city": "KAVANADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691585",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691587",
    "city": "ANCHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691588",
    "city": "KAVANADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691589",
    "city": "KOLLAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691590",
    "city": "KAVANADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691601",
    "city": "KAVANADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691602",
    "city": "KAVANADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691604",
    "city": "KAVANADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691605",
    "city": "KAVANADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691623",
    "city": "KOTTARAKKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691624",
    "city": "KOTTARAKKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "691625",
    "city": "KOTTARAKKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "694582",
    "city": "KAVANADU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695001",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695002",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695003",
    "city": "ULOOR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695004",
    "city": "ULOOR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695005",
    "city": "ULOOR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695006",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695007",
    "city": "ULOOR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695008",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695009",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695010",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695011",
    "city": "ULOOR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695012",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695013",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695014",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695015",
    "city": "ULOOR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695016",
    "city": "ULOOR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695017",
    "city": "ULOOR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695018",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695019",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695020",
    "city": "PEYAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695021",
    "city": "ULOOR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695022",
    "city": "ULOOR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695023",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695024",
    "city": "ULOOR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695025",
    "city": "ULOOR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695026",
    "city": "PEYAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695027",
    "city": "PEYAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695028",
    "city": "KARAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695029",
    "city": "ULOOR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695030",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695031",
    "city": "ULOOR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695032",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695033",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695034",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695035",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695036",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695037",
    "city": "ULOOR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695038",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695039",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695040",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695041",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695042",
    "city": "PEYAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695043",
    "city": "ULOOR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695044",
    "city": "ULOOR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695049",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695099",
    "city": "ULOOR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695101",
    "city": "ATTINGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695102",
    "city": "ATTINGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695103",
    "city": "ATTINGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695104",
    "city": "ATTINGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695121",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695122",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695123",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695124",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695125",
    "city": "KATTAKADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695126",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695127",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695128",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695130",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695131",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695132",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695133",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695134",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695141",
    "city": "VARKALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695142",
    "city": "VARKALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695143",
    "city": "VARKALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695144",
    "city": "ATTINGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695145",
    "city": "VARKALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695146",
    "city": "TRV APEX/SFC PUD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695212",
    "city": "MAVELIKARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695301",
    "city": "PALLIPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695302",
    "city": "PALLIPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695303",
    "city": "PALLIPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695304",
    "city": "ATTINGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695305",
    "city": "PALLIPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695306",
    "city": "ATTINGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695307",
    "city": "ATTINGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695308",
    "city": "ATTINGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695309",
    "city": "VARKALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695310",
    "city": "VARKALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695311",
    "city": "VARKALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695312",
    "city": "VARKALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695314",
    "city": "ATTINGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695316",
    "city": "PALLIPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695317",
    "city": "PALLIPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695318",
    "city": "VARKALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695501",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695502",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695503",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695504",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695505",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695506",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695507",
    "city": "PEYAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695508",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695509",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695510",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695512",
    "city": "KATTAKADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695513",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695521",
    "city": "PEYAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695522",
    "city": "PEYAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695523",
    "city": "PEYAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695525",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695526",
    "city": "BALARAMAPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695527",
    "city": "PEYAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695541",
    "city": "KARAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695542",
    "city": "KATTAKADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695543",
    "city": "KATTAKADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695544",
    "city": "TRIVANDRUM SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695547",
    "city": "KARAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695551",
    "city": "KATTAKADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695557",
    "city": "KATTAKADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695560",
    "city": "KARAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695561",
    "city": "KARAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695562",
    "city": "KARAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695563",
    "city": "KATTAKADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695564",
    "city": "KARAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695568",
    "city": "KARAKULAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695571",
    "city": "KATTAKADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695572",
    "city": "KATTAKADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695573",
    "city": "KATTAKADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695574",
    "city": "KATTAKADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695575",
    "city": "KATTAKADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695581",
    "city": "ULOOR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695582",
    "city": "ULOOR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695583",
    "city": "ULOOR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695584",
    "city": "POTHENCODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695585",
    "city": "PALLIPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695586",
    "city": "PALLIPPURAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695587",
    "city": "POTHENCODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695588",
    "city": "POTHENCODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695589",
    "city": "POTHENCODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695601",
    "city": "POTHENCODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695602",
    "city": "VARKALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695603",
    "city": "PARIPALLI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695604",
    "city": "VARKALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695605",
    "city": "VARKALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695606",
    "city": "ATTINGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695607",
    "city": "POTHENCODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695608",
    "city": "POTHENCODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695609",
    "city": "POTHENCODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695610",
    "city": "POTHENCODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695611",
    "city": "ATTINGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695612",
    "city": "ATTINGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695614",
    "city": "ATTINGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695615",
    "city": "POTHENCODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695616",
    "city": "POTHENCODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "695618",
    "city": "POTHENCODE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700000",
    "city": "EAST REGIONAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700001",
    "city": "DALHOUSIE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700002",
    "city": "B T ROAD SERVICE CENTRE.",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700003",
    "city": "B T ROAD SERVICE CENTRE.",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700004",
    "city": "B T ROAD SERVICE CENTRE.",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700005",
    "city": "DALHOUSIE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700006",
    "city": "DALHOUSIE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700007",
    "city": "DALHOUSIE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700008",
    "city": "BEHALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700009",
    "city": "DALHOUSIE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700010",
    "city": "BELIAGHATA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700011",
    "city": "BELIAGHATA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700012",
    "city": "DALHOUSIE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700013",
    "city": "DALHOUSIE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700014",
    "city": "BMB SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700015",
    "city": "BMB SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700016",
    "city": "PARK STREET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700017",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700018",
    "city": "MAHESHTALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700019",
    "city": "BHOWANIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700020",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700021",
    "city": "DALHOUSIE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700022",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700023",
    "city": "MAHESHTALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700024",
    "city": "MAHESHTALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700025",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700026",
    "city": "BHOWANIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700027",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700028",
    "city": "DUMDUM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700029",
    "city": "BHOWANIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700030",
    "city": "B T ROAD SERVICE CENTRE.",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700031",
    "city": "BHOWANIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700032",
    "city": "JADAVPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700033",
    "city": "TOLLYGUNGE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700034",
    "city": "BEHALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700035",
    "city": "B T ROAD SERVICE CENTRE.",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700036",
    "city": "B T ROAD SERVICE CENTRE.",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700037",
    "city": "B T ROAD SERVICE CENTRE.",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700038",
    "city": "BEHALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700039",
    "city": "RAJDANGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700040",
    "city": "TOLLYGUNGE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700041",
    "city": "TOLLYGUNGE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700042",
    "city": "RAJDANGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700043",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700044",
    "city": "MAHESHTALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700045",
    "city": "BHOWANIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700046",
    "city": "BMB SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700048",
    "city": "DUMDUM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700049",
    "city": "B T ROAD SERVICE CENTRE.",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700050",
    "city": "B T ROAD SERVICE CENTRE.",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700051",
    "city": "DUMDUM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700052",
    "city": "DUMDUM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700053",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700054",
    "city": "BELIAGHATA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700055",
    "city": "DUMDUM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700056",
    "city": "B T ROAD SERVICE CENTRE.",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700057",
    "city": "B T ROAD SERVICE CENTRE.",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700058",
    "city": "B T ROAD SERVICE CENTRE.",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700059",
    "city": "DUMDUM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700060",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700061",
    "city": "BEHALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700062",
    "city": "DALHOUSIE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700063",
    "city": "BEHALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700064",
    "city": "SALT LAKE SERVICE CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700065",
    "city": "DUMDUM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700066",
    "city": "MAHESHTALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700067",
    "city": "BELIAGHATA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700068",
    "city": "BHOWANIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700069",
    "city": "DALHOUSIE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700070",
    "city": "TOLLYGUNGE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700071",
    "city": "PARK STREET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700072",
    "city": "DALHOUSIE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700073",
    "city": "DALHOUSIE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700074",
    "city": "DUMDUM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700075",
    "city": "JADAVPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700076",
    "city": "B T ROAD SERVICE CENTRE.",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700077",
    "city": "B T ROAD SERVICE CENTRE.",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700078",
    "city": "RAJDANGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700079",
    "city": "DUMDUM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700080",
    "city": "DUMDUM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700081",
    "city": "DUMDUM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700082",
    "city": "TOLLYGUNGE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700083",
    "city": "B T ROAD SERVICE CENTRE.",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700084",
    "city": "JADAVPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700085",
    "city": "BELIAGHATA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700086",
    "city": "JADAVPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700087",
    "city": "PARK STREET",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700088",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700089",
    "city": "DUMDUM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700090",
    "city": "B T ROAD SERVICE CENTRE.",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700091",
    "city": "SALT LAKE SERVICE CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700092",
    "city": "JADAVPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700093",
    "city": "TOLLYGUNGE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700094",
    "city": "JADAVPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700095",
    "city": "TOLLYGUNGE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700096",
    "city": "TOLLYGUNGE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700097",
    "city": "SALT LAKE SERVICE CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700098",
    "city": "SALT LAKE SERVICE CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700099",
    "city": "RAJDANGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700100",
    "city": "RAJDANGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700101",
    "city": "DUMDUM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700102",
    "city": "DUMDUM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700103",
    "city": "GARIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700104",
    "city": "AMTALA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700105",
    "city": "BELIAGHATA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700106",
    "city": "SALT LAKE SERVICE CENTER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700107",
    "city": "RAJDANGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700108",
    "city": "B T ROAD SERVICE CENTRE.",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700109",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700110",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700111",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700112",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700113",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700114",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700115",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700116",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700117",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700118",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700119",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700120",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700121",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700122",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700123",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700124",
    "city": "BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700125",
    "city": "BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700126",
    "city": "BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700127",
    "city": "BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700128",
    "city": "BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700129",
    "city": "BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700130",
    "city": "BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700131",
    "city": "BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700132",
    "city": "BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700133",
    "city": "BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700134",
    "city": "BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700135",
    "city": "NEW TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700136",
    "city": "NEW TOWN SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700137",
    "city": "MAHESHTALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700138",
    "city": "MAHESHTALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700139",
    "city": "MAHESHTALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700140",
    "city": "MAHESHTALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700141",
    "city": "MAHESHTALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700142",
    "city": "MAHESHTALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700143",
    "city": "MAHESHTALA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700144",
    "city": "GARIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700145",
    "city": "GARIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700146",
    "city": "GARIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700147",
    "city": "GARIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700148",
    "city": "GARIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700149",
    "city": "GARIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700150",
    "city": "GARIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700151",
    "city": "GARIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700152",
    "city": "GARIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700153",
    "city": "GARIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700154",
    "city": "GARIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700155",
    "city": "BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700156",
    "city": "NEW TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700157",
    "city": "NEW TOWN SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700158",
    "city": "BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700159",
    "city": "NEW TOWN SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700160",
    "city": "NEW TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700161",
    "city": "NEW TOWN SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "700162",
    "city": "NEW TOWN SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "701111",
    "city": "KOLKATA DEBAGGING CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711101",
    "city": "HOWRAH SALKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711102",
    "city": "HOWRAH SALKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711103",
    "city": "HOWRAH SALKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711104",
    "city": "HOWRAH SALKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711105",
    "city": "HOWRAH SALKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711106",
    "city": "HOWRAH SALKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711107",
    "city": "HOWRAH SALKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711108",
    "city": "HOWRAH SALKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711109",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711110",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711111",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711112",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711113",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711114",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711115",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711201",
    "city": "BALLY BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711202",
    "city": "BALLY BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711203",
    "city": "BALLY BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711204",
    "city": "BALLY BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711205",
    "city": "BALLY BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711206",
    "city": "BALLY BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711225",
    "city": "AMTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711226",
    "city": "AMTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711227",
    "city": "BALLY BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711247",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711301",
    "city": "ULUBERIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711302",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711303",
    "city": "ULUBERIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711304",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711305",
    "city": "ULUBERIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711306",
    "city": "ULUBERIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711307",
    "city": "ULUBERIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711308",
    "city": "ULUBERIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711309",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711310",
    "city": "ULUBERIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711311",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711312",
    "city": "ULUBERIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711313",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711314",
    "city": "ULUBERIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711315",
    "city": "ULUBERIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711316",
    "city": "ULUBERIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711317",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711320",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711321",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711322",
    "city": "ULUBERIA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711323",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711324",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711325",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711326",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711327",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711328",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711401",
    "city": "AMTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711402",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711403",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711404",
    "city": "AMTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711405",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711406",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711408",
    "city": "AMTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711409",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711410",
    "city": "AMTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711411",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711412",
    "city": "AMTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711413",
    "city": "AMTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711414",
    "city": "AMTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711415",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "711503",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712101",
    "city": "HOOGHLY CHINSURAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712102",
    "city": "HOOGHLY CHINSURAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712103",
    "city": "HOOGHLY CHINSURAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712104",
    "city": "HOOGHLY CHINSURAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712105",
    "city": "HOOGHLY CHINSURAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712121",
    "city": "HOOGHLY CHINSURAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712122",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712123",
    "city": "HOOGHLY CHINSURAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712124",
    "city": "HOOGLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712125",
    "city": "HOOGLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712134",
    "city": "GURAP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712135",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712136",
    "city": "HOOGHLY CHINSURAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712137",
    "city": "HOOGHLY CHINSURAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712138",
    "city": "HOOGHLY CHINSURAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712139",
    "city": "HOOGHLY CHINSURAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712146",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712147",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712148",
    "city": "HOOGHLY CHINSURAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712149",
    "city": "GURAP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712150",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712152",
    "city": "GURAP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712153",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712154",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712156",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712157",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712158",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712201",
    "city": "RISHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712202",
    "city": "RISHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712203",
    "city": "RISHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712204",
    "city": "RISHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712205",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712221",
    "city": "HOOGLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712222",
    "city": "HOOGLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712223",
    "city": "HOOGLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712224",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712232",
    "city": "BALLY BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712233",
    "city": "BALLY BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712234",
    "city": "RISHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712235",
    "city": "RISHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712245",
    "city": "BALLY BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712246",
    "city": "RISHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712247",
    "city": "BALLY BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712248",
    "city": "RISHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712249",
    "city": "RISHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712250",
    "city": "RISHRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712258",
    "city": "BALLY BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712301",
    "city": "GURAP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712302",
    "city": "GURAP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712303",
    "city": "GURAP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712304",
    "city": "HOOGLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712305",
    "city": "HOOGLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712306",
    "city": "HOOGLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712308",
    "city": "GURAP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712309",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712310",
    "city": "BALLY BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712311",
    "city": "BALLY BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712344",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712401",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712402",
    "city": "GURAP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712403",
    "city": "HOOGLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712404",
    "city": "AMTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712405",
    "city": "HOOGLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712406",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712407",
    "city": "HOOGLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712408",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712409",
    "city": "HOOGLY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712410",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712411",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712412",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712413",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712414",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712415",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712416",
    "city": "AMTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712417",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712418",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712419",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712420",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712422",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712423",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712424",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712426",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712428",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712429",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712501",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712502",
    "city": "HOOGHLY CHINSURAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712503",
    "city": "HOOGHLY CHINSURAH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712504",
    "city": "GURAP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712512",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712513",
    "city": "GURAP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712514",
    "city": "GURAP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712515",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712543",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712601",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712602",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712611",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712612",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712613",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712614",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712615",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712616",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712617",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712701",
    "city": "BALLY BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712702",
    "city": "BALLY BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712704",
    "city": "BALLY BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712705",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712706",
    "city": "BALLY BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712707",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "712708",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713101",
    "city": "BURDWAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713102",
    "city": "BURDWAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713103",
    "city": "BURDWAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713104",
    "city": "BURDWAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713105",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713121",
    "city": "SANTINIKETAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713122",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713123",
    "city": "KATWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713124",
    "city": "BURDWAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713125",
    "city": "BURDWAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713126",
    "city": "SANTINIKETAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713127",
    "city": "BURDWAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713128",
    "city": "SANTINIKETAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713129",
    "city": "KATWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713130",
    "city": "KATWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713131",
    "city": "BURDWAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713140",
    "city": "KATWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713141",
    "city": "BURDWAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713142",
    "city": "BURDWAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713143",
    "city": "KATWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713144",
    "city": "SANTINIKETAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713145",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713146",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713147",
    "city": "KATWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713149",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713150",
    "city": "KATWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713151",
    "city": "BURDWAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713152",
    "city": "SANTINIKETAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713153",
    "city": "SANTINIKETAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713154",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713155",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713156",
    "city": "SANTINIKETAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713157",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713158",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713160",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713162",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713165",
    "city": "BURDWAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713166",
    "city": "GURAP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713167",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713168",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713169",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713170",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713171",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713172",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713173",
    "city": "SANTINIKETAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713201",
    "city": "DURGAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713202",
    "city": "DURGAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713203",
    "city": "DURGAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713204",
    "city": "DURGAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713205",
    "city": "DURGAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713206",
    "city": "DURGAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713207",
    "city": "DURGAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713208",
    "city": "DURGAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713209",
    "city": "DURGAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713210",
    "city": "DURGAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713211",
    "city": "DURGAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713212",
    "city": "DURGAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713213",
    "city": "DURGAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713214",
    "city": "DURGAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713215",
    "city": "DURGAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713216",
    "city": "DURGAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713217",
    "city": "DURGAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713218",
    "city": "DURGAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713219",
    "city": "DURGAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713301",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713302",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713303",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713304",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713305",
    "city": "BARABANI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713308",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713310",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713314",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713315",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713321",
    "city": "RANIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713322",
    "city": "RANIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713323",
    "city": "RANIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713324",
    "city": "RAGHUNATHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713325",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713326",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713330",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713331",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713332",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713333",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713334",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713335",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713336",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713337",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713338",
    "city": "RANIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713339",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713340",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713341",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713342",
    "city": "RANIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713343",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713344",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713346",
    "city": "RANIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713347",
    "city": "RANIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713352",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713357",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713358",
    "city": "RANIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713359",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713360",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713361",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713362",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713363",
    "city": "RANIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713364",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713365",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713366",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713367",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713368",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713369",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713370",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713371",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713372",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713373",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713375",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713376",
    "city": "RANIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713377",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713378",
    "city": "RANIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713380",
    "city": "BURWAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713381",
    "city": "RANIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713383",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713384",
    "city": "RANIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713385",
    "city": "RANIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713386",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713401",
    "city": "GURAP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713402",
    "city": "BURDWAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713403",
    "city": "BURDWAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713404",
    "city": "GURAP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713405",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713406",
    "city": "BURDWAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713407",
    "city": "BURDWAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713408",
    "city": "BURDWAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713409",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713419",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713421",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713422",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713423",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713424",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713425",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713426",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713427",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713428",
    "city": "BURDWAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713429",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713430",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713432",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713433",
    "city": "BURDWAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713434",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713501",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713502",
    "city": "KATWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713512",
    "city": "KATWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713513",
    "city": "KATWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713514",
    "city": "KATWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713515",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713516",
    "city": "KATWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713517",
    "city": "KATWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713518",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713519",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "713520",
    "city": "BURDWAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721101",
    "city": "MIDNAPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721102",
    "city": "MIDNAPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721121",
    "city": "SARBERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721122",
    "city": "MIDNAPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721123",
    "city": "SARBERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721124",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721125",
    "city": "JHARGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721126",
    "city": "GHATAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721127",
    "city": "BISHNUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721128",
    "city": "SARBERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721129",
    "city": "SARBERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721130",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721131",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721132",
    "city": "SARBERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721133",
    "city": "BELDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721134",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721135",
    "city": "BELDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721136",
    "city": "GHATAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721137",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721139",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721140",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721141",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721142",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721143",
    "city": "JHARGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721144",
    "city": "BELDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721145",
    "city": "KHARAGPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721146",
    "city": "GHATAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721147",
    "city": "SARBERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721148",
    "city": "GHATAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721149",
    "city": "KHARAGPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721150",
    "city": "GHATAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721151",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721152",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721153",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721154",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721155",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721156",
    "city": "GHATAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721157",
    "city": "SARBERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721158",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721159",
    "city": "BELDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721160",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721161",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721165",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721166",
    "city": "BELDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721167",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721168",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721169",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721170",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721171",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721172",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721201",
    "city": "GHATAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721211",
    "city": "GHATAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721212",
    "city": "GHATAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721222",
    "city": "GHATAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721228",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721232",
    "city": "GHATAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721242",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721252",
    "city": "SARBERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721253",
    "city": "SARBERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721254",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721256",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721257",
    "city": "SARBERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721258",
    "city": "SARBERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721260",
    "city": "GHATAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721301",
    "city": "KHARAGPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721302",
    "city": "KHARAGPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721303",
    "city": "KHARAGPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721304",
    "city": "KHARAGPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721305",
    "city": "KHARAGPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721306",
    "city": "KHARAGPUR PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721401",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721420",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721422",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721423",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721424",
    "city": "BELDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721425",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721426",
    "city": "BELDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721427",
    "city": "BELDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721428",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721429",
    "city": "BELDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721430",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721431",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721432",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721433",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721434",
    "city": "BELDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721435",
    "city": "BELDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721436",
    "city": "BELDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721437",
    "city": "BELDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721438",
    "city": "BELDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721439",
    "city": "BELDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721440",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721441",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721442",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721443",
    "city": "BELDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721444",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721445",
    "city": "BELDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721446",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721447",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721448",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721449",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721450",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721451",
    "city": "BELDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721452",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721453",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721454",
    "city": "BELDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721455",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721456",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721457",
    "city": "BELDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721458",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721459",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721461",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721462",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721463",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721464",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721465",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721466",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721467",
    "city": "BELDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721501",
    "city": "JHARGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721502",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721503",
    "city": "JHARGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721504",
    "city": "JHARGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721505",
    "city": "JHARGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721506",
    "city": "JHARGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721507",
    "city": "JHARGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721513",
    "city": "JHARGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721514",
    "city": "JHARGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721515",
    "city": "JHARGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721516",
    "city": "SARBERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721517",
    "city": "JHARGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721518",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721577",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721601",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721602",
    "city": "HALDIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721603",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721604",
    "city": "HALDIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721605",
    "city": "HALDIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721606",
    "city": "HALDIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721607",
    "city": "HALDIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721625",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721626",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721627",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721628",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721629",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721630",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721631",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721632",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721633",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721634",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721635",
    "city": "HALDIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721636",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721638",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721641",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721642",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721643",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721644",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721645",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721646",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721647",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721648",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721649",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721650",
    "city": "CONTAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721651",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721652",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721653",
    "city": "PASKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721654",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721655",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721656",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721657",
    "city": "HALDIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721658",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721659",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721663",
    "city": "HALDIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721664",
    "city": "TAMLUK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721666",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721667",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721668",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721669",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "721670",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722101",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722102",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722107",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722110",
    "city": "BISHNUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722111",
    "city": "BISHNUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722112",
    "city": "BISHNUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722121",
    "city": "KHATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722122",
    "city": "BISHNUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722132",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722133",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722134",
    "city": "KHATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722135",
    "city": "KHATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722136",
    "city": "KHATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722137",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722138",
    "city": "BISHNUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722139",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722140",
    "city": "KHATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722141",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722142",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722143",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722144",
    "city": "BISHNUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722145",
    "city": "KHATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722146",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722147",
    "city": "BISHNUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722148",
    "city": "KHATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722149",
    "city": "BISHNUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722150",
    "city": "SARBERA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722151",
    "city": "KHATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722152",
    "city": "BISHNUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722153",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722154",
    "city": "BISHNUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722155",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722156",
    "city": "BISHNUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722157",
    "city": "BISHNUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722158",
    "city": "RAGHUNATHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722160",
    "city": "KHATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722161",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722162",
    "city": "JHARGRAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722163",
    "city": "BISHNUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722164",
    "city": "BISHNUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722165",
    "city": "BISHNUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722166",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722168",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722169",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722170",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722171",
    "city": "KHATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722172",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722173",
    "city": "KHATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722174",
    "city": "BISHNUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722175",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722176",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722177",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722178",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722179",
    "city": "BISHNUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722180",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722181",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722182",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722183",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722201",
    "city": "ARAMBAGH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722202",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722203",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722204",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722205",
    "city": "BURDWAN BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722206",
    "city": "BISHNUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722207",
    "city": "BISHNUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722208",
    "city": "BANKURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "722209",
    "city": "BISHNUPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723101",
    "city": "PURULIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723102",
    "city": "PURULIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723103",
    "city": "PURULIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723104",
    "city": "PURULIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723121",
    "city": "RAGHUNATHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723126",
    "city": "RAGHUNATHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723127",
    "city": "PURULIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723129",
    "city": "KHATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723130",
    "city": "PURULIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723131",
    "city": "KHATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723132",
    "city": "RAGHUNATHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723133",
    "city": "RAGHUNATHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723142",
    "city": "RAGHUNATHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723143",
    "city": "PURULIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723145",
    "city": "RAGHUNATHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723146",
    "city": "RAGHUNATHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723147",
    "city": "PURULIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723148",
    "city": "PURULIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723149",
    "city": "PURULIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723151",
    "city": "KHATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723152",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723153",
    "city": "PURULIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723154",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723155",
    "city": "RAGHUNATHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723156",
    "city": "RAGHUNATHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723157",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723158",
    "city": "RAGHUNATHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723160",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723162",
    "city": "RAGHUNATHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723163",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723164",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723168",
    "city": "RAGHUNATHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723201",
    "city": "PURULIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723202",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723212",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723213",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723214",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723215",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723216",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723401",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "723422",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "727120",
    "city": "KOHIMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731101",
    "city": "SIURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731102",
    "city": "SIURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731103",
    "city": "SIURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731104",
    "city": "SIURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731121",
    "city": "SIURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731122",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731123",
    "city": "SIURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731124",
    "city": "SIURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731125",
    "city": "SIURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731126",
    "city": "SIURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731127",
    "city": "SIURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731128",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731129",
    "city": "SIURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731130",
    "city": "SIURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731131",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731132",
    "city": "SIURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731139",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731147",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731201",
    "city": "SANTINIKETAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731202",
    "city": "RAMPURHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731203",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731204",
    "city": "SANTINIKETAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731213",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731214",
    "city": "SIURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731215",
    "city": "KATWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731216",
    "city": "RAMPURHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731217",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731218",
    "city": "RAMPURHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731219",
    "city": "RAMPURHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731220",
    "city": "RAMPURHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731221",
    "city": "RAGHUNATHGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731222",
    "city": "RAGHUNATHGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731223",
    "city": "RAMPURHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731224",
    "city": "RAMPURHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731233",
    "city": "RAMPURHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731234",
    "city": "SIURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731235",
    "city": "SANTINIKETAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731236",
    "city": "SANTINIKETAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731237",
    "city": "RAMPURHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731238",
    "city": "RAMPURHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731239",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731240",
    "city": "SANTINIKETAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731241",
    "city": "RAMPURHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731242",
    "city": "RAMPURHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731243",
    "city": "RAMPURHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731244",
    "city": "RAMPURHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731245",
    "city": "RAMPURHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731246",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731247",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731251",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731253",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731254",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731255",
    "city": "ASANSOL BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731301",
    "city": "SANTINIKETAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731302",
    "city": "SANTINIKETAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731303",
    "city": "SANTINIKETAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "731304",
    "city": "SANTINIKETAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732101",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732102",
    "city": "MALDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732103",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732121",
    "city": "MALDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732122",
    "city": "MALDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732123",
    "city": "CHANCHAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732124",
    "city": "GAZOLE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732125",
    "city": "CHANCHAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732126",
    "city": "CHANCHAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732127",
    "city": "FARAKKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732128",
    "city": "MALDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732138",
    "city": "GAZOLE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732139",
    "city": "CHANCHAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732140",
    "city": "CHANCHAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732141",
    "city": "MALDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732142",
    "city": "MALDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732143",
    "city": "MALDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732144",
    "city": "MALDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732146",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732147",
    "city": "GAZOLE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732149",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732150",
    "city": "CHANCHAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732151",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732152",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732154",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732155",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732156",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732157",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732158",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732161",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732163",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732201",
    "city": "MALDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732202",
    "city": "MALDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732203",
    "city": "MALDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732204",
    "city": "GAZOLE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732205",
    "city": "CHANCHAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732206",
    "city": "MALDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732207",
    "city": "MALDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732208",
    "city": "MALDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732209",
    "city": "MALDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732210",
    "city": "FARAKKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732211",
    "city": "MALDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732212",
    "city": "MALDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732213",
    "city": "GAZOLE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732214",
    "city": "GAZOLE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732215",
    "city": "FARAKKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "732216",
    "city": "MALDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733101",
    "city": "BALURGHAT ULTRA FRUGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733102",
    "city": "BALURGHAT ULTRA FRUGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733103",
    "city": "BALURGHAT ULTRA FRUGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733120",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733121",
    "city": "GANGARAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733123",
    "city": "RAIGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733124",
    "city": "GANGARAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733125",
    "city": "GANGARAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733126",
    "city": "BALURGHAT ULTRA FRUGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733127",
    "city": "GANGARAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733128",
    "city": "CHANCHAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733129",
    "city": "RAIGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733130",
    "city": "RAIGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733131",
    "city": "BALURGHAT ULTRA FRUGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733132",
    "city": "GANGARAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733133",
    "city": "BALURGHAT ULTRA FRUGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733134",
    "city": "RAIGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733135",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733140",
    "city": "GANGARAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733141",
    "city": "BALURGHAT ULTRA FRUGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733142",
    "city": "GANGARAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733143",
    "city": "RAIGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733144",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733145",
    "city": "BALURGHAT ULTRA FRUGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733146",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733147",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733148",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733149",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733151",
    "city": "BALURGHAT ULTRA FRUGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733153",
    "city": "BALURGHAT ULTRA FRUGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733154",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733155",
    "city": "BALURGHAT ULTRA FRUGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733156",
    "city": "RAIGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733157",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733158",
    "city": "BALURGHAT ULTRA FRUGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733201",
    "city": "DALKHOLA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733202",
    "city": "CHOPRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733207",
    "city": "CHOPRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733208",
    "city": "DALKHOLA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733209",
    "city": "DALKHOLA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733210",
    "city": "DALKHOLA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733211",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733212",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733213",
    "city": "MALDA COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733214",
    "city": "CHOPRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733215",
    "city": "DALKHOLA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733216",
    "city": "CHOPRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733246",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "733252",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734001",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734002",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734003",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734004",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734005",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734006",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734007",
    "city": "BHAKTINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734008",
    "city": "SALUGARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734009",
    "city": "SHIVMANDIR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734010",
    "city": "SHIVMANDIR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734011",
    "city": "SHIVMANDIR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734012",
    "city": "SHIVMANDIR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734013",
    "city": "SHIVMANDIR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734014",
    "city": "SHIVMANDIR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734015",
    "city": "BHAKTINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734101",
    "city": "DARJEELING",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734102",
    "city": "GHOOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734103",
    "city": "GHOOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734104",
    "city": "GHOOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734105",
    "city": "GHOOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734121",
    "city": "DARJEELING OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734122",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734123",
    "city": "GHOOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734124",
    "city": "DARJEELING OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734201",
    "city": "DARJEELING OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734203",
    "city": "KURSEONG RSP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734209",
    "city": "GHOOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734213",
    "city": "DARJEELING",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734214",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734215",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734216",
    "city": "DARJEELING OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734217",
    "city": "DARJEELING OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734218",
    "city": "DARJEELING",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734219",
    "city": "DARJEELING OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734220",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734221",
    "city": "GHOOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734222",
    "city": "DARJEELING",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734223",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734224",
    "city": "GHOOM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734226",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734227",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734313",
    "city": "DARJEELING",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734314",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734315",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734316",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734319",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734320",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734321",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734333",
    "city": "SHIVMANDIR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734401",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734403",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734404",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734405",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734421",
    "city": "SHIVMANDIR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734422",
    "city": "SHIVMANDIR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734423",
    "city": "SHIVMANDIR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734424",
    "city": "SHIVMANDIR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734426",
    "city": "CHOPRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734427",
    "city": "SHIVMANDIR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734429",
    "city": "SHIVMANDIR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734431",
    "city": "SHIVMANDIR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734434",
    "city": "SHIVMANDIR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734436",
    "city": "SHIVMANDIR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734501",
    "city": "MALBAZAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734502",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "734503",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735101",
    "city": "JALPAIGURI COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735102",
    "city": "JALPAIGURI COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735121",
    "city": "JALPAIGURI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735122",
    "city": "JALPAIGURI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735132",
    "city": "JALPAIGURI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735133",
    "city": "JALPAIGURI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735134",
    "city": "JALPAIGURI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735135",
    "city": "BHAKTINAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735136",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735137",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735138",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735139",
    "city": "JALPAIGURI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735140",
    "city": "JALPAIGURI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735201",
    "city": "DHUPGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735202",
    "city": "BANARHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735203",
    "city": "BANARHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735204",
    "city": "BIRPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735205",
    "city": "BANARHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735206",
    "city": "MALBAZAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735207",
    "city": "BANARHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735208",
    "city": "JAIGON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735209",
    "city": "MALBAZAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735210",
    "city": "DHUPGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735211",
    "city": "FALAKATA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735212",
    "city": "BANARHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735213",
    "city": "BANARHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735214",
    "city": "ALIPURDUAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735215",
    "city": "HASIMARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735216",
    "city": "BANARHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735217",
    "city": "ALIPURDUAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735218",
    "city": "MALBAZAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735219",
    "city": "JALPAIGURI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735220",
    "city": "BANARHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735221",
    "city": "MALBAZAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735222",
    "city": "MALBAZAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735223",
    "city": "MALBAZAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735224",
    "city": "JALPAIGURI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735225",
    "city": "NAGRAKATA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735226",
    "city": "ALIPURDUAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735227",
    "city": "ALIPURDUAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735228",
    "city": "BANARHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735229",
    "city": "MALBAZAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735230",
    "city": "MALBAZAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735231",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735232",
    "city": "BANARHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735233",
    "city": "BANARHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735234",
    "city": "MALBAZAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735235",
    "city": "MAYNAGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735236",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735237",
    "city": "MAYNAGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735238",
    "city": "MAYNAGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735301",
    "city": "JALPAIGURI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735302",
    "city": "JALPAIGURI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735303",
    "city": "NISHIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735304",
    "city": "JALPAIGURI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735305",
    "city": "JALPAIGURI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735306",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "735307",
    "city": "MAYNAGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736101",
    "city": "COOCH BEHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736118",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736121",
    "city": "ALIPURDUAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736122",
    "city": "ALIPURDUAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736123",
    "city": "ALIPURDUAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736131",
    "city": "ALIPURDUAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736132",
    "city": "COOCH BEHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736133",
    "city": "ALIPURDUAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736134",
    "city": "NISHIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736135",
    "city": "DINAHATA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736145",
    "city": "NISHIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736146",
    "city": "NISHIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736150",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736156",
    "city": "COOCH BEHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736157",
    "city": "NISHIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736158",
    "city": "NISHIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736159",
    "city": "ALIPURDUAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736160",
    "city": "ALIPURDUAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736165",
    "city": "COOCH BEHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736166",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736167",
    "city": "NISHIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736168",
    "city": "NISHIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736169",
    "city": "NISHIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736170",
    "city": "NISHIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736171",
    "city": "NISHIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736172",
    "city": "NISHIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736173",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736174",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736175",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736176",
    "city": "NISHIGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736177",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736179",
    "city": "COOCH BEHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736180",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736181",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736182",
    "city": "JAIGON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736203",
    "city": "ALIPURDUAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736204",
    "city": "ALIPURDUAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736205",
    "city": "ALIPURDUAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736208",
    "city": "ALIPURDUAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "736257",
    "city": "COOCH BEHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737101",
    "city": "GANGTOK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737102",
    "city": "RANIPOOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737103",
    "city": "GANGTOK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737106",
    "city": "GANGTOK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737107",
    "city": "GANGTOK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737111",
    "city": "GANGTOK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737112",
    "city": "GANGTOK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737113",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737114",
    "city": "GANGTOK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737117",
    "city": "GANGTOK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737118",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737119",
    "city": "GANGTOK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737120",
    "city": "GANGTOK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737121",
    "city": "JORETHANG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737128",
    "city": "GANGTOK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737131",
    "city": "GANGTOK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737132",
    "city": "RANGPO OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737134",
    "city": "RANGPO OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737135",
    "city": "RANIPOOL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737137",
    "city": "GANGTOK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737138",
    "city": "GANGTOK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "737139",
    "city": "SILIGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "740145",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741101",
    "city": "KRISHNANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741102",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741103",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741121",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741122",
    "city": "DOMKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741123",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741124",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741125",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741126",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741127",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741137",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741138",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741139",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741140",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741150",
    "city": "KATWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741151",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741152",
    "city": "DOMKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741153",
    "city": "KATWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741154",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741155",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741156",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741157",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741158",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741159",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741160",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741161",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741162",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741163",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741164",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741165",
    "city": "DOMKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741166",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741167",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741168",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741169",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741170",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741171",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741173",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741181",
    "city": "KATWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741183",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741184",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741185",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741187",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741188",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741189",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741191",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741192",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741196",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741201",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741202",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741203",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741221",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741222",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741223",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741224",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741225",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741232",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741234",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741235",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741238",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741245",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741246",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741247",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741248",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741249",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741250",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741251",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741252",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741253",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741254",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741255",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741256",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741257",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741258",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741301",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741302",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741313",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741315",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741316",
    "city": "KATWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741317",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741318",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741319",
    "city": "MEMARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741401",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741402",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741403",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741404",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741405",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741501",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741502",
    "city": "SHANTIPUR REMOTE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741504",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741505",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741506",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741507",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741508",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741509",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741510",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741511",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741512",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741513",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741514",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741515",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "741516",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742000",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742101",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742102",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742103",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742104",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742109",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742113",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742121",
    "city": "DOMKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742122",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742123",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742131",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742132",
    "city": "BURWAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742133",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742134",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742135",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742136",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742137",
    "city": "BURWAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742138",
    "city": "BURWAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742140",
    "city": "BURWAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742147",
    "city": "BURWAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742148",
    "city": "RAGHUNATHGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742149",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742150",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742157",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742160",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742161",
    "city": "BURWAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742162",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742163",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742164",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742165",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742166",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742168",
    "city": "BURWAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742170",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742172",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742173",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742174",
    "city": "TEHATTA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742175",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742176",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742177",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742178",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742179",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742180",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742181",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742182",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742183",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742184",
    "city": "BURWAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742185",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742187",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742188",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742189",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742190",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742191",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742201",
    "city": "RAGHUNATHGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742202",
    "city": "RAGHUNATHGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742212",
    "city": "FARAKKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742213",
    "city": "RAGHUNATHGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742220",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742223",
    "city": "RAGHUNATHGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742224",
    "city": "RAGHUNATHGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742225",
    "city": "RAGHUNATHGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742226",
    "city": "RAGHUNATHGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742227",
    "city": "RAGHUNATHGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742229",
    "city": "RAGHUNATHGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742230",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742231",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742232",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742234",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742235",
    "city": "RAGHUNATHGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742236",
    "city": "FARAKKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742237",
    "city": "RAGHUNATHGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742238",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742286",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742301",
    "city": "BURWAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742302",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742303",
    "city": "DOMKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742304",
    "city": "DOMKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742305",
    "city": "DOMKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742306",
    "city": "DOMKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742307",
    "city": "HOWRAH CITY",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742308",
    "city": "DOMKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742401",
    "city": "KATWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742402",
    "city": "KATWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742403",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742404",
    "city": "KATWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742405",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742406",
    "city": "DOMKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742407",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742408",
    "city": "BERHAMPORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "742409",
    "city": "DOMKAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743101",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743102",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743120",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743121",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743122",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743123",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743124",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743125",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743126",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743127",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743128",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743129",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743130",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743133",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743134",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743135",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743136",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743144",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743145",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743155",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743165",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743166",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743170",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743175",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743176",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743177",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743178",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743179",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743180",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743186",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743187",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743188",
    "city": "BARRACKPORE BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743193",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743194",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743195",
    "city": "KALYANI BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743201",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743202",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743203",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743204",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743206",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743221",
    "city": "BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743222",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743223",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743232",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743233",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743234",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743235",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743244",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743245",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743247",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743248",
    "city": "BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743249",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743251",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743252",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743262",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743263",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743268",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743269",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743270",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743271",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743272",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743273",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743274",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743276",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743286",
    "city": "BASIRHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743287",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743288",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743289",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743290",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743291",
    "city": "BASIRHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743292",
    "city": "BASIRHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743293",
    "city": "BASIRHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743294",
    "city": "BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743295",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743297",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743299",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743302",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743304",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743312",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743313",
    "city": "HSW APEX/SFC PUD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743318",
    "city": "AMTALA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743319",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743329",
    "city": "CANNING",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743330",
    "city": "BHANGAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743331",
    "city": "AMTALA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743332",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743336",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743337",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743338",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743339",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743345",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743348",
    "city": "KAKDWIP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743349",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743351",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743352",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743353",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743354",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743355",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743356",
    "city": "AMTALA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743358",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743363",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743368",
    "city": "AMTALA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743369",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743370",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743371",
    "city": "AMTALA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743372",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743373",
    "city": "AMTALA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743375",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743376",
    "city": "CANNING",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743377",
    "city": "AMTALA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743378",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743383",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743384",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743385",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743387",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743389",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743391",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743392",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743395",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743396",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743398",
    "city": "AMTALA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743399",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743401",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743405",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743411",
    "city": "BASIRHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743412",
    "city": "BASIRHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743413",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743414",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743422",
    "city": "BASIRHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743423",
    "city": "BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743424",
    "city": "BASIRHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743425",
    "city": "BHANGAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743426",
    "city": "BASIRHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743427",
    "city": "BASIRHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743428",
    "city": "BASIRHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743429",
    "city": "BASIRHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743437",
    "city": "BASIRHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743438",
    "city": "BASIRHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743439",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743440",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743442",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743443",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743445",
    "city": "BASIRHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743446",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743456",
    "city": "BASIRHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743486",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743502",
    "city": "BHANGAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743503",
    "city": "AMTALA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743504",
    "city": "AMTALA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743505",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743506",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743507",
    "city": "BHANGAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743508",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743511",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743512",
    "city": "APX SFC ETAIL PUD IN KSW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743513",
    "city": "AMTALA BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743601",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743603",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743609",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743610",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743611",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743613",
    "city": "DAKSHIN BARASAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743700",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743701",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743702",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743703",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743704",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743705",
    "city": "AJC SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743706",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743708",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743710",
    "city": "RANAGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743711",
    "city": "HABRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "743744",
    "city": "EJR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "746537",
    "city": "MORADABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751001",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751002",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751003",
    "city": "KHANDAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751004",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751005",
    "city": "CHANDRASHEKHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751006",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751007",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751008",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751009",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751010",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751011",
    "city": "CHANDRASHEKHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751012",
    "city": "KHANDAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751013",
    "city": "CHANDRASHEKHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751014",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751015",
    "city": "CHANDRASHEKHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751016",
    "city": "CHANDRASHEKHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751017",
    "city": "CHANDRASHEKHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751018",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751019",
    "city": "KHANDAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751020",
    "city": "KHANDAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751021",
    "city": "CHANDRASHEKHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751022",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751023",
    "city": "CHANDRASHEKHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751024",
    "city": "CHANDRASHEKHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751025",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751026",
    "city": "CHANDRASHEKHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751027",
    "city": "CHANDRASHEKHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751028",
    "city": "APX SFC ETAIL PUD IN BBW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751029",
    "city": "KHANDAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751030",
    "city": "KHANDAGIRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751031",
    "city": "CHANDRASHEKHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "751062",
    "city": "CHANDRASHEKHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752001",
    "city": "PURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752002",
    "city": "PURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752003",
    "city": "PURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752010",
    "city": "PURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752011",
    "city": "PURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752012",
    "city": "PURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752013",
    "city": "PURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752014",
    "city": "PURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752015",
    "city": "JATNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752016",
    "city": "JATNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752017",
    "city": "PURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752018",
    "city": "JATNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752019",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752020",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752021",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752022",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752023",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752024",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752025",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752026",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752027",
    "city": "BALUGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752028",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752030",
    "city": "BALUGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752031",
    "city": "BALUGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752032",
    "city": "PURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752033",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752034",
    "city": "BALUGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752035",
    "city": "BALUGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752036",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752037",
    "city": "BALUGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752038",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752045",
    "city": "PURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752046",
    "city": "PURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752050",
    "city": "JATNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752054",
    "city": "JATNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752055",
    "city": "JATNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752056",
    "city": "JATNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752057",
    "city": "JATNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752060",
    "city": "JATNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752061",
    "city": "JATNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752062",
    "city": "JATNI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752063",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752064",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752065",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752066",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752068",
    "city": "NAYAGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752069",
    "city": "NAYAGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752070",
    "city": "NAYAGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752077",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752078",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752079",
    "city": "NAYAGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752080",
    "city": "NAYAGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752081",
    "city": "NAYAGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752082",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752083",
    "city": "NAYAGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752084",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752085",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752087",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752089",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752090",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752091",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752092",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752093",
    "city": "RANPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752094",
    "city": "NAYAGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752100",
    "city": "CHANDRASHEKHARPUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752101",
    "city": "CHANDRASHEKHARPUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752102",
    "city": "NIMAPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752103",
    "city": "NIMAPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752104",
    "city": "NIMAPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752105",
    "city": "NIMAPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752106",
    "city": "NIMAPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752107",
    "city": "NIMAPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752108",
    "city": "NIMAPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752109",
    "city": "NIMAPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752110",
    "city": "NIMAPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752111",
    "city": "NIMAPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752112",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752113",
    "city": "NIMAPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752114",
    "city": "NIMAPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752115",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752116",
    "city": "NIMAPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752118",
    "city": "NIMAPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752119",
    "city": "NIMAPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752120",
    "city": "PURI EXPANSION",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "752121",
    "city": "NIMAPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "753001",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "753002",
    "city": "CUTTACK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "753003",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "753004",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "753005",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "753006",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "753007",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "753008",
    "city": "CUTTACK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "753009",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "753010",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "753011",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "753012",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "753013",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "753014",
    "city": "CUTTACK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "753015",
    "city": "CUTTACK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "753051",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754001",
    "city": "CHANDRASHEKHARPUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754002",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754003",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754004",
    "city": "NIMAPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754005",
    "city": "CUTTACK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754006",
    "city": "CUTTACK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754007",
    "city": "BANKI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754008",
    "city": "BANKI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754009",
    "city": "BANKI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754010",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754011",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754012",
    "city": "APX SFC ETAIL PUD IN BBW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754013",
    "city": "APX SFC ETAIL PUD IN BBW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754016",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754017",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754018",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754021",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754022",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754023",
    "city": "CHANDIKHOL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754024",
    "city": "CHANDIKHOL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754025",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754026",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754027",
    "city": "BANKI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754028",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754029",
    "city": "BANKI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754030",
    "city": "BANKI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754031",
    "city": "BANKI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754032",
    "city": "BANKI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754035",
    "city": "BANKI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754037",
    "city": "BANKI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754070",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754071",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754081",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754082",
    "city": "CHANDIKHOL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754100",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754102",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754103",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754104",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754105",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754106",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754107",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754108",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754109",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754110",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754111",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754112",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754113",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754114",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754118",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754119",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754120",
    "city": "PARADEEP E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754130",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754131",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754132",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754133",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754134",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754135",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754136",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754137",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754138",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754139",
    "city": "PARADEEP E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754140",
    "city": "PARADEEP E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754141",
    "city": "PARADEEP E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754142",
    "city": "PARADEEP E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754143",
    "city": "PARADEEP E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754145",
    "city": "PARADEEP E-TAIL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754153",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754155",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754156",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754157",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754159",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754160",
    "city": "JAGATSINGHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754162",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754200",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754201",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754202",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754203",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754204",
    "city": "CHANDIKHOL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754205",
    "city": "CHANDIKHOL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754206",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754207",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754208",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754209",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754210",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754211",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754212",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754213",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754214",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754215",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754216",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754217",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754218",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754219",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754220",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754221",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754222",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754223",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754224",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754225",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754226",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754227",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754228",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754229",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754231",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754233",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754236",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754237",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754238",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754239",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754240",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754241",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754242",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754243",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754244",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754245",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754246",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754248",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754250",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754251",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754253",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754261",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754282",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754285",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754286",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754288",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754289",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754290",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754292",
    "city": "CHANDIKHOL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754293",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754294",
    "city": "CUTTAK BLUE DART EXPRESS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754295",
    "city": "BANKI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "754296",
    "city": "CHANDIKHOL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755001",
    "city": "JAJPUR TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755003",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755004",
    "city": "JAJPUR TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755005",
    "city": "JAJPUR TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755006",
    "city": "JAJPUR TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755007",
    "city": "JAJPUR TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755008",
    "city": "CHANDIKHOL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755009",
    "city": "JAJPUR TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755010",
    "city": "KENDRAPARA ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755011",
    "city": "JAJPUR TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755012",
    "city": "JAJPUR TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755013",
    "city": "JAJPUR TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755014",
    "city": "JAJPUR TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755015",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755016",
    "city": "JAJPUR TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755017",
    "city": "JAJPUR TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755018",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755019",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755020",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755021",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755022",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755023",
    "city": "CHANDIKHOL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755024",
    "city": "CHANDIKHOL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755025",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755026",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755027",
    "city": "JAJPUR TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755028",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755029",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755030",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755031",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755032",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755033",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755035",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755036",
    "city": "JAJPUR TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755038",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755039",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755040",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755041",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755043",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755044",
    "city": "CHANDIKHOL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755045",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755046",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755047",
    "city": "BHUBANESWAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755049",
    "city": "CHANDIKHOL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755050",
    "city": "CHANDIKHOL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755051",
    "city": "JAJPUR TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755061",
    "city": "JAJPUR TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "755062",
    "city": "JAJPUR TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756001",
    "city": "BALASORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756002",
    "city": "BALASORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756003",
    "city": "BALASORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756018",
    "city": "BALASORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756019",
    "city": "BALASORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756020",
    "city": "BALASORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756021",
    "city": "BALASORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756022",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756023",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756024",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756025",
    "city": "BALASORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756026",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756027",
    "city": "BALASORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756028",
    "city": "BALASORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756029",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756030",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756032",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756033",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756034",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756035",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756036",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756037",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756038",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756039",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756040",
    "city": "BALASORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756041",
    "city": "BALASORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756042",
    "city": "SORO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756043",
    "city": "SORO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756044",
    "city": "BALASORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756045",
    "city": "SORO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756046",
    "city": "SORO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756047",
    "city": "SORO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756048",
    "city": "SORO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756049",
    "city": "SORO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756051",
    "city": "SORO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756053",
    "city": "BALASORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756055",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756056",
    "city": "BALASORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756058",
    "city": "BALASORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756059",
    "city": "SORO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756060",
    "city": "BALASORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756079",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756080",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756081",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756083",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756084",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756085",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756086",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756087",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756100",
    "city": "BHADRAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756101",
    "city": "BHADRAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756111",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756112",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756113",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756114",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756115",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756116",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756117",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756118",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756119",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756120",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756121",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756122",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756123",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756124",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756125",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756126",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756127",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756128",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756129",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756130",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756131",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756132",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756133",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756134",
    "city": "SORO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756135",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756137",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756138",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756139",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756142",
    "city": "BALASORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756144",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756162",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756163",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756164",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756165",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756166",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756167",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756168",
    "city": "SORO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756171",
    "city": "BHADRAK OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756181",
    "city": "BHADRAK",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "756182",
    "city": "SORO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757001",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757002",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757003",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757014",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757015",
    "city": "BALASORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757016",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757017",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757018",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757019",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757020",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757021",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757022",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757023",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757024",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757025",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757026",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757027",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757028",
    "city": "BALASORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757029",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757030",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757031",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757032",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757033",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757034",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757035",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757036",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757037",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757038",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757039",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757040",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757041",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757042",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757043",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757045",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757046",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757047",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757048",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757049",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757050",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757051",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757052",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757053",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757054",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757055",
    "city": "BALIAPAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757073",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757074",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757075",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757077",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757079",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757081",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757082",
    "city": "BALASORE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757083",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757084",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757085",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757086",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757087",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757091",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757092",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757093",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757100",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757101",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757102",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757103",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757104",
    "city": "UDALA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757105",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757106",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "757107",
    "city": "MAYURBHANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758001",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758002",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758013",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758014",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758015",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758016",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758017",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758018",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758019",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758020",
    "city": "BARBIL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758021",
    "city": "BARBIL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758022",
    "city": "BARBIL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758023",
    "city": "BARBIL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758025",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758026",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758027",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758028",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758029",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758030",
    "city": "BARBIL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758031",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758032",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758034",
    "city": "BARBIL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758035",
    "city": "BARBIL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758036",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758037",
    "city": "BARBIL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758038",
    "city": "BARBIL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758040",
    "city": "BARBIL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758041",
    "city": "BARBIL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758043",
    "city": "BARBIL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758044",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758045",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758046",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758047",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758052",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758072",
    "city": "JAJPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758076",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758078",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758079",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758080",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758081",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758082",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758083",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758084",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758085",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758086",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "758087",
    "city": "KEONJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759001",
    "city": "DHENKANAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759013",
    "city": "DHENKANAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759014",
    "city": "DHENKANAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759015",
    "city": "DHENKANAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759016",
    "city": "DHENKANAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759017",
    "city": "DHENKANAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759018",
    "city": "DHENKANAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759019",
    "city": "DHENKANAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759020",
    "city": "DHENKANAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759021",
    "city": "ANUGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759022",
    "city": "DHENKANAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759023",
    "city": "DHENKANAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759024",
    "city": "DHENKANAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759025",
    "city": "DHENKANAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759026",
    "city": "DHENKANAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759027",
    "city": "DHENKANAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759028",
    "city": "DHENKANAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759029",
    "city": "DHENKANAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759037",
    "city": "TALCHER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759039",
    "city": "DHENKANAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759040",
    "city": "ANUGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759100",
    "city": "TALCHER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759101",
    "city": "TALCHER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759102",
    "city": "TALCHER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759103",
    "city": "TALCHER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759104",
    "city": "TALCHER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759105",
    "city": "TALCHER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759106",
    "city": "TALCHER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759107",
    "city": "TALCHER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759111",
    "city": "ANUGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759116",
    "city": "TALCHER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759117",
    "city": "TALCHER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759118",
    "city": "TALCHER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759119",
    "city": "TALCHER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759120",
    "city": "TALCHER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759121",
    "city": "ANUGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759122",
    "city": "ANUGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759123",
    "city": "ANUGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759124",
    "city": "DEBAGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759125",
    "city": "BOUDH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759126",
    "city": "BOUDH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759127",
    "city": "ANUGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759128",
    "city": "TALCHER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759129",
    "city": "ANUGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759130",
    "city": "ANUGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759132",
    "city": "ANUGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759141",
    "city": "TALCHER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759143",
    "city": "ANUGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759145",
    "city": "ANUGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759146",
    "city": "TALCHER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759147",
    "city": "TALCHER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "759148",
    "city": "ANUGUL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "760001",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "760002",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "760003",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "760004",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "760005",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "760006",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "760007",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "760008",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "760009",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "760010",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "760011",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "760020",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761001",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761002",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761003",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761004",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761005",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761006",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761007",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761008",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761009",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761010",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761011",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761012",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761013",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761014",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761015",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761016",
    "city": "GAJAPATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761017",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761018",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761019",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761020",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761025",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761026",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761027",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761028",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761029",
    "city": "BALUGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761030",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761031",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761032",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761035",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761036",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761037",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761041",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761042",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761043",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761045",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761052",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761054",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761055",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761100",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761101",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761102",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761103",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761104",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761105",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761106",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761107",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761108",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761109",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761110",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761111",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761114",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761115",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761116",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761117",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761118",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761119",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761120",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761121",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761122",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761123",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761124",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761125",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761126",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761128",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761131",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761132",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761133",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761140",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761141",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761143",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761144",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761146",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761151",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761200",
    "city": "GAJAPATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761201",
    "city": "GAJAPATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761206",
    "city": "GAJAPATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761207",
    "city": "GAJAPATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761208",
    "city": "GAJAPATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761209",
    "city": "ASKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761210",
    "city": "GAJAPATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761211",
    "city": "GAJAPATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761212",
    "city": "GAJAPATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761213",
    "city": "GAJAPATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761214",
    "city": "GAJAPATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761215",
    "city": "GAJAPATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "761217",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762001",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762002",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762010",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762011",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762012",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762013",
    "city": "BOUDH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762014",
    "city": "BOUDH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762015",
    "city": "BOUDH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762016",
    "city": "SAMBALPUR WARE HOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762017",
    "city": "SONEPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762018",
    "city": "SONEPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762019",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762020",
    "city": "BOUDH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762021",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762022",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762023",
    "city": "BOUDH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762024",
    "city": "BOUDH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762026",
    "city": "BOUDH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762027",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762028",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762029",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762030",
    "city": "BOUDH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762100",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762101",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762102",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762103",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762104",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762105",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762106",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762107",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762109",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762110",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "762112",
    "city": "KANDHAMAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "763001",
    "city": "KORAPUT TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "763002",
    "city": "KORAPUT TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "763003",
    "city": "KORAPUT TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "763004",
    "city": "KORAPUT TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "763008",
    "city": "KORAPUT TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764001",
    "city": "KORAPUT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764002",
    "city": "KORAPUT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764003",
    "city": "KORAPUT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764004",
    "city": "KORAPUT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764005",
    "city": "KORAPUT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764006",
    "city": "KORAPUT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764011",
    "city": "KORAPUT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764014",
    "city": "KORAPUT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764020",
    "city": "KORAPUT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764021",
    "city": "KORAPUT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764027",
    "city": "KORAPUT TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764028",
    "city": "KORAPUT TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764036",
    "city": "KORAPUT TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764037",
    "city": "KORAPUT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764038",
    "city": "KORAPUT TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764039",
    "city": "KORAPUT TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764040",
    "city": "KORAPUT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764041",
    "city": "KORAPUT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764042",
    "city": "KORAPUT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764043",
    "city": "KORAPUT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764044",
    "city": "MALKANAGIRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764045",
    "city": "MALKANAGIRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764046",
    "city": "MALKANAGIRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764047",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764048",
    "city": "MALKANAGIRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764049",
    "city": "NABARANGPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764051",
    "city": "MALKANAGIRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764052",
    "city": "MALKANAGIRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764055",
    "city": "KORAPUT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764056",
    "city": "KORAPUT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764057",
    "city": "KORAPUT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764058",
    "city": "KORAPUT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764059",
    "city": "NABARANGPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764061",
    "city": "NABARANGPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764062",
    "city": "RAYGADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764063",
    "city": "NABARANGPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764070",
    "city": "NABARANGPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764071",
    "city": "NABARANGPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764072",
    "city": "NABARANGPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764073",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764074",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764075",
    "city": "NABARANGPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764076",
    "city": "NABARANGPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764077",
    "city": "NABARANGPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764078",
    "city": "NABARANGPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764081",
    "city": "KORAPUT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764085",
    "city": "NABARANGPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764086",
    "city": "MALKANAGIRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764087",
    "city": "MALKANAGIRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "764088",
    "city": "MALKANAGIRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "765001",
    "city": "RAYGADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "765002",
    "city": "RAYGADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "765013",
    "city": "KORAPUT TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "765015",
    "city": "BERHAMPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "765016",
    "city": "RAYGADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "765017",
    "city": "RAYGADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "765018",
    "city": "RAYGADA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "765019",
    "city": "RAYGADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "765020",
    "city": "RAYGADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "765021",
    "city": "RAYGADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "765022",
    "city": "RAYGADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "765023",
    "city": "RAYGADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "765024",
    "city": "RAYGADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "765025",
    "city": "RAYGADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "765026",
    "city": "RAYGADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "765029",
    "city": "RAYGADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "765033",
    "city": "RAYGADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "765034",
    "city": "RAYGADA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766001",
    "city": "KALAHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766002",
    "city": "KALAHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766011",
    "city": "KALAHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766012",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766013",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766014",
    "city": "KALAHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766015",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766016",
    "city": "KALAHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766017",
    "city": "KALAHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766018",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766019",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766020",
    "city": "KALAHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766023",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766026",
    "city": "KALAHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766027",
    "city": "KALAHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766028",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766029",
    "city": "KALAHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766031",
    "city": "KALAHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766032",
    "city": "KALAHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766036",
    "city": "KALAHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766037",
    "city": "KALAHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766100",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766101",
    "city": "KALAHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766102",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766103",
    "city": "KALAHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766104",
    "city": "NUAPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766105",
    "city": "NUAPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766106",
    "city": "NUAPARA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766107",
    "city": "KHARIAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766108",
    "city": "KHARIAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766110",
    "city": "KALAHANDI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766111",
    "city": "KHARIAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "766118",
    "city": "KHARIAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767001",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767002",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767016",
    "city": "SONEPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767017",
    "city": "SONEPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767018",
    "city": "SONEPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767019",
    "city": "SONEPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767020",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767021",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767022",
    "city": "TITILAGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767023",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767024",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767025",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767026",
    "city": "TITILAGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767027",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767028",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767029",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767030",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767032",
    "city": "TITILAGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767033",
    "city": "TITILAGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767035",
    "city": "TITILAGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767037",
    "city": "TITILAGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767038",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767039",
    "city": "TITILAGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767040",
    "city": "KHARIAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767041",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767042",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767045",
    "city": "SONEPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767046",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767048",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767060",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767061",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767062",
    "city": "SONEPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767065",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767066",
    "city": "TITILAGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767067",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767068",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767070",
    "city": "TITILAGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "767071",
    "city": "BALANGIR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768001",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768002",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768003",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768004",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768005",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768006",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768016",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768017",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768018",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768019",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768020",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768025",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768026",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768027",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768028",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768029",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768030",
    "city": "SAMBALPUR WARE HOUSE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768031",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768032",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768033",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768034",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768035",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768036",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768037",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768038",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768039",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768040",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768042",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768045",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768048",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768049",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768050",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768052",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768102",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768103",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768104",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768105",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768106",
    "city": "BOUDH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768107",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768108",
    "city": "DEBAGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768109",
    "city": "DEBAGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768110",
    "city": "DEBAGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768111",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768112",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768113",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768115",
    "city": "ATTABIRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768118",
    "city": "BOUDH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768119",
    "city": "DEBAGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768121",
    "city": "DEBAGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768200",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768201",
    "city": "JHARSUGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768202",
    "city": "JHARSUGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768203",
    "city": "JHARSUGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768204",
    "city": "JHARSUGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768210",
    "city": "JHARSUGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768211",
    "city": "JHARSUGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768212",
    "city": "BRAJRAJ NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768213",
    "city": "BRAJRAJ NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768214",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768215",
    "city": "BRAJRAJ NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768216",
    "city": "JHARSUGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768217",
    "city": "JHARSUGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768218",
    "city": "JHARSUGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768219",
    "city": "BRAJRAJ NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768220",
    "city": "BRAJRAJ NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768221",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768222",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768224",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768225",
    "city": "JHARSUGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768226",
    "city": "BRAJRAJ NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768227",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768228",
    "city": "SAMBALPUR BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768230",
    "city": "JHARSUGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768233",
    "city": "JHARSUGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "768234",
    "city": "JHARSUGUDA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "769001",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "769002",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "769003",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "769004",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "769005",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "769006",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "769007",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "769008",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "769009",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "769010",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "769011",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "769012",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "769013",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "769014",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "769015",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "769016",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "769041",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "769042",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "769043",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770001",
    "city": "BRAJRAJ NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770002",
    "city": "BRAJRAJ NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770011",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770012",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770013",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770014",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770015",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770016",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770017",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770018",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770019",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770020",
    "city": "BRAJRAJ NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770021",
    "city": "BRAJRAJ NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770022",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770023",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770024",
    "city": "BRAJRAJ NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770025",
    "city": "BRAJRAJ NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770031",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770032",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770033",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770034",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770035",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770036",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770037",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770038",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770039",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770040",
    "city": "BARBIL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770041",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770042",
    "city": "BARBIL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770043",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770044",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770046",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770048",
    "city": "BARBIL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770051",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770052",
    "city": "BARBIL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770070",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770072",
    "city": "BRAJRAJ NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770073",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770074",
    "city": "SUNDERGARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770075",
    "city": "BRAJRAJ NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "770076",
    "city": "BRAJRAJ NAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "777888",
    "city": "DHLEC INTL IB  CHINA/S",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781001",
    "city": "REHABARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781002",
    "city": "REHABARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781003",
    "city": "GUWAHATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781004",
    "city": "REHABARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781005",
    "city": "GUWAHATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781006",
    "city": "SIXMILE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781007",
    "city": "REHABARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781008",
    "city": "REHABARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781009",
    "city": "REHABARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781010",
    "city": "GOTANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781011",
    "city": "GOTANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781012",
    "city": "GOTANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781013",
    "city": "GOTANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781014",
    "city": "GOTANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781015",
    "city": "GAUAIRPORT SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781016",
    "city": "REHABARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781017",
    "city": "GAUAIRPORT SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781018",
    "city": "REHABARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781019",
    "city": "GUWAHATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781020",
    "city": "GUWAHATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781021",
    "city": "GUWAHATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781022",
    "city": "SIXMILE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781023",
    "city": "SIXMILE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781024",
    "city": "GUWAHATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781025",
    "city": "REHABARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781026",
    "city": "GUWAHATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781027",
    "city": "GUWAHATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781028",
    "city": "HATIGOAN BELTOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781029",
    "city": "HATIGOAN BELTOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781030",
    "city": "CHANGSARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781031",
    "city": "IIT GUWAHATI CAMPUS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781032",
    "city": "REHABARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781033",
    "city": "GUWAHATI BELTOLA COD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781034",
    "city": "GUWAHATI BELTOLA COD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781035",
    "city": "GUWAHATI BELTOLA COD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781036",
    "city": "SIXMILE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781037",
    "city": "SIXMILE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781038",
    "city": "HATIGOAN BELTOLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781039",
    "city": "IIT GUWAHATI CAMPUS",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781040",
    "city": "GUWAHATI BELTOLA COD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781071",
    "city": "GUWAHATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781101",
    "city": "CHANGSARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781102",
    "city": "HAJO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781103",
    "city": "HAJO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781104",
    "city": "HAJO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781112",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781121",
    "city": "BAIHATA CHARIALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781122",
    "city": "BIJOYNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781123",
    "city": "CHHAYGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781124",
    "city": "CHHAYGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781125",
    "city": "GAUAIRPORT SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781126",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781127",
    "city": "PILKHUWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781128",
    "city": "GAUAIRPORT SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781129",
    "city": "GUWAHATI AIRPORT REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781130",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781131",
    "city": "GUWAHATI AIRPORT REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781132",
    "city": "CHHAYGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781133",
    "city": "BAIHATA CHARIALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781134",
    "city": "CHHAYGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781135",
    "city": "GUWAHATI AIRPORT REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781136",
    "city": "GUWAHATI AIRPORT REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781137",
    "city": "GUWAHATI AIRPORT REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781138",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781141",
    "city": "GUWAHATI AIRPORT REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781150",
    "city": "GUWAHATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781171",
    "city": "GUWAHATI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781301",
    "city": "BARPETA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781302",
    "city": "BARPETA TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781303",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781304",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781305",
    "city": "BARPETA TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781306",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781307",
    "city": "BARPETA TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781308",
    "city": "BARPETA TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781309",
    "city": "BARPETA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781310",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781311",
    "city": "BARPETA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781312",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781313",
    "city": "BARPETA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781314",
    "city": "BARPETA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781315",
    "city": "BARPETA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781316",
    "city": "BARPETA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781317",
    "city": "BARPETA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781318",
    "city": "BARPETA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781319",
    "city": "BARPETA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781321",
    "city": "BARPETA TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781325",
    "city": "TIHU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781326",
    "city": "TIHU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781327",
    "city": "BARPETA TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781328",
    "city": "TIHU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781329",
    "city": "TIHU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781330",
    "city": "BARPETA TOWN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781333",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781334",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781335",
    "city": "NALBARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781337",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781338",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781339",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781340",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781341",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781343",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781344",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781345",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781346",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781347",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781348",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781349",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781350",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781351",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781352",
    "city": "BARPETA ROAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781353",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781354",
    "city": "RANGIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781355",
    "city": "TIHU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781360",
    "city": "TAMULPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781364",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781365",
    "city": "RANGIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781367",
    "city": "TAMULPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781368",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781369",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781370",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781371",
    "city": "TIHU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781372",
    "city": "TIHU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781373",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781374",
    "city": "TIHU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781375",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781376",
    "city": "RANGIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781377",
    "city": "NALBARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781378",
    "city": "TIHU",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781380",
    "city": "DIMU RSP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781381",
    "city": "BAIHATA CHARIALI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781382",
    "city": "DIMU RSP",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "781385",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782001",
    "city": "NAGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782002",
    "city": "NAGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782003",
    "city": "NAGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782101",
    "city": "KOLIABOR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782102",
    "city": "NAGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782103",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782104",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782105",
    "city": "MARIGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782107",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782108",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782120",
    "city": "KOLIABOR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782122",
    "city": "DABOKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782123",
    "city": "NAGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782124",
    "city": "NAGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782125",
    "city": "NAGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782126",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782127",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782135",
    "city": "KOLIABOR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782136",
    "city": "KOLIABOR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782137",
    "city": "KOLIABOR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782138",
    "city": "KOLIABOR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782139",
    "city": "KOLIABOR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782140",
    "city": "KOLIABOR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782141",
    "city": "NAGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782142",
    "city": "NAGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782143",
    "city": "KOLIABOR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782144",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782401",
    "city": "MARIGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782402",
    "city": "MARIGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782403",
    "city": "MARIGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782410",
    "city": "MARIGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782411",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782412",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782413",
    "city": "NAGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782425",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782426",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782427",
    "city": "NAGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782428",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782429",
    "city": "DABOKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782440",
    "city": "DABOKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782442",
    "city": "DABOKA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782447",
    "city": "LUMDING",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782448",
    "city": "DIPHU OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782460",
    "city": "DIPHU OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782461",
    "city": "DIPHU OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782462",
    "city": "DIPHU OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782470",
    "city": "DIPHU OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782475",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782480",
    "city": "BOKAJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "782485",
    "city": "DIPHU OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783101",
    "city": "GOALPARA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783120",
    "city": "GOALPARA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783121",
    "city": "GOALPARA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783122",
    "city": "KRISHNAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783123",
    "city": "GUWAHATI AIRPORT REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783124",
    "city": "KRISHNAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783125",
    "city": "KRISHNAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783126",
    "city": "KRISHNAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783127",
    "city": "DHUBRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783128",
    "city": "DHUBRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783130",
    "city": "KRISHNAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783131",
    "city": "DHUBRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783132",
    "city": "KRISHNAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783133",
    "city": "KRISHNAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783134",
    "city": "KRISHNAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783135",
    "city": "DHUBRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783301",
    "city": "DHUBRI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783324",
    "city": "GAURIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783325",
    "city": "DHUBRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783330",
    "city": "DHUBRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783331",
    "city": "GAURIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783332",
    "city": "GOSSAIGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783333",
    "city": "GOSSAIGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783334",
    "city": "AGOMONI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783336",
    "city": "GOSSAIGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783337",
    "city": "KOKRAJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783338",
    "city": "BONGAIGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783339",
    "city": "GAURIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783345",
    "city": "KOKRAJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783346",
    "city": "KOKRAJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783347",
    "city": "KOKRAJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783350",
    "city": "GOSSAIGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783351",
    "city": "BONGAIGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783354",
    "city": "GOSSAIGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783360",
    "city": "GOSSAIGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783361",
    "city": "GOSSAIGAON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783369",
    "city": "KOKRAJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783370",
    "city": "KOKRAJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783371",
    "city": "DHUBRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783372",
    "city": "KOKRAJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783373",
    "city": "BONGAIGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783374",
    "city": "BONGAIGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783375",
    "city": "BONGAIGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783376",
    "city": "KOKRAJHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783380",
    "city": "BONGAIGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783381",
    "city": "BONGAIGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783382",
    "city": "BONGAIGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783383",
    "city": "BONGAIGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783384",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783385",
    "city": "BONGAIGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783386",
    "city": "BONGAIGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783388",
    "city": "BONGAIGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783389",
    "city": "BONGAIGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783390",
    "city": "MANIKPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783391",
    "city": "MANIKPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783392",
    "city": "MANIKPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783393",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "783394",
    "city": "BONGAIGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784001",
    "city": "TEZPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784010",
    "city": "NAPAAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784025",
    "city": "NAPAAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784026",
    "city": "NAPAAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784027",
    "city": "NAPAAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784028",
    "city": "NAPAAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784101",
    "city": "NAPAAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784102",
    "city": "JAMUGURIHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784103",
    "city": "JAMUGURIHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784104",
    "city": "NAPAAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784105",
    "city": "NAPAAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784110",
    "city": "DHEKIAJULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784111",
    "city": "NAPAAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784112",
    "city": "NAPAAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784113",
    "city": "TEZPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784115",
    "city": "MANGALDOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784116",
    "city": "RANGIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784117",
    "city": "DHEKIAJULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784118",
    "city": "TEZPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784125",
    "city": "MANGALDOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784144",
    "city": "MANGALDOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784145",
    "city": "MANGALDOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784146",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784147",
    "city": "TEZPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784148",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784149",
    "city": "NAPAAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784150",
    "city": "NAPAAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784151",
    "city": "TEZPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784152",
    "city": "TEZPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784153",
    "city": "NAPAAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784154",
    "city": "NAPAAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784160",
    "city": "BANDERDEWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784161",
    "city": "BANDERDEWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784162",
    "city": "TEZPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784163",
    "city": "BANDERDEWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784164",
    "city": "BANDERDEWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784165",
    "city": "BANDERDEWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784166",
    "city": "JAMUGURIHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784167",
    "city": "JAMUGURIHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784168",
    "city": "GOHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784169",
    "city": "GOHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784170",
    "city": "GOHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784171",
    "city": "GOHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784172",
    "city": "GOHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784173",
    "city": "JAMUGURIHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784174",
    "city": "JAMUGURIHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784175",
    "city": "JAMUGURIHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784176",
    "city": "JAMUGURIHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784177",
    "city": "JAMUGURIHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784178",
    "city": "GOHPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784179",
    "city": "JAMUGURIHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784180",
    "city": "JAMUGURIHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784181",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784183",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784184",
    "city": "JAMUGURIHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784185",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784189",
    "city": "JAMUGURIHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784190",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784501",
    "city": "NAPAAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784502",
    "city": "NAPAAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784504",
    "city": "NAPAAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784505",
    "city": "NAPAAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784506",
    "city": "NAPAAM",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784507",
    "city": "TEZPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784508",
    "city": "TEZPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784509",
    "city": "MANGALDOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784510",
    "city": "TEZPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784513",
    "city": "TEZPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784514",
    "city": "TEZPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784521",
    "city": "MANGALDOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784522",
    "city": "MANGALDOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784523",
    "city": "TEZPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784524",
    "city": "TEZPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784525",
    "city": "MANGALDOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784526",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784527",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "784528",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785001",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785002",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785004",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785005",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785006",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785007",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785008",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785009",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785010",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785011",
    "city": "DOOM DOOMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785013",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785015",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785101",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785102",
    "city": "DHAKUAKHANA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785103",
    "city": "GOLAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785104",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785105",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785106",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785107",
    "city": "AMGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785108",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785109",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785110",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785111",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785112",
    "city": "AMGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785601",
    "city": "GOLAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785602",
    "city": "GOLAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785603",
    "city": "GOLAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785604",
    "city": "GOLAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785609",
    "city": "BOKAKHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785610",
    "city": "GOLAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785611",
    "city": "BOKAKHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785612",
    "city": "BOKAKHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785613",
    "city": "GOLAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785614",
    "city": "BOKAKHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785615",
    "city": "BOKAKHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785616",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785617",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785618",
    "city": "GOLAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785619",
    "city": "BOKAKHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785620",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785621",
    "city": "GOLAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785622",
    "city": "GOLAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785625",
    "city": "GOLAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785626",
    "city": "GOLAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785630",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785632",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785633",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785634",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785635",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785636",
    "city": "AMGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785640",
    "city": "SIBSAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785660",
    "city": "SIBSAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785661",
    "city": "AMGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785662",
    "city": "DEMOW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785663",
    "city": "SIBSAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785664",
    "city": "SIBSAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785665",
    "city": "SIBSAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785666",
    "city": "SIBSAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785667",
    "city": "SIBSAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785669",
    "city": "MORAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785670",
    "city": "MORAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785671",
    "city": "DEMOW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785672",
    "city": "DEMOW",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785673",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785674",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785675",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785676",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785680",
    "city": "AMGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785681",
    "city": "AMGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785682",
    "city": "AMGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785683",
    "city": "AMGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785684",
    "city": "NAZIRA EXTERIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785685",
    "city": "NAZIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785686",
    "city": "NAZIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785687",
    "city": "NAZIRA EXTERIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785688",
    "city": "SONARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785689",
    "city": "SONARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785690",
    "city": "SONARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785691",
    "city": "SONARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785692",
    "city": "SONARI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785693",
    "city": "NAHARKATIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785694",
    "city": "SIBSAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785695",
    "city": "SIBSAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785696",
    "city": "NAZIRA EXTERIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785697",
    "city": "SIBSAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785698",
    "city": "NAZIRA EXTERIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785699",
    "city": "BOKAKHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785700",
    "city": "AMGURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785701",
    "city": "NAZIRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785702",
    "city": "GOLAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785703",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785704",
    "city": "JORHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "785705",
    "city": "GOLAGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786001",
    "city": "DIBRUGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786002",
    "city": "DIBRUGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786003",
    "city": "DIBRUGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786004",
    "city": "DIBRUGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786005",
    "city": "DIBRUGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786006",
    "city": "DIBRUGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786007",
    "city": "DIBRUGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786008",
    "city": "DIBRUGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786010",
    "city": "DIBRUGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786012",
    "city": "DIBRUGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786053",
    "city": "DIBRUGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786054",
    "city": "DIBRUGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786101",
    "city": "DIBRUGARH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786102",
    "city": "TINSUKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786103",
    "city": "TINSUKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786110",
    "city": "NORTH LAKHIMPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786125",
    "city": "TINSUKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786126",
    "city": "TINSUKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786145",
    "city": "TINSUKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786146",
    "city": "TINSUKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786147",
    "city": "TINSUKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786148",
    "city": "TINSUKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786150",
    "city": "DOOM DOOMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786151",
    "city": "DOOM DOOMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786152",
    "city": "DOOM DOOMA EXTERIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786153",
    "city": "DOOM DOOMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786156",
    "city": "DOOM DOOMA EXTERIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786159",
    "city": "DOOM DOOMA EXTERIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786160",
    "city": "DOOM DOOMA EXTERIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786165",
    "city": "DIGBOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786170",
    "city": "TINSUKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786171",
    "city": "DIGBOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786172",
    "city": "DIGBOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786173",
    "city": "DIGBOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786174",
    "city": "DIGBOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786179",
    "city": "JAGUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786180",
    "city": "DIGBOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786181",
    "city": "DIGBOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786182",
    "city": "JAGUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786183",
    "city": "TINSUKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786184",
    "city": "TINSUKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786185",
    "city": "TINSUKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786187",
    "city": "DIGBOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786188",
    "city": "JAGUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786189",
    "city": "TINSUKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786190",
    "city": "DOOM DOOMA EXTERIOR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786191",
    "city": "DULIAJAN COD CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786192",
    "city": "TINSUKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786601",
    "city": "DULIAJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786602",
    "city": "DULIAJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786610",
    "city": "NAHARKATIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786611",
    "city": "MORAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786612",
    "city": "NAHARKATIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786613",
    "city": "MORAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786614",
    "city": "NAHARKATIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786615",
    "city": "DULIAJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786616",
    "city": "DULIAJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786624",
    "city": "DULIAJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786629",
    "city": "TINSUKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786631",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "786692",
    "city": "DULIAJAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787001",
    "city": "NORTH LAKHIMPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787023",
    "city": "NORTH LAKHIMPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787026",
    "city": "GOGAMUKH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787028",
    "city": "NORTH LAKHIMPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787029",
    "city": "NORTH LAKHIMPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787030",
    "city": "NORTH LAKHIMPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787031",
    "city": "NORTH LAKHIMPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787032",
    "city": "NORTH LAKHIMPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787033",
    "city": "DHAKUAKHANA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787034",
    "city": "GOGAMUKH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787035",
    "city": "GOGAMUKH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787051",
    "city": "NORTH LAKHIMPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787052",
    "city": "NORTH LAKHIMPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787053",
    "city": "DHAKUAKHANA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787054",
    "city": "BANDERDEWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787055",
    "city": "DHAKUAKHANA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787056",
    "city": "GOGAMUKH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787057",
    "city": "DHEMAJI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787058",
    "city": "GOGAMUKH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787059",
    "city": "SILAPATHER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787060",
    "city": "JONAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787061",
    "city": "JONAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787110",
    "city": "SILAPATHER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "787160",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788001",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788002",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788003",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788004",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788005",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788006",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788007",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788008",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788009",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788010",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788011",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788013",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788014",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788015",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788025",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788026",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788030",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788031",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788108",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788109",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788110",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788111",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788112",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788113",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788115",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788116",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788117",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788118",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788119",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788121",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788123",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788126",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788127",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788145",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788150",
    "city": "HAILAKANDI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788151",
    "city": "HAILAKANDI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788152",
    "city": "HAILAKANDI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788155",
    "city": "HAILAKANDI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788160",
    "city": "HAILAKANDI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788161",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788163",
    "city": "HAILAKANDI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788164",
    "city": "HAILAKANDI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788165",
    "city": "HAILAKANDI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788166",
    "city": "HAILAKANDI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788167",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788168",
    "city": "HAILAKANDI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788702",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788705",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788706",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788708",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788709",
    "city": "KARIMGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788711",
    "city": "KARIMGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788713",
    "city": "KARIMGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788716",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788719",
    "city": "KARIMGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788720",
    "city": "KARIMGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788721",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788725",
    "city": "KARIMGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788726",
    "city": "KARIMGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788727",
    "city": "KARIMGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788729",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788740",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788781",
    "city": "KARIMGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788790",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788801",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788804",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788816",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788817",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788819",
    "city": "HAFLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788820",
    "city": "HAFLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788830",
    "city": "HAFLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788831",
    "city": "HAFLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788832",
    "city": "HAFLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "788834",
    "city": "SILCHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "790101",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "790102",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "790105",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "791101",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "791102",
    "city": "PASIGHAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "791104",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "791110",
    "city": "NAHARLAGUN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "791111",
    "city": "ITANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "791113",
    "city": "ITANAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "791123",
    "city": "BANDERDEWA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "791125",
    "city": "SILAPATHER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "792051",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "792055",
    "city": "TINSUKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "792101",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "792103",
    "city": "TINSUKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "792111",
    "city": "TINSUKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "792120",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "792121",
    "city": "TINSUKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "792122",
    "city": "TINSUKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "792123",
    "city": "TINSUKIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793001",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793002",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793003",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793004",
    "city": "SHILLONG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793005",
    "city": "SHILLONG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793008",
    "city": "SHILLONG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793009",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793010",
    "city": "SHILLONG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793011",
    "city": "SHILLONG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793012",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793014",
    "city": "SHILLONG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793015",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793016",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793017",
    "city": "SHILLONG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793018",
    "city": "SHILLONG NONGMENSON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793019",
    "city": "SHILLONG NONGMENSON",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793021",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793022",
    "city": "SHILLONG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793103",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793104",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793106",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793107",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793108",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793109",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793110",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793111",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793112",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793113",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793114",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793119",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793120",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793121",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793122",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793150",
    "city": "JOWAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793151",
    "city": "SHILLONG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793160",
    "city": "KHLIEHRIAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793200",
    "city": "KHLIEHRIAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "793210",
    "city": "KHLIEHRIAT",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "794001",
    "city": "TURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "794002",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "794005",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "794101",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "794102",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "794103",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "794104",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "794105",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "794106",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "794107",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "794108",
    "city": "GOALPARA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "794109",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "794110",
    "city": "GOALPARA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "794111",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "794112",
    "city": "GOALPARA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "794114",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "794115",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "795001",
    "city": "IMPHAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "795002",
    "city": "MANTRIPUKHURI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "795003",
    "city": "IMPHAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "795004",
    "city": "IMPHAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "795005",
    "city": "IMPHAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "795008",
    "city": "IMPHAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "796001",
    "city": "AIZAWL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "796004",
    "city": "AIZAWL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "796005",
    "city": "AIZAWL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "796007",
    "city": "AIZAWL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "796008",
    "city": "AIZAWL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "796009",
    "city": "AIZAWL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "796012",
    "city": "AIZAWL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "796014",
    "city": "AIZAWL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "797001",
    "city": "KOHIMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "797004",
    "city": "KOHIMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "797100",
    "city": "AIZAWL SERVICE CENTRE-3",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "797101",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "797102",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "797103",
    "city": "CHUMUKDIMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "797104",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "797105",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "797107",
    "city": "DIMAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "797108",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "797109",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "797110",
    "city": "DIMAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "797112",
    "city": "DIMAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "797115",
    "city": "CHUMUKDIMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "797116",
    "city": "DIMAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "797121",
    "city": "KOHIMA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "798601",
    "city": "MOKOKCHUNG",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "798602",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "798603",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "798604",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "798611",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "798613",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "798614",
    "city": "DIMAPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "798615",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "798616",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "798617",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "798618",
    "city": "TULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "798619",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "798620",
    "city": "ZUNHEBOTO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "798621",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "798622",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "798623",
    "city": "TULI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "798625",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "798626",
    "city": "GUH-APEX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799001",
    "city": "AGARTALA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799002",
    "city": "AGARTALA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799003",
    "city": "AGARTALA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799004",
    "city": "AGARTALA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799005",
    "city": "AGARTALA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799006",
    "city": "AGARTALA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799007",
    "city": "AGARTALA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799008",
    "city": "AGARTALA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799009",
    "city": "AGARTALA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799010",
    "city": "AGARTALA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799011",
    "city": "AGARTALA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799012",
    "city": "AGARTALA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799014",
    "city": "AGARTALA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799015",
    "city": "AGARTALA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799022",
    "city": "AGARTALA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799035",
    "city": "AGARTALA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799046",
    "city": "AGARTALA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799101",
    "city": "AMARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799120",
    "city": "UDAIPUR TRIPURA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799130",
    "city": "AGARTALA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799204",
    "city": "AMBASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799210",
    "city": "AGARTALA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799211",
    "city": "AGARTALA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "799289",
    "city": "AMBASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800001",
    "city": "PATNA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800002",
    "city": "PATNA ANISABAD PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800003",
    "city": "PATNA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800004",
    "city": "PATNA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800005",
    "city": "PATNA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800006",
    "city": "PATNA PAX",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800007",
    "city": "PATNA PAX",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800008",
    "city": "PATNA PAX",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800009",
    "city": "PATNA PAX",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800010",
    "city": "PATNA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800011",
    "city": "PATNA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800012",
    "city": "PATNA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800013",
    "city": "PATNA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800014",
    "city": "PATNA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800015",
    "city": "PATNA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800016",
    "city": "PATNA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800017",
    "city": "PATNA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800018",
    "city": "PATNA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800019",
    "city": "PATNA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800020",
    "city": "PATNA ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800021",
    "city": "PATNA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800022",
    "city": "PATNA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800023",
    "city": "PATNA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800024",
    "city": "PATNA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800025",
    "city": "PATNA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800026",
    "city": "PATNA PAX",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800027",
    "city": "PATNA PAX",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800028",
    "city": "PATNA SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800030",
    "city": "PATNA PAX",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "800111",
    "city": "BIHTA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801102",
    "city": "BIHTA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801103",
    "city": "BIHTA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801104",
    "city": "BIHTA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801105",
    "city": "PHULWARISHARIF",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801106",
    "city": "BIHTA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801108",
    "city": "BIHTA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801109",
    "city": "BIHTA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801110",
    "city": "ARWAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801111",
    "city": "BIHTA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801112",
    "city": "BIHTA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801113",
    "city": "BIHTA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801301",
    "city": "JAHANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801302",
    "city": "BIHARSHARIF OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801303",
    "city": "BIHARSHARIF OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801304",
    "city": "FATUHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801305",
    "city": "BIHARSHARIF OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801306",
    "city": "JAHANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801307",
    "city": "BIHARSHARIF OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801501",
    "city": "PATNA ANISABAD PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801503",
    "city": "PATNA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801505",
    "city": "PATNA ANISABAD EXTN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801506",
    "city": "PATNA ANISABAD PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "801507",
    "city": "PHULWARISHARIF",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802101",
    "city": "BUXAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802102",
    "city": "BUXAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802103",
    "city": "BUXAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802111",
    "city": "BUXAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802112",
    "city": "BIHIYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802115",
    "city": "BUXAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802117",
    "city": "BUXAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802119",
    "city": "BUXAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802122",
    "city": "BUXAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802123",
    "city": "BUXAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802125",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802127",
    "city": "BIHIYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802130",
    "city": "BIHIYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802131",
    "city": "BUXAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802132",
    "city": "BHABHUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802133",
    "city": "BUXAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802134",
    "city": "BIHIYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802135",
    "city": "BUXAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802136",
    "city": "BUXAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802151",
    "city": "BIHIYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802152",
    "city": "BIHIYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802153",
    "city": "BIHIYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802154",
    "city": "BIHIYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802155",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802156",
    "city": "ARRAH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802157",
    "city": "ARRAH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802158",
    "city": "BIHIYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802159",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802160",
    "city": "ARRAH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802161",
    "city": "ARRAH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802162",
    "city": "ARRAH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802163",
    "city": "ARRAH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802164",
    "city": "ARRAH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802165",
    "city": "BIHIYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802166",
    "city": "BIHIYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802183",
    "city": "BIHIYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802201",
    "city": "ARRAH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802202",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802203",
    "city": "ARRAH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802204",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802205",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802206",
    "city": "ARRAH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802207",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802208",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802209",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802210",
    "city": "ARRAH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802211",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802212",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802213",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802214",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802216",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802218",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802219",
    "city": "ARRAH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802220",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802221",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802222",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802223",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802226",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802229",
    "city": "BIHIYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802301",
    "city": "ARRAH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802302",
    "city": "ARRAH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802311",
    "city": "ARRAH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802312",
    "city": "ARRAH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802313",
    "city": "BUXAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802314",
    "city": "ARRAH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802316",
    "city": "ARRAH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802351",
    "city": "BIHIYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "802352",
    "city": "ARRAH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803101",
    "city": "BIHARSHARIF OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803107",
    "city": "BIHARSHARIF OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803108",
    "city": "BIHARSHARIF OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803109",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803110",
    "city": "BAARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803111",
    "city": "BIHARSHARIF OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803113",
    "city": "BIHARSHARIF OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803114",
    "city": "BIHARSHARIF OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803116",
    "city": "BIHARSHARIF OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803117",
    "city": "BIHARSHARIF OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803118",
    "city": "BIHARSHARIF OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803119",
    "city": "BIHARSHARIF OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803120",
    "city": "BIHARSHARIF OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803201",
    "city": "FATUHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803202",
    "city": "FATUHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803203",
    "city": "FATUHA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803211",
    "city": "BAARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803212",
    "city": "BAARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803213",
    "city": "BAARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803214",
    "city": "BAARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803215",
    "city": "BAARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803216",
    "city": "PAW-APX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803221",
    "city": "BAARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803301",
    "city": "MOKAMA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803302",
    "city": "MOKAMA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803303",
    "city": "MOKAMA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "803307",
    "city": "BAARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804401",
    "city": "ARWAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804402",
    "city": "ARWAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804403",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804404",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804405",
    "city": "JAHANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804406",
    "city": "JAHANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804407",
    "city": "JAHANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804408",
    "city": "JAHANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804417",
    "city": "JAHANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804418",
    "city": "JAHANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804419",
    "city": "ARWAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804420",
    "city": "JAHANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804422",
    "city": "JAHANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804423",
    "city": "JAHANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804424",
    "city": "JAHANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804425",
    "city": "JAHANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804426",
    "city": "ARWAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804427",
    "city": "JAHANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804428",
    "city": "ARWAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804429",
    "city": "JAHANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804432",
    "city": "JAHANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804434",
    "city": "JAHANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804451",
    "city": "MASAURHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804452",
    "city": "MASAURHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804453",
    "city": "MASAURHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "804454",
    "city": "JAHANABAD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805101",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805102",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805103",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805104",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805105",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805106",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805107",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805108",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805109",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805110",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805113",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805121",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805122",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805123",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805124",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805125",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805126",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805127",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805128",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805129",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805130",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805131",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805132",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805133",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805141",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "805236",
    "city": "NAWADA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811101",
    "city": "SHEKHAPURA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811102",
    "city": "SHEKHAPURA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811103",
    "city": "SHEKHAPURA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811104",
    "city": "SHEKHAPURA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811105",
    "city": "SHEKHAPURA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811106",
    "city": "LAKHISARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811107",
    "city": "LAKHISARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811112",
    "city": "LAKHISARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811201",
    "city": "MUNGER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811202",
    "city": "MUNGER",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811211",
    "city": "MUNGER OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811212",
    "city": "MUNGER OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811213",
    "city": "MUNGER OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811214",
    "city": "MUNGER OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811301",
    "city": "JAMUI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811302",
    "city": "LAKHISARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811303",
    "city": "JAMUI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811304",
    "city": "SHEKHAPURA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811305",
    "city": "JAMUI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811307",
    "city": "JAMUI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811308",
    "city": "JAMUI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811309",
    "city": "LAKHISARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811310",
    "city": "LAKHISARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811311",
    "city": "LAKHISARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811312",
    "city": "JAMUI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811313",
    "city": "JAMUI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811314",
    "city": "JAMUI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811315",
    "city": "JAMUI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811316",
    "city": "JAMUI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "811317",
    "city": "JAMUI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "812001",
    "city": "BHAGALPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "812002",
    "city": "BHAGALPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "812003",
    "city": "BHAGALPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "812004",
    "city": "BHAGALPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "812005",
    "city": "BHAGALPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "812006",
    "city": "BHAGALPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "812007",
    "city": "BHAGALPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813101",
    "city": "BANKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813102",
    "city": "BANKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813103",
    "city": "BANKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813104",
    "city": "BANKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813106",
    "city": "BANKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813107",
    "city": "BANKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813108",
    "city": "BHAGALPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813109",
    "city": "BANKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813110",
    "city": "BANKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813112",
    "city": "BHAGALPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813116",
    "city": "BHAGALPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813117",
    "city": "BHAGALPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813118",
    "city": "BHAGALPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813123",
    "city": "BHAGALPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813124",
    "city": "BHAGALPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813125",
    "city": "BHAGALPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813126",
    "city": "BHAGALPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813127",
    "city": "BHAGALPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813128",
    "city": "BANKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813129",
    "city": "BHAGALPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813201",
    "city": "MUNGER OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813202",
    "city": "BANKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813203",
    "city": "KAHALGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813204",
    "city": "KAHALGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813205",
    "city": "KAHALGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813206",
    "city": "KAHALGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813207",
    "city": "BANKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813208",
    "city": "SAHIBGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813209",
    "city": "KAHALGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813210",
    "city": "BHAGALPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813211",
    "city": "BANKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813214",
    "city": "KAHALGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813221",
    "city": "MUNGER OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813222",
    "city": "KAHALGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813223",
    "city": "BHAGALPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813224",
    "city": "BHAGALPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813225",
    "city": "BHAGALPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813227",
    "city": "BHAGALPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813231",
    "city": "BHAGALPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "813233",
    "city": "BHAGALPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814101",
    "city": "DUMKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814102",
    "city": "DUMKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814103",
    "city": "DUMKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814110",
    "city": "DUMKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814111",
    "city": "PAKUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814112",
    "city": "DEOGHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814113",
    "city": "DEOGHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814114",
    "city": "DEOGHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814115",
    "city": "DEOGHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814116",
    "city": "DEOGHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814118",
    "city": "DUMKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814119",
    "city": "DUMKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814120",
    "city": "DEOGHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814122",
    "city": "DEOGHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814124",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814131",
    "city": "BANKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814133",
    "city": "GODDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814141",
    "city": "DUMKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814142",
    "city": "DEOGHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814143",
    "city": "DEOGHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814144",
    "city": "DUMKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814145",
    "city": "DUMKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814146",
    "city": "DEOGHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814147",
    "city": "GODDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814148",
    "city": "DUMKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814149",
    "city": "DEOGHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814150",
    "city": "DEOGHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814151",
    "city": "DUMKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814152",
    "city": "RAW APX/SFC/SFCETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814153",
    "city": "GODDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814154",
    "city": "GODDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814155",
    "city": "SAHEBGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814156",
    "city": "GODDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814157",
    "city": "DEOGHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814158",
    "city": "DUMKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814160",
    "city": "KAHALGAON OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814165",
    "city": "GODDA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "814166",
    "city": "JAMTARA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "815301",
    "city": "GIRIDIH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "815302",
    "city": "GIRIDIH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "815311",
    "city": "GIRIDIH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "815312",
    "city": "GIRIDIH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "815313",
    "city": "GIRIDIH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "815314",
    "city": "GIRIDIH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "815315",
    "city": "GIRIDIH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "815316",
    "city": "GIRIDIH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "815317",
    "city": "GIRIDIH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "815318",
    "city": "GIRIDIH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "815351",
    "city": "JAMTARA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "815352",
    "city": "JAMTARA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "815353",
    "city": "RAW APX/SFC/SFCETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "815354",
    "city": "JAMTARA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "815355",
    "city": "JAMTARA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "815356",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "815357",
    "city": "JAMTARA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "815359",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "815552",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "816101",
    "city": "SAHEBGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "816102",
    "city": "SAHEBGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "816103",
    "city": "DUMKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "816104",
    "city": "PAKUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "816105",
    "city": "SAHEBGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "816106",
    "city": "PAKUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "816107",
    "city": "PAKUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "816108",
    "city": "SAHIBGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "816109",
    "city": "SAHIBGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "816110",
    "city": "SAHEBGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "816115",
    "city": "SAHIBGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "816116",
    "city": "SAHIBGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "816117",
    "city": "DUMKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "816118",
    "city": "DUMKA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "816120",
    "city": "SAHIBGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "816129",
    "city": "SAHIBGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "821101",
    "city": "BHABHUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "821102",
    "city": "BHABHUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "821103",
    "city": "BHABHUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "821104",
    "city": "BHABHUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "821105",
    "city": "BHABHUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "821106",
    "city": "BHABHUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "821108",
    "city": "BHABHUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "821109",
    "city": "BHABHUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "821110",
    "city": "BHABHUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "821113",
    "city": "BHABHUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "821302",
    "city": "AURANGABAD BH UFO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "821303",
    "city": "BHABHUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "821304",
    "city": "BHABHUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "821305",
    "city": "AURANGABAD BH UFO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "821306",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "821308",
    "city": "AURANGABAD BH UFO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "821309",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "821310",
    "city": "BIKRAMGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "821311",
    "city": "BHABHUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "821312",
    "city": "BHABHUA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822101",
    "city": "DALTONGUNJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822102",
    "city": "DALTONGUNJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822110",
    "city": "DALTONGUNJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822111",
    "city": "DALTONGUNJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822113",
    "city": "DALTONGUNJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822114",
    "city": "GARHWA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822115",
    "city": "GARHWA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822116",
    "city": "GARHWA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822117",
    "city": "GARHWA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822118",
    "city": "DALTONGUNJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822119",
    "city": "DALTONGUNJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822120",
    "city": "GARHWA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822121",
    "city": "GARHWA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822122",
    "city": "DALTONGUNJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822123",
    "city": "DALTONGUNJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822124",
    "city": "GARHWA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822125",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822126",
    "city": "LATEHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822127",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822128",
    "city": "GARHWA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822131",
    "city": "DALTONGUNJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822132",
    "city": "GARHWA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "822133",
    "city": "GARHWA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "823001",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "823002",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "823003",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "823004",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "823005",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "823311",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824101",
    "city": "AURANGABAD BH UFO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824102",
    "city": "AURANGABAD BH UFO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824103",
    "city": "AURANGABAD BH UFO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824111",
    "city": "AURANGABAD BH UFO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824112",
    "city": "AURANGABAD BH UFO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824113",
    "city": "AURANGABAD BH UFO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824114",
    "city": "AURANGABAD BH UFO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824115",
    "city": "ARWAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824116",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824118",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824119",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824120",
    "city": "ARWAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824121",
    "city": "AURANGABAD BH UFO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824123",
    "city": "AURANGABAD BH UFO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824124",
    "city": "AURANGABAD BH UFO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824125",
    "city": "AURANGABAD BH UFO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824127",
    "city": "AURANGABAD BH UFO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824143",
    "city": "AURANGABAD BH UFO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824201",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824202",
    "city": "AURANGABAD BH UFO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824203",
    "city": "ARWAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824205",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824206",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824207",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824208",
    "city": "AURANGABAD BH UFO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824209",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824210",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824211",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824217",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824231",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824232",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824233",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824234",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824236",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824237",
    "city": "GAYA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824301",
    "city": "AURANGABAD BH UFO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824302",
    "city": "AURANGABAD BH UFO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "824303",
    "city": "AURANGABAD BH UFO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825101",
    "city": "GOLA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825102",
    "city": "PHUSRO OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825103",
    "city": "CHATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825106",
    "city": "GIRIDIH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825108",
    "city": "GIRIDIH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825109",
    "city": "KODERMA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825132",
    "city": "KODERMA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825137",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825167",
    "city": "GIRIDIH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825301",
    "city": "HAZARIBAG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825302",
    "city": "HAZARIBAG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825311",
    "city": "HAZARIBAG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825312",
    "city": "HAZARIBAG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825314",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825315",
    "city": "HAZARIBAG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825316",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825318",
    "city": "KODERMA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825320",
    "city": "GIRIDIH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825321",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825322",
    "city": "GIRIDIH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825323",
    "city": "HAZARIBAG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825324",
    "city": "GIRIDIH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825325",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825329",
    "city": "GIRIDIH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825330",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825335",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825336",
    "city": "HAZARIBAG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825401",
    "city": "CHATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825402",
    "city": "HAZARIBAG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825403",
    "city": "CHATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825404",
    "city": "CHATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825405",
    "city": "HAZARIBAG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825406",
    "city": "HAZARIBAG OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825407",
    "city": "KODERMA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825408",
    "city": "CHATRA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825409",
    "city": "KODERMA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825410",
    "city": "KODERMA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825412",
    "city": "GIRIDIH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825413",
    "city": "KODERMA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825418",
    "city": "KODERMA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825420",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "825421",
    "city": "KODERMA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "826001",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "826003",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "826004",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "826005",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "826006",
    "city": "GOMOH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "826106",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "826124",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "827001",
    "city": "BOKARO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "827003",
    "city": "BOKARO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "827004",
    "city": "BOKARO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "827006",
    "city": "BOKARO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "827009",
    "city": "BOKARO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "827010",
    "city": "BOKARO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "827011",
    "city": "BOKARO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "827012",
    "city": "BOKARO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "827013",
    "city": "BOKARO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "827014",
    "city": "BOKARO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "827015",
    "city": "BOKARO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "827302",
    "city": "GOLA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "827611",
    "city": "BOKARO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828101",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828102",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828103",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828104",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828105",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828106",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828107",
    "city": "SINDRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828108",
    "city": "SINDRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828109",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828110",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828111",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828112",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828113",
    "city": "GOMOH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828114",
    "city": "GOMOH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828115",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828116",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828117",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828119",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828120",
    "city": "SINDRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828121",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828122",
    "city": "SINDRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828123",
    "city": "SINDRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828124",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828125",
    "city": "GOMOH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828126",
    "city": "SINDRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828127",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828128",
    "city": "GOMOH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828129",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828130",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828131",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828132",
    "city": "SINDRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828133",
    "city": "SINDRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828134",
    "city": "BOKARO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828135",
    "city": "SINDRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828142",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828201",
    "city": "SINDRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828202",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828203",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828204",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828205",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828206",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828207",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828301",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828302",
    "city": "SINDRI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828303",
    "city": "BOKARO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828304",
    "city": "GOMOH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828305",
    "city": "GOMOH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828306",
    "city": "GOMOH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828307",
    "city": "GOMOH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828308",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828309",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828311",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828401",
    "city": "GOMOH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828402",
    "city": "GOMOH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828403",
    "city": "PHUSRO OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828404",
    "city": "PHUSRO OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "828504",
    "city": "DHANBAD BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829101",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829102",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829103",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829104",
    "city": "PHUSRO OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829105",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829106",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829107",
    "city": "BOKARO THARMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829108",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829109",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829110",
    "city": "GOLA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829111",
    "city": "BOKARO THARMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829112",
    "city": "BOKARO THARMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829113",
    "city": "BOKARO THARMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829114",
    "city": "PHUSRO OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829115",
    "city": "BOKARO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829116",
    "city": "BOKARO THARMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829117",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829118",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829119",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829120",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829121",
    "city": "GOLA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829122",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829123",
    "city": "BOKARO THARMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829124",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829125",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829126",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829127",
    "city": "PHUSRO OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829128",
    "city": "BOKARO THARMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829129",
    "city": "BOKARO THARMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829130",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829131",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829132",
    "city": "PHUSRO OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829133",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829134",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829135",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829138",
    "city": "PHUSRO OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829143",
    "city": "RAMGARH BDEL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829144",
    "city": "PHUSRO OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829145",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829149",
    "city": "BOKARO THARMAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829150",
    "city": "GOLA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829201",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829202",
    "city": "LATEHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829203",
    "city": "LATEHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829204",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829205",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829206",
    "city": "LATEHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829207",
    "city": "LATEHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829208",
    "city": "LATEHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829209",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829210",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "829301",
    "city": "BOKARO",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831001",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831002",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831003",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831004",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831005",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831006",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831007",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831008",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831009",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831010",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831011",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831012",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831013",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831014",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831015",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831016",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831017",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831018",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831019",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831020",
    "city": "JAMSHEDPUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831021",
    "city": "JAMTARA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "831035",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832009",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832101",
    "city": "JMW-APX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832102",
    "city": "GHATSILA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832103",
    "city": "GHATSILA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832104",
    "city": "GHATSILA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832105",
    "city": "JAMSHEDPUR REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832106",
    "city": "GHATSILA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832107",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832108",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832109",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832110",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832111",
    "city": "GHATSILA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832113",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832119",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832301",
    "city": "JMW-APX SFC ETAIL PUD",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832302",
    "city": "GHATSILA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832303",
    "city": "GHATSILA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832304",
    "city": "GHATSILA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832401",
    "city": "CHAKRADHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832402",
    "city": "CHAKRADHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832403",
    "city": "CHAKRADHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "832404",
    "city": "CHAKRADHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "833101",
    "city": "CHAKRADHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "833102",
    "city": "CHAKRADHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "833103",
    "city": "CHAKRADHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "833104",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "833105",
    "city": "CHAKRADHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "833106",
    "city": "ROURKELA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "833201",
    "city": "CHAIBASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "833202",
    "city": "CHAIBASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "833203",
    "city": "CHAIBASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "833212",
    "city": "CHAIBASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "833215",
    "city": "CHAIBASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "833216",
    "city": "CHAKRADHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "833217",
    "city": "CHAIBASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "833218",
    "city": "CHAIBASA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "833219",
    "city": "CHAKRADHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "833220",
    "city": "CHAKRADHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "833222",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "833223",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "833326",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "834001",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "834002",
    "city": "RANCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "834003",
    "city": "RANCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "834004",
    "city": "RANCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "834005",
    "city": "RANCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "834006",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "834007",
    "city": "RANCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "834008",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "834009",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "834010",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "834011",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "834012",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "834013",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835101",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835102",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835103",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835202",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835203",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835204",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835205",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835206",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835207",
    "city": "GUMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835208",
    "city": "GUMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835209",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835210",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835211",
    "city": "SIMDEGA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835212",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835213",
    "city": "LOHARDAGA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835214",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835215",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835216",
    "city": "CHAKRADHARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835217",
    "city": "ORMANJHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835218",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835219",
    "city": "ORMANJHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835220",
    "city": "GUMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835221",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835222",
    "city": "RANCHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835223",
    "city": "SIMDEGA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835224",
    "city": "GUMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835225",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835226",
    "city": "SIMDEGA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835227",
    "city": "GUMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835228",
    "city": "SIMDEGA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835229",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835230",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835231",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835232",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835233",
    "city": "GUMLA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835234",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835235",
    "city": "SIMDEGA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835236",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835238",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835239",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835240",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835301",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835302",
    "city": "LOHARDAGA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835303",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835304",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835305",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835324",
    "city": "JAMSHEDPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "835325",
    "city": "LOHARDAGA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "836001",
    "city": "RANCHI SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841101",
    "city": "HAJIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841201",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841202",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841204",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841205",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841206",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841207",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841208",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841209",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841211",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841212",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841213",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841214",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841215",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841216",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841217",
    "city": "HAJIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841218",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841219",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841220",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841221",
    "city": "HAJIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841222",
    "city": "HAJIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841223",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841224",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841225",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841226",
    "city": "SIWAN",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841239",
    "city": "SIWAN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841245",
    "city": "SIWAN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841301",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841302",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841305",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841311",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841312",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841313",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841316",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841401",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841402",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841403",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841405",
    "city": "GOPALGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841407",
    "city": "GOPALGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841409",
    "city": "GOPALGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841411",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841412",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841413",
    "city": "GOPALGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841414",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841415",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841418",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841419",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841421",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841422",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841423",
    "city": "GOPALGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841424",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841426",
    "city": "GOPALGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841427",
    "city": "GOPALGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841428",
    "city": "GOPALGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841436",
    "city": "GOPALGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841437",
    "city": "GOPALGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841438",
    "city": "GOPALGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841440",
    "city": "GOPALGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841441",
    "city": "GOPALGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841442",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841443",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841460",
    "city": "CHHAPRA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841503",
    "city": "GOPALGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841505",
    "city": "GOPALGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841506",
    "city": "SIWAN OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "841508",
    "city": "GOPALGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "842001",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "842002",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "842003",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "842004",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "842005",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "842008",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843101",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843102",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843103",
    "city": "KATRA GAYGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843104",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843105",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843106",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843107",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843108",
    "city": "KANTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843109",
    "city": "KANTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843110",
    "city": "MAHUA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843111",
    "city": "MOTIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843112",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843113",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843114",
    "city": "MAHUA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843115",
    "city": "KATRA GAYGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843116",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843117",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843118",
    "city": "KATRA GAYGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843119",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843120",
    "city": "MOTIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843121",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843122",
    "city": "MOTIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843123",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843124",
    "city": "MOTIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843125",
    "city": "MOTIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843126",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843127",
    "city": "MOTIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843128",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843129",
    "city": "KATRA GAYGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843130",
    "city": "KANTI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843131",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843132",
    "city": "MOTIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843133",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843136",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843139",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843141",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843143",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843144",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843146",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843147",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843149",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843152",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843153",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843158",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843161",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843162",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843164",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843165",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843301",
    "city": "SITAMARHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843302",
    "city": "SITAMARHI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843311",
    "city": "SITAMARHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843312",
    "city": "KATRA GAYGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843313",
    "city": "SITAMARHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843314",
    "city": "SITAMARHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843315",
    "city": "SITAMARHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843316",
    "city": "SITAMARHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843317",
    "city": "SITAMARHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843318",
    "city": "SITAMARHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843319",
    "city": "SITAMARHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843320",
    "city": "SITAMARHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843321",
    "city": "KATRA GAYGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843322",
    "city": "SITAMARHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843323",
    "city": "SITAMARHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843324",
    "city": "SITAMARHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843325",
    "city": "SITAMARHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843326",
    "city": "SITAMARHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843327",
    "city": "SITAMARHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843328",
    "city": "SITAMARHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843329",
    "city": "SHEOHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843330",
    "city": "SITAMARHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843331",
    "city": "SITAMARHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843332",
    "city": "SITAMARHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843333",
    "city": "SITAMARHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843334",
    "city": "SHEOHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843335",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843337",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843338",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843339",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843343",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843344",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843346",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843349",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843351",
    "city": "SITAMARHI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843354",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843359",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843360",
    "city": "KATRA GAYGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843363",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843364",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843365",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "843367",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844101",
    "city": "HAJIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844102",
    "city": "HAJIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844103",
    "city": "HAJIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844111",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844112",
    "city": "MAHUA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844113",
    "city": "HAJIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844114",
    "city": "MAHUA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844115",
    "city": "HAJIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844116",
    "city": "MAHUA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844117",
    "city": "HAJIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844118",
    "city": "MAHUA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844119",
    "city": "HAJIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844120",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844121",
    "city": "HAJIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844122",
    "city": "MAHUA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844123",
    "city": "MAHUA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844124",
    "city": "MAHUA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844125",
    "city": "MAHUA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844126",
    "city": "MAHUA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844127",
    "city": "MUZAFFARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844128",
    "city": "HAJIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844501",
    "city": "MAHUA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844502",
    "city": "HAJIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844503",
    "city": "HAJIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844504",
    "city": "HAJIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844505",
    "city": "MAHUA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844506",
    "city": "MAHUA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844507",
    "city": "MAHUA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "844508",
    "city": "BAARH OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845101",
    "city": "BETIAH ULTRA FRUGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845102",
    "city": "NARKATIYAGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845103",
    "city": "NARKATIYAGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845105",
    "city": "NARKATIYAGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845106",
    "city": "NARKATIYAGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845107",
    "city": "NARKATIYAGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845120",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845145",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845301",
    "city": "RAXAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845302",
    "city": "MOTIHARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845303",
    "city": "MOTIHARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845304",
    "city": "MOTIHARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845305",
    "city": "RAXAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845306",
    "city": "NARKATIYAGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845307",
    "city": "NARKATIYAGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845401",
    "city": "MOTIHARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845406",
    "city": "MOTIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845411",
    "city": "ARERAJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845412",
    "city": "MOTIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845413",
    "city": "MOTIHARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845414",
    "city": "SHEOHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845415",
    "city": "MOTIHARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845416",
    "city": "MOTIHARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845417",
    "city": "ARERAJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845419",
    "city": "ARERAJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845420",
    "city": "SHEOHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845422",
    "city": "ARERAJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845423",
    "city": "ARERAJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845424",
    "city": "MOTIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845425",
    "city": "ARERAJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845426",
    "city": "MOTIPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845427",
    "city": "SHEOHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845428",
    "city": "MOTIHARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845429",
    "city": "MOTIHARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845430",
    "city": "SHEOHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845431",
    "city": "MOTIHARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845432",
    "city": "MOTIHARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845433",
    "city": "RAXAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845434",
    "city": "ARERAJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845435",
    "city": "MOTIHARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845436",
    "city": "SHEOHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845437",
    "city": "ARERAJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845438",
    "city": "BETIAH ULTRA FRUGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845440",
    "city": "RAXAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845449",
    "city": "BETIAH ULTRA FRUGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845450",
    "city": "BETIAH ULTRA FRUGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845451",
    "city": "NARKATIYAGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845452",
    "city": "BETIAH ULTRA FRUGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845453",
    "city": "BETIAH ULTRA FRUGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845454",
    "city": "BETIAH ULTRA FRUGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845455",
    "city": "NARKATIYAGANJ",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845456",
    "city": "RAXAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845457",
    "city": "MOTIHARI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845458",
    "city": "ARERAJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845459",
    "city": "BETIAH ULTRA FRUGAL",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845462",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845465",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845466",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845467",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845468",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845485",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845486",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845490",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845494",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845495",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845496",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845498",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845507",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845509",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845514",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845518",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845519",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845520",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845521",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845523",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845524",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "845525",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "846001",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "846002",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "846003",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "846004",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "846005",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "846006",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "846007",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "846008",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "846009",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847101",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847102",
    "city": "MADHUBANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847103",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847104",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847105",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847106",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847107",
    "city": "KATRA GAYGHAT OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847108",
    "city": "MADHUBANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847109",
    "city": "JHANJHARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847115",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847121",
    "city": "MADHUBANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847122",
    "city": "MADHUBANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847123",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847203",
    "city": "DARBHANGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847211",
    "city": "MADHUBANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847212",
    "city": "MADHUBANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847222",
    "city": "MADHUBANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847223",
    "city": "JAYNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847224",
    "city": "MADHUBANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847225",
    "city": "JAYNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847226",
    "city": "JAYNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847227",
    "city": "MADHUBANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847228",
    "city": "MADHUBANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847229",
    "city": "JAYNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847230",
    "city": "JAYNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847231",
    "city": "MADHUBANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847232",
    "city": "JAYNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847233",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847234",
    "city": "MADHUBANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847235",
    "city": "MADHUBANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847236",
    "city": "MADHUBANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847238",
    "city": "MADHUBANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847239",
    "city": "MADHUBANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847301",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847302",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847303",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847305",
    "city": "MADHUBANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847306",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847308",
    "city": "JAYNAGAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847337",
    "city": "MADHUBANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847401",
    "city": "JHANJHARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847402",
    "city": "JHANJHARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847403",
    "city": "JHANJHARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847404",
    "city": "JHANJHARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847405",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847406",
    "city": "DARBHANGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847407",
    "city": "JHANJHARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847408",
    "city": "JHANJHARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847409",
    "city": "JHANJHARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847410",
    "city": "JHANJHARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847411",
    "city": "JHANJHARPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847421",
    "city": "MADHUBANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847422",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847423",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847424",
    "city": "MADHUBANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847427",
    "city": "DARBHANGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847428",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847429",
    "city": "DARBHANGA REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847451",
    "city": "MADHUBANI REACH",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "847452",
    "city": "SUPAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848101",
    "city": "SAMASTIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848102",
    "city": "SAMASTIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848109",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848111",
    "city": "DARBHANGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848112",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848113",
    "city": "SAMASTIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848114",
    "city": "DALSINGH SARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848115",
    "city": "SAMASTIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848116",
    "city": "DARBHANGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848117",
    "city": "SAMASTIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848118",
    "city": "DARBHANGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848121",
    "city": "SAMASTIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848122",
    "city": "SAMASTIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848123",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848125",
    "city": "SAMASTIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848127",
    "city": "DALSINGH SARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848128",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848129",
    "city": "SAMASTIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848130",
    "city": "SAMASTIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848131",
    "city": "SAMASTIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848132",
    "city": "DALSINGH SARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848133",
    "city": "SAMASTIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848134",
    "city": "SAMASTIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848136",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848138",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848140",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848142",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848145",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848146",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848149",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848154",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848157",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848158",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848160",
    "city": "DALSINGH SARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848161",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848183",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848202",
    "city": "BEGUSARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848203",
    "city": "KHAGARIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848204",
    "city": "DALSINGH SARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848205",
    "city": "DALSINGH SARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848206",
    "city": "DALSINGH SARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848207",
    "city": "BEGUSARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848208",
    "city": "DALSINGH SARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848209",
    "city": "SAMASTIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848210",
    "city": "SAMASTIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848211",
    "city": "DALSINGH SARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848216",
    "city": "DALSINGH SARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848217",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848220",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848224",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848225",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848226",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848229",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848230",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848233",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848234",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848236",
    "city": "SAMASTIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848237",
    "city": "DARBHANGA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848301",
    "city": "SAMASTIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848302",
    "city": "SAMASTIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848303",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848501",
    "city": "DALSINGH SARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848502",
    "city": "DALSINGH SARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848503",
    "city": "DALSINGH SARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848504",
    "city": "SAMASTIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848505",
    "city": "SAMASTIPUR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848506",
    "city": "DALSINGH SARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848507",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848508",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848510",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848512",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848514",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848515",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "848517",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851101",
    "city": "BEGUSARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851103",
    "city": "BEGUSARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851111",
    "city": "DALSINGH SARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851112",
    "city": "BARAUNI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851113",
    "city": "BARAUNI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851114",
    "city": "BARAUNI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851115",
    "city": "BARAUNI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851116",
    "city": "BARAUNI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851117",
    "city": "BEGUSARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851118",
    "city": "BARAUNI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851126",
    "city": "BARAUNI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851127",
    "city": "BEGUSARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851128",
    "city": "DALSINGH SARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851129",
    "city": "BEGUSARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851130",
    "city": "BEGUSARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851131",
    "city": "BEGUSARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851132",
    "city": "BEGUSARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851133",
    "city": "BARAUNI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851134",
    "city": "BEGUSARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851135",
    "city": "BARAUNI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851202",
    "city": "KHAGARIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851203",
    "city": "KHAGARIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851204",
    "city": "KHAGARIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851205",
    "city": "KHAGARIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851210",
    "city": "BARAUNI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851211",
    "city": "BEGUSARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851212",
    "city": "KHAGARIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851213",
    "city": "KHAGARIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851214",
    "city": "KHAGARIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851215",
    "city": "BEGUSARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851216",
    "city": "NAUGACHIA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851217",
    "city": "BEGUSARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851218",
    "city": "BEGUSARAI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851219",
    "city": "BEGUSARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "851225",
    "city": "BEGUSARAI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852101",
    "city": "MADHEPURA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852105",
    "city": "SUPAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852106",
    "city": "SAHARSA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852107",
    "city": "MADHEPURA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852108",
    "city": "SUPAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852109",
    "city": "SUPAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852110",
    "city": "SUPAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852111",
    "city": "SUPAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852112",
    "city": "MADHEPURA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852113",
    "city": "MADHEPURA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852114",
    "city": "MADHEPURA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852115",
    "city": "MADHEPURA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852116",
    "city": "MADHEPURA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852121",
    "city": "MADHEPURA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852122",
    "city": "MADHEPURA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852123",
    "city": "SAHARSA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852125",
    "city": "SUPAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852126",
    "city": "SAHARSA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852127",
    "city": "SAHARSA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852128",
    "city": "MADHEPURA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852129",
    "city": "SAHARSA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852130",
    "city": "SUPAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852131",
    "city": "SUPAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852132",
    "city": "MADHEPURA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852133",
    "city": "SUPAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852137",
    "city": "SUPAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852138",
    "city": "SUPAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852139",
    "city": "SUPAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852201",
    "city": "SAHARSA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852212",
    "city": "SAHARSA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852213",
    "city": "MADHEPURA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852214",
    "city": "SUPAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852215",
    "city": "SUPAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852216",
    "city": "SAHARSA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852217",
    "city": "SAHARSA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852218",
    "city": "SUPAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852220",
    "city": "MADHEPURA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "852221",
    "city": "SAHARSA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "853201",
    "city": "NAUGACHIA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "853202",
    "city": "NAUGACHIA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "853204",
    "city": "NAUGACHIA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "853205",
    "city": "NAUGACHIA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "853207",
    "city": "BHAGALPUR SERVICE CENTRE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854101",
    "city": "KATIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854102",
    "city": "PURNEA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854103",
    "city": "KATIHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854104",
    "city": "KATIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854105",
    "city": "KATIHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854106",
    "city": "KATIHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854108",
    "city": "KATIHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854109",
    "city": "KATIHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854113",
    "city": "KATIHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854114",
    "city": "KATIHAR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854115",
    "city": "KATIHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854116",
    "city": "KATIHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854117",
    "city": "KATIHAR OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854201",
    "city": "PURNEA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854202",
    "city": "PURNEA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854206",
    "city": "PURNIA",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854301",
    "city": "PURNEA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854302",
    "city": "PURNEA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854303",
    "city": "PURNEA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854304",
    "city": "PURNEA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854305",
    "city": "PURNEA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854306",
    "city": "PURNEA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854311",
    "city": "ARARIA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854312",
    "city": "ARARIA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854315",
    "city": "PURNEA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854316",
    "city": "JOGBANI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854318",
    "city": "JOGBANI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854325",
    "city": "ARARIA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854326",
    "city": "PURNEA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854327",
    "city": "PURNEA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854328",
    "city": "JOGBANI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854329",
    "city": "ARARIA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854330",
    "city": "PURNEA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854331",
    "city": "ARWAL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854332",
    "city": "JOGBANI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854333",
    "city": "JOGBANI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854334",
    "city": "ARARIA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854335",
    "city": "JOGBANI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854336",
    "city": "JOGBANI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854337",
    "city": "PURNEA OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854338",
    "city": "JOGBANI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854339",
    "city": "JOGBANI OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "854340",
    "city": "SUPAUL OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "855101",
    "city": "KISHANGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "855105",
    "city": "BARSOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "855106",
    "city": "KISHANGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "855107",
    "city": "KISHANGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "855108",
    "city": "KISHANGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "855113",
    "city": "BARSOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "855114",
    "city": "BARSOI",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "855115",
    "city": "KISHANGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "855116",
    "city": "KISHANGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "855117",
    "city": "KISHANGANJ OFFICE",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  },
  {
    "pincode": "855456",
    "city": "MUZAFFARPUR",
    "days": "5",
    "cod": "FALSE",
    "metro": "TRUE"
  }
];

/* CONVERT TO FAST LOOKUP FORMAT */
window.PINCODE_DATA = {};

window.RAW_PINCODE_DATA.forEach(function(item) {
  var pin = String(item.pincode);

  window.PINCODE_DATA[pin] = {
    city: item.city,
    days: Number(item.days),
    cod: item.cod === "TRUE",
    metro: item.metro === "TRUE"
  };
});
